import $TBcmg$react, {createContext as $TBcmg$createContext, useState as $TBcmg$useState, useRef as $TBcmg$useRef, useCallback as $TBcmg$useCallback, useEffect as $TBcmg$useEffect, useContext as $TBcmg$useContext, useMemo as $TBcmg$useMemo, useSyncExternalStore as $TBcmg$useSyncExternalStore, forwardRef as $TBcmg$forwardRef} from "react";
import {reservoirChains as $TBcmg$reservoirChains, createClient as $TBcmg$createClient, axios as $TBcmg$axios, setParams as $TBcmg$setParams, LogLevel as $TBcmg$LogLevel, getClient as $TBcmg$getClient, customChains as $TBcmg$customChains, APIError as $TBcmg$APIError} from "@reservoir0x/reservoir-sdk";
import $TBcmg$swr, {SWRConfig as $TBcmg$SWRConfig, useSWRConfig as $TBcmg$useSWRConfig} from "swr";
import {Provider as $TBcmg$Provider, Arrow as $TBcmg$Arrow, Root as $TBcmg$Root, Trigger as $TBcmg$Trigger, Content as $TBcmg$Content} from "@radix-ui/react-tooltip";
import {redDark as $TBcmg$redDark, indigoDark as $TBcmg$indigoDark, indigoDarkA as $TBcmg$indigoDarkA, slateDark as $TBcmg$slateDark, blackA as $TBcmg$blackA, green as $TBcmg$green, indigo as $TBcmg$indigo, indigoA as $TBcmg$indigoA, red as $TBcmg$red, gray as $TBcmg$gray, whiteA as $TBcmg$whiteA} from "@radix-ui/colors";
import {createStitches as $TBcmg$createStitches, styled as $TBcmg$styled, keyframes as $TBcmg$keyframes} from "@stitches/react";
import $TBcmg$swrinfinite from "swr/infinite";
import {useAccount as $TBcmg$useAccount, useChains as $TBcmg$useChains, useConfig as $TBcmg$useConfig, useSwitchChain as $TBcmg$useSwitchChain, useWalletClient as $TBcmg$useWalletClient, useReadContracts as $TBcmg$useReadContracts, useBalance as $TBcmg$useBalance, useReadContract as $TBcmg$useReadContract} from "wagmi";
import {parseUnits as $TBcmg$parseUnits, formatUnits as $TBcmg$formatUnits, zeroAddress as $TBcmg$zeroAddress, erc20Abi as $TBcmg$erc20Abi, erc721Abi as $TBcmg$erc721Abi} from "viem";
import {getAccount as $TBcmg$getAccount, getWalletClient as $TBcmg$getWalletClient, switchChain as $TBcmg$switchChain, getBalance as $TBcmg$getBalance} from "wagmi/actions";
import $TBcmg$swrimmutable from "swr/immutable";
import * as $TBcmg$viemchains from "viem/chains";
import {faCircleExclamation as $TBcmg$faCircleExclamation} from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import {faCheckCircle as $TBcmg$faCheckCircle} from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import {faChevronLeft as $TBcmg$faChevronLeft} from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import {faChevronDown as $TBcmg$faChevronDown} from "@fortawesome/free-solid-svg-icons/faChevronDown";
import {FontAwesomeIcon as $TBcmg$FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {motion as $TBcmg$motion, AnimatePresence as $TBcmg$AnimatePresence} from "framer-motion";
import {Arrow as $TBcmg$Arrow1, Root as $TBcmg$Root1, Trigger as $TBcmg$Trigger1, Content as $TBcmg$Content1, Portal as $TBcmg$Portal1} from "@radix-ui/react-popover";
import {useMediaQuery as $TBcmg$useMediaQuery, useMeasure as $TBcmg$useMeasure} from "@react-hookz/web";
import {faSpinner as $TBcmg$faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";
import {faCube as $TBcmg$faCube} from "@fortawesome/free-solid-svg-icons/faCube";
import {faWallet as $TBcmg$faWallet} from "@fortawesome/free-solid-svg-icons/faWallet";
import {Title as $TBcmg$Title, Close as $TBcmg$Close, Overlay as $TBcmg$Overlay, Content as $TBcmg$Content2, Root as $TBcmg$Root2, DialogTrigger as $TBcmg$DialogTrigger, DialogPortal as $TBcmg$DialogPortal} from "@radix-ui/react-dialog";
import {faClose as $TBcmg$faClose} from "@fortawesome/free-solid-svg-icons/faClose";
import {faLock as $TBcmg$faLock} from "@fortawesome/free-solid-svg-icons/faLock";
import {useCapabilities as $TBcmg$useCapabilities} from "wagmi/experimental";
import {faMinus as $TBcmg$faMinus} from "@fortawesome/free-solid-svg-icons/faMinus";
import {faPlus as $TBcmg$faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {faInfoCircle as $TBcmg$faInfoCircle} from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import {faImage as $TBcmg$faImage} from "@fortawesome/free-solid-svg-icons/faImage";
import {faCalendar as $TBcmg$faCalendar} from "@fortawesome/free-solid-svg-icons/faCalendar";
import {faImages as $TBcmg$faImages} from "@fortawesome/free-solid-svg-icons/faImages";
import {faTag as $TBcmg$faTag} from "@fortawesome/free-solid-svg-icons/faTag";
import $TBcmg$dayjs from "dayjs";
import $TBcmg$reactflatpickr from "react-flatpickr";
import {Trigger as $TBcmg$Trigger2, Content as $TBcmg$Content3, ItemText as $TBcmg$ItemText, Value as $TBcmg$Value, Icon as $TBcmg$Icon, Root as $TBcmg$Root3, Portal as $TBcmg$Portal, ScrollUpButton as $TBcmg$ScrollUpButton, Viewport as $TBcmg$Viewport, ScrollDownButton as $TBcmg$ScrollDownButton, Item as $TBcmg$Item} from "@radix-ui/react-select";
import {faPenNib as $TBcmg$faPenNib} from "@fortawesome/free-solid-svg-icons/faPenNib";
import $TBcmg$dayjspluginrelativeTimejs from "dayjs/plugin/relativeTime.js";
import {CollapsibleContent as $TBcmg$CollapsibleContent, Root as $TBcmg$Root4, Trigger as $TBcmg$Trigger3} from "@radix-ui/react-collapsible";
import {faEllipsis as $TBcmg$faEllipsis} from "@fortawesome/free-solid-svg-icons/faEllipsis";
import {DropdownMenuContent as $TBcmg$DropdownMenuContent, DropdownMenuItem as $TBcmg$DropdownMenuItem, Root as $TBcmg$Root5, Trigger as $TBcmg$Trigger4} from "@radix-ui/react-dropdown-menu";
import {faHand as $TBcmg$faHand} from "@fortawesome/free-solid-svg-icons/faHand";
import {mainnet as $TBcmg$mainnet, goerli as $TBcmg$goerli} from "wagmi/chains";
import {faMagnifyingGlass as $TBcmg$faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import {Root as $TBcmg$Root6, Viewport as $TBcmg$Viewport1, Scrollbar as $TBcmg$Scrollbar, Thumb as $TBcmg$Thumb, Corner as $TBcmg$Corner} from "@radix-ui/react-scroll-area";
import {faCircleCheck as $TBcmg$faCircleCheck} from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import {faEnvelopeOpen as $TBcmg$faEnvelopeOpen} from "@fortawesome/free-solid-svg-icons/faEnvelopeOpen";
import {faCircleNotch as $TBcmg$faCircleNotch} from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import {faGasPump as $TBcmg$faGasPump} from "@fortawesome/free-solid-svg-icons/faGasPump";
import {faChevronRight as $TBcmg$faChevronRight} from "@fortawesome/free-solid-svg-icons/faChevronRight";
import {faEye as $TBcmg$faEye} from "@fortawesome/free-solid-svg-icons/faEye";
import {faPlay as $TBcmg$faPlay} from "@fortawesome/free-solid-svg-icons/faPlay";
import {faPause as $TBcmg$faPause} from "@fortawesome/free-solid-svg-icons/faPause";
import {faRefresh as $TBcmg$faRefresh} from "@fortawesome/free-solid-svg-icons/faRefresh";
import {faShoppingCart as $TBcmg$faShoppingCart} from "@fortawesome/free-solid-svg-icons/faShoppingCart";
import {faArrowDown as $TBcmg$faArrowDown} from "@fortawesome/free-solid-svg-icons/faArrowDown";
import {faArrowUp as $TBcmg$faArrowUp} from "@fortawesome/free-solid-svg-icons/faArrowUp";
import {faCircleInfo as $TBcmg$faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import {faTriangleExclamation as $TBcmg$faTriangleExclamation} from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";

/// <reference path="./types/parcel.d.ts" />
//Providers



const $7e16985c42c068dc$export$8e8f484d816a71e3 = (overrides)=>{
    return {
        radii: {
            borderRadius: overrides?.borderRadius || "4px"
        },
        fonts: {
            body: overrides?.font || "sans-serif",
            button: overrides?.buttonFont || overrides?.font || "sans-serif",
            headline: overrides?.headlineFont || overrides?.font || "sans-serif"
        }
    };
};


function $1fa63d73b4d6b2f8$export$2e2bcd8739ae039(overrides) {
    let sharedTheme = (0, $7e16985c42c068dc$export$8e8f484d816a71e3)(overrides);
    return {
        colors: {
            ...(0, $TBcmg$redDark),
            ...(0, $TBcmg$indigoDark),
            ...(0, $TBcmg$indigoDarkA),
            ...(0, $TBcmg$slateDark),
            ...(0, $TBcmg$blackA),
            ...(0, $TBcmg$green),
            // accent colors
            accentBase: "$indigo1",
            accentBgSubtle: "$indigo2",
            accentBg: "$indigo3",
            accentBgHover: "$indigo4",
            accentBgActive: "$indigo5",
            accentLine: "$indigo6",
            accentBorder: "$indigo7",
            accentBorderHover: overrides?.primaryColor || "$indigo8",
            accentSolid: overrides?.primaryColor || "$indigo9",
            accentSolidHover: overrides?.primaryHoverColor || overrides?.primaryColor || "$indigo10",
            accentText: "$indigo11",
            accentTextContrast: "$indigo12",
            // neutral colors
            neutralBase: "$slate1",
            neutralBgSubtle: "$slate2",
            neutralBg: "$slate3",
            neutralBgHover: "$slate4",
            neutralBgActive: "$slate5",
            neutralLine: "$slate6",
            neutralBorder: "$slate7",
            neutralBorderHover: "$slate8",
            neutralSolid: "$slate9",
            neutralSolidHover: "$slate10",
            neutralText: "$slate11",
            neutralTextContrast: "$slate12",
            // secondary colors
            secondaryBase: "$indigoA1",
            secondaryBgSubtle: "$indigoA2",
            secondaryBg: "$indigoA3",
            secondaryBgHover: "$indigoA4",
            secondaryBgActive: "$indigoA5",
            secondaryLine: "$indigoA6",
            secondaryBorder: "$indigoA7",
            secondaryBorderHover: "$indigoA8",
            secondarySolid: "$indigoA9",
            secondarySolidHover: "$indigoA10",
            secondaryText: "$indigoA11",
            secondaryTextContrast: "$indigoA12",
            // general colors
            borderColor: overrides?.borderColor || "$neutralBorder",
            textColor: overrides?.textColor || "$neutralTextContrast",
            focusColor: "$neutralTextContrast",
            errorText: "$red12",
            errorAccent: "$red10",
            successAccent: "$green10",
            // component colors
            reservoirLogoColor: "#ECEDEE",
            inputBackground: "$neutralBgHover",
            buttonTextColor: overrides?.buttonTextColor || "white",
            buttonTextHoverColor: overrides?.buttonTextHoverColor || "white",
            overlayBackground: overrides?.overlayBackground || "$blackA10",
            headerBackground: overrides?.headerBackground || "$neutralBgHover",
            footerBackground: overrides?.footerBackground || "$neutralBg",
            contentBackground: overrides?.contentBackground || "$neutralBgSubtle",
            wellBackground: overrides?.wellBackground || "$neutralBase",
            popoverBackground: overrides?.popoverBackground || "$neutralBgActive"
        },
        assets: {
            ethIcon: overrides?.ethIcon || "purple",
            chainIcon: overrides?.chainIcon || "dark"
        },
        ...sharedTheme
    };
}




var $fe6ce5c2ceb86f27$exports = {};
$fe6ce5c2ceb86f27$exports = JSON.parse('{"name":"@reservoir0x/reservoir-kit-ui","description":"ReservoirKit is the official frontend kit to get you started building dApps with the ReservoirProtocol.","version":"2.7.47","author":"Reservoir Protocol","license":"MIT","exports":{".":{"import":"./dist/index.mjs","require":"./dist/index.js","types":"./dist/index.d.ts"}},"source":"./src/index.ts","main":"./dist/index.js","module":"./dist/index.mjs","types":"./dist/index.d.ts","files":["dist"],"keywords":["nft","reservoir","reservoirkit","protocol","sdk"],"sideEffects":false,"scripts":{"clean":"rm -rf dist"},"dependencies":{"@fortawesome/fontawesome-svg-core":"^6.1.1","@fortawesome/free-solid-svg-icons":"^6.1.1","@fortawesome/react-fontawesome":"^0.2.0","@radix-ui/colors":"^0.1.8","@radix-ui/react-collapsible":"1.0.3","@radix-ui/react-dialog":"1.0.4","@radix-ui/react-dropdown-menu":"2.0.5","@radix-ui/react-popover":"1.0.6","@radix-ui/react-scroll-area":"1.0.4","@radix-ui/react-select":"1.2.2","@radix-ui/react-switch":"1.0.3","@radix-ui/react-toggle-group":"1.0.4","@radix-ui/react-tooltip":"1.0.6","@react-hookz/web":"^19.2.0","@reservoir0x/reservoir-sdk":"workspace:*","@stitches/react":"1.3.1-1","dayjs":"^1.11.4","flatpickr":"^4.6.13","framer-motion":"^6.4.2","react-flatpickr":"^3.10.13","swr":"2.0.1"},"peerDependencies":{"@tanstack/react-query":"^5.45.1","react":"^18.0","react-dom":"^18.0","viem":"~2.17.4","wagmi":"~2.10.11"},"repository":{"type":"git","url":"https://github.com/reservoirprotocol/reservoir-kit"}}');


const $2deec6552e3d4fa0$export$61eba4f5b935df88 = /*#__PURE__*/ (0, $TBcmg$createContext)(null);
const $2deec6552e3d4fa0$export$9d733ffc7f61c45c = function({ children: children, options: options }) {
    const [clientContext, _] = (0, $TBcmg$useState)((0, $TBcmg$createClient)({
        ...options,
        uiVersion: (0, $fe6ce5c2ceb86f27$exports.version)
    }));
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($2deec6552e3d4fa0$export$61eba4f5b935df88.Provider, {
        value: clientContext
    }, children);
};





const { createTheme: $4a58f4053e821189$export$25d302a5b900a763, keyframes: $4a58f4053e821189$export$d25ddfdf17c3ad3e, styled: $4a58f4053e821189$export$3817b7a54a07cec7, globalCss: $4a58f4053e821189$export$db53682eef82cc11, getCssText: $4a58f4053e821189$export$681e449128971c74, theme: $4a58f4053e821189$export$bca14c5b3b88a9c9, config: $4a58f4053e821189$export$e506a1d27d1eaa20 } = (0, $TBcmg$createStitches)({
    theme: {
        space: {
            1: "4px",
            2: "8px",
            3: "12px",
            4: "16px",
            5: "32px",
            6: "64px"
        },
        fontSizes: {},
        fontWeights: {},
        fonts: {
            body: "sans-serif",
            button: "$body"
        },
        lineHeights: {},
        letterSpacings: {},
        sizes: {},
        radii: {
            borderRadius: 0
        },
        shadows: {},
        transitions: {}
    },
    utils: {
        // MARGIN
        m: (value)=>({
                margin: value
            }),
        mx: (value)=>({
                marginLeft: value,
                marginRight: value
            }),
        my: (value)=>({
                marginTop: value,
                marginBottom: value
            }),
        mt: (value)=>({
                marginTop: value
            }),
        mb: (value)=>({
                marginBottom: value
            }),
        ml: (value)=>({
                marginLeft: value
            }),
        mr: (value)=>({
                marginRight: value
            }),
        // PADDING
        p: (value)=>({
                padding: value
            }),
        px: (value)=>({
                paddingLeft: value,
                paddingRight: value
            }),
        py: (value)=>({
                paddingTop: value,
                paddingBottom: value
            }),
        pt: (value)=>({
                paddingTop: value
            }),
        pb: (value)=>({
                paddingBottom: value
            }),
        pl: (value)=>({
                paddingLeft: value
            }),
        pr: (value)=>({
                paddingRight: value
            }),
        // DIMENSIONS
        w: (value)=>({
                width: value
            }),
        h: (value)=>({
                height: value
            }),
        size: (value)=>({
                width: value,
                height: value
            })
    },
    media: {
        bp1: "(min-width: 600px)",
        bp2: "(min-width: 905px)",
        bp3: "(min-width: 1240px)",
        bp4: "(min-width: 1440px)",
        motion: "(prefers-reduced-motion)",
        hover: "(any-hover: hover)",
        dark: "(prefers-color-scheme: dark)",
        light: "(prefers-color-scheme: light)"
    },
    prefix: "rk"
});




const $36299c87cce4672d$export$a6f1ecf08e412113 = (apiKey, clientVersion)=>{
    const headers = {
        "x-rkui-version": (0, $fe6ce5c2ceb86f27$exports.version)
    };
    if (apiKey) headers["x-api-key"] = apiKey;
    if (clientVersion) headers["x-rkc-version"] = clientVersion;
    return headers;
};
const $36299c87cce4672d$export$77754e0ac9f8aba3 = (params)=>{
    let resource;
    let apiKey;
    let clientVersion;
    if (Array.isArray(params)) {
        resource = params[0];
        apiKey = params[1];
        clientVersion = params[2];
    } else resource = params;
    const headers = $36299c87cce4672d$export$a6f1ecf08e412113(apiKey, clientVersion);
    return (0, $TBcmg$axios)(resource, {
        headers: headers
    }).then((res)=>{
        if (res.headers?.["deprecation"] === "true") console.warn(`Warning: API ${res.config.url} is deprecated. Stability and performance may be affected.`);
        return res.data;
    }).catch((e)=>{
        throw e;
    });
};
const $36299c87cce4672d$var$CACHE_KEY = "reservoirkit.swr.cache";
const $36299c87cce4672d$var$CACHE_KEY_TTL = "reservoirkit.swr.cache-TTL";
const $36299c87cce4672d$export$aa821bfb3308a1f5 = ()=>{
    let map = new Map([]);
    let cacheTTL = {};
    try {
        map = typeof window !== "undefined" ? new Map(JSON.parse(localStorage.getItem($36299c87cce4672d$var$CACHE_KEY) || "[]")) : new Map([]);
        cacheTTL = typeof window !== "undefined" ? JSON.parse(localStorage.getItem($36299c87cce4672d$var$CACHE_KEY_TTL) || "{}") : {};
        for(let key in cacheTTL){
            const ttl = cacheTTL[key];
            const response = map.get(key);
            let purge = false;
            if (Date.now() >= ttl) purge = true;
            else if (response.value && response.data && response.data.some((data)=>!data)) purge = true;
            if (purge) {
                map.delete(key);
                delete cacheTTL[key];
            }
        }
    } catch (e) {
        console.warn("Failed to rehydrate SWR cache");
    }
    //Handlers to set TTL:
    const mapSet = map.set.bind(map);
    map.set = (key, value)=>{
        const url = key;
        const coingeckoCoinsApi = "/api/v3/coins/list";
        if (url.includes(coingeckoCoinsApi)) cacheTTL[url] = Date.now() + 7200000; //2hr
        else cacheTTL[url] = Date.now() + 300000; //5m
        return mapSet(key, value);
    };
    // Before unloading the app, we write back all the data into `localStorage`.
    if (typeof window !== "undefined") //Allowlist of all domains or urls we want to cache locally
    window.addEventListener("beforeunload", ()=>{
        const cachedApis = [
            "api.coingecko.com",
            "/api/v3/coins/list",
            "/api/v3/coins/markets",
            "/currencies/conversion/v"
        ];
        for (let url of map.keys())if (!cachedApis.some((cachedApi)=>url.includes(cachedApi))) map.delete(url);
        const appCache = JSON.stringify(Array.from(map.entries()));
        localStorage.setItem($36299c87cce4672d$var$CACHE_KEY_TTL, JSON.stringify(cacheTTL));
        localStorage.setItem($36299c87cce4672d$var$CACHE_KEY, appCache);
    });
    // We still use the map for write & read for performance.
    return map;
};
const $36299c87cce4672d$export$6f9d915eee0c027b = {
    fetcher: $36299c87cce4672d$export$77754e0ac9f8aba3,
    revalidateOnFocus: false,
    provider: $36299c87cce4672d$export$aa821bfb3308a1f5
};



const $dc47145da9e25ac7$var$fpFadeInDown = (0, $4a58f4053e821189$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0,
        transform: "translate3d(0, -20px, 0)"
    },
    "100%": {
        opacity: 1,
        transform: "translate3d(0, 0, 0)"
    }
});
const $dc47145da9e25ac7$var$calendarCss = (0, $4a58f4053e821189$export$db53682eef82cc11)({
    ".flatpickr-calendar": {
        opacity: 0,
        display: "none",
        textAlign: "center",
        visibility: "hidden",
        padding: 20,
        animation: "none",
        direction: "ltr",
        fontSize: 14,
        lineHeight: "24px",
        borderRadius: 5,
        position: "absolute",
        boxSizing: "border-box",
        touchAction: "manipulation",
        backgroundColor: "$contentBackground",
        boxShadow: "1px 0 0 #20222c, -1px 0 0 #20222c, 0 1px 0 #20222c, 0 -1px 0 #20222c, 0 3px 13px rgba(0,0,0,0.08)",
        border: "1px solid $borderColor",
        fontFamily: "$body"
    },
    ".flatpickr-calendar.open": {
        opacity: 1,
        maxHeight: 640,
        visibility: "visible",
        display: "inline-block",
        zIndex: 99999,
        pointerEvents: "all"
    },
    ".flatpickr-calendar.inline": {
        opacity: 1,
        maxHeight: 640,
        visibility: "visible",
        display: "block",
        position: "relative",
        top: 2
    },
    ".flatpickr-calendar.animate.open": {
        animation: `${$dc47145da9e25ac7$var$fpFadeInDown} 300ms cubic-bezier(0.23, 1, 0.32, 1)`
    },
    ".flatpickr-calendar.static": {
        position: "absolute",
        top: "calc(100% + 2px)"
    },
    ".flatpickr-calendar.static.open": {
        zIndex: 999,
        display: "block"
    },
    ".flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7)": {
        boxShadow: "none !important"
    },
    ".flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1)": {
        boxShadow: "-2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6"
    },
    ".flatpickr-calendar .hasWeeks .dayContainer": {
        borderBottom: 0,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeft: 0
    },
    ".flatpickr-calendar .hasTime .dayContainer": {
        borderBottom: 0,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
    },
    ".flatpickr-calendar.hasTime .flatpickr-time": {
        height: 40
    },
    ".flatpickr-calendar.noCalendar.hasTime .flatpickr-time": {
        height: "auto"
    },
    ".flatpickr-calendar:before": {
        position: "absolute",
        display: "block",
        pointerEvents: "none",
        border: "solid transparent",
        content: "",
        height: 0,
        width: 0,
        left: 22,
        borderWidth: 5,
        margin: "0 -5px"
    },
    ".flatpickr-calendar:after": {
        position: "absolute",
        display: "block",
        pointerEvents: "none",
        border: "solid transparent",
        content: "",
        height: 0,
        width: 0,
        left: 22,
        borderWidth: 4,
        margin: "0 -4px"
    },
    ".flatpickr-calendar.rightMost:before, .flatpickr-calendar.arrowRight:before, .flatpickr-calendar.rightMost:after, .flatpickr-calendar.arrowRight:after": {
        left: "auto",
        right: 22
    },
    ".flatpickr-calendar.arrowCenter:before, .flatpickr-calendar.arrowCenter:after": {
        left: "50%",
        right: "50%"
    },
    ".flatpickr-calendar.arrowTop:before, .flatpickr-calendar.arrowTop:after": {
        bottom: "100%"
    },
    ".flatpickr-calendar.arrowTop:before": {
        display: "none"
    },
    ".flatpickr-calendar.arrowTop:after": {
        display: "none"
    },
    ".flatpickr-calendar.arrowBottom:before, .flatpickr-calendar.arrowBottom:after": {
        top: "100%"
    },
    ".flatpickr-calendar.arrowBottom:before": {
        display: "none"
    },
    ".flatpickr-calendar.arrowBottom:after": {
        display: "none"
    },
    ".flatpickr-calendar:focus": {
        outline: 0
    },
    ".flatpickr-wrapper": {
        position: "relative",
        display: "inline-block"
    },
    ".flatpickr-months": {
        display: "flex"
    },
    ".flatpickr-months .flatpickr-month": {
        backgroundColor: "$contentBackground",
        color: "$neutralTextContrast",
        fill: "$neutralTextContrast",
        height: 34,
        lineHeight: "1px",
        textAlign: "center",
        position: "relative",
        userSelect: "none",
        overflow: "hidden",
        flex: 1,
        marginBottom: 8
    },
    ".flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month": {
        userSelect: "none",
        textDecoration: "none",
        cursor: "pointer",
        position: "absolute",
        top: 20,
        height: 34,
        padding: 10,
        zIndex: 3,
        color: "$neutralText",
        fill: "$neutralText"
    },
    ".flatpickr-months .flatpickr-prev-month.flatpickr-disabled, .flatpickr-months .flatpickr-next-month.flatpickr-disabled": {
        display: "none"
    },
    ".flatpickr-months .flatpickr-prev-month i, .flatpickr-months .flatpickr-next-month i": {
        position: "relative"
    },
    ".flatpickr-months .flatpickr-prev-month.flatpickr-prev-month, .flatpickr-months .flatpickr-next-month.flatpickr-prev-month": {
        left: 0
    },
    ".flatpickr-months .flatpickr-prev-month.flatpickr-next-month, .flatpickr-months .flatpickr-next-month.flatpickr-next-month": {
        right: 0
    },
    ".flatpickr-months .flatpickr-prev-month:hover, .flatpickr-months .flatpickr-next-month:hover": {
        color: "$neutralText"
    },
    ".flatpickr-months .flatpickr-prev-month:hover svg, .flatpickr-months .flatpickr-next-month:hover svg": {
        fill: "$neutralTextContrast"
    },
    ".flatpickr-months .flatpickr-prev-month svg, .flatpickr-months .flatpickr-next-month svg": {
        width: 14,
        height: 14
    },
    ".flatpickr-months .flatpickr-prev-month svg path, .flatpickr-months .flatpickr-next-month svg path": {
        transition: "fill 0.1s",
        fill: "inherit"
    },
    ".numInputWrapper": {
        position: "relative",
        height: "auto"
    },
    ".numInputWrapper input, .numInputWrapper span": {
        display: "inline-block"
    },
    ".numInputWrapper input": {
        width: "100%"
    },
    ".numInputWrapper input::-ms-clear": {
        display: "none"
    },
    ".numInputWrapper input::-webkit-outer-spin-button, .numInputWrapper input::-webkit-inner-spin-button": {
        margin: 0,
        "-webkit-appearance": "none"
    },
    ".numInputWrapper span": {
        position: "absolute",
        right: 0,
        width: 14,
        padding: "0 4px 0 2px",
        height: "50%",
        lineHeight: "50%",
        opacity: 0,
        cursor: "pointer",
        boxSizing: "border-box"
    },
    ".numInputWrapper span:hover": {
        background: "$neutralBgHover"
    },
    ".numInputWrapper span:active": {
        background: "$neutralBgActive"
    },
    ".numInputWrapper span:after": {
        display: "block",
        content: "",
        position: "absolute"
    },
    ".numInputWrapper span.arrowUp": {
        top: 0,
        borderBottom: 0
    },
    ".numInputWrapper span.arrowUp:after": {
        borderLeft: "4px solid transparent",
        borderRight: "4px solid transparent",
        borderBottom: "4px solid $neutralText",
        top: "26%"
    },
    ".numInputWrapper span.arrowDown": {
        top: "50%"
    },
    ".numInputWrapper span.arrowDown:after": {
        borderLeft: "4px solid transparent",
        borderRight: "4px solid transparent",
        borderTop: "4px solid $neutralText",
        top: "40%"
    },
    ".numInputWrapper span svg": {
        width: "inherit",
        height: "auto"
    },
    ".numInputWrapper span svg path": {
        fill: "$neutralBgHover"
    },
    ".numInputWrapper:hover": {
        background: "$neutralBgHover"
    },
    ".numInputWrapper:hover span": {
        opacity: 1
    },
    ".flatpickr-current-month": {
        fontSize: "135%",
        fontWeight: 300,
        color: "$neutralText",
        position: "absolute",
        width: "83%",
        left: "12.5%",
        lineHeight: "1px",
        height: 34,
        display: "flex",
        alignItems: "center",
        gap: 12,
        textAlign: "center",
        transform: "translate3d(0px, 0px, 0px)"
    },
    ".flatpickr-current-month span.cur-month": {
        fontFamily: "inherit",
        fontWeight: 700,
        color: "$neutralText",
        display: "inline-block",
        marginLeft: "0.5ch",
        padding: 0
    },
    ".flatpickr-current-month span.cur-month:hover": {
        background: "rgba(192,187,167,0.05)"
    },
    ".flatpickr-current-month .numInputWrapper": {
        width: "7ch\x00",
        display: "inline-block"
    },
    ".flatpickr-current-month .numInputWrapper span.arrowUp:after": {
        borderBottomColor: "$neutralText"
    },
    ".flatpickr-current-month .numInputWrapper span.arrowDown:after": {
        borderTopColor: "$neutralText"
    },
    ".flatpickr-current-month input.cur-year": {
        backgroundColor: "transparent",
        boxSizing: "border-box",
        color: "$neutralText",
        cursor: "text",
        margin: 0,
        display: "inline-block",
        fontSize: "inherit",
        fontFamily: "inherit",
        lineHeight: "inherit",
        height: "auto",
        border: 0,
        borderRadius: 0,
        verticalAlign: "initial",
        appearance: "textfield",
        padding: "4px 0px"
    },
    ".flatpickr-current-month input.cur-year:focus": {
        outline: 0
    },
    ".flatpickr-current-month input.cur-year[disabled], .flatpickr-current-month input.cur-year[disabled]:hover": {
        fontSize: "100%",
        color: "$neutralText",
        background: "transparent",
        pointerEvents: "none"
    },
    ".flatpickr-current-month .flatpickr-monthDropdown-months": {
        appearance: "menulist",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: 0,
        boxSizing: "border-box",
        color: "$neutralText",
        cursor: "pointer",
        fontSize: "inherit",
        fontFamily: "inherit",
        height: "auto",
        lineHeight: "inherit",
        outline: "none",
        position: "relative",
        verticalAlign: "initial",
        width: "auto",
        padding: "4px 8px"
    },
    ".flatpickr-current-month .flatpickr-monthDropdown-months:focus, .flatpickr-current-month .flatpickr-monthDropdown-months:active": {
        outline: "none"
    },
    ".flatpickr-current-month .flatpickr-monthDropdown-months:hover": {
        backgroundColor: "$neutralBgHover"
    },
    ".flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month": {
        backgroundColor: "$neutralBg",
        outline: "none",
        padding: 0
    },
    ".flatpickr-weekdays": {
        backgroundColor: "transparent",
        color: "$neutralText",
        textAlign: "center",
        overflow: "hidden",
        width: "100%",
        display: "flex",
        alignItems: "center",
        height: 28,
        border: "transparent",
        marginBottom: 8
    },
    ".flatpickr-weekdays .flatpickr-weekdaycontainer": {
        display: "flex",
        flex: 1
    },
    "span.flatpickr-weekday": {
        cursor: "default",
        fontSize: "90%",
        background: "transparent",
        color: "$neutralText",
        lineHeight: "1px",
        margin: 0,
        textAlign: "center",
        display: "block",
        flex: 1,
        fontWeight: "bolder"
    },
    ".dayContainer, .flatpickr-weeks": {
        padding: "1px 0 0 0"
    },
    ".flatpickr-days": {
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "flex-start",
        width: 307.875,
        marginBottom: 12
    },
    ".flatpickr-days:focus": {
        outline: 0
    },
    ".dayContainer": {
        padding: 0,
        outline: 0,
        textAlign: "left",
        width: 307.875,
        minWidth: 307.875,
        maxWidth: 307.875,
        boxSizing: "border-box",
        display: "flex",
        flexWrap: "wrap",
        "-ms-flex-pack": "justify",
        justifyContent: "space-around",
        transform: "translate3d(0px, 0px, 0px)",
        opacity: 1
    },
    ".dayContainer + .dayContainer": {
        boxShadow: "-1px 0 0 #20222c"
    },
    ".flatpickr-day": {
        background: "none",
        border: "1px solid transparent",
        borderRadius: 150,
        boxSizing: "border-box",
        color: "$neutralText",
        cursor: "pointer",
        fontWeight: 400,
        width: "14.2857143%",
        flexBasis: "14.2857143%",
        maxWidth: 39,
        height: 39,
        lineHeight: "39px",
        margin: 0,
        display: "inline-block",
        position: "relative",
        "-webkit-box-pack": "center",
        "-ms-flex-pack": "center",
        justifyContent: "center",
        textAlign: "center"
    },
    ".flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus": {
        cursor: "pointer",
        outline: 0,
        backgroundColor: "$accentBg",
        borderColor: "$neutralBorder"
    },
    ".flatpickr-day.today": {
        borderColor: "$neutralBorder"
    },
    ".flatpickr-day.today:hover, .flatpickr-day.today:focus": {
        borderColor: "$neutralBorder",
        backgroundColor: "$neutralBg",
        color: "$buttonTextColor"
    },
    ".flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay": {
        backgroundColor: "$accentBg",
        boxShadow: "none",
        color: "$neutralTextContrast",
        borderColor: "$borderColor"
    },
    ".flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange": {
        borderRadius: "50px 0 0 50px"
    },
    ".flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange": {
        borderRadius: "0 50px 50px 0"
    },
    ".flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1))": {
        boxShadow: "-10px 0 0 #80cbc4"
    },
    ".flatpickr-day.selected.startRange.endRange, .flatpickr-day.startRange.startRange.endRange, .flatpickr-day.endRange.startRange.endRange": {
        borderRadius: 50
    },
    ".flatpickr-day.inRange": {
        borderRadius: 0,
        boxShadow: "-5px 0 0 #646c8c, 5px 0 0 #646c8c"
    },
    ".flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay": {
        color: "$neutralText",
        background: "transparent",
        borderColor: "transparent",
        cursor: "default"
    },
    ".flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover": {
        cursor: "not-allowed",
        color: "$neutralText",
        opacity: 0.5
    },
    ".flatpickr-day.week.selected": {
        borderRadius: 0,
        boxShadow: "-5px 0 0 #80cbc4, 5px 0 0 #80cbc4"
    },
    ".flatpickr-day.hidden": {
        visibility: "hidden"
    },
    ".rangeMode .flatpickr-day": {
        marginTop: 1
    },
    ".flatpickr-weekwrapper": {
        float: "left"
    },
    ".flatpickr-weekwrapper .flatpickr-weeks": {
        padding: "0 12px",
        boxShadow: "1px 0 0 #20222c"
    },
    ".flatpickr-weekwrapper .flatpickr-weekday": {
        float: "none",
        width: "100%",
        lineHeight: "28px"
    },
    ".flatpickr-weekwrapper span.flatpickr-day, .flatpickr-weekwrapper span.flatpickr-day:hover": {
        display: "block",
        width: "100%",
        maxWidth: "none",
        color: "$neutralText",
        background: "transparent",
        cursor: "default",
        border: "none"
    },
    ".flatpickr-innerContainer": {
        display: "flex",
        boxSizing: "border-box",
        overflow: "hidden"
    },
    ".flatpickr-rContainer": {
        display: "inline-block",
        padding: 0,
        boxSizing: "border-box"
    },
    ".flatpickr-time": {
        textAlign: "center",
        outline: 0,
        height: 0,
        lineHeight: "40px",
        maxHeight: 40,
        boxSizing: "border-box",
        overflow: "hidden",
        display: "flex"
    },
    ".flatpickr-time:after": {
        content: "",
        display: "table",
        clear: "both"
    },
    ".flatpickr-time .numInputWrapper": {
        flex: 1,
        width: "40%",
        height: 40,
        float: "left"
    },
    ".flatpickr-time .numInputWrapper span.arrowUp:after": {
        borderBottomColor: "$neutralText"
    },
    ".flatpickr-time .numInputWrapper span.arrowDown:after": {
        borderTopColor: "$neutralText"
    },
    ".flatpickr-time.hasSeconds .numInputWrapper": {
        width: "26%"
    },
    ".flatpickr-time.time24hr .numInputWrapper": {
        width: "49%"
    },
    ".flatpickr-time input": {
        background: "transparent",
        boxShadow: "none",
        border: 0,
        borderRadius: 0,
        textAlign: "center",
        margin: 0,
        padding: 0,
        height: "inherit",
        lineHeight: "inherit",
        color: "$neutralText",
        fontSize: 14,
        position: "relative",
        boxSizing: "border-box",
        appearance: "textfield"
    },
    ".flatpickr-time input.flatpickr-hour": {},
    ".flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second": {
        fontWeight: 400
    },
    ".flatpickr-time input:focus": {
        outline: 0,
        border: 0
    },
    ".flatpickr-time .flatpickr-time-separator, .flatpickr-time .flatpickr-am-pm": {
        height: "inherit",
        float: "left",
        lineHeight: "inherit",
        color: "$neutralText",
        fontWeight: "bold",
        width: "2%",
        userSelect: "none",
        "-ms-flex-item-align": "center",
        alignSelf: "center"
    },
    ".flatpickr-time .flatpickr-am-pm": {
        outline: 0,
        width: "18%",
        cursor: "pointer",
        textAlign: "center",
        fontWeight: 400
    },
    ".flatpickr-time input:hover, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:focus": {
        background: "$neutralBgHover"
    },
    ".flatpickr-input[readonly]": {
        cursor: "pointer"
    },
    ".flatpickr-input.flatpickr-mobile": {
        "&::-webkit-inner-spin-button": {
            display: "none",
            "-webkit-appearance": "none"
        },
        "&::-webkit-calendar-picker-indicator": {
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "none"
        },
        "&::-webkit-datetime-edit": {
            display: "none",
            "-webkit-appearance": "none"
        },
        "&::-webkit-date-and-time-value": {
            display: "none",
            "-webkit-appearance": "none"
        }
    },
    "@-moz-document url-prefix()": {
        "@media only screen and (max-width: 600px)": {
            '.flatpickr-input[type="text"]': {
                color: "transparent"
            }
        }
    }
});
var $dc47145da9e25ac7$export$2e2bcd8739ae039 = $dc47145da9e25ac7$var$calendarCss;



const $3fd7a7c58aadc6ae$var$useMutationObservable = (callback, el, options)=>{
    const [observer, setObserver] = (0, $TBcmg$useState)(null);
    (0, $TBcmg$useEffect)(()=>{
        if (observer) observer.disconnect();
        if (!el || typeof window === "undefined" || !("MutationObserver" in window)) return;
        const obs = new MutationObserver(callback);
        obs.observe(el, options);
        setObserver(obs);
        return ()=>{
            obs.disconnect();
        };
    }, [
        el,
        callback,
        options
    ]);
    return observer;
};
var $3fd7a7c58aadc6ae$export$2e2bcd8739ae039 = $3fd7a7c58aadc6ae$var$useMutationObservable;


const $f4609ce2cb6b416b$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $TBcmg$createContext)(undefined);
const $f4609ce2cb6b416b$export$f66a1c3c9465af21 = /*#__PURE__*/ (0, $TBcmg$createContext)({});
const $f4609ce2cb6b416b$var$defaultOptions = {
    chains: [
        {
            ...(0, $TBcmg$reservoirChains).mainnet,
            active: true
        }
    ]
};
const $f4609ce2cb6b416b$var$classNameObserverOptions = {
    attributeFilter: [
        "class"
    ]
};
const $f4609ce2cb6b416b$export$14ec072536e53e19 = function({ children: children, options: options = $f4609ce2cb6b416b$var$defaultOptions, theme: theme, swrOptions: swrOptions = {} }) {
    const [globalTheme, setGlobalTheme] = (0, $TBcmg$useState)();
    const [providerOptions, setProviderOptions] = (0, $TBcmg$useState)({});
    const currentTheme = (0, $TBcmg$useRef)(null);
    const classNameCallback = (0, $TBcmg$useCallback)((mutationList)=>{
        mutationList.forEach((mutation)=>{
            const body = mutation.target;
            if (mutation.attributeName === "class" && body && !body.className.includes(currentTheme.current)) document.body.classList.add(currentTheme.current);
        });
    }, [
        currentTheme
    ]);
    (0, $3fd7a7c58aadc6ae$export$2e2bcd8739ae039)(classNameCallback, typeof window !== "undefined" ? document.body : null, $f4609ce2cb6b416b$var$classNameObserverOptions);
    (0, $dc47145da9e25ac7$export$2e2bcd8739ae039)();
    (0, $TBcmg$useEffect)(()=>{
        let newTheme = (0, $4a58f4053e821189$export$25d302a5b900a763)(theme ? theme : (0, $1fa63d73b4d6b2f8$export$2e2bcd8739ae039)());
        let oldTheme = currentTheme.current;
        currentTheme.current = newTheme;
        document.body.classList.add(newTheme);
        if (oldTheme) document.body.classList.remove(oldTheme);
        setGlobalTheme(newTheme);
    }, [
        JSON.stringify(theme)
    ]);
    (0, $TBcmg$useEffect)(()=>{
        setProviderOptions(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($f4609ce2cb6b416b$export$2c657da244d00bd6.Provider, {
        value: globalTheme
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Provider, null, /*#__PURE__*/ (0, $TBcmg$react).createElement($f4609ce2cb6b416b$export$f66a1c3c9465af21.Provider, {
        value: providerOptions
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2deec6552e3d4fa0$export$9d733ffc7f61c45c), {
        options: options
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$SWRConfig), {
        value: {
            ...(0, $36299c87cce4672d$export$6f9d915eee0c027b),
            ...swrOptions
        }
    }, children)))));
};






function $3663d60eaf20fbf3$export$2e2bcd8739ae039() {
    return (0, $TBcmg$useContext)((0, $2deec6552e3d4fa0$export$61eba4f5b935df88));
}


function $7c7b75a236ce465b$export$2e2bcd8739ae039(collection, chainId, swrOptions = {}) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const pathname = `${chain?.baseApiUrl}/collections/${collection}/attributes/all/v4`;
    const path = collection ? new URL(pathname) : null;
    const { data: data, mutate: mutate, error: error, isValidating: isValidating } = (0, $TBcmg$swr)(path ? [
        path.href,
        client?.apiKey,
        client?.version
    ] : null, null, {
        revalidateOnMount: true,
        ...swrOptions
    });
    const collections = data && data.attributes ? data.attributes : null;
    return {
        response: data,
        data: collections,
        mutate: mutate,
        error: error,
        isValidating: isValidating
    };
}





function $5e2a1f52f4fac2ad$export$2e2bcd8739ae039(getKey, options, limit) {
    const { mutate: globalMutate } = (0, $TBcmg$useSWRConfig)();
    const [keys, setKeys] = (0, $TBcmg$useState)([]);
    const response = (0, $TBcmg$swrinfinite)((pageIndex, previousPageData)=>{
        const params = getKey(pageIndex, previousPageData);
        const key = params && params[0] ? params[0] : null;
        if (key && !keys.includes(key)) setKeys([
            ...keys,
            key
        ]);
        return params;
    }, null, options);
    const { size: size, error: error, setSize: setSize, mutate: mutate } = response;
    const data = response.data;
    let hasNextPage;
    if (limit !== undefined) hasNextPage = size === 0 || Boolean(data?.[size - 1]?.collections?.length === limit);
    else hasNextPage = size === 0 || Boolean(data?.[size - 1]?.continuation);
    const isFetchingInitialData = !data && !error && size > 0;
    const isFetchingPage = size > 0 && (isFetchingInitialData || data && typeof data[size - 1] === "undefined");
    const fetchNextPage = ()=>{
        if (!isFetchingPage && hasNextPage) setSize((size)=>size + 1);
    };
    const resetCache = ()=>{
        setSize(0);
        return mutate(undefined, {
            revalidate: false
        }).then(()=>{
            globalMutate((key)=>{
                const url = key && key[0] ? key[0] : null;
                if (url) return keys.includes(url);
                return false;
            }, undefined, false).then(()=>{
                setKeys([]);
            });
        });
    };
    return {
        ...response,
        hasNextPage: hasNextPage,
        isFetchingInitialData: isFetchingInitialData,
        isFetchingPage: isFetchingPage,
        resetCache: resetCache,
        fetchNextPage: fetchNextPage
    };
}



function $e5a3042549429464$export$2e2bcd8739ae039(options, swrOptions = {}, enabled = true, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!enabled) return null;
        const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
        const url = new URL(`${chain?.baseApiUrl || ""}/orders/bids/v6`);
        let query = options || {};
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client?.normalizeRoyalties;
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const bids = (0, $TBcmg$useMemo)(()=>response.data?.flatMap((page)=>page.orders || []) ?? [], [
        response.data
    ]);
    return {
        ...response,
        data: bids
    };
}




function $392877f7a5a0835e$export$2e2bcd8739ae039(chainId, from, to) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const path = new URL(`${chain?.baseApiUrl}/currencies/conversion/v1?from=${from}&to=${to}`);
    return (0, $TBcmg$swrimmutable)(from && to ? [
        path.href,
        client?.apiKey,
        client?.version
    ] : null, null, {
        refreshInterval: 300000
    });
}





var $57dcd81a309fc6e2$export$2e2bcd8739ae039 = (chainId)=>{
    const client = (0, $TBcmg$getClient)();
    const reservoirChain = chainId ? client.chains.find((chain)=>chain.id === chainId) : client.currentChain();
    const chains = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    });
    let chain = chains.find((chain)=>reservoirChain?.id === chain.id);
    if (!chain && chains.length > 0) chain = chains[0];
    const ETHChains = [
        $TBcmg$viemchains.mainnet.id,
        $TBcmg$viemchains.goerli.id
    ];
    if (!chain || !chain.nativeCurrency || ETHChains.includes(chain.id)) return {
        name: "Ethereum",
        symbol: "ETH",
        decimals: 18,
        address: (0, $TBcmg$zeroAddress),
        chainId: chain?.id || $TBcmg$viemchains.mainnet.id
    };
    else if (chain.id === $TBcmg$viemchains.skaleNebula.id) return {
        name: "Europa ETH",
        symbol: "ETH",
        decimals: 18,
        address: "0xab01bad2c86e24d371a13ed6367bdca819589c5d",
        chainId: 1482601649
    };
    else return {
        ...chain.nativeCurrency,
        address: (0, $TBcmg$zeroAddress),
        chainId: chain.id
    };
};








var $ad5b3085b935ed8c$export$de7bcda3c490bf18;
(function(CheckoutStatus) {
    CheckoutStatus[CheckoutStatus["Idle"] = 0] = "Idle";
    CheckoutStatus[CheckoutStatus["Approving"] = 1] = "Approving";
    CheckoutStatus[CheckoutStatus["Finalizing"] = 2] = "Finalizing";
    CheckoutStatus[CheckoutStatus["Complete"] = 3] = "Complete";
})($ad5b3085b935ed8c$export$de7bcda3c490bf18 || ($ad5b3085b935ed8c$export$de7bcda3c490bf18 = {}));
var $ad5b3085b935ed8c$export$6adf53dcf2d42374;
(function(CheckoutTransactionError) {
    CheckoutTransactionError[CheckoutTransactionError["Unknown"] = 0] = "Unknown";
    CheckoutTransactionError[CheckoutTransactionError["PiceMismatch"] = 1] = "PiceMismatch";
    CheckoutTransactionError[CheckoutTransactionError["InsufficientBalance"] = 2] = "InsufficientBalance";
    CheckoutTransactionError[CheckoutTransactionError["UserDenied"] = 3] = "UserDenied";
})($ad5b3085b935ed8c$export$6adf53dcf2d42374 || ($ad5b3085b935ed8c$export$6adf53dcf2d42374 = {}));
const $ad5b3085b935ed8c$var$CartStorageKey = `reservoirkit.cart.${(0, $fe6ce5c2ceb86f27$exports.version)}`;
function $ad5b3085b935ed8c$var$cartStore({ feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, persist: persist = true, walletClient: walletClient }) {
    const { address: address } = (0, $TBcmg$useAccount)();
    const chains = (0, $TBcmg$useChains)();
    const config = (0, $TBcmg$useConfig)();
    const { switchChainAsync: switchChainAsync } = (0, $TBcmg$useSwitchChain)();
    const [cartCurrency, setCartCurrency] = (0, $TBcmg$useState)();
    const [cartChain, setCartChain] = (0, $TBcmg$useState)();
    const cartData = (0, $TBcmg$useRef)({
        totalPrice: 0,
        feesOnTopBps: undefined,
        feesOnTopUsd: undefined,
        items: [],
        pools: {},
        isValidating: false,
        transaction: null
    });
    const subscribers = (0, $TBcmg$useRef)(new Set());
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const { data: usdFeeConversion } = (0, $392877f7a5a0835e$export$2e2bcd8739ae039)(cartChain?.id, cartCurrency?.contract, "usd");
    const usdPrice = Number(usdFeeConversion?.usd || 0);
    (0, $TBcmg$useEffect)(()=>{
        subscribe(()=>{
            setCartCurrency(cartData.current.currency);
            setCartChain(cartData.current.chain);
        });
        if (persist && typeof window !== "undefined" && window.localStorage) {
            const storedCart = window.localStorage.getItem($ad5b3085b935ed8c$var$CartStorageKey);
            if (storedCart) {
                const rehydratedCart = JSON.parse(storedCart);
                const currency = getCartCurrency(rehydratedCart.items, rehydratedCart.chain?.id || 1);
                const pools = calculatePools(rehydratedCart.items);
                const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(rehydratedCart.items, currency, cartData.current.feesOnTopBps, cartData.current.feesOnTopUsd, usdPrice);
                cartData.current = {
                    ...cartData.current,
                    chain: rehydratedCart.items.length > 0 ? rehydratedCart.chain : undefined,
                    items: rehydratedCart.items,
                    pools: pools,
                    totalPrice: totalPrice,
                    feeOnTop: feeOnTop,
                    currency: currency
                };
                subscribers.current.forEach((callback)=>callback());
                validate();
            }
        }
    }, []);
    (0, $TBcmg$useEffect)(()=>{
        const currency = getCartCurrency(cartData.current.items, cartData.current.chain?.id || 1);
        const pools = calculatePools(cartData.current.items);
        const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(cartData.current.items, currency, feesOnTopBps, feesOnTopUsd, usdPrice);
        cartData.current = {
            ...cartData.current,
            pools: pools,
            totalPrice: totalPrice,
            feesOnTopBps: feesOnTopBps,
            feesOnTopUsd: feesOnTopUsd,
            feeOnTop: feeOnTop,
            currency: currency
        };
        commit();
    }, [
        feesOnTopBps,
        feesOnTopUsd,
        usdPrice
    ]);
    const get = (0, $TBcmg$useCallback)(()=>cartData.current, []);
    const set = (0, $TBcmg$useCallback)((value)=>{
        cartData.current = {
            ...cartData.current,
            ...value
        };
        commit();
    }, []);
    const subscribe = (0, $TBcmg$useCallback)((callback)=>{
        subscribers.current.add(callback);
        return ()=>subscribers.current.delete(callback);
    }, []);
    const commit = (0, $TBcmg$useCallback)(()=>{
        subscribers.current.forEach((callback)=>callback());
        if (persist && typeof window !== "undefined" && window.localStorage) window.localStorage.setItem($ad5b3085b935ed8c$var$CartStorageKey, JSON.stringify(cartData.current));
    }, [
        persist
    ]);
    const calculatePools = (0, $TBcmg$useCallback)((items)=>{
        const pools = {};
        items.forEach((item)=>{
            if (item.poolId) {
                if (!pools[item.poolId] && item.poolPrices) {
                    pools[item.poolId] = {
                        prices: item.poolPrices,
                        itemCount: 1
                    };
                    item.price = item.poolPrices[0];
                } else if (item.poolPrices) {
                    item.price = item.poolPrices[pools[item.poolId].itemCount];
                    pools[item.poolId].itemCount += 1;
                }
            }
        });
        return pools;
    }, []);
    const calculatePricing = (0, $TBcmg$useCallback)((items, currency, feesOnTopBps, feesOnTopUsd, usdPrice)=>{
        let feeOnTop = 0;
        let subtotal = items.reduce((total, { price: price, order: order })=>{
            let amount = price?.amount?.decimal;
            if (price?.currency?.contract !== currency?.contract) amount = price?.amount?.native;
            if (amount && order?.quantity) amount = amount * order?.quantity;
            return total += amount || 0;
        }, 0);
        if (feesOnTopBps) feeOnTop = feesOnTopBps.reduce((total, feeOnTopBps)=>{
            const [_, feeBps] = feeOnTopBps.split(":");
            total += Number(feeBps || 0) / 10000 * subtotal;
            return total;
        }, 0);
        else if (feesOnTopUsd && usdPrice && currency && currency?.decimals) feeOnTop = feesOnTopUsd.reduce((totalFees, feeOnTop)=>{
            const [_, fee] = feeOnTop.split(":");
            const atomicUsdPrice = (0, $TBcmg$parseUnits)(`${usdPrice}`, 6);
            const atomicFee = BigInt(fee);
            const convertedAtomicFee = atomicFee * BigInt(10 ** (currency?.decimals || 18));
            const currencyFee = convertedAtomicFee / atomicUsdPrice;
            const parsedFee = (0, $TBcmg$formatUnits)(currencyFee, currency.decimals || 18);
            return totalFees + Number(parsedFee);
        }, 0);
        subtotal = subtotal + feeOnTop;
        return {
            totalPrice: subtotal,
            feeOnTop: feeOnTop
        };
    }, []);
    const getCartCurrency = (0, $TBcmg$useCallback)((items, chainId)=>{
        let currencies = new Set();
        let currenciesData = {};
        for(let i = 0; i < items.length; i++){
            const currency = items[i].price?.currency;
            if (currency?.contract) {
                currencies.add(currency.contract);
                currenciesData[currency.contract] = currency;
            }
            if (currencies.size > 1) break;
        }
        if (currencies.size > 1) {
            const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(chainId);
            return {
                ...chainCurrency,
                contract: chainCurrency.address
            };
        } else if (currencies.size > 0) return Object.values(currenciesData)[0];
    }, [
        chains
    ]);
    const fetchTokens = (0, $TBcmg$useCallback)(async (tokenIds, chainId)=>{
        if (!tokenIds || tokenIds.length === 0) return {
            tokens: []
        };
        const reservoirChain = client?.chains.find((chain)=>chain.id === chainId);
        const url = new URL(`${reservoirChain?.baseApiUrl}/tokens/v7`);
        const query = {
            tokens: tokenIds,
            limit: 100,
            includeDynamicPricing: true
        };
        if (client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client?.normalizeRoyalties;
        (0, $TBcmg$setParams)(url, query);
        const params = [
            url.href
        ];
        if (client?.apiKey) params.push(client.apiKey);
        if (client?.version) params.push(client.version);
        const response = await (0, $36299c87cce4672d$export$77754e0ac9f8aba3)(params);
        return {
            tokens: response.tokens
        };
    }, [
        client
    ]);
    const fetchOrders = (0, $TBcmg$useCallback)(async (orderIds, chainId)=>{
        if (!orderIds || orderIds.length === 0) return {
            orders: []
        };
        const reservoirChain = client?.chains.find((chain)=>chain.id === chainId);
        const url = new URL(`${reservoirChain?.baseApiUrl}/orders/asks/v5`);
        const query = {
            ids: orderIds,
            limit: 1000,
            includeCriteriaMetadata: true
        };
        if (client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client?.normalizeRoyalties;
        (0, $TBcmg$setParams)(url, query);
        const params = [
            url.href
        ];
        if (client?.apiKey) params.push(client.apiKey);
        if (client?.version) params.push(client.version);
        const response = await (0, $36299c87cce4672d$export$77754e0ac9f8aba3)(params);
        return {
            orders: response.orders
        };
    }, [
        client
    ]);
    const convertTokenToItem = (0, $TBcmg$useCallback)((tokenData)=>{
        const token = tokenData.token;
        const market = tokenData.market;
        if (!token?.tokenId || !token.collection?.id) return;
        const dynamicPricing = market?.floorAsk?.dynamicPricing;
        let order = undefined;
        if (token.kind === "erc1155" && market?.floorAsk) order = {
            id: market?.floorAsk?.id || "",
            quantityRemaining: market?.floorAsk?.quantityRemaining || 1,
            quantity: 1,
            maker: market?.floorAsk?.maker || ""
        };
        return {
            token: {
                id: token.tokenId,
                name: token.name || ""
            },
            collection: {
                id: token.collection.id,
                name: token.collection.name || ""
            },
            order: order,
            price: dynamicPricing?.kind === "pool" ? undefined : market?.floorAsk?.price,
            poolId: dynamicPricing?.kind === "pool" ? dynamicPricing.data?.pool : undefined,
            poolPrices: dynamicPricing?.kind === "pool" ? dynamicPricing.data?.prices : undefined
        };
    }, []);
    const convertOrderToItem = (0, $TBcmg$useCallback)((orderData)=>{
        let criteria = orderData.criteria?.data;
        if (!criteria?.token?.tokenId || !criteria.collection?.id) return;
        return {
            token: {
                id: criteria.token.tokenId,
                name: criteria.token.name || ""
            },
            collection: {
                id: criteria.collection.id,
                name: criteria.collection.name || ""
            },
            order: {
                id: orderData.id,
                quantityRemaining: orderData.quantityRemaining || 1,
                quantity: 1,
                maker: orderData.maker
            },
            price: orderData.price,
            poolId: undefined,
            poolPrices: undefined
        };
    }, []);
    const clear = (0, $TBcmg$useCallback)(()=>{
        cartData.current = {
            ...cartData.current,
            items: [],
            pools: {},
            totalPrice: 0,
            feeOnTop: 0,
            chain: undefined
        };
        commit();
    }, [
        commit
    ]);
    const clearTransaction = (0, $TBcmg$useCallback)(()=>{
        cartData.current = {
            ...cartData.current,
            transaction: null,
            pendingTransactionId: undefined
        };
        commit();
    }, [
        commit
    ]);
    const setQuantity = (0, $TBcmg$useCallback)((orderId, quantity)=>{
        const updatedItems = [
            ...cartData.current.items
        ];
        let item = updatedItems.find((item)=>item.order?.id === orderId);
        if (item?.order && (quantity > 0 || quantity == -1)) {
            if (quantity > item?.order?.quantityRemaining) quantity = item?.order?.quantityRemaining;
            item.order = {
                ...item.order,
                quantity: quantity
            };
        }
        if (quantity == -1) cartData.current = {
            ...cartData.current,
            items: updatedItems
        };
        else {
            const currency = getCartCurrency(updatedItems, cartData.current.chain?.id || 1);
            const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(updatedItems, currency, cartData.current.feesOnTopBps, cartData.current.feesOnTopUsd, usdPrice);
            cartData.current = {
                ...cartData.current,
                items: updatedItems,
                totalPrice: totalPrice,
                feeOnTop: feeOnTop,
                currency: currency
            };
        }
        commit();
    }, [
        commit,
        usdPrice
    ]);
    const add = (0, $TBcmg$useCallback)(async (items, chainId)=>{
        try {
            if (cartData.current.chain && chainId != cartData.current.chain?.id) throw `ChainId: ${chainId}, is different than the cart chainId (${cartData.current.chain?.id})`;
            if (cartData.current.isValidating) throw "Currently validating, adding items temporarily disabled";
            const updatedItems = [
                ...cartData.current.items
            ];
            const currentIds = cartData.current.items.map((item)=>`${item.collection.id}:${item.token.id}`);
            const currentOrderIds = cartData.current.items.map((item)=>item.order?.id);
            const tokensToFetch = [];
            const tokens = [];
            const ordersToFetch = [];
            const tokensByMaker = updatedItems.reduce((map, item)=>{
                if (item.order) {
                    const maker = item.order?.maker;
                    if (!map[maker]) map[maker] = [];
                    map[maker].push(`${item.collection.id}:${item.token.id}`);
                }
                return map;
            }, {});
            items.forEach((item)=>{
                const token = item;
                const asyncToken = item;
                const asyncOrder = item;
                if (token.token) {
                    if (!currentIds.includes(`${token.token?.collection?.id}:${token.token?.tokenId}`)) tokens.push(token);
                } else if (asyncToken && asyncToken.id && !currentIds.includes(asyncToken.id)) tokensToFetch.push(asyncToken.id);
                else if (asyncOrder && asyncOrder.orderId && !currentOrderIds.includes(asyncOrder.orderId)) ordersToFetch.push(asyncOrder.orderId);
            });
            const promises = [];
            if (tokensToFetch.length > 0) promises.push(new Promise(async (resolve)=>{
                const { tokens: fetchedTokens } = await fetchTokens(tokensToFetch, chainId);
                fetchedTokens?.forEach((tokenData)=>{
                    const item = convertTokenToItem(tokenData);
                    const id = `${item?.collection.id}:${item?.token.id}`;
                    const maker = tokenData.market?.floorAsk?.maker;
                    const duplicateListingDetected = item && maker && tokensByMaker[maker] && tokensByMaker[maker].includes(id);
                    if (duplicateListingDetected) client?.log([
                        "Detected adding duplicate listing to cart, aborting",
                        tokenData,
                        updatedItems
                    ], (0, $TBcmg$LogLevel).Error);
                    else if (item) updatedItems.push(item);
                });
                resolve();
            }));
            if (ordersToFetch.length > 0) promises.push(new Promise(async (resolve)=>{
                const { orders: fetchedOrders } = await fetchOrders(ordersToFetch, chainId);
                fetchedOrders?.forEach((orderData)=>{
                    const item = convertOrderToItem(orderData);
                    const id = `${item?.collection.id}:${item?.token.id}`;
                    const duplicateListingDetected = item && tokensByMaker[orderData.maker] && tokensByMaker[orderData.maker].includes(id);
                    if (duplicateListingDetected) client?.log([
                        "Detected adding duplicate listing to cart, aborting",
                        orderData,
                        updatedItems
                    ], (0, $TBcmg$LogLevel).Error);
                    else if (item) updatedItems.push(item);
                });
                resolve();
            }));
            if (promises.length > 0) {
                cartData.current.isValidating = true;
                subscribers.current.forEach((callback)=>callback());
                await Promise.allSettled(promises);
            }
            if (tokens.length > 0) tokens.forEach((token)=>{
                if (token.market?.floorAsk?.maker?.toLowerCase() !== address?.toLowerCase() && token.token?.owner?.toLowerCase() !== address?.toLowerCase()) {
                    const item = convertTokenToItem(token);
                    if (item) updatedItems.push(item);
                }
            });
            const pools = calculatePools(updatedItems);
            const currency = getCartCurrency(updatedItems, chainId);
            const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(updatedItems, currency, cartData.current.feesOnTopBps, cartData.current.feesOnTopUsd, usdPrice);
            cartData.current = {
                ...cartData.current,
                isValidating: false,
                items: updatedItems,
                totalPrice: totalPrice,
                feeOnTop: feeOnTop,
                currency: currency,
                pools: pools
            };
            if (!cartData.current.chain) cartData.current.chain = client?.chains.find((chain)=>chain.id === chainId) || client?.currentChain() || undefined;
            commit();
        } catch (e) {
            if (cartData.current.isValidating) {
                cartData.current.isValidating = false;
                commit();
            }
            throw e;
        }
    }, [
        fetchTokens,
        commit,
        address,
        usdPrice
    ]);
    /**
     * @param ids An array of order ids or token keys. Tokens should be in the format `collection:token`
     */ const remove = (0, $TBcmg$useCallback)((ids)=>{
        if (cartData.current.isValidating) {
            console.warn("Currently validating, removing items temporarily disabled");
            return;
        }
        const updatedItems = [];
        const removedItems = [];
        cartData.current.items.forEach((item)=>{
            const key = `${item.collection.id}:${item.token.id}`;
            const orderId = item.order?.id;
            if (orderId && ids.includes(orderId)) removedItems.push(item);
            else if (ids.includes(key)) removedItems.push(item);
            else updatedItems.push(item);
        });
        const pools = calculatePools(updatedItems);
        const currency = getCartCurrency(updatedItems, cartData.current.chain?.id || 1);
        const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(updatedItems, currency, cartData.current.feesOnTopBps, cartData.current.feesOnTopUsd, usdPrice);
        //Suppress pool price changes if the removed item was from the pool
        const removedPoolIds = removedItems.reduce((poolIds, item)=>{
            if (item.poolId) poolIds.push(item.poolId);
            return poolIds;
        }, []);
        updatedItems.forEach((item)=>{
            if (item.poolId && removedPoolIds.includes(item.poolId)) item.previousPrice = item.price;
        });
        cartData.current = {
            ...cartData.current,
            items: updatedItems,
            pools: pools,
            totalPrice: totalPrice,
            feeOnTop: feeOnTop,
            currency: currency
        };
        if (updatedItems.length === 0) cartData.current.chain = undefined;
        commit();
    }, [
        usdPrice
    ]);
    const validate = (0, $TBcmg$useCallback)(async ()=>{
        try {
            if (cartData.current.items.length === 0) return false;
            cartData.current = {
                ...cartData.current,
                isValidating: true
            };
            commit();
            const items = [
                ...cartData.current.items
            ];
            const positionMap = cartData.current.items.reduce((items, item, index)=>{
                if (item.order?.id) items[`${item.order.id}`] = index;
                else if (item.collection.id && item.token?.id) items[`${item.collection.id}:${item.token.id}`] = index;
                return items;
            }, {}) || {};
            const tokensToFetch = [];
            const ordersToFetch = [];
            //find tokens and order ids to fetch
            cartData.current.items.map((item)=>{
                if (item.order?.id) ordersToFetch.push(item.order.id);
                else {
                    const contract = item.collection.id.split(":")[0];
                    tokensToFetch.push(`${contract}:${item.token.id}`);
                }
            });
            //fetch tokens and orders in tandem
            const promises = [];
            if (ordersToFetch.length > 0) promises.push(fetchOrders(ordersToFetch, cartData.current.chain?.id));
            if (tokensToFetch.length > 0) promises.push(fetchTokens(tokensToFetch, cartData.current.chain?.id));
            const responses = await Promise.allSettled(promises);
            // hashmap of items to remove { orderId/tokenId: item index }
            let itemsToRemove = {};
            responses.forEach((response)=>{
                if (response.status === "fulfilled") {
                    const ordersResponse = response.value;
                    const tokensResponse = response.value;
                    if (ordersResponse && ordersResponse.orders) // process orders response
                    ordersResponse.orders.map((order)=>{
                        let index = positionMap[order.id];
                        if (address && order.maker.toLowerCase() === address?.toLowerCase()) itemsToRemove[order.id] = index;
                        else if (order.status !== "active") items[index] = {
                            ...items[index],
                            price: undefined
                        };
                    });
                    else if (tokensResponse && tokensResponse.tokens) // process tokens response
                    tokensResponse.tokens.map(({ token: token, market: market })=>{
                        const index = positionMap[`${token?.collection?.id}:${token?.tokenId}`];
                        if (address && (token?.owner?.toLowerCase() === address?.toLowerCase() || market?.floorAsk?.maker?.toLowerCase() === address?.toLowerCase())) {
                            if (token?.collection?.id && token?.tokenId) itemsToRemove[`${token.collection.id}:${token.tokenId}`] = index;
                        } else {
                            const dynamicPricing = market?.floorAsk?.dynamicPricing;
                            items[index] = {
                                ...items[index],
                                previousPrice: items[index].price,
                                price: market?.floorAsk?.price,
                                poolId: dynamicPricing?.kind === "pool" ? dynamicPricing.data?.pool : undefined,
                                poolPrices: dynamicPricing?.kind === "pool" ? dynamicPricing.data?.prices : undefined
                            };
                            if (token?.name) items[index].token.name = token.name;
                            if (token?.collection?.name) items[index].collection.name = token.collection.name;
                        }
                    });
                }
            });
            // Remove all items in itemsToRemove
            if (Object.values(itemsToRemove).length > 0) Object.values(itemsToRemove).map((index)=>{
                items.splice(index, 1);
            });
            const pools = calculatePools(items);
            const currency = getCartCurrency(items, cartData.current.chain?.id || 1);
            const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(items, currency, cartData.current.feesOnTopBps, cartData.current.feesOnTopUsd, usdPrice);
            cartData.current = {
                ...cartData.current,
                items: items,
                pools: pools,
                isValidating: false,
                totalPrice: totalPrice,
                feeOnTop: feeOnTop,
                currency: currency
            };
            commit();
            return true;
        } catch (e) {
            if (cartData.current.isValidating) {
                cartData.current.isValidating = false;
                commit();
            }
            throw e;
        }
    }, [
        fetchTokens,
        fetchOrders,
        address,
        usdPrice
    ]);
    const checkout = (0, $TBcmg$useCallback)(async (options = {})=>{
        if (!client) throw "Reservoir SDK not initialized";
        const { chain: activeChain } = await (0, $TBcmg$getAccount)(config);
        if (cartData.current.chain && cartData.current.chain?.id !== activeChain?.id) {
            const chain = await switchChainAsync?.({
                ...config,
                chainId: cartData.current.chain.id
            });
            if (chain?.id !== cartData.current.chain.id) throw "Active chain does not match cart chain";
        }
        let wagmiWalletClient;
        if (!walletClient) wagmiWalletClient = await (0, $TBcmg$getWalletClient)(config, {
            chainId: cartData.current.chain?.id
        });
        const wallet = walletClient || wagmiWalletClient;
        if (!wallet) throw "Wallet/Signer not available";
        let isMixedCurrency = false;
        const tokens = cartData.current.items.reduce((items, { token: token, collection: collection, price: price, order: order })=>{
            if (price) {
                const contract = collection.id.split(":")[0];
                items?.push({
                    token: order?.id ? undefined : `${contract}:${token.id}`,
                    orderId: order?.id,
                    quantity: order?.quantity
                });
                if (price.currency?.contract != cartData.current.currency?.contract) isMixedCurrency = true;
            }
            return items;
        }, []);
        if (!tokens || tokens.length === 0) throw "Cart is empty";
        const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(cartData.current.chain?.id || 1);
        const currencyChain = client.chains.find((chain)=>chainCurrency.chainId === chain.id);
        const feeOnTop = cartData.current.feeOnTop ? cartData.current.feeOnTop : 0;
        const expectedPrice = cartData.current.totalPrice - feeOnTop;
        let currencyDecimals = cartData.current.currency?.decimals || 18;
        if (isMixedCurrency) {
            options.currency = (0, $TBcmg$zeroAddress);
            currencyDecimals = chainCurrency.decimals;
        } else options.currency = cartData.current.currency?.contract;
        if (feeOnTop) {
            if (cartData.current.feesOnTopBps) {
                const fixedFees = cartData.current.feesOnTopBps.map((fullFee)=>{
                    const [referrer, feeBps] = fullFee.split(":");
                    const fee = Math.floor(Number((0, $TBcmg$parseUnits)(`${expectedPrice}`, currencyDecimals) * BigInt(feeBps)) / 10000);
                    const atomicUnitsFee = (0, $TBcmg$formatUnits)(BigInt(fee), 0);
                    return `${referrer}:${atomicUnitsFee}`;
                });
                options.feesOnTop = fixedFees;
            } else if (cartData.current.feesOnTopUsd && usdPrice) options.feesOnTop = cartData.current.feesOnTopUsd.map((feeOnTop)=>{
                const [recipient, fee] = feeOnTop.split(":");
                const atomicUsdPrice = (0, $TBcmg$parseUnits)(`${usdPrice}`, 6);
                const atomicFee = BigInt(fee);
                const convertedAtomicFee = atomicFee * BigInt(10 ** cartData.current?.currency?.decimals);
                const currencyFee = convertedAtomicFee / atomicUsdPrice;
                const parsedFee = (0, $TBcmg$formatUnits)(currencyFee, 0);
                return `${recipient}:${parsedFee}`;
            });
        }
        if (options.partial === undefined) options.partial = true;
        const transactionId = `${new Date().getTime()}`;
        cartData.current = {
            ...cartData.current,
            pendingTransactionId: transactionId,
            transaction: {
                id: transactionId,
                chain: cartData.current.chain || currencyChain || client.chains[0],
                items: cartData.current.items,
                status: $ad5b3085b935ed8c$export$de7bcda3c490bf18.Approving
            }
        };
        commit();
        client.actions.buyToken({
            expectedPrice: {
                [options.currency || (0, $TBcmg$zeroAddress)]: {
                    amount: expectedPrice,
                    raw: (0, $TBcmg$parseUnits)(`${expectedPrice}`, currencyDecimals),
                    currencyAddress: options.currency || (0, $TBcmg$zeroAddress),
                    currencyDecimals: currencyDecimals
                }
            },
            wallet: wallet,
            items: tokens,
            options: options,
            onProgress: (steps, path)=>{
                if (!steps) return;
                if (transactionId != cartData.current.pendingTransactionId) return;
                let status = cartData.current.transaction?.status || $ad5b3085b935ed8c$export$de7bcda3c490bf18.Approving;
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStep.error) return;
                executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const transactionSteps = steps.filter((step)=>step.kind === "transaction" && step.items && step.items?.length > 0);
                if (transactionSteps.length > 0 && transactionSteps.every((step)=>step.items?.every((item)=>item.txHashes))) {
                    status = $ad5b3085b935ed8c$export$de7bcda3c490bf18.Finalizing;
                    if (cartData.current.items.length > 0) {
                        cartData.current.items = [];
                        cartData.current.pools = {};
                        cartData.current.totalPrice = 0;
                        cartData.current.currency = undefined;
                        cartData.current.chain = undefined;
                    }
                }
                if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) status = $ad5b3085b935ed8c$export$de7bcda3c490bf18.Complete;
                if (cartData.current.transaction?.status != status && (status === $ad5b3085b935ed8c$export$de7bcda3c490bf18.Finalizing || status === $ad5b3085b935ed8c$export$de7bcda3c490bf18.Complete)) {
                    cartData.current.items = [];
                    cartData.current.pools = {};
                    cartData.current.totalPrice = 0;
                    cartData.current.currency = undefined;
                    cartData.current.chain = undefined;
                }
                if (cartData.current.transaction) {
                    cartData.current.transaction.status = status;
                    cartData.current.transaction.currentStep = currentStep;
                    if (currentStepItem) {
                        cartData.current.transaction.txHashes = currentStepItem?.txHashes;
                        cartData.current.transaction.steps = steps;
                        cartData.current.transaction.path = path;
                    }
                }
                commit();
            }
        }).catch((e)=>{
            if (transactionId != cartData.current.pendingTransactionId) return;
            let error = e;
            let errorType = $ad5b3085b935ed8c$export$6adf53dcf2d42374.Unknown;
            const errorStatus = error?.statusCode;
            if (error?.message && error?.message.includes("ETH balance")) errorType = $ad5b3085b935ed8c$export$6adf53dcf2d42374.InsufficientBalance;
            else if (error?.code && error?.code == 4001) errorType = $ad5b3085b935ed8c$export$6adf53dcf2d42374.UserDenied;
            else {
                let message = "Oops, something went wrong. Please try again.";
                if (errorStatus >= 400 && errorStatus < 500) message = error.message;
                if (error?.type && error?.type === "price mismatch") {
                    errorType = $ad5b3085b935ed8c$export$6adf53dcf2d42374.PiceMismatch;
                    message = error.message;
                }
                //@ts-ignore: Should be fixed in an update to typescript
                error = new Error(message, {
                    cause: error
                });
            }
            if (cartData.current.transaction) {
                cartData.current.transaction.status = $ad5b3085b935ed8c$export$de7bcda3c490bf18.Idle;
                cartData.current.transaction.error = error;
                cartData.current.transaction.errorType = errorType;
                if (cartData.current.chain?.id == cartData.current.transaction.chain.id) {
                    const items = [
                        ...cartData.current.transaction.items
                    ];
                    const pools = calculatePools(items);
                    const currency = getCartCurrency(items, cartData.current.transaction.chain.id);
                    const { totalPrice: totalPrice, feeOnTop: feeOnTop } = calculatePricing(items, currency, cartData.current.feesOnTopBps, cartData.current.feesOnTopUsd, usdPrice);
                    cartData.current.items = items;
                    cartData.current.pools = pools;
                    cartData.current.currency = currency;
                    cartData.current.totalPrice = totalPrice;
                    cartData.current.feeOnTop = feeOnTop;
                    cartData.current.chain = cartData.current.transaction.chain;
                }
                commit();
                validate();
            }
        });
    }, [
        client,
        switchChainAsync,
        usdPrice,
        walletClient,
        config
    ]);
    return {
        get: get,
        set: set,
        subscribe: subscribe,
        setQuantity: setQuantity,
        add: add,
        remove: remove,
        clear: clear,
        clearTransaction: clearTransaction,
        validate: validate,
        checkout: checkout
    };
}
const $ad5b3085b935ed8c$export$5558332cef65f159 = /*#__PURE__*/ (0, $TBcmg$createContext)(null);
const $ad5b3085b935ed8c$export$9081b9c87ee4e12e = function({ children: children, feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, persist: persist, walletClient: walletClient }) {
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($ad5b3085b935ed8c$export$5558332cef65f159.Provider, {
        value: $ad5b3085b935ed8c$var$cartStore({
            feesOnTopBps: feesOnTopBps,
            feesOnTopUsd: feesOnTopUsd,
            persist: persist,
            walletClient: walletClient
        })
    }, children);
};



function $95b0bed557a4469f$export$2e2bcd8739ae039(selector) {
    const cart = (0, $TBcmg$useContext)((0, $ad5b3085b935ed8c$export$5558332cef65f159));
    if (!cart) throw new Error("Cart not found");
    const data = (0, $TBcmg$useSyncExternalStore)(cart.subscribe, ()=>selector(cart.get()), ()=>selector(cart.get()));
    const { clear: clear, remove: remove, add: add, validate: validate, checkout: checkout, clearTransaction: clearTransaction, setQuantity: setQuantity } = cart;
    return {
        data: data,
        clear: clear,
        clearTransaction: clearTransaction,
        setQuantity: setQuantity,
        remove: remove,
        add: add,
        validate: validate,
        checkout: checkout,
        set: cart.set
    };
}







const $d146464ef641db65$var$createBaseUrl = (config)=>{
    if (config?.proxy) return `${config.proxy}/api/v3/coins/list?`;
    if (config?.apiKey) return `https://pro-api.coingecko.com/api/v3/coins/list?x_cg_pro_api_key={${config.apiKey}}`;
    return "https://api.coingecko.com/api/v3/coins/list";
};
function $d146464ef641db65$export$2e2bcd8739ae039() {
    const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const baseUrl = $d146464ef641db65$var$createBaseUrl(providerOptionsContext?.coinGecko);
    const response = (0, $TBcmg$swrimmutable)(baseUrl, null, {
        refreshInterval: 7200000
    });
    const coins = response?.data?.reduce((coins, coin)=>{
        //Hardcoded symbol to id pairings for established cryptocurrencies
        if (coin.symbol === "eth" && coin.id !== "ethereum" || coin.symbol === "weth" && coin.id !== "weth" || coin.symbol === "wmatic" && coin.id !== "wmatic" || coin.symbol === "usdc" && coin.id !== "usd-coin" || coin.symbol === "matic" && coin.id !== "matic-network" || coin.symbol === "dai" && coin.id !== "dai" || coin.symbol === "sand" && coin.id !== "the-sandbox") return coins;
        if (!coins[coin.symbol]) coins[coin.symbol] = [
            coin
        ];
        else coins[coin.symbol].push(coin);
        return coins;
    }, {}) || {};
    return {
        ...response,
        data: coins
    };
}


const $b5d8dec284676ed1$var$createBaseUrl = (config)=>{
    if (config?.proxy) return `${config.proxy}/api/v3/coins/markets?`;
    if (config?.apiKey) return `https://pro-api.coingecko.com/api/v3/coins/markets?x_cg_pro_api_key={${config.apiKey}}&`;
    return "https://api.coingecko.com/api/v3/coins/markets?";
};
function $b5d8dec284676ed1$export$2e2bcd8739ae039(vs_currency, symbols = "eth", id = "") {
    const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const { data: coinIds } = (0, $d146464ef641db65$export$2e2bcd8739ae039)();
    const baseUrl = $b5d8dec284676ed1$var$createBaseUrl(providerOptionsContext?.coinGecko);
    if (id.length === 0) id = symbols.split(",").reduce((ids, symbol)=>{
        const normalizedSymbol = symbol.toLowerCase();
        if (providerOptionsContext.coinGecko?.coinIds?.[normalizedSymbol]) ids.push(providerOptionsContext.coinGecko.coinIds[normalizedSymbol]);
        else {
            const coins = coinIds[normalizedSymbol];
            if (coins?.length === 1) ids.push(coins[0].id);
        }
        return ids;
    }, []).join(",");
    const { data: data } = (0, $TBcmg$swrimmutable)(vs_currency ? `${baseUrl}vs_currency=${vs_currency}&ids=${id}` : null, null, {
        refreshInterval: 300000
    });
    if (data && data.length > 0) return data.filter((conversion)=>symbols.split(",").some((symbol)=>symbol.toLowerCase().includes(conversion.symbol))).map((conversion)=>({
            price: conversion.current_price,
            symbol: (conversion.symbol || "").toUpperCase(),
            coinGeckoId: conversion.id
        }));
    return [];
}



function $3ec5bd98aa11a4af$export$2e2bcd8739ae039(options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!options || !options.collection && !options.collectionsSetId && !options.community) return null;
        const url = new URL(`${chain?.baseApiUrl}/collections/activity/v6`);
        let query = {
            ...options
        };
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const activities = response.data?.flatMap((page)=>page.activities || []) ?? [];
    return {
        ...response,
        data: activities
    };
}



function $afd6276a623787c2$export$2e2bcd8739ae039(options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!options) return null;
        const url = new URL(`${chain?.baseApiUrl}/collections/v7`);
        let query = {
            ...options
        };
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client.normalizeRoyalties;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const collections = response.data?.flatMap((page)=>page?.collections || []) ?? [];
    return {
        ...response,
        data: collections
    };
}





function $074b4666df4341a7$export$2e2bcd8739ae039(options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!options) return null;
        const url = new URL(`${chain?.baseApiUrl}/tokens/v7`);
        let query = {
            ...options
        };
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client.normalizeRoyalties;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const tokens = (0, $TBcmg$useMemo)(()=>response.data?.flatMap((page)=>page.tokens || []) ?? [], [
        response.data
    ]);
    return {
        ...response,
        data: tokens
    };
}


function $7eca4ecf85dae226$export$2e2bcd8739ae039(options = {}, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const tokensResponse = (0, $074b4666df4341a7$export$2e2bcd8739ae039)({
        includeDynamicPricing: true,
        ...options
    }, swrOptions, chainId);
    const { data: cartItems, ...cartActions } = (0, $95b0bed557a4469f$export$2e2bcd8739ae039)((cart)=>cart.items);
    const { data: cartPools } = (0, $95b0bed557a4469f$export$2e2bcd8739ae039)((cart)=>cart.pools);
    const { data: cartChain } = (0, $95b0bed557a4469f$export$2e2bcd8739ae039)((cart)=>cart.chain);
    const cartRequiresReordering = (0, $TBcmg$useMemo)(()=>Object.values(cartPools).some((pool)=>pool.itemCount > 0), [
        cartPools
    ]);
    const itemsMap = (0, $TBcmg$useMemo)(()=>{
        return cartItems.reduce((itemMap, item)=>{
            itemMap[`${item.collection.id}:${item.token.id}`] = item;
            return itemMap;
        }, {});
    }, [
        cartItems
    ]);
    let dynamicTokens;
    if (cartChain && (chainId === cartChain?.id || chainId === undefined && client?.currentChain()?.id === cartChain?.id)) {
        dynamicTokens = tokensResponse.data.map((tokenData)=>{
            const id = `${tokenData?.token?.collection?.id}:${tokenData?.token?.tokenId}`;
            const cartItem = itemsMap[id];
            const dynamicTokenData = {
                ...tokenData,
                isInCart: cartItem !== undefined
            };
            const floorAsk = tokenData?.market?.floorAsk;
            const isInPool = floorAsk?.dynamicPricing?.kind === "pool";
            const poolId = isInPool ? floorAsk?.dynamicPricing?.data?.pool : undefined;
            const poolPrices = isInPool ? floorAsk?.dynamicPricing?.data?.prices : undefined;
            if (cartItem) {
                if (dynamicTokenData.market?.floorAsk && cartItem.poolId && cartItem.price && cartItem.price.amount?.decimal != dynamicTokenData.market?.floorAsk?.price) dynamicTokenData.market.floorAsk.price = cartItem.price;
            } else if (isInPool && poolId && poolPrices && floorAsk && dynamicTokenData.market?.floorAsk) {
                const nextPoolCartIndex = cartPools[poolId] ? cartPools[poolId].itemCount : 0;
                if (nextPoolCartIndex >= poolPrices.length) dynamicTokenData.market.floorAsk.price = undefined;
                else if (poolPrices && poolPrices[nextPoolCartIndex]) dynamicTokenData.market.floorAsk.price = poolPrices[nextPoolCartIndex];
            }
            return dynamicTokenData;
        });
        if (cartRequiresReordering && (!options || !options.sortBy || options.sortBy === "floorAskPrice")) dynamicTokens.sort((a, b)=>{
            const aPrice = a.market?.floorAsk?.price?.amount?.decimal;
            const bPrice = b.market?.floorAsk?.price?.amount?.decimal;
            if (aPrice === undefined) return 1;
            else if (bPrice === undefined) return -1;
            else if (!options || !options.sortDirection || options.sortDirection === "asc") return aPrice - bPrice;
            else return bPrice - aPrice;
        });
    } else dynamicTokens = tokensResponse.data.map((tokenData)=>{
        const floorAsk = tokenData?.market?.floorAsk;
        const isInPool = floorAsk?.dynamicPricing?.kind === "pool";
        const poolPrices = isInPool ? floorAsk?.dynamicPricing?.data?.prices : undefined;
        if (tokenData.market?.floorAsk && poolPrices && poolPrices[0]) tokenData.market.floorAsk.price = poolPrices[0];
        return tokenData;
    });
    return {
        ...tokensResponse,
        data: dynamicTokens,
        ...cartActions
    };
}




function $b9d7d4ec194b807a$export$2e2bcd8739ae039(options, swrOptions = {}, enabled = true, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!enabled) return null;
        const url = new URL(`${chain?.baseApiUrl || ""}/orders/asks/v5`);
        let query = options || {};
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client.normalizeRoyalties;
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const listings = response.data?.flatMap((page)=>page.orders || []) ?? [];
    return {
        ...response,
        data: listings
    };
}




function $64e3a4f1258fcb50$export$2e2bcd8739ae039(collectionId, chainId, options, enabled = true) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const { data: data, error: error } = (0, $TBcmg$swrimmutable)(()=>{
        if (!enabled || !collectionId) return null;
        const url = new URL(`${chain?.baseApiUrl}/collections/${collectionId}/marketplace-configurations/v2`);
        let query = {
            ...options
        };
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    });
    return {
        data: data,
        isError: !!error,
        isLoading: !data && !error
    };
}





function $13e7ce1cd1160f0c$export$2e2bcd8739ae039(address, options, swrOptions = {}, enabled = true, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!enabled || !address) return null;
        const url = new URL(`${chain?.baseApiUrl || ""}/users/${address}/asks/v1`);
        let query = options || {};
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client.normalizeRoyalties;
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const listings = response.data?.flatMap((page)=>page.orders || []) ?? [];
    return {
        ...response,
        data: listings
    };
}


function $6b5464cef6d36d49$export$2e2bcd8739ae039(query, swrOptions, chainId) {
    const { address: address } = (0, $TBcmg$useAccount)();
    return (0, $13e7ce1cd1160f0c$export$2e2bcd8739ae039)(address, query ? query : undefined, swrOptions, address !== undefined, chainId);
}




function $201908b8377e3dd2$export$2e2bcd8739ae039(chainId, enabled = true) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const { data: data, error: error } = (0, $TBcmg$swr)(chain && enabled ? `${chain?.baseApiUrl}/execute/solve/capacity/v2` : null, async (url)=>{
        try {
            const response = await (0, $TBcmg$axios).post(url, {
                kind: "cross-chain-intent"
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching solver capacity:", error);
            return undefined;
        }
    }, {
        revalidateOnFocus: false
    });
    return {
        data: data,
        isError: !!error,
        isLoading: !data && !error
    };
}



function $a6a22af2ea7cc64d$export$2e2bcd8739ae039(token, options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!token) return null;
        const url = new URL(`${chain?.baseApiUrl}/tokens/${token}/activity/v5`);
        let query = {
            ...options
        };
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const activities = response.data?.flatMap((page)=>page.activities || []) ?? [];
    return {
        ...response,
        data: activities
    };
}




function $bfd69022dcb7499e$export$2e2bcd8739ae039(options, chainId, swrOptions = {}) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const url = new URL(`${chain?.baseApiUrl}/collections/trending/v1`);
    let query = {
        ...options
    };
    (0, $TBcmg$setParams)(url, query);
    const { data: data, mutate: mutate, error: error, isValidating: isValidating, isLoading: isLoading } = (0, $TBcmg$swr)(url && options ? [
        url.href,
        client?.apiKey,
        client?.version
    ] : null, null, {
        revalidateOnMount: true,
        ...swrOptions
    });
    const collections = data && data.collections ? data.collections : null;
    return {
        response: data,
        data: collections,
        mutate: mutate,
        error: error,
        isValidating: isValidating,
        isLoading: isLoading
    };
}




function $4719414bc2959e37$export$2e2bcd8739ae039(options, chainId, swrOptions = {}) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const url = new URL(`${chain?.baseApiUrl}/collections/trending-mints/v1`);
    let query = {
        ...options
    };
    (0, $TBcmg$setParams)(url, query);
    const { data: data, mutate: mutate, error: error, isValidating: isValidating, isLoading: isLoading } = (0, $TBcmg$swr)(url && options ? [
        url.href,
        client?.apiKey,
        client?.version
    ] : null, null, {
        revalidateOnMount: true,
        ...swrOptions
    });
    const mints = data && data.mints ? data.mints : null;
    return {
        response: data,
        data: mints,
        mutate: mutate,
        error: error,
        isValidating: isValidating,
        isLoading: isLoading
    };
}




function $739a88828d18ea96$export$2e2bcd8739ae039(address, options, swrOptions = {}, enabled = true, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!enabled) return null;
        const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
        const url = new URL(`${chain?.baseApiUrl || ""}/users/${address}/bids/v1`);
        let query = options || {};
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client?.normalizeRoyalties;
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const bids = (0, $TBcmg$useMemo)(()=>response.data?.flatMap((page)=>page.orders || []) ?? [], [
        response.data
    ]);
    return {
        ...response,
        data: bids
    };
}



function $f03c3cbef8c597c8$export$2e2bcd8739ae039(user, options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    let defaultLimit = 20;
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!user) return null;
        const url = new URL(`${chain?.baseApiUrl || ""}/users/${user}/collections/v4`);
        let query = {
            offset: pageIndex * (options?.limit || defaultLimit),
            limit: options?.limit || defaultLimit,
            ...options
        };
        if (previousPageData?.collections && previousPageData?.collections?.length === 0) return null;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    }, options?.limit || defaultLimit);
    const collections = response.data?.flatMap((page)=>page.collections || []) ?? [];
    return {
        ...response,
        data: collections
    };
}



function $df89d2f0bf3a2e94$export$2e2bcd8739ae039(users, options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!users) return null;
        const url = new URL(`${chain?.baseApiUrl}/users/activity/v6`);
        let query = {
            ...options,
            users: users
        };
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const activities = response.data?.flatMap((page)=>page.activities || []) ?? [];
    return {
        ...response,
        data: activities
    };
}



function $adb61885b37a317b$export$2e2bcd8739ae039(user, options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!user) return null;
        const url = new URL(`${chain?.baseApiUrl}/users/${user}/tokens/v10`);
        let query = {
            ...options
        };
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client.normalizeRoyalties;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const tokens = response.data?.flatMap((page)=>page.tokens || []) ?? [];
    return {
        ...response,
        data: tokens
    };
}



function $9e5d58301bd315fe$export$2e2bcd8739ae039(user, options, swrOptions = {}, chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const response = (0, $5e2a1f52f4fac2ad$export$2e2bcd8739ae039)((pageIndex, previousPageData)=>{
        if (!user) return null;
        const url = new URL(`${chain?.baseApiUrl || ""}/orders/users/${user}/top-bids/v4`);
        let query = options || {};
        if (previousPageData && !previousPageData.continuation) return null;
        else if (previousPageData && pageIndex > 0) query.continuation = previousPageData.continuation;
        if (query.normalizeRoyalties === undefined && client?.normalizeRoyalties !== undefined) query.normalizeRoyalties = client.normalizeRoyalties;
        (0, $TBcmg$setParams)(url, query);
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    }, {
        revalidateOnMount: true,
        revalidateFirstPage: false,
        ...swrOptions
    });
    const bids = response.data?.flatMap((page)=>page.topBids || []) ?? [];
    return {
        ...response,
        data: bids
    };
}




function $e235ec7f4c2cf2ae$export$2e2bcd8739ae039(overrides) {
    let sharedTheme = (0, $7e16985c42c068dc$export$8e8f484d816a71e3)(overrides);
    return {
        colors: {
            ...(0, $TBcmg$indigo),
            ...(0, $TBcmg$indigoA),
            ...(0, $TBcmg$red),
            ...(0, $TBcmg$gray),
            ...(0, $TBcmg$blackA),
            ...(0, $TBcmg$whiteA),
            ...(0, $TBcmg$green),
            // accent colors
            accentBase: "$indigo1",
            accentBgSubtle: "$indigo2",
            accentBg: "$indigo3",
            accentBgHover: "$indigo4",
            accentBgActive: "$indigo5",
            accentLine: "$indigo6",
            accentBorder: "$indigo7",
            accentBorderHover: overrides?.primaryColor || "$indigo8",
            accentSolid: overrides?.primaryColor || "$indigo9",
            accentSolidHover: overrides?.primaryHoverColor || overrides?.primaryColor || "$indigo10",
            accentText: "$indigo11",
            accentTextContrast: "$indigo12",
            // neutral colors
            neutralBase: "$gray1",
            neutralBgSubtle: "white",
            neutralBg: "$gray3",
            neutralBgHover: "$gray2",
            neutralBgActive: "$gray5",
            neutralLine: "$gray6",
            neutralBorder: "$gray7",
            neutralBorderHover: "$gray8",
            neutralSolid: "$gray9",
            neutralSolidHover: "$gray10",
            neutralText: "$gray11",
            neutralTextContrast: "$gray12",
            // secondary colors
            secondaryBase: "$indigoA1",
            secondaryBgSubtle: "$indigoA2",
            secondaryBg: "$indigoA3",
            secondaryBgHover: "$indigoA4",
            secondaryBgActive: "$indigoA5",
            secondaryLine: "$indigoA6",
            secondaryBorder: "$indigoA7",
            secondaryBorderHover: "$indigoA8",
            secondarySolid: "$indigoA9",
            secondarySolidHover: "$indigoA10",
            secondaryText: "$indigoA11",
            secondaryTextContrast: "$indigoA12",
            // general colors
            borderColor: overrides?.borderColor || "$neutralBorder",
            textColor: overrides?.textColor || "$neutralTextContrast",
            focusColor: "$neutralTextContrast",
            errorText: "$red12",
            errorAccent: "$red10",
            successAccent: "$green10",
            // component colors
            reservoirLogoColor: "#11181C",
            buttonTextColor: overrides?.buttonTextColor || "white",
            buttonTextHoverColor: overrides?.buttonTextHoverColor || "white",
            inputBackground: "$neutralBgHover",
            overlayBackground: overrides?.overlayBackground || "$blackA10",
            headerBackground: overrides?.headerBackground || "$neutralBgHover",
            footerBackground: overrides?.footerBackground || "$neutralBgHover",
            contentBackground: overrides?.contentBackground || "$neutralBgSubtle",
            wellBackground: overrides?.wellBackground || "$gray3",
            popoverBackground: overrides?.popoverBackground || "$neutralBase"
        },
        assets: {
            ethIcon: overrides?.ethIcon || "gray",
            chainIcon: overrides?.chainIcon || "light"
        },
        ...sharedTheme
    };
}




const $b69d00be56c1bdb6$var$useFallbackState = (defaultValue, state)=>{
    const _state = (0, $TBcmg$useState)(defaultValue);
    if (state) return state;
    return _state;
};
var $b69d00be56c1bdb6$export$2e2bcd8739ae039 = $b69d00be56c1bdb6$var$useFallbackState;




const $a663831c1deeb453$export$ec39d0bf2d6d1efb = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("a", {
    backgroundColor: "transparent",
    cursor: "pointer",
    fontFamily: "$body",
    fontSize: 16,
    color: "inherit",
    textDecoration: "inherit",
    $$focusColor: "$colors$neutralTextContrast",
    "&:focus-visible": {
        color: "$neutralTextContrast",
        outline: "none",
        borderRadius: 4,
        boxShadow: "0 0 0 2px $$focusColor"
    },
    variants: {
        color: {
            primary: {
                color: "$accentText",
                "&:hover": {
                    color: "$accentSolidHover"
                }
            },
            gray: {
                color: "$neutralText",
                "&:hover": {
                    color: "$accentText"
                }
            },
            error: {
                color: "$errorAccent"
            }
        },
        weight: {
            heavy: {
                fontWeight: 700
            },
            medium: {
                fontWeight: 500
            }
        }
    },
    defaultVariants: {
        color: "gray",
        weight: "heavy"
    }
});
var $a663831c1deeb453$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ children: children, ...props }, forwardedRef)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($a663831c1deeb453$export$ec39d0bf2d6d1efb, {
        ref: forwardedRef,
        ...props,
        tabIndex: 0
    }, children));


var $0af15c1ef5e8ac4a$export$2e2bcd8739ae039 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("div", {
    boxSizing: "border-box",
    borderStyle: "solid",
    borderWidth: 0
});


const $e6a4e3d86984e475$var$Button = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("button", {
    backgroundColor: "transparent",
    backgroundImage: "none",
    outline: "none",
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "$button",
    transition: "background-color 250ms linear",
    gap: "$space$2",
    display: "inline-flex",
    justifyContent: "center",
    color: "$buttonTextColor",
    alignItems: "center",
    lineHeight: "20px",
    $$focusColor: "$colors$focusColor",
    cursor: "pointer",
    border: 0,
    borderWidth: 0,
    "&:focus-visible": {
        boxShadow: "0 0 0 2px $$focusColor"
    },
    "&:disabled": {
        backgroundColor: "$neutralBorder",
        color: "$neutralText"
    },
    "&:disabled:hover": {
        backgroundColor: "$neutralBorderHover",
        color: "$neutralText"
    },
    variants: {
        color: {
            primary: {
                backgroundColor: "$accentSolid",
                color: "$buttonTextColor",
                "&:hover": {
                    backgroundColor: "$accentSolidHover",
                    color: "$buttonTextHoverColor"
                }
            },
            secondary: {
                backgroundColor: "$neutralBgHover",
                color: "$textColor",
                "&:hover": {
                    backgroundColor: "$neutralBgActive"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                p: 0
            }
        },
        corners: {
            rounded: {
                borderRadius: "$borderRadius"
            },
            pill: {
                borderRadius: 99999
            },
            circle: {
                borderRadius: "99999px",
                alignItems: "center",
                justifyContent: "center"
            }
        },
        size: {
            none: {},
            xs: {
                p: "$space$3",
                lineHeight: "16px",
                minHeight: 40
            },
            small: {
                px: "$space$3",
                py: "$space$4",
                lineHeight: "12px",
                minHeight: 44
            },
            medium: {
                px: "$space$5",
                py: "$space$3",
                minHeight: 44
            },
            large: {
                px: "$space$5",
                py: "$space$4",
                minHeight: 52
            }
        }
    },
    compoundVariants: [
        {
            size: "xs",
            corners: "circle",
            css: {
                height: 40,
                width: 40,
                p: 0
            }
        },
        {
            size: "small",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "medium",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "large",
            corners: "circle",
            css: {
                height: 52,
                width: 52,
                p: 0
            }
        }
    ],
    defaultVariants: {
        color: "primary",
        corners: "rounded",
        size: "medium"
    }
});
var $e6a4e3d86984e475$export$2e2bcd8739ae039 = $e6a4e3d86984e475$var$Button;




var $72916f97ef55a375$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "5 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9441 17.97L4.58008 13.62L11.9431 24L19.3131 13.62L11.9411 17.97H11.9441V17.97ZM12.0561 0L4.69008 12.223L12.0551 16.577L19.4201 12.227L12.0561 0Z",
        fill: "black"
    }));



var $dc8d2782b4d6e176$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "5 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        clipPath: "url(#clip0_2127_56739)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9979 0L11.8369 0.546928V16.4161L11.9979 16.5767L19.3641 12.2225L11.9979 0Z",
        fill: "#343434"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9979 0L4.63159 12.2225L11.9979 16.5767V8.87428V0Z",
        fill: "#8C8C8C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.998 17.9714L11.9072 18.0821V23.7349L11.998 23.9999L19.3686 13.6195L11.998 17.9714Z",
        fill: "#3C3C3B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9979 23.9999V17.9714L4.63159 13.6195L11.9979 23.9999Z",
        fill: "#8C8C8C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.998 16.5767L19.3642 12.2225L11.998 8.87427V16.5767Z",
        fill: "#141414"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M4.63159 12.2225L11.9979 16.5767V8.87427L4.63159 12.2225Z",
        fill: "#393939"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_2127_56739"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $b2cf897cad2fb98b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "5 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.3654 8.87477V0L5 12.2224L12.3654 8.87477Z",
        fill: "#8A92B2"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.3654 16.5772V8.87477L5 12.2224L12.3654 16.5772ZM12.3654 8.87477L19.7322 12.2224L12.3654 0V8.87477Z",
        fill: "#62688F"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.3655 8.87476V16.5772L19.7322 12.2224L12.3655 8.87476Z",
        fill: "#454A75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.3654 17.972L5 13.6199L12.3654 23.9999V17.972Z",
        fill: "#8A92B2"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M19.7363 13.6199L12.3655 17.972V23.9999L19.7363 13.6199Z",
        fill: "#62688F"
    }));


const $01f02cf0ad39d100$var$EthLogo = ()=>{
    const themeContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$2c657da244d00bd6));
    const ethIcon = themeContext && themeContext ? themeContext["assets"]["ethIcon"]["value"] : "glyph";
    switch(ethIcon){
        case "glyph":
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $72916f97ef55a375$export$2e2bcd8739ae039), null);
        case "gray":
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $dc8d2782b4d6e176$export$2e2bcd8739ae039), null);
        case "purple":
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b2cf897cad2fb98b$export$2e2bcd8739ae039), null);
    }
};
var $01f02cf0ad39d100$export$2e2bcd8739ae039 = $01f02cf0ad39d100$var$EthLogo;







const $539986c326843873$var$wrappedContracts = {
    1: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    10: "0x4200000000000000000000000000000000000006",
    56: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
    204: "0x4200000000000000000000000000000000000006",
    137: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    324: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
    1101: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
    42161: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    42170: "0x722e8bdd2ce80a4422e880164f2079488e115365",
    43114: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
    59144: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
    999: "0x8a5027ea12f45a13deb6CB96A07913c6e192BE84",
    80002: "0x0ae690aad8663aab12a671a6a0d74242332de85f",
    8453: "0x4200000000000000000000000000000000000006",
    84532: "0x4200000000000000000000000000000000000006",
    534353: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
    534352: "0x5300000000000000000000000000000000000004",
    7777777: "0x4200000000000000000000000000000000000006",
    11155111: "0x7b79995e5f793a07bc00c21412e50ecae098e7f9",
    888888888: "0x4200000000000000000000000000000000000006",
    28122024: "0x4200000000000000000000000000000000000006",
    68840142: "0x822b4c4713433c6b88547845850a39343bf0957e",
    168587773: "0x4200000000000000000000000000000000000023",
    70700: "0x77684A04145a5924eFCE0D92A7c4a2A2E8C359de",
    70800: "0xBfB86801053600dd3C7FCBa6d5E85017a64cE728",
    81457: "0x4300000000000000000000000000000000000004",
    3776: "0xE9CC37904875B459Fa5D0FE37680d36F1ED55e38",
    17069: "0x4200000000000000000000000000000000000006",
    690: "0x4200000000000000000000000000000000000006",
    80084: "0x7507c1dc16935b82698e4c63f2746a2fcf994df8",
    666666666: "0xeb54dacb4c2ccb64f8074eceea33b5ebb38e5387",
    660279: "0x3fb787101dc6be47cfe18aeee15404dcc842e6af",
    1482601649: "0xab01bad2c86e24d371a13ed6367bdca819589c5d",
    713715: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
    7560: "0x4200000000000000000000000000000000000006",
    200901: "0xff204e2681a6fa0e2c3fade68a1b28fb90e4fc5f",
    1329: "0xE30feDd158A2e3b13e9badaeABaFc5516e95e8C7",
    1993: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
    646: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
    70805: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
    13746: "0x6b885d96916d18cd78e44b42c6489ca6f8794565",
    70701: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
    984122: "0xd5eace1274dbf70960714f513db207433615a263",
    984123: "0xd5eace1274dbf70960714f513db207433615a263",
    8333: "0x4200000000000000000000000000000000000006",
    33139: "0x48b62137edfa95a428d35c09e44256a739f6b557",
    33111: "0x8643a49363e80c7a15790703b915d1b0b6b71d56",
    360: "0x4200000000000000000000000000000000000006",
    11011: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
    11124: "0x9edcde0257f2386ce177c3a7fcdd97787f0d841d",
    1946: "0x4200000000000000000000000000000000000006",
    2911: "0x2b1499d631bffb29eed7749b12cba754273d6da7",
    29112: "0x2549584be33491340eee6762992055cda05b2581",
    747: "0xd3bf53dac106a0290b0483ecbc89d40fcc961f3e",
    543210: "0xac98b49576b1c892ba6bfae08fe1bb0d80cf599c",
    43210: "0xee6b04fcd07a54d78a7a23f353f2b4a0bfb4a78c",
    2741: "0x3439153eb7af838ad19d56e1571fbd09333c2809",
    6900: "0x8f3e2785985aa4005c63f97f7cc89ce91a948267",
    41454: "0x3c6dd29e612b28c10f3ee9bacf0f4af5f17b3f3e",
    2187: "0xfa3ed70386b9255fC04aA008A8ad1B0CDa816Fac",
    4654: "0x34AF38Ec07708dBC01C5A814fc418D3840448fce",
    1868: "0x4200000000000000000000000000000000000006"
};
var $539986c326843873$export$2e2bcd8739ae039 = $539986c326843873$var$wrappedContracts;



var $5db90028f86e062a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.49721 0L0 12.4432L7.49721 9.03511V0Z",
        fill: "#AE1955"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.49721 9.03506L0 12.4432L7.49721 16.8767V9.03506Z",
        fill: "#801D45"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.9959 12.4433L7.49731 0V9.03511L14.9959 12.4433Z",
        fill: "#801D45"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.49731 16.8767L14.9959 12.4432L11.2466 10.7391L7.49731 9.03506V16.8767Z",
        fill: "#641D3B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0 13.8661L7.49721 24.4337V18.2968L0 13.8661Z",
        fill: "#AE1955"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.49731 18.2968V24.4337L15.0001 13.8661L7.49731 18.2968Z",
        fill: "#801D45"
    }));



const $facfb14f3ab47807$var$StyledImg = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {});
const $facfb14f3ab47807$var$CryptoCurrencyIcon = ({ address: address = (0, $TBcmg$zeroAddress), chainId: chainId, css: css })=>{
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(chainId);
    const chain = client?.chains.find((chain)=>chain.id === chainCurrency.chainId);
    if (chainCurrency.symbol === "ETH") {
        if (chainCurrency.chainId === (0, $TBcmg$customChains).nebula.id && (0, $539986c326843873$export$2e2bcd8739ae039)[chainCurrency.chainId] === address || (0, $TBcmg$zeroAddress) === address) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                display: "flex",
                ...css
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $01f02cf0ad39d100$export$2e2bcd8739ae039), null));
        else if ((0, $539986c326843873$export$2e2bcd8739ae039)[chainCurrency.chainId] === address) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                display: "flex",
                ...css
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5db90028f86e062a$export$2e2bcd8739ae039), null));
    }
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($facfb14f3ab47807$var$StyledImg, {
        src: `${chain?.baseApiUrl}/redirect/currency/${address}/icon/v1`,
        css: {
            borderRadius: "100%",
            ...css
        }
    });
};
var $facfb14f3ab47807$export$2e2bcd8739ae039 = $facfb14f3ab47807$var$CryptoCurrencyIcon;





const $602940fa56061b3b$var$flexCss = {
    display: "flex",
    boxSizing: "border-box",
    borderStyle: "solid",
    borderWidth: 0,
    variants: {
        align: {
            start: {
                alignItems: "flex-start"
            },
            center: {
                alignItems: "center"
            },
            end: {
                alignItems: "flex-end"
            },
            stretch: {
                alignItems: "stretch"
            },
            baseline: {
                alignItems: "baseline"
            }
        },
        justify: {
            start: {
                justifyContent: "flex-start"
            },
            center: {
                justifyContent: "center"
            },
            end: {
                justifyContent: "flex-end"
            },
            between: {
                justifyContent: "space-between"
            }
        },
        direction: {
            row: {
                flexDirection: "row"
            },
            column: {
                flexDirection: "column"
            },
            rowReverse: {
                flexDirection: "row-reverse"
            },
            columnReverse: {
                flexDirection: "column-reverse"
            }
        },
        wrap: {
            noWrap: {
                flexWrap: "nowrap"
            },
            wrap: {
                flexWrap: "wrap"
            },
            wrapReverse: {
                flexWrap: "wrap-reverse"
            }
        }
    }
};
var $602940fa56061b3b$export$2e2bcd8739ae039 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("div", $602940fa56061b3b$var$flexCss);
const $602940fa56061b3b$export$d31dc64e78f336f = (0, $4a58f4053e821189$export$3817b7a54a07cec7)((0, $TBcmg$motion).div, $602940fa56061b3b$var$flexCss);



var $38b6348718e47dcf$export$2e2bcd8739ae039 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("span", {
    color: "$textColor",
    fontFamily: "$body",
    letterSpacing: 0,
    margin: 0,
    variants: {
        color: {
            base: {
                color: "$textColor"
            },
            subtle: {
                color: "$neutralText"
            },
            error: {
                color: "$errorAccent"
            },
            errorLight: {
                color: "$errorText"
            },
            accent: {
                color: "$accentText"
            },
            success: {
                color: "$successAccent"
            },
            button: {
                color: "$buttonTextColor"
            }
        },
        style: {
            h2: {
                fontWeight: 700,
                fontSize: 48,
                fontFamily: "$headline"
            },
            h3: {
                fontWeight: 700,
                fontSize: 32,
                fontFamily: "$headline"
            },
            h4: {
                fontWeight: 700,
                fontSize: 24,
                fontFamily: "$headline"
            },
            h5: {
                fontWeight: 700,
                fontSize: 20,
                fontFamily: "$headline"
            },
            h6: {
                fontWeight: 700,
                fontSize: 16,
                fontFamily: "$headline"
            },
            subtitle1: {
                fontWeight: 500,
                fontSize: 16
            },
            subtitle2: {
                fontWeight: 500,
                fontSize: 14
            },
            subtitle3: {
                fontWeight: 500,
                fontSize: 12
            },
            body1: {
                fontWeight: 400,
                fontSize: 16
            },
            body2: {
                fontWeight: 400,
                fontSize: 14
            },
            body3: {
                fontWeight: 400,
                fontSize: 12
            },
            tiny: {
                fontWeight: 500,
                fontSize: 10,
                color: "$neutralSolidHover"
            }
        },
        italic: {
            true: {
                fontStyle: "italic"
            }
        },
        ellipsify: {
            true: {
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap"
            }
        }
    },
    compoundVariants: [
        {
            style: "tiny",
            color: "base",
            css: {
                color: "$textColor"
            }
        }
    ],
    defaultVariants: {
        style: "body1",
        color: "base"
    }
});




/**
 * Ensure that an Ethereum address does not overflow
 * by removing the middle characters
 * @param address An Ethereum address
 * @param shrinkInidicator Visual indicator to show address is only
 * partially displayed
 * @returns A shrinked version of the Ethereum address
 * with the middle characters removed.
 */ function $fb2072c99d61ad71$export$cd8822fabcdefd67(address, shrinkInidicator) {
    return address.slice(0, 4) + (shrinkInidicator || "\u2026") + address.slice(-4);
}


function $f9c59e90de25e993$export$2e2bcd8739ae039({ error: error, css: css }) {
    let message = "Oops, something went wrong. Please try again.";
    let messageWithContent = null;
    const errorType = error?.type;
    const errorStatus = error?.statusCode;
    if (error) {
        if (error?.message?.includes("rejected")) message = "User rejected the request.";
        else if (errorType && errorType === "price mismatch") message = error.message;
        else if (error.name === "TransactionTimeoutError" && error.txHash && error.blockExplorerBaseUrl) {
            let transactionError = error;
            messageWithContent = /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, "Your transaction was sent, but is taking longer to process.", /*#__PURE__*/ (0, $TBcmg$react).createElement("br", null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                href: `${transactionError.blockExplorerBaseUrl}/tx/${transactionError.txHash}`,
                color: "primary",
                weight: "medium",
                target: "_blank",
                css: {
                    fontSize: 12
                }
            }, "View on block explorer: ", (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(transactionError.txHash)));
        } else if (error.name === "CrossChainTransactionError") messageWithContent = /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, "Cross-chain purchase failed and funds have been refunded. Please try again.", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
            href: `https://reservoir.tools/#contact-us`,
            color: "primary",
            weight: "medium",
            target: "_blank",
            css: {
                fontSize: 12
            }
        }, "Reservoir"), ".");
        else if (errorStatus >= 400 && errorStatus < 500) message = error.message;
    }
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            color: "$errorAccent",
            p: "$4",
            gap: "$2",
            background: "$wellBackground",
            ...css
        },
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faCircleExclamation),
        width: 16,
        height: 16
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "errorLight"
    }, messageWithContent ? messageWithContent : message));
}


const $6f54b4a5aad888ed$var$isSafariBrowser = ()=>typeof window !== "undefined" && navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") <= -1;
function $6f54b4a5aad888ed$export$a81f732198733497(num, fixed) {
    const re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    const fixedNum = num.toString().match(re);
    return fixedNum ? fixedNum[0] : num;
}
function $6f54b4a5aad888ed$export$f5dd818bff069720(amount, maximumFractionDigits = 2) {
    const { format: format } = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: maximumFractionDigits
    });
    if (amount === null || amount === undefined) return "-";
    return format(amount);
}
const $6f54b4a5aad888ed$var$truncateFractionAndFormat = (parts, digits)=>{
    return parts.map(({ type: type, value: value })=>{
        if (type !== "fraction" || !value || value.length < digits) return value;
        let formattedValue = "";
        for(let idx = 0; idx < value.length && idx < digits; idx++)formattedValue += value[idx];
        return formattedValue;
    }).reduce((string, part)=>string + part);
};
/**
 *  Convert ETH values to human readable formats
 * @param amount An ETH amount
 * @param maximumFractionDigits Number of decimal digits
 * @returns returns the ETH value as a `string` or `-` if the amount is `null` or `undefined`
 */ function $6f54b4a5aad888ed$export$87710fd8420713d9(amount, maximumFractionDigits, decimals = 18) {
    if (typeof amount === "undefined" || amount === null) return "-";
    const amountToFormat = typeof amount === "number" ? amount : +(0, $TBcmg$formatUnits)(BigInt(amount), decimals || 18);
    const amountFraction = `${amount}`.split(".")[1];
    const isSafari = $6f54b4a5aad888ed$var$isSafariBrowser();
    const formatOptions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 20,
        useGrouping: true,
        notation: "compact",
        compactDisplay: "short"
    };
    // New issue introduced in Safari v16 causes a regression and now need lessPrecision flagged in format options
    if (isSafari) //@ts-ignore
    formatOptions.roundingPriority = "lessPrecision";
    const parts = new Intl.NumberFormat("en-US", formatOptions).formatToParts(amountToFormat);
    // Safari has a few bugs with the fraction part of formatToParts, sometimes rounding when unnecessary and
    // when amount is in the thousands not properly representing the value in compact display. Until the bug is fixed
    // this workaround should help. bugzilla bug report: https://bugs.webkit.org/show_bug.cgi?id=249231
    // Update: this has been fixed, but still applied for >v15.3 and <v16
    if (isSafari) {
        const partTypes = parts.map((part)=>part.type);
        const partsIncludesFraction = partTypes.includes("fraction");
        const partsIncludeCompactIdentifier = partTypes.includes("compact");
        if (amountFraction) {
            if (!partsIncludesFraction && !partsIncludeCompactIdentifier) {
                const integerIndex = parts.findIndex((part)=>part.type === "integer");
                parts.splice(integerIndex + 1, 0, {
                    type: "decimal",
                    value: "."
                }, {
                    type: "fraction",
                    value: amountFraction
                });
            }
        } else if (!partsIncludesFraction && partsIncludeCompactIdentifier) {
            const compactIdentifier = parts.find((part)=>part.type === "compact");
            const integerIndex = parts.findIndex((part)=>part.type === "integer");
            const integer = parts[integerIndex];
            if (compactIdentifier?.value === "K" && integer) {
                const fraction = `${amount}`.replace(integer.value, "")[0];
                if (fraction && Number(fraction) > 0) parts.splice(integerIndex + 1, 0, {
                    type: "decimal",
                    value: "."
                }, {
                    type: "fraction",
                    value: fraction
                });
            }
        }
    }
    if (parts && parts.length > 0) {
        const lowestValue = Number(`0.${new Array(maximumFractionDigits).join("0")}1`);
        if (amountToFormat > 1000) return $6f54b4a5aad888ed$var$truncateFractionAndFormat(parts, 1);
        else if (amountToFormat < 1 && amountToFormat < lowestValue && amountToFormat !== 0) return `< ${lowestValue}`;
        else return $6f54b4a5aad888ed$var$truncateFractionAndFormat(parts, maximumFractionDigits);
    } else return typeof amount === "string" || typeof amount === "number" ? `${amount}` : "";
}




const $916b743aad99c93e$var$FormatCrypto = ({ amount: amount, maximumFractionDigits: maximumFractionDigits = 4, decimals: decimals = 18, css: css, textStyle: textStyle = "subtitle3", textColor: textColor = "base", children: children })=>{
    const value = (0, $6f54b4a5aad888ed$export$87710fd8420713d9)(amount, maximumFractionDigits, decimals);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, value !== "-" ? children : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: textStyle,
        color: textColor,
        css: css,
        as: "p"
    }, value));
};
var $916b743aad99c93e$export$2e2bcd8739ae039 = $916b743aad99c93e$var$FormatCrypto;











const $656b4c95fe3d553c$export$c27ee0ad710f7559 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Arrow, {
    fill: "$neutralBgHover"
});
const $656b4c95fe3d553c$var$PopoverArrow = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Arrow1, {
    fill: "$neutralBgHover"
});
const $656b4c95fe3d553c$var$Tooltip = ({ children: children, content: content, open: open, defaultOpen: defaultOpen, onOpenChange: onOpenChange, delayDuration: delayDuration = 0, ...props })=>{
    const isSmallDevice = (0, $TBcmg$useMediaQuery)("only screen and (max-width : 768px)");
    if (isSmallDevice) return /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root1, {
        open: open,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Trigger1, {
        style: {
            backgroundColor: "transparent",
            borderWidth: 0,
            padding: 0,
            display: "flex"
        }
    }, children), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Content1, {
        sideOffset: 2,
        side: "bottom",
        align: "center",
        style: {
            zIndex: 100,
            outline: "none"
        },
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($656b4c95fe3d553c$var$PopoverArrow, null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            zIndex: 9999,
            $$shadowColor: "$colors$gray7",
            boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
            borderRadius: 8,
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            background: "$neutralBgHover",
            p: "$2"
        }
    }, content))));
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root, {
        open: open,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        delayDuration: delayDuration
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Trigger, {
        style: {
            backgroundColor: "transparent",
            borderWidth: 0,
            padding: 0,
            display: "flex"
        }
    }, children), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Content, {
        sideOffset: 2,
        side: "bottom",
        align: "center",
        style: {
            zIndex: 100
        },
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($656b4c95fe3d553c$export$c27ee0ad710f7559, null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            zIndex: 9999,
            $$shadowColor: "$colors$gray7",
            boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
            borderRadius: 8,
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            background: "$neutralBgHover",
            p: "$2"
        }
    }, content))));
};
var $656b4c95fe3d553c$export$2e2bcd8739ae039 = $656b4c95fe3d553c$var$Tooltip;




const $bedde9b021cf9a1c$var$FormatCryptoCurrency = ({ amount: amount, address: address = (0, $TBcmg$zeroAddress), maximumFractionDigits: maximumFractionDigits, logoWidth: logoWidth = 14, textStyle: textStyle, css: css, textColor: textColor, decimals: decimals, chainId: chainId, symbol: symbol })=>{
    const { chain: activeChain } = (0, $TBcmg$useAccount)();
    const blockExplorerBaseUrl = activeChain?.blockExplorers?.default?.url || "https://etherscan.io";
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $916b743aad99c93e$export$2e2bcd8739ae039), {
        css: css,
        textColor: textColor,
        textStyle: textStyle,
        amount: amount,
        maximumFractionDigits: maximumFractionDigits,
        decimals: decimals
    }, symbol ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $656b4c95fe3d553c$export$2e2bcd8739ae039), {
        side: "top",
        content: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
            href: `${blockExplorerBaseUrl}/address/${address}`,
            target: "_blank",
            weight: "medium",
            css: {
                fontSize: 14
            },
            onClick: (event)=>event.stopPropagation()
        }, symbol)
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
        css: {
            height: logoWidth
        },
        address: address,
        chainId: chainId
    })) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
        css: {
            height: logoWidth
        },
        address: address,
        chainId: chainId
    }));
};
var $bedde9b021cf9a1c$export$2e2bcd8739ae039 = $bedde9b021cf9a1c$var$FormatCryptoCurrency;






const $bbced143042e1aed$var$LoaderContainer = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "$neutralText"
});
function $bbced143042e1aed$export$2e2bcd8739ae039(props) {
    const { icon: icon, ...containerProps } = props;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($bbced143042e1aed$var$LoaderContainer, {
        ...containerProps
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$motion).div, {
        initial: {
            rotate: 0
        },
        transition: {
            repeat: Infinity,
            duration: 1,
            ease: "linear"
        },
        animate: {
            rotate: 360
        }
    }, icon ? icon : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faSpinner),
        width: 20,
        height: 20
    })));
}










const $e11f8e20e03baf92$var$getChainBlockExplorerUrl = (chainId)=>{
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>id === chainId);
    if (chainId === 999) return $TBcmg$viemchains.zoraTestnet.blockExplorers.default.url;
    if (chainId === 747) return (0, $TBcmg$customChains).flow.blockExplorers.default.url;
    return wagmiChain?.blockExplorers?.default?.url || "https://etherscan.io";
};
var $e11f8e20e03baf92$export$2e2bcd8739ae039 = $e11f8e20e03baf92$var$getChainBlockExplorerUrl;


const $e92d8c2581b5f9df$var$Progress = ({ title: title, txHashes: txHashes })=>{
    const hasTxHashes = txHashes && txHashes.length > 0;
    const enhancedTxHashes = (0, $TBcmg$useMemo)(()=>{
        return txHashes?.map((hash)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return {
                txHash: hash.txHash,
                chainId: hash.chainId,
                truncatedTxHash: truncatedTxHash,
                blockExplorerUrl: blockExplorerUrl
            };
        });
    }, [
        txHashes
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            alignItems: "center",
            gap: "$4",
            mt: "$5",
            mb: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, title), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralText"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: hasTxHashes ? (0, $TBcmg$faCube) : (0, $TBcmg$faWallet),
        style: {
            width: "32px",
            height: "32px",
            marginTop: "12px 0px"
        }
    })), hasTxHashes ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        css: {
            gap: "$2"
        }
    }, enhancedTxHashes?.map((enhancedTxHash, index)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
            key: index,
            href: `${enhancedTxHash.blockExplorerUrl}/tx/${enhancedTxHash.txHash}`,
            color: "primary",
            weight: "medium",
            target: "_blank",
            css: {
                fontSize: 12
            }
        }, "View transaction: ", enhancedTxHash.truncatedTxHash))) : null);
};
var $e92d8c2581b5f9df$export$2e2bcd8739ae039 = $e92d8c2581b5f9df$var$Progress;
















const $768c94381da6e8b2$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $TBcmg$useState)(false);
    (0, $TBcmg$useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) setMatches(media.matches);
        const listener = ()=>{
            setMatches(media.matches);
        };
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        matches,
        query
    ]);
    return matches;
};
var $768c94381da6e8b2$export$2e2bcd8739ae039 = $768c94381da6e8b2$var$useMediaQuery;


const $2fec296c1c0f429e$export$c6fdb837b070b4ff = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Overlay, {
    backgroundColor: "$overlayBackground",
    position: "fixed",
    inset: 0,
    zIndex: 1000
});
const $2fec296c1c0f429e$export$a14718312a4275d3 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ ...props }, forwardedRef)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($2fec296c1c0f429e$export$c6fdb837b070b4ff, {
        ...props,
        forceMount: true,
        asChild: true
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$motion).div, {
        ref: forwardedRef,
        transition: {
            duration: 0.5
        },
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    })));
const $2fec296c1c0f429e$export$7c6e2c02157bb7d2 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Content2, {
    backgroundColor: "$contentBackground",
    borderRadius: "$borderRadius",
    $$shadowColor: "$colors$gray7",
    boxShadow: "box-shadow: 0px 2px 16px $$shadowColor",
    border: "1px solid $borderColor",
    position: "fixed",
    left: "50%",
    maxWidth: 516,
    top: "100%",
    width: "100%",
    zIndex: 1000,
    "&:focus": {
        outline: "none"
    },
    "@media(max-width: 520px)": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        border: 0
    }
});
const $2fec296c1c0f429e$export$43a7eb3180015c73 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ children: children, ...props }, forwardedRef)=>{
    const isMobile = (0, $768c94381da6e8b2$export$2e2bcd8739ae039)("(max-width: 520px)");
    const animation = isMobile ? {
        initial: {
            opacity: 0,
            bottom: "-100%",
            top: "auto",
            left: 0
        },
        animate: {
            opacity: 1,
            bottom: 0,
            top: "auto",
            left: 0
        },
        exit: {
            opacity: 0,
            bottom: "-100%",
            top: "auto",
            left: 0
        }
    } : {
        initial: {
            opacity: 0,
            top: "14%",
            transform: "translateX(-50%)"
        },
        animate: {
            opacity: 1,
            top: "9%",
            transform: "translateX(-50%)"
        },
        exit: {
            opacity: 0,
            top: "14%",
            transform: "translateX(-50%)"
        }
    };
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($2fec296c1c0f429e$export$7c6e2c02157bb7d2, {
        forceMount: true,
        asChild: true,
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$motion).div, {
        key: isMobile + "modal",
        ref: forwardedRef,
        transition: {
            type: isMobile ? "tween" : "spring",
            duration: 0.5
        },
        ...animation
    }, children));
});
const $2fec296c1c0f429e$export$c8d6a95fc1e37f93 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($2fec296c1c0f429e$export$43a7eb3180015c73, {});
const $2fec296c1c0f429e$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ children: children, trigger: trigger, portalProps: portalProps, onOpenChange: onOpenChange, open: open, size: size, ...props }, forwardedRef)=>{
    const [dialogOpen, setDialogOpen] = (0, $TBcmg$useState)(false);
    (0, $TBcmg$useEffect)(()=>{
        if (open !== undefined && open !== dialogOpen) {
            setDialogOpen(open);
            if (onOpenChange) onOpenChange(open);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root2, {
        onOpenChange: (open)=>{
            setDialogOpen(open);
            if (onOpenChange) onOpenChange(open);
        },
        open: dialogOpen
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$DialogTrigger, {
        asChild: true
    }, trigger), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$AnimatePresence), null, dialogOpen && /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$DialogPortal, {
        forceMount: true,
        ...portalProps
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($2fec296c1c0f429e$export$a14718312a4275d3, {
        "data-radix-dismissable": true
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement($2fec296c1c0f429e$export$c8d6a95fc1e37f93, {
        ref: forwardedRef,
        ...props,
        forceMount: true,
        css: {
            maxWidth: size === (0, $32d03e1adcee2721$export$e8598848ef5f29c0).MD ? 516 : 750
        }
    }, children))));
});




const $d20859f9b2cb3548$var$ReservoirText = (props)=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "50",
        height: "10",
        viewBox: "0 0 50 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.104492 8.99985V2.75985C0.608492 2.72385 1.11249 2.72385 1.62849 2.75985L1.73649 3.77985H1.80849C2.00049 2.97585 2.78049 2.63985 3.87249 2.63985C3.92049 3.04785 3.92049 3.71985 3.87249 4.12785C2.51649 4.12785 2.14449 4.40385 1.82049 5.26785V8.99985C1.40049 9.05985 0.512492 9.05985 0.104492 8.99985Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.2115 5.02785V6.40785C9.40749 6.46785 7.55949 6.47985 6.52749 6.41985V6.71985C6.52749 7.57185 7.01949 7.72785 8.05149 7.72785C8.75949 7.72785 9.26349 7.66785 9.93549 7.53585C9.98349 7.94385 9.98349 8.51985 9.93549 8.92785C9.09549 9.07185 8.42349 9.14385 7.63149 9.14385C5.90349 9.14385 4.81149 8.62785 4.81149 7.10385V4.70385C4.81149 3.10785 5.96349 2.63985 7.55949 2.63985C9.14349 2.63985 10.2115 3.31185 10.2115 5.02785ZM8.53149 5.36385V4.95585C8.53149 4.13985 8.06349 4.04385 7.53549 4.04385C7.00749 4.04385 6.52749 4.13985 6.52749 4.95585V5.42385L7.45149 5.36385H8.53149Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.9181 6.94785V7.53585C15.9181 8.69985 15.0061 9.14385 13.5181 9.14385C12.8821 9.14385 12.1501 9.09585 11.4661 8.97585C11.4061 8.54385 11.4061 8.05185 11.4661 7.63185C12.1141 7.73985 12.7621 7.77585 13.2661 7.77585C13.7461 7.77585 14.2021 7.73985 14.2021 7.33185V7.10385C14.2021 6.75585 13.9621 6.69585 13.5541 6.58785L12.4741 6.27585C11.7901 6.08385 11.4181 5.65185 11.4181 4.85985V4.19985C11.4181 3.08385 12.3781 2.63985 13.9021 2.63985C14.5021 2.63985 15.1261 2.68785 15.8221 2.83185C15.8821 3.26385 15.8821 3.74385 15.8221 4.16385C15.0901 4.03185 14.6221 3.99585 14.0941 3.99585C13.5781 3.99585 13.1341 4.03185 13.1341 4.43985V4.66785C13.1341 4.96785 13.4101 5.07585 13.7821 5.18385L14.7901 5.45985C15.5341 5.66385 15.9181 6.03585 15.9181 6.94785Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M22.5865 5.02785V6.40785C21.7825 6.46785 19.9345 6.47985 18.9025 6.41985V6.71985C18.9025 7.57185 19.3945 7.72785 20.4265 7.72785C21.1345 7.72785 21.6385 7.66785 22.3105 7.53585C22.3585 7.94385 22.3585 8.51985 22.3105 8.92785C21.4705 9.07185 20.7985 9.14385 20.0065 9.14385C18.2785 9.14385 17.1865 8.62785 17.1865 7.10385V4.70385C17.1865 3.10785 18.3385 2.63985 19.9345 2.63985C21.5185 2.63985 22.5865 3.31185 22.5865 5.02785ZM20.9065 5.36385V4.95585C20.9065 4.13985 20.4385 4.04385 19.9105 4.04385C19.3825 4.04385 18.9025 4.13985 18.9025 4.95585V5.42385L19.8265 5.36385H20.9065Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24.0811 8.99985V2.75985C24.5851 2.72385 25.0891 2.72385 25.6051 2.75985L25.7131 3.77985H25.7851C25.9771 2.97585 26.7571 2.63985 27.8491 2.63985C27.8971 3.04785 27.8971 3.71985 27.8491 4.12785C26.4931 4.12785 26.1211 4.40385 25.7971 5.26785V8.99985C25.3771 9.05985 24.4891 9.05985 24.0811 8.99985Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M30.1801 8.99985L28.2601 2.80785C28.6801 2.74785 29.5681 2.74785 29.9761 2.80785L31.2841 7.42785L32.5801 2.80785C32.9881 2.74785 33.8401 2.74785 34.2481 2.80785L32.3401 8.99985C31.8121 9.05985 30.7081 9.05985 30.1801 8.99985Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M40.7087 4.66785V7.13985C40.7087 8.62785 39.5807 9.14385 37.9007 9.14385C36.2207 9.14385 35.0927 8.62785 35.0927 7.13985V4.66785C35.0927 3.11985 36.2207 2.63985 37.9007 2.63985C39.5807 2.63985 40.7087 3.11985 40.7087 4.66785ZM38.9927 6.76785V5.01585C38.9927 4.18785 38.4887 4.09185 37.9007 4.09185C37.3007 4.09185 36.8087 4.18785 36.8087 5.01585V6.76785C36.8087 7.58385 37.3007 7.67985 37.9007 7.67985C38.4887 7.67985 38.9927 7.58385 38.9927 6.76785Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M42.3037 8.99985V2.80785C42.7117 2.74785 43.5997 2.74785 44.0197 2.80785V8.99985C43.5997 9.05985 42.7117 9.05985 42.3037 8.99985ZM44.0917 0.467852L44.0557 1.83585C43.6357 1.89585 42.6877 1.89585 42.2557 1.83585L42.2317 0.467852C42.6637 0.407852 43.6597 0.407852 44.0917 0.467852Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M45.7725 8.99985V2.75985C46.2765 2.72385 46.7805 2.72385 47.2965 2.75985L47.4045 3.77985H47.4765C47.6685 2.97585 48.4485 2.63985 49.5405 2.63985C49.5885 3.04785 49.5885 3.71985 49.5405 4.12785C48.1845 4.12785 47.8125 4.40385 47.4885 5.26785V8.99985C47.0685 9.05985 46.1805 9.05985 45.7725 8.99985Z"
    }));
};
var $d20859f9b2cb3548$export$2e2bcd8739ae039 = $d20859f9b2cb3548$var$ReservoirText;


const $32d03e1adcee2721$var$Title = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Title, {
    margin: 0
});
var $32d03e1adcee2721$export$e8598848ef5f29c0;
(function(ModalSize) {
    ModalSize[ModalSize["MD"] = 0] = "MD";
    ModalSize[ModalSize["LG"] = 1] = "LG";
})($32d03e1adcee2721$export$e8598848ef5f29c0 || ($32d03e1adcee2721$export$e8598848ef5f29c0 = {}));
const $32d03e1adcee2721$export$e6ff31bff12b7ff4 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)((0, $d20859f9b2cb3548$export$2e2bcd8739ae039), {
    fill: "$neutralText",
    "&:hover": {
        fill: "$neutralSolid"
    }
});
const $32d03e1adcee2721$export$2b77a92f1a5ad772 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ title: title, children: children, trigger: trigger, onBack: onBack, open: open, size: size = $32d03e1adcee2721$export$e8598848ef5f29c0.MD, onOpenChange: onOpenChange, loading: loading, onPointerDownOutside: onPointerDownOutside, onFocusCapture: onFocusCapture }, forwardedRef)=>{
    const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2fec296c1c0f429e$export$3ddf2d174ce01153), {
        ref: forwardedRef,
        trigger: trigger,
        open: open,
        onOpenChange: onOpenChange,
        size: size,
        onPointerDownOutside: onPointerDownOutside,
        onFocusCapture: onFocusCapture
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            p: 16,
            backgroundColor: "$headerBackground",
            alignItems: "center",
            justifyContent: "space-between",
            borderTopRightRadius: "$borderRadius",
            borderTopLeftRadius: "$borderRadius"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($32d03e1adcee2721$var$Title, {
        css: {
            alignItems: "center",
            display: "flex"
        }
    }, onBack && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        color: "ghost",
        size: "none",
        css: {
            mr: "$2",
            color: "$neutralText"
        },
        onClick: onBack
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faChevronLeft),
        width: 16,
        height: 16
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, title)), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Close, {
        asChild: true
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        color: "ghost",
        size: "none",
        css: {
            color: "$neutralText"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faClose),
        width: 16,
        height: 16
    })))), loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
        css: {
            minHeight: 242,
            backgroundColor: "$contentBackground"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            maxHeight: "85vh",
            overflowY: "auto"
        }
    }, children), !providerOptionsContext.disablePoweredByReservoir && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            mx: "auto",
            alignItems: "center",
            justifyContent: "center",
            pb: 12,
            gap: "$1",
            visibility: "$poweredByReservoirVisibility",
            borderBottomRightRadius: "$borderRadius",
            borderBottomLeftRadius: "$borderRadius"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralBorderHover"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faLock),
        width: 9,
        height: 10
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        color: "subtle",
        css: {
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            fontWeight: 400,
            lineHeight: "12px",
            color: "$neutralText"
        }
    }, "Powered by", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
        href: "https://reservoir.tools/",
        target: "_blank",
        weight: "heavy",
        color: "gray",
        css: {
            height: 12,
            fontSize: 12,
            "&:hover": {
                color: "$neutralSolid",
                fill: "$neutralSolid"
            }
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($32d03e1adcee2721$export$e6ff31bff12b7ff4, null)))));
});





















const $7da278adab40104e$var$fetcher = async (urls)=>{
    const fetches = urls.map((url)=>(0, $TBcmg$axios)(url).then((r)=>r.data).catch(()=>undefined) // If a fetch fails, return undefined
    );
    const results = await Promise.allSettled(fetches);
    return results.map((result)=>result.status === "fulfilled" ? result.value : undefined);
};
function $7da278adab40104e$export$2e2bcd8739ae039(preferredCurrencyAddress, currencies) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chains = client?.chains.reduce((map, chain)=>{
        map[chain.id] = chain.baseApiUrl;
        return map;
    }, {});
    const urls = preferredCurrencyAddress ? currencies?.map((currency)=>chains?.[currency.chainId] + `/currencies/conversion/v1?from=${currency.address}&to=${preferredCurrencyAddress}`) : undefined;
    const { data: data, error: error } = (0, $TBcmg$swrimmutable)(urls, $7da278adab40104e$var$fetcher, {
        refreshInterval: 300000
    });
    return {
        data: data,
        isError: !!error,
        isLoading: !data && !error
    };
}




const $f19c84e0e180ca0e$var$fetchNativeBalances = async (address, config, tokens)=>{
    const balancePromises = tokens?.map((currency)=>(0, $TBcmg$getBalance)(config, {
            address: address,
            chainId: currency?.chainId
        }));
    const settledResults = balancePromises ? await Promise.allSettled(balancePromises) : [];
    return settledResults.map((result)=>{
        return result.status === "fulfilled" ? result.value : null;
    });
};
function $f19c84e0e180ca0e$export$2e2bcd8739ae039(options) {
    const { open: open, address: address, quantityToken: quantityToken, path: path, nativeOnly: nativeOnly, chainId: chainId, crossChainDisabled: crossChainDisabled } = options;
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const config = (0, $TBcmg$useConfig)();
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const includeListingCurrency = providerOptions.alwaysIncludeListingCurrency !== false;
    const listingCurrency = path && path[0] && path[0].currency ? {
        contract: path[0].currency,
        decimals: path[0].currencyDecimals || 18,
        symbol: path[0].currencySymbol || ""
    } : undefined;
    const listingCurrencyChainId = path && path[0] && path[0].fromChainId ? path[0].fromChainId : chainId;
    const allPaymentTokens = (0, $TBcmg$useMemo)(()=>{
        let paymentTokens = chain?.paymentTokens;
        if (includeListingCurrency) {
            const listingCurrencyAlreadyExists = paymentTokens?.some((token)=>token?.address?.toLowerCase() === listingCurrency?.contract?.toLowerCase() && token.chainId === listingCurrencyChainId);
            if (!listingCurrencyAlreadyExists && listingCurrency) paymentTokens?.push({
                ...listingCurrency,
                decimals: listingCurrency.decimals || 18,
                address: listingCurrency.contract,
                chainId: listingCurrencyChainId || 1,
                name: listingCurrency.symbol
            });
        }
        if (crossChainDisabled) paymentTokens = paymentTokens?.filter((token)=>token.chainId === chain?.id);
        if (nativeOnly) paymentTokens = paymentTokens?.filter((token)=>token.address === (0, $TBcmg$zeroAddress));
        return paymentTokens;
    }, [
        chain?.paymentTokens,
        crossChainDisabled,
        nativeOnly,
        includeListingCurrency,
        listingCurrency,
        listingCurrencyChainId
    ]);
    const nonNativeCurrencies = (0, $TBcmg$useMemo)(()=>{
        return allPaymentTokens?.filter((currency)=>currency.address !== (0, $TBcmg$zeroAddress));
    }, [
        allPaymentTokens,
        chain?.paymentTokens,
        crossChainDisabled,
        nativeOnly,
        includeListingCurrency,
        listingCurrency
    ]);
    const nativeCurrencies = (0, $TBcmg$useMemo)(()=>{
        return allPaymentTokens?.filter((currency)=>currency.address === (0, $TBcmg$zeroAddress));
    }, [
        allPaymentTokens,
        chain?.paymentTokens,
        crossChainDisabled,
        nativeOnly,
        includeListingCurrency,
        listingCurrency
    ]);
    const { data: nonNativeBalances } = (0, $TBcmg$useReadContracts)({
        contracts: open ? nonNativeCurrencies?.map((currency)=>({
                abi: (0, $TBcmg$erc20Abi),
                address: currency.address.toLowerCase(),
                chainId: currency.chainId,
                functionName: "balanceOf",
                args: [
                    address
                ]
            })) : [],
        query: {
            enabled: open
        },
        allowFailure: false
    });
    const { data: nativeBalances } = (0, $TBcmg$swr)(open ? address : undefined, ()=>$f19c84e0e180ca0e$var$fetchNativeBalances(address, config, nativeCurrencies), {
        revalidateOnFocus: false
    });
    const crosschainChainIds = (0, $TBcmg$useMemo)(()=>{
        if (crossChainDisabled) return [];
        else return allPaymentTokens?.filter((token)=>token?.chainId !== chain?.id)?.map((token)=>token?.chainId) ?? [];
    }, [
        allPaymentTokens,
        crossChainDisabled
    ]);
    const { data: solverCapacity } = (0, $201908b8377e3dd2$export$2e2bcd8739ae039)(chain?.id, open);
    const preferredCurrencyConversions = (0, $7da278adab40104e$export$2e2bcd8739ae039)(path && path[0] ? path[0].currency ?? path[0].buyInCurrency ?? undefined : undefined, open ? allPaymentTokens : undefined);
    return (0, $TBcmg$useMemo)(()=>{
        if (!open) return [];
        const paymentTokens = allPaymentTokens?.reduce((tokens, token, i)=>{
            const conversionData = preferredCurrencyConversions?.data?.[i];
            tokens[`${token.address.toLowerCase()}:${token.chainId}`] = {
                total: 0n,
                usdTotal: 0,
                currency: {
                    ...token,
                    contract: token.address.toLowerCase()
                },
                chainId: token.chainId,
                conversionData: conversionData
            };
            return tokens;
        }, {});
        if (!paymentTokens) return [];
        let totalQuantities = {};
        let orders = {};
        const normalizedQuantities = {};
        for(const key in quantityToken)normalizedQuantities[key.toLowerCase()] = quantityToken[key];
        let currencyChainId = chainId;
        path?.forEach((pathItem, i)=>{
            const tokenKey = `${pathItem.contract?.toLowerCase()}:${pathItem.tokenId}`;
            const contractKey = `${pathItem.contract?.toLowerCase()}`; //todo: test with sweeping
            let assetKey = tokenKey;
            let totalQuantity = 0;
            let requiredQuantity = 0;
            //Determine correct key to use
            if (normalizedQuantities[tokenKey] !== undefined) assetKey = tokenKey;
            else if (normalizedQuantities[contractKey] !== undefined) assetKey = contractKey;
            totalQuantity = totalQuantities[assetKey] || 0;
            requiredQuantity = normalizedQuantities[assetKey] || 0;
            //quantity check
            const pathQuantity = pathItem.quantity || 0;
            const quantityLeft = requiredQuantity - totalQuantity;
            if (totalQuantity === requiredQuantity) return;
            let quantityToTake = 0;
            if (quantityLeft >= pathQuantity) quantityToTake = pathQuantity;
            else quantityToTake = quantityLeft;
            orders[pathItem.orderId] = quantityToTake;
            totalQuantities[assetKey] = totalQuantity + quantityToTake;
            //Total for BuyIn or listing currency
            const currency = pathItem.buyInCurrency ? pathItem.buyInCurrency : pathItem.currency;
            const totalRaw = BigInt(pathItem.buyInRawQuote ? pathItem.buyInRawQuote : pathItem.totalRawPrice ?? 0);
            if (pathItem.fromChainId && pathItem.fromChainId !== chainId) currencyChainId = pathItem.fromChainId;
            const currencyKey = `${currency?.toLowerCase()}:${currencyChainId}`;
            if (paymentTokens[currencyKey]) {
                if (currencyChainId !== chainId && i === 0) paymentTokens[currencyKey].total += (totalRaw - BigInt(pathItem.gasCost ?? 0)) * BigInt(quantityToTake) + BigInt(pathItem.gasCost ?? 0);
                else paymentTokens[currencyKey].total += totalRaw * BigInt(quantityToTake);
            }
        });
        const preferredToken = Object.values(paymentTokens).find((token)=>token.total > 0n);
        return Object.values(paymentTokens).map((token)=>{
            const currency = token.currency;
            let capacityPerRequest = undefined;
            if (!crossChainDisabled && crosschainChainIds?.length > 0 && solverCapacity && token.chainId !== chain?.id && path) capacityPerRequest = BigInt(solverCapacity.capacityPerRequest);
            let balance = 0n;
            if (currency.contract === (0, $TBcmg$zeroAddress)) {
                const index = nativeCurrencies?.findIndex((nativeCurrency)=>nativeCurrency.symbol === currency.symbol && nativeCurrency.chainId === token.chainId) || 0;
                balance = nativeBalances?.[index]?.value ?? 0n;
            } else {
                const index = nonNativeCurrencies?.findIndex((nonNativeCurrency)=>nonNativeCurrency.symbol === currency.symbol && nonNativeCurrency?.address?.toLowerCase() === currency?.contract?.toLowerCase()) || 0;
                balance = nonNativeBalances && nonNativeBalances[index] && (typeof nonNativeBalances[index] === "string" || typeof nonNativeBalances[index] === "number" || typeof nonNativeBalances[index] === "bigint") ? nonNativeBalances[index] : 0n;
            }
            const conversionData = token.conversionData;
            let currencyTotalRaw = token.total;
            if (!currencyTotalRaw && (token.currency.contract !== preferredToken?.currency.contract || token.chainId !== preferredToken?.chainId)) currencyTotalRaw = conversionData?.conversion && conversionData?.conversion !== "0" && preferredToken?.total ? preferredToken.total * (0, $TBcmg$parseUnits)("1", currency.decimals ?? 18) / (0, $TBcmg$parseUnits)(conversionData?.conversion?.toString(), preferredToken.currency.decimals ?? 18) : 0n;
            const currencyTotalFormatted = currencyTotalRaw > 0n ? (0, $TBcmg$formatUnits)(currencyTotalRaw, currency?.decimals || 18) : undefined;
            const usdPrice = Number(conversionData?.usd ?? 0);
            const usdPriceRaw = (0, $TBcmg$parseUnits)(usdPrice.toString(), 6);
            const usdTotalPriceRaw = conversionData?.usd ? (preferredToken?.total || 0n) * usdPriceRaw / (0, $TBcmg$parseUnits)("1", preferredToken?.currency?.decimals ?? 18) : undefined;
            const usdTotalFormatted = usdTotalPriceRaw ? (0, $TBcmg$formatUnits)(usdTotalPriceRaw, 6) : undefined;
            const usdBalanceRaw = conversionData?.usd && typeof balance === "bigint" ? (balance || 0n) * usdPriceRaw / (0, $TBcmg$parseUnits)("1", preferredToken?.currency?.decimals ?? 18) : undefined;
            return {
                ...currency,
                address: token?.currency?.contract?.toLowerCase(),
                usdPrice: token.usdTotal,
                usdPriceRaw: usdPriceRaw,
                usdTotalPriceRaw: usdTotalPriceRaw,
                balance: balance,
                currencyTotalRaw: currencyTotalRaw,
                currencyTotalFormatted: currencyTotalFormatted,
                usdTotalFormatted: usdTotalFormatted,
                usdBalanceRaw: usdBalanceRaw,
                capacityPerRequest: capacityPerRequest,
                chainId: token.chainId
            };
        }).sort((a, b)=>{
            return Number(b.usdBalanceRaw) - Number(a.usdBalanceRaw);
        });
    }, [
        address,
        chainId,
        allPaymentTokens,
        path,
        nonNativeBalances,
        nativeBalances,
        quantityToken,
        listingCurrency,
        listingCurrencyChainId,
        preferredCurrencyConversions
    ]);
}







function $ff7ce0ca6096b543$export$2e2bcd8739ae039(chainId) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const { data: mainnetData, error: mainnetError } = (0, $TBcmg$swr)(chain ? "https://api.relay.link/chains" : null, async (url)=>{
        try {
            const response = await (0, $TBcmg$axios).get(url);
            return response.data;
        } catch (error) {
            console.error("Error fetching relay mainnet chains:", error);
            return undefined;
        }
    }, {
        revalidateOnFocus: false
    });
    const { data: testnetData, error: testnetError } = (0, $TBcmg$swr)(chain ? "https://api.testnets.relay.link/chains" : null, async (url)=>{
        try {
            const response = await (0, $TBcmg$axios).get(url);
            return response.data;
        } catch (error) {
            console.error("Error fetching relay testnet chains:", error);
            return undefined;
        }
    }, {
        revalidateOnFocus: false
    });
    let relayLink = null;
    const mainnetChain = mainnetData?.chains?.find((chain)=>chain.id === chainId);
    const testnetChain = !mainnetChain ? testnetData?.chains?.find((chain)=>chain.id === chainId) : null;
    if (mainnetChain) relayLink = `https://relay.link/bridge/${mainnetChain.name}`;
    else if (testnetChain) relayLink = `https://testnets.relay.link/bridge/${testnetChain.name}`;
    return {
        relayLink: relayLink,
        isError: !!mainnetError || !!testnetError,
        isLoading: !mainnetData && !mainnetError || !testnetData && !testnetError
    };
}


var $1cf2d84a10342ca7$export$b41ddf00b39567e8;
(function(BuyStep) {
    BuyStep[BuyStep["Checkout"] = 0] = "Checkout";
    BuyStep[BuyStep["Approving"] = 1] = "Approving";
    BuyStep[BuyStep["Complete"] = 2] = "Complete";
    BuyStep[BuyStep["Unavailable"] = 3] = "Unavailable";
    BuyStep[BuyStep["SelectPayment"] = 4] = "SelectPayment";
})($1cf2d84a10342ca7$export$b41ddf00b39567e8 || ($1cf2d84a10342ca7$export$b41ddf00b39567e8 = {}));
const $1cf2d84a10342ca7$export$8913f774683cde87 = ({ open: open, token: token, orderId: orderId, chainId: chainId, feesOnTopBps: feesOnTopBps, defaultQuantity: defaultQuantity, feesOnTopUsd: feesOnTopUsd, normalizeRoyalties: normalizeRoyalties, onConnectWallet: onConnectWallet, children: children, walletClient: walletClient, executeBuyOptions: executeBuyOptions })=>{
    const [totalIncludingFees, setTotalIncludingFees] = (0, $TBcmg$useState)(0n);
    const [averageUnitPrice, setAverageUnitPrice] = (0, $TBcmg$useState)(0n);
    const [path, setPath] = (0, $TBcmg$useState)(undefined);
    const [isFetchingPath, setIsFetchingPath] = (0, $TBcmg$useState)(false);
    const [feeOnTop, setFeeOnTop] = (0, $TBcmg$useState)(0n);
    const [buyStep, setBuyStep] = (0, $TBcmg$useState)($1cf2d84a10342ca7$export$b41ddf00b39567e8.Checkout);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [hasEnoughCurrency, setHasEnoughCurrency] = (0, $TBcmg$useState)(true);
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [steps, setSteps] = (0, $TBcmg$useState)(null);
    const [quantity, setQuantity] = (0, $TBcmg$useState)(1);
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const includeListingCurrency = providerOptions.alwaysIncludeListingCurrency !== false;
    const [buyResponseFees, setBuyResponseFees] = (0, $TBcmg$useState)(undefined);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const { data: wagmiWalletClient } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWalletClient;
    const blockExplorerBaseUrl = wagmiChain?.blockExplorers?.default?.url || "https://etherscan.io";
    const blockExplorerBaseName = wagmiChain?.blockExplorers?.default?.name || "Etherscan";
    const { address: address, connector: connector } = (0, $TBcmg$useAccount)();
    const { data: capabilities } = (0, $TBcmg$useCapabilities)({
        query: {
            enabled: connector && (connector.id === "coinbaseWalletSDK" || connector.id === "coinbase")
        }
    });
    const hasAuxiliaryFundsSupport = Boolean(rendererChain?.id ? capabilities?.[rendererChain?.id]?.auxiliaryFunds?.supported : false);
    const [_paymentCurrency, _setPaymentCurrency] = (0, $TBcmg$useState)(undefined);
    const paymentTokens = (0, $f19c84e0e180ca0e$export$2e2bcd8739ae039)({
        open: open,
        address: address,
        quantityToken: {
            [`${token}`]: quantity
        },
        path: path,
        chainId: rendererChain?.id,
        nativeOnly: executeBuyOptions && executeBuyOptions.executionMethod !== undefined
    });
    const paymentCurrency = paymentTokens?.find((paymentToken)=>paymentToken?.address === _paymentCurrency?.address && paymentToken?.chainId === _paymentCurrency?.chainId);
    const { data: tokens, mutate: mutateTokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && token ? {
        tokens: [
            token
        ],
        normalizeRoyalties: normalizeRoyalties
    } : false, {
        revalidateFirstPage: true
    }, rendererChain?.id);
    const tokenData = tokens && tokens[0] ? tokens[0] : undefined;
    const collectionId = tokenData?.token?.collection?.id;
    const is1155 = tokenData?.token?.kind === "erc1155";
    const isOwner = tokenData?.token?.owner?.toLowerCase() === address?.toLowerCase();
    const { data: collections, mutate: mutateCollection } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && collectionId ? {
        id: collectionId,
        normalizeRoyalties: normalizeRoyalties
    } : false, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    const quantityRemaining = (0, $TBcmg$useMemo)(()=>{
        return path ? path.reduce((total, pathItem)=>total + (pathItem.quantity || 0), 0) : 0;
    }, [
        path,
        orderId
    ]);
    const usdPrice = paymentCurrency?.usdPrice || 0;
    const usdPriceRaw = paymentCurrency?.usdPriceRaw || 0n;
    const feeUsd = (0, $TBcmg$formatUnits)(feeOnTop * usdPriceRaw, (paymentCurrency?.decimals || 18) + 6);
    const totalUsd = totalIncludingFees * usdPriceRaw;
    const { relayLink: relayLink } = (0, $ff7ce0ca6096b543$export$2e2bcd8739ae039)(rendererChain?.id);
    let addFundsLink = "";
    if (relayLink) addFundsLink = paymentCurrency?.address ? `${relayLink}?toCurrency=${paymentCurrency?.address}` : relayLink;
    else addFundsLink = paymentCurrency?.address ? `https://jumper.exchange/?toChain=${rendererChain?.id}&toToken=${paymentCurrency?.address}` : `https://jumper.exchange/?toChain=${rendererChain?.id}`;
    if (providerOptions?.convertLink?.chainUrl) {
        addFundsLink = paymentCurrency?.address && providerOptions.convertLink.tokenUrl ? providerOptions.convertLink.tokenUrl : providerOptions.convertLink.chainUrl;
        if (rendererChain?.id) addFundsLink = addFundsLink.replace("{toChain}", `${rendererChain.id}`);
        if (paymentCurrency?.address) addFundsLink = addFundsLink.replace("{toToken}", paymentCurrency?.address);
    } else if (providerOptions?.convertLink?.customUrl) addFundsLink = providerOptions.convertLink.customUrl?.({
        toChain: rendererChain?.id,
        toToken: paymentCurrency?.address,
        toCurrency: paymentCurrency
    });
    const fetchPath = (0, $TBcmg$useCallback)((paymentCurrency, paymentTokens)=>{
        if (!open || !client || !tokenData || !token) {
            setPath(undefined);
            return;
        }
        setTransactionError(null);
        setIsFetchingPath(true);
        const options = {
            ...executeBuyOptions,
            onlyPath: true,
            partial: true
        };
        if (feesOnTopBps && feesOnTopBps?.length > 0) {
            const fixedFees = feesOnTopBps.map((fullFee)=>{
                const [referrer] = fullFee.split(":");
                return `${referrer}:1`;
            });
            options.feesOnTop = fixedFees;
        } else if (feesOnTopUsd && feesOnTopUsd.length > 0) {
            const feesOnTopFixed = feesOnTopUsd.map((feeOnTop)=>{
                const [recipient] = feeOnTop.split(":");
                return `${recipient}:1`;
            });
            options.feesOnTop = feesOnTopFixed;
        } else if (!feesOnTopUsd && !feesOnTopBps) delete options.feesOnTop;
        if (normalizeRoyalties !== undefined) options.normalizeRoyalties = normalizeRoyalties;
        if (paymentCurrency) {
            options.currency = paymentCurrency.address;
            if (paymentCurrency.chainId) options.currencyChainId = paymentCurrency.chainId;
        } else if (!includeListingCurrency && paymentTokens[0]) {
            options.currency = paymentTokens[0].address;
            if (paymentTokens[0].chainId) options.currencyChainId = paymentTokens[0].chainId;
            _setPaymentCurrency(paymentTokens[0]);
        }
        let items = {
            fillType: "trade"
        };
        if (orderId) items.orderId = orderId;
        else items.token = token;
        return client.actions.buyToken({
            options: options,
            chainId: rendererChain?.id,
            items: [
                items
            ],
            wallet: {
                address: async ()=>{
                    return address || (0, $TBcmg$zeroAddress);
                }
            },
            onProgress: ()=>{},
            precheck: true
        }).then((data)=>{
            if (data && data.path) {
                const response = data;
                const path = response.path;
                if (!paymentCurrency && path?.[0]) {
                    const listingToken = {
                        address: path[0].buyInCurrency || path[0].currency,
                        decimals: path[0].buyInCurrencyDecimals || path[0].currencyDecimals || 18,
                        symbol: path[0].buyInCurrencySymbol || path[0].currencySymbol || "",
                        name: path[0].buyInCurrencySymbol || path[0].currencySymbol || "",
                        chainId: rendererChain?.id || 1
                    };
                    _setPaymentCurrency(listingToken);
                }
                setPath(path);
                if (response.fees) setBuyResponseFees(response.fees);
            } else setPath([]);
        }).catch((err)=>{
            if (!err?.response?.data?.message?.includes("Price too high")) setPath([]);
            else {
                err = new (0, $TBcmg$APIError)(err?.response?.data?.message, err?.response?.status, err?.response?.data);
                setTransactionError(err);
            }
            throw err;
        }).finally(()=>{
            setIsFetchingPath(false);
        });
    }, [
        open,
        client,
        address,
        tokenData,
        token,
        orderId,
        normalizeRoyalties,
        rendererChain,
        rendererChain?.paymentTokens,
        includeListingCurrency,
        feesOnTopBps,
        feesOnTopUsd,
        executeBuyOptions,
        _setPaymentCurrency
    ]);
    const setPaymentCurrency = (0, $TBcmg$useCallback)((value)=>{
        if (typeof value === "function") _setPaymentCurrency((prevState)=>{
            const newValue = value(prevState);
            if (newValue?.address !== paymentCurrency?.address || newValue?.chainId !== paymentCurrency?.chainId) fetchPath(newValue, paymentTokens)?.catch((err)=>{
                if (err?.statusCode === 400 && err?.message?.includes("Price too high")) _setPaymentCurrency(prevState);
            });
            return newValue;
        });
        else if (value?.address !== paymentCurrency?.address || value?.chainId !== paymentCurrency?.chainId) {
            _setPaymentCurrency(value);
            fetchPath(value, paymentTokens)?.catch((err)=>{
                if (err?.statusCode === 400 && err?.message?.includes("Price too high")) _setPaymentCurrency(paymentCurrency);
            });
        }
    }, [
        fetchPath,
        _setPaymentCurrency,
        paymentCurrency
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (token || orderId) fetchPath(paymentCurrency, paymentTokens);
    }, [
        fetchPath,
        token,
        orderId
    ]);
    const buyToken = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            onConnectWallet();
            if (document.body.style) document.body.style.pointerEvents = "auto";
            client?.log([
                "Missing wallet, prompting connection"
            ], (0, $TBcmg$LogLevel).Verbose);
            return;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (paymentCurrency?.chainId !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: paymentCurrency?.chainId
        });
        if (paymentCurrency?.chainId !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!token && !orderId) {
            const error = new Error("Missing token or order");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        let options = {
            ...executeBuyOptions,
            currency: paymentCurrency?.address,
            currencyChainId: paymentCurrency?.chainId,
            skipBalanceCheck: hasAuxiliaryFundsSupport
        };
        const relayerFee = BigInt(buyResponseFees?.relayer?.amount?.raw ?? 0);
        if (feesOnTopBps && feesOnTopBps?.length > 0) {
            const fixedFees = feesOnTopBps.map((fullFee)=>{
                const [referrer, feeBps] = fullFee.split(":");
                let totalFeeTruncated = totalIncludingFees - feeOnTop;
                // if relayer fee, subtract from total
                if (relayerFee) totalFeeTruncated -= relayerFee;
                const fee = Math.floor(Number(totalFeeTruncated * BigInt(feeBps)) / 10000);
                const atomicUnitsFee = (0, $TBcmg$formatUnits)(BigInt(fee), 0);
                return `${referrer}:${atomicUnitsFee}`;
            });
            options.feesOnTop = fixedFees;
        } else if (feesOnTopUsd && feesOnTopUsd.length > 0 && usdPriceRaw) {
            const feesOnTopFixed = feesOnTopUsd.map((feeOnTop)=>{
                const [recipient, fee] = feeOnTop.split(":");
                const atomicFee = BigInt(fee);
                const convertedAtomicFee = atomicFee * BigInt(10 ** paymentCurrency?.decimals);
                const currencyFee = convertedAtomicFee / usdPriceRaw;
                const parsedFee = (0, $TBcmg$formatUnits)(currencyFee, 0);
                return `${recipient}:${parsedFee}`;
            });
            options.feesOnTop = feesOnTopFixed;
        } else if (!feesOnTopUsd && !feesOnTopBps) delete options.feesOnTop;
        if (normalizeRoyalties !== undefined) options.normalizeRoyalties = normalizeRoyalties;
        setBuyStep($1cf2d84a10342ca7$export$b41ddf00b39567e8.Approving);
        const items = [];
        const item = {
            fillType: "trade",
            quantity: quantity
        };
        if (is1155) options.partial = true;
        if (orderId) item.orderId = orderId;
        else item.token = token;
        items.push(item);
        client.actions.buyToken({
            chainId: rendererChain?.id,
            items: items,
            expectedPrice: {
                [paymentCurrency?.address || (0, $TBcmg$zeroAddress)]: {
                    raw: totalIncludingFees - relayerFee,
                    currencyAddress: paymentCurrency?.address,
                    currencyDecimals: paymentCurrency?.decimals || 18
                }
            },
            wallet: wallet,
            onProgress: (steps)=>{
                if (!steps) return;
                setSteps(steps);
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem
                });
                else if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setBuyStep($1cf2d84a10342ca7$export$b41ddf00b39567e8.Complete);
            },
            options: options
        }).catch((error)=>{
            if (error && error?.message && error?.message.includes("ETH balance")) setHasEnoughCurrency(false);
            else {
                setTransactionError(error);
                mutateCollection();
                mutateTokens();
                fetchPath(paymentCurrency, paymentTokens);
            }
            setBuyStep($1cf2d84a10342ca7$export$b41ddf00b39567e8.Checkout);
            setStepData(null);
            setSteps(null);
        });
    }, [
        token,
        orderId,
        feesOnTopBps,
        feesOnTopUsd,
        quantity,
        normalizeRoyalties,
        is1155,
        client,
        config,
        rendererChain,
        rendererChain,
        totalIncludingFees,
        hasAuxiliaryFundsSupport,
        wallet,
        paymentCurrency,
        buyResponseFees,
        executeBuyOptions,
        mutateTokens,
        mutateCollection,
        onConnectWallet
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if ((!path || path && path.length === 0) && !isFetchingPath) setBuyStep($1cf2d84a10342ca7$export$b41ddf00b39567e8.Unavailable);
        else setBuyStep($1cf2d84a10342ca7$export$b41ddf00b39567e8.Checkout);
    }, [
        path,
        isFetchingPath
    ]);
    (0, $TBcmg$useEffect)(()=>{
        let totalFees = 0n;
        if (paymentCurrency?.currencyTotalRaw && paymentCurrency.currencyTotalRaw > 0n) {
            let currencyTotalRawMinusRelayerFees = paymentCurrency?.currencyTotalRaw;
            // if relayer fees, subtract from currencyTotalRaw
            if (buyResponseFees?.relayer?.amount?.raw) {
                const relayerFees = BigInt(buyResponseFees?.relayer?.amount?.raw ?? 0);
                currencyTotalRawMinusRelayerFees -= relayerFees;
            }
            if (feesOnTopBps && feesOnTopBps.length > 0) {
                const fees = feesOnTopBps.reduce((totalFees, feeOnTop)=>{
                    const [_, fee] = feeOnTop.split(":");
                    return totalFees + BigInt(fee) * currencyTotalRawMinusRelayerFees / 10000n;
                }, 0n);
                totalFees += fees;
                setFeeOnTop(fees);
            } else if (feesOnTopUsd && feesOnTopUsd.length > 0 && usdPriceRaw) {
                const fees = feesOnTopUsd.reduce((totalFees, feeOnTop)=>{
                    const [_, fee] = feeOnTop.split(":");
                    const atomicFee = BigInt(fee);
                    const convertedAtomicFee = atomicFee * BigInt(10 ** paymentCurrency?.decimals);
                    const currencyFee = convertedAtomicFee / usdPriceRaw;
                    return totalFees + currencyFee;
                }, 0n);
                totalFees += fees;
                setFeeOnTop(fees);
            } else setFeeOnTop(0n);
            setTotalIncludingFees(paymentCurrency?.currencyTotalRaw + totalFees);
            setAverageUnitPrice(paymentCurrency?.currencyTotalRaw / BigInt(quantity));
        } else {
            setTotalIncludingFees(0n);
            setAverageUnitPrice(0n);
        }
    }, [
        feesOnTopBps,
        feesOnTopUsd,
        usdPriceRaw,
        feeOnTop,
        quantity,
        paymentCurrency,
        buyResponseFees
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (paymentCurrency?.balance != undefined && totalIncludingFees != undefined && BigInt(paymentCurrency?.balance) < totalIncludingFees) setHasEnoughCurrency(false);
        else setHasEnoughCurrency(true);
    }, [
        totalIncludingFees,
        paymentCurrency
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setBuyStep($1cf2d84a10342ca7$export$b41ddf00b39567e8.Checkout);
            setTransactionError(null);
            setStepData(null);
            setSteps(null);
            setQuantity(1);
            setPath(undefined);
            _setPaymentCurrency(undefined);
            setBuyResponseFees(undefined);
        } else setQuantity(defaultQuantity || 1);
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "buyModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    (0, $TBcmg$useEffect)(()=>{
        if (quantityRemaining > 0 && quantity > quantityRemaining) setQuantity(quantityRemaining);
    }, [
        quantityRemaining,
        quantity
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: !token || !path || !(paymentTokens.length > 0) && path.length > 0,
        isFetchingPath: isFetchingPath,
        tokenData: tokenData,
        collection: collection,
        quantityAvailable: quantityRemaining || 1,
        paymentCurrency: paymentCurrency,
        paymentTokens: paymentTokens,
        totalIncludingFees: totalIncludingFees,
        averageUnitPrice: averageUnitPrice,
        feeOnTop: feeOnTop,
        buyResponseFees: buyResponseFees,
        buyStep: buyStep,
        transactionError: transactionError,
        hasEnoughCurrency: hasEnoughCurrency,
        hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport,
        addFundsLink: addFundsLink,
        feeUsd: feeUsd,
        totalUsd: totalUsd,
        usdPrice: usdPrice,
        balance: paymentCurrency?.balance ? BigInt(paymentCurrency.balance) : undefined,
        address: address,
        blockExplorerBaseUrl: blockExplorerBaseUrl,
        blockExplorerBaseName: blockExplorerBaseName,
        steps: steps,
        stepData: stepData,
        path: path,
        quantity: quantity,
        isConnected: wallet !== undefined,
        isOwner: isOwner,
        setPaymentCurrency: setPaymentCurrency,
        setQuantity: setQuantity,
        setBuyStep: setBuyStep,
        buyToken: buyToken
    }));
};




const $2e70e0c380877307$var$ProgressBar = ({ value: value, max: max, ...props })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        ...props,
        css: {
            width: "100%",
            gap: "$2",
            ...props.css
        }
    }, [
        ...Array(max)
    ].map((_item, i)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            key: i,
            css: {
                height: 4,
                borderRadius: 99999,
                flex: 1,
                background: "linear-gradient(to left, $neutralBorderHover 50%, $accentSolid 50%) right",
                backgroundSize: "200% 100%",
                backgroundPosition: i + 1 <= value ? "left" : "right",
                transition: "all 0.5s ease"
            }
        })));
};
var $2e70e0c380877307$export$2e2bcd8739ae039 = $2e70e0c380877307$var$ProgressBar;





const $822ff51685ab152b$var$PseudoInput = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("div", {
    all: "unset",
    width: "auto",
    padding: "$4",
    borderRadius: "$space$2",
    fontFamily: "$body",
    fontSize: 16,
    fontWeight: 400,
    color: "$neutralText",
    backgroundColor: "$inputBackground"
});
var $822ff51685ab152b$export$2e2bcd8739ae039 = $822ff51685ab152b$var$PseudoInput;






const $c1ab7eea10f2afe3$var$QuantityButton = (0, $4a58f4053e821189$export$3817b7a54a07cec7)((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
    color: "$neutralSolid",
    backgroundColor: "transparent",
    "&:disabled": {
        backgroundColor: "$transparent",
        color: "$neutralBorderHover"
    },
    "&:disabled:hover": {
        backgroundColor: "$transparent",
        color: "$neutralBorderHover"
    },
    defaultVariants: {
        color: "ghost"
    }
});
const $c1ab7eea10f2afe3$var$QuantityInput = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("input", {
    border: 0,
    background: "none",
    fontSize: 16,
    maxWidth: 53,
    textAlign: "center",
    color: "$neutralTextContrast"
});
const $c1ab7eea10f2afe3$var$QuantitySelector = ({ max: max, min: min, quantity: quantity, setQuantity: setQuantity, css: css })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $822ff51685ab152b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1",
            direction: "column",
            display: "flex",
            alignItems: "center",
            p: 0,
            ...css
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($c1ab7eea10f2afe3$var$QuantityButton, {
        css: {
            px: 20
        },
        disabled: quantity <= min,
        onClick: ()=>{
            setQuantity(quantity - 1);
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faMinus),
        width: "16",
        height: "16",
        style: {
            height: 16
        }
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement($c1ab7eea10f2afe3$var$QuantityInput, {
        value: quantity == -1 ? "" : quantity,
        onChange: (e)=>{
            if (e.target.value === "") {
                setQuantity(-1);
                return;
            }
            const newQuantity = Number(e.target.value || 0);
            if (newQuantity && newQuantity >= min && newQuantity <= max) setQuantity(newQuantity);
            else setQuantity(quantity);
        },
        onBlur: (e)=>{
            if (e.target.value === "") setQuantity(min);
            else if (Number(e.target.value) > max) setQuantity(max);
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement($c1ab7eea10f2afe3$var$QuantityButton, {
        css: {
            px: 20
        },
        disabled: quantity >= max,
        onClick: ()=>{
            setQuantity(quantity + 1);
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faPlus),
        width: "16",
        height: "16",
        style: {
            height: 16
        }
    })));
};
var $c1ab7eea10f2afe3$export$2e2bcd8739ae039 = $c1ab7eea10f2afe3$var$QuantitySelector;












var $e9f22f83d7ce6c58$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.2031 12.2344L7.125 0L0 12.2344L7.125 16.5938L14.2031 12.2344ZM7.125 18L0 13.6406L7.125 24L14.25 13.6406L7.125 18Z",
        fill: "#151718"
    }));



var $7084704732449a1c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.2031 12.2344L7.125 0L0 12.2344L7.125 16.5938L14.2031 12.2344ZM7.125 18L0 13.6406L7.125 24L14.25 13.6406L7.125 18Z",
        fill: "#ECEDEE"
    }));



var $7d47708f704afd5e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 22 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M22 10.4001V15.5719C21.9982 15.8944 21.9162 16.2109 21.7619 16.4905C21.6077 16.77 21.3865 17.003 21.12 17.1668L16.8231 19.7473C16.557 19.9127 16.253 20 15.9431 20C15.6333 20 15.3293 19.9127 15.0631 19.7473L10.7663 17.1668C10.4997 17.003 10.2786 16.77 10.1243 16.4905C9.97009 16.2109 9.88804 15.8944 9.88627 15.5719V14.1203L12.0863 12.7889V15.312L15.9362 17.6417L19.7863 15.312V10.6635L15.9362 8.33391L6.91627 13.7816C6.64765 13.9394 6.34454 14.0224 6.03624 14.0224C5.72794 14.0224 5.42487 13.9394 5.15625 13.7816L0.859362 11.1904C0.59697 11.0242 0.380036 10.7903 0.229515 10.5112C0.0789936 10.2322 -4.12339e-05 9.91743 1.61387e-08 9.59729V4.42551C0.00177377 4.10301 0.08382 3.78651 0.238054 3.50695C0.392329 3.2274 0.613512 2.99434 0.879987 2.83063L5.17688 0.250114C5.44356 0.0863567 5.74741 0 6.05687 0C6.36636 0 6.67021 0.0863567 6.93689 0.250114L11.2337 2.83063C11.5003 2.99434 11.7214 3.2274 11.8757 3.50695C12.03 3.78651 12.112 4.10301 12.1138 4.42551V5.87704L9.90001 7.19956V4.69075L6.05002 2.36113L2.19999 4.69075V9.33385L6.05002 11.6635L15.07 6.21574C15.3386 6.05794 15.6417 5.97505 15.95 5.97505C16.2583 5.97505 16.5614 6.05794 16.83 6.21574L21.1269 8.80701C21.3919 8.97149 21.6115 9.20464 21.7645 9.48376C21.9175 9.76294 21.9986 10.0786 22 10.4001Z",
        fill: "#151718"
    }));



var $fa23e6b7777a860c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 22 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M22 10.4001V15.5719C21.9982 15.8944 21.9162 16.2109 21.7619 16.4905C21.6077 16.77 21.3865 17.003 21.12 17.1668L16.8231 19.7473C16.557 19.9127 16.253 20 15.9431 20C15.6333 20 15.3293 19.9127 15.0631 19.7473L10.7663 17.1668C10.4997 17.003 10.2786 16.77 10.1243 16.4905C9.97009 16.2109 9.88804 15.8944 9.88627 15.5719V14.1203L12.0863 12.7889V15.312L15.9362 17.6417L19.7863 15.312V10.6635L15.9362 8.33391L6.91627 13.7816C6.64765 13.9394 6.34454 14.0224 6.03624 14.0224C5.72794 14.0224 5.42487 13.9394 5.15625 13.7816L0.859362 11.1904C0.59697 11.0242 0.380036 10.7903 0.229515 10.5112C0.0789936 10.2322 -4.12339e-05 9.91743 1.61387e-08 9.59729V4.42551C0.00177377 4.10301 0.08382 3.78651 0.238054 3.50695C0.392329 3.2274 0.613512 2.99434 0.879987 2.83063L5.17688 0.250114C5.44356 0.0863567 5.74741 0 6.05687 0C6.36636 0 6.67021 0.0863567 6.93689 0.250114L11.2337 2.83063C11.5003 2.99434 11.7214 3.2274 11.8757 3.50695C12.03 3.78651 12.112 4.10301 12.1138 4.42551V5.87704L9.90001 7.19956V4.69075L6.05002 2.36113L2.19999 4.69075V9.33385L6.05002 11.6635L15.07 6.21574C15.3386 6.05794 15.6417 5.97505 15.95 5.97505C16.2583 5.97505 16.5614 6.05794 16.83 6.21574L21.1269 8.80701C21.3919 8.97149 21.6115 9.20464 21.7645 9.48376C21.9175 9.76294 21.9986 10.0786 22 10.4001Z",
        fill: "#ECEDEE"
    }));



var $fddcc1a25ecfbbc3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_176_1602)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "url(#paint0_linear_176_1602)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM14.1492 9.97186L11.6029 11.4422V11.4425C11.4681 11.5201 11.3009 11.5201 11.166 11.4425L10.2084 10.8895V9.50626L11.3843 10.1854L13.1699 9.15458V7.09263L11.3843 6.06185L9.63104 7.07426L9.5987 7.09263V12.3473C9.5987 12.5027 9.51528 12.6479 9.38041 12.7258L6.83413 14.1957C6.69927 14.2732 6.53169 14.2732 6.3972 14.1957L3.85091 12.7254C3.71642 12.6475 3.63263 12.5023 3.63263 12.3469V9.40667C3.63263 9.25086 3.71605 9.10607 3.85091 9.02816L6.3972 7.55787C6.46298 7.51965 6.53868 7.49944 6.61548 7.49944C6.69228 7.49944 6.76798 7.51965 6.83413 7.55787L7.79363 8.11166V9.49486L6.61585 8.81502L4.83025 9.84581V11.9078L6.61585 12.9385L8.40144 11.9078V6.65313C8.40144 6.49768 8.48486 6.35253 8.61973 6.27462L11.166 4.80432C11.3009 4.72679 11.4681 4.72642 11.6029 4.80432L14.1492 6.27462C14.2837 6.35253 14.3675 6.49768 14.3675 6.65313V9.59335C14.3675 9.74916 14.2841 9.89395 14.1492 9.97186Z",
        fill: "#F5F0FD"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_176_1602",
        x1: "1.52312",
        y1: "15.6526",
        x2: "18.2537",
        y2: "4.84284",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#A726C1"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.88",
        "stop-color": "#803BDF"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#7B3FE4"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_176_1602"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }))));



var $14da40da7324b67b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0 27.4501H44.626V32.4964H0C0.00804265 35.3958 0.952733 38.4999 2.02134 41.1675C7.03141 53.6749 19.9286 61.178 33.2382 59.8482C47.871 58.3862 59.9284 45.3962 59.9996 30.6484C60.0167 27.0554 59.5248 23.4575 58.3133 20.0583C54.9025 10.4882 46.777 3.13389 36.8681 0.788703C22.7699 -2.54798 7.93539 4.97004 2.2476 18.2814C1.05458 21.0734 0.0254091 24.3866 0 27.4501Z",
        fill: "#11181C"
    }));



var $66db8f2c4f96b2a7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0 27.4501H44.626V32.4964H0C0.00804265 35.3958 0.952733 38.4999 2.02134 41.1675C7.03141 53.6749 19.9286 61.178 33.2382 59.8482C47.871 58.3862 59.9284 45.3962 59.9996 30.6484C60.0167 27.0554 59.5248 23.4575 58.3133 20.0583C54.9025 10.4882 46.777 3.13389 36.8681 0.788703C22.7699 -2.54798 7.93539 4.97004 2.2476 18.2814C1.05458 21.0734 0.0254091 24.3866 0 27.4501Z",
        fill: "#ECEDEE"
    }));



var $376fd4008438767b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "#0054FF"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M2 8.90501H12.4127V10.0825H2C2.00188 10.759 2.2223 11.4833 2.47165 12.1058C3.64066 15.0241 6.65001 16.7749 9.75558 16.4646C13.1699 16.1235 15.9833 13.0924 15.9999 9.6513C16.0039 8.81292 15.8891 7.97342 15.6064 7.18026C14.8106 4.94725 12.9146 3.23124 10.6025 2.68403C7.31297 1.90547 3.85159 3.65968 2.52444 6.76566C2.24607 7.41713 2.00593 8.1902 2 8.90501Z",
        fill: "white"
    }));



var $cba61d2f7feded0d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5303_21434)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.2908 0C13.8114 1.36458 14.3038 2.72938 14.7976 4.09367C15.1797 5.14943 15.5627 6.20485 15.9467 7.25988C16.536 8.87877 17.1288 10.4963 17.7158 12.1161C18.2039 13.4629 18.6823 14.8134 19.1794 16.1568C19.2089 16.2363 19.3662 16.3115 19.4651 16.3129C20.299 16.3253 21.1331 16.32 22 16.32C22 17.0738 22 17.8091 21.9687 18.5722C16.1574 18.6 10.3774 18.6 4.5975 18.6001C4.49921 18.6001 4.39427 18.5795 4.30466 18.6081C4.22858 18.6324 4.17019 18.7139 4.08712 18.7795C4.10586 18.827 4.13519 18.8759 4.17798 18.9015C5.36482 19.6114 5.83208 20.8912 5.34665 22.2721C5.14472 22.8465 4.95113 23.424 4.75375 24C3.84682 24 2.93989 24 2.00528 24C2.11999 23.5687 2.25092 23.1331 2.40691 22.7069C2.88271 21.4071 3.36815 20.1109 3.85879 18.7892C3.2296 18.7892 2.62595 18.7892 2 18.7892C2 17.969 2 17.1658 2 16.3353C2.07129 16.3307 2.1555 16.3208 2.23973 16.3207C2.99703 16.3195 3.75438 16.3155 4.51161 16.3233C4.68961 16.3251 4.77431 16.2815 4.84292 16.0917C5.58325 14.043 6.33886 12 7.09006 9.95534C7.84132 7.91056 8.593 5.86595 9.34208 3.82035C9.40187 3.65708 9.44285 3.48671 9.5367 3.30434C9.72638 3.27269 9.8718 3.24395 10.0175 3.24226C10.5278 3.23634 11.0382 3.24343 11.5485 3.23663C11.6547 3.23521 11.8297 3.28469 11.7762 3.05724C11.5209 2.29102 11.2644 1.52527 11.0114 0.758296C10.9334 0.521996 10.8652 0.282368 10.7856 0.0221322C11.6067 1.78814e-09 12.4349 0 13.2908 0ZM11.9118 3.45758C11.8954 3.43397 11.879 3.41037 11.8626 3.38676C11.8368 3.44012 11.811 3.49347 11.7831 3.59733C11.7637 3.7222 11.7621 3.85332 11.7219 3.97085C11.5526 4.46623 11.3679 4.95617 11.1958 5.45062C10.4153 7.69333 9.63818 9.93723 8.85786 12.18C8.51697 13.1597 8.1692 14.137 7.8289 15.117C7.69219 15.5106 7.56716 15.9085 7.43368 16.314C10.4508 16.314 13.4322 16.314 16.4249 16.314C15.91 14.8313 15.4006 13.3566 14.8859 11.8838C14.0609 9.52309 13.2344 7.16285 12.4033 4.80434C12.2464 4.35921 12.0647 3.92312 11.9118 3.45758Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.8939 24C18.6421 23.4415 18.4353 22.8784 18.1974 22.3256C17.6908 21.1484 18.182 19.7982 19.4119 19.1846C19.5228 19.1293 19.6264 19.0625 19.7813 19.0002C19.8779 18.9997 19.9267 19.0002 19.9754 19.0007C20.1562 19.3887 20.3462 19.7736 20.516 20.1653C20.8843 21.0146 21.2533 21.8639 21.5998 22.7201C21.7692 23.1387 21.8888 23.5729 22 24C20.9543 24 19.9396 24 18.8939 24Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M20.1245 18.91C20.0755 19.0047 20.0316 19.0026 19.9656 18.9985C19.8349 18.9184 19.7262 18.7722 19.6175 18.7719C14.4209 18.7589 9.22428 18.7586 4 18.7391C4.03918 18.4926 4.09812 18.1607 4.1749 18.0619C4.26536 17.9454 4.37128 18.0291 4.47049 18.029C10.3046 18.0287 16.1386 18.0288 22 18.0287C21.9808 18.2729 21.9339 18.7306 21.888 18.729C21.3178 18.7087 20.7478 18.6195 20.1776 18.5629C20.1621 18.5614 20.1456 18.7261 20.1245 18.91Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5303_21434"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $486c3fd4717bcbc9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5303_21433)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.2908 0C13.8114 1.36458 14.3038 2.72938 14.7976 4.09367C15.1797 5.14943 15.5627 6.20485 15.9467 7.25988C16.536 8.87877 17.1288 10.4963 17.7158 12.1161C18.2039 13.4629 18.6823 14.8134 19.1794 16.1568C19.2089 16.2363 19.3662 16.3115 19.4651 16.3129C20.299 16.3253 21.1331 16.32 22 16.32C22 17.0738 22 17.8091 21.9687 18.5722C16.1574 18.6 10.3774 18.6 4.5975 18.6001C4.49921 18.6001 4.39427 18.5795 4.30466 18.6081C4.22858 18.6324 4.17019 18.7139 4.08712 18.7795C4.10586 18.827 4.13519 18.8759 4.17798 18.9015C5.36482 19.6114 5.83208 20.8912 5.34665 22.2721C5.14472 22.8465 4.95113 23.424 4.75375 24C3.84682 24 2.93989 24 2.00528 24C2.11999 23.5687 2.25092 23.1331 2.40691 22.7069C2.88271 21.4071 3.36815 20.1109 3.85879 18.7892C3.2296 18.7892 2.62595 18.7892 2 18.7892C2 17.969 2 17.1658 2 16.3353C2.07129 16.3307 2.1555 16.3208 2.23973 16.3207C2.99703 16.3195 3.75438 16.3155 4.51161 16.3233C4.68961 16.3251 4.77431 16.2815 4.84292 16.0917C5.58325 14.043 6.33886 12 7.09006 9.95534C7.84132 7.91056 8.593 5.86595 9.34208 3.82035C9.40187 3.65708 9.44285 3.48671 9.5367 3.30434C9.72638 3.27269 9.8718 3.24395 10.0175 3.24226C10.5278 3.23634 11.0382 3.24343 11.5485 3.23663C11.6547 3.23521 11.8297 3.28469 11.7762 3.05724C11.5209 2.29102 11.2644 1.52527 11.0114 0.758296C10.9334 0.521996 10.8652 0.282368 10.7856 0.0221322C11.6067 1.78814e-09 12.4349 0 13.2908 0ZM11.9118 3.45758C11.8954 3.43397 11.879 3.41037 11.8626 3.38676C11.8368 3.44012 11.811 3.49347 11.7831 3.59733C11.7637 3.7222 11.7621 3.85332 11.7219 3.97085C11.5526 4.46623 11.3679 4.95617 11.1958 5.45062C10.4153 7.69333 9.63818 9.93723 8.85786 12.18C8.51697 13.1597 8.1692 14.137 7.8289 15.117C7.69219 15.5106 7.56716 15.9085 7.43368 16.314C10.4508 16.314 13.4322 16.314 16.4249 16.314C15.91 14.8313 15.4006 13.3566 14.8859 11.8838C14.0609 9.52309 13.2344 7.16285 12.4033 4.80434C12.2464 4.35921 12.0647 3.92312 11.9118 3.45758Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.8939 24C18.6421 23.4415 18.4353 22.8784 18.1974 22.3256C17.6908 21.1484 18.182 19.7982 19.4119 19.1846C19.5228 19.1293 19.6264 19.0625 19.7813 19.0002C19.8779 18.9997 19.9267 19.0002 19.9754 19.0007C20.1562 19.3887 20.3462 19.7736 20.516 20.1653C20.8843 21.0146 21.2533 21.8639 21.5998 22.7201C21.7692 23.1387 21.8888 23.5729 22 24C20.9543 24 19.9396 24 18.8939 24Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M20.1245 18.91C20.0755 19.0047 20.0316 19.0026 19.9656 18.9985C19.8349 18.9184 19.7262 18.7722 19.6175 18.7719C14.4209 18.7589 9.22428 18.7586 4 18.7391C4.03918 18.4926 4.09812 18.1607 4.1749 18.0619C4.26536 17.9454 4.37128 18.0291 4.47049 18.029C10.3046 18.0287 16.1386 18.0288 22 18.0287C21.9808 18.2729 21.9339 18.7306 21.888 18.729C21.3178 18.7087 20.7478 18.6195 20.1776 18.5629C20.1621 18.5614 20.1456 18.7261 20.1245 18.91Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5303_21433"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $4c7f319d74acbe9e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.64539 4C9.90572 4.62543 10.1519 5.25097 10.3988 5.87627C10.5898 6.36015 10.7813 6.84389 10.9734 7.32744C11.268 8.06944 11.5644 8.81083 11.8579 9.55321C12.102 10.1705 12.3412 10.7895 12.5897 11.4052C12.6044 11.4416 12.6831 11.4761 12.7326 11.4768C13.1495 11.4824 13.5665 11.48 14 11.48C14 11.8255 14 12.1625 13.9843 12.5122C11.0787 12.525 8.18872 12.525 5.29875 12.525C5.2496 12.525 5.19714 12.5156 5.15233 12.5287C5.11429 12.5398 5.0851 12.5772 5.04356 12.6073C5.05293 12.6291 5.0676 12.6514 5.08899 12.6632C5.68241 12.9886 5.91604 13.5751 5.67332 14.2081C5.57236 14.4713 5.47556 14.736 5.37687 15C4.92341 15 4.46995 15 4.00264 15C4.06 14.8023 4.12546 14.6027 4.20346 14.4073C4.44135 13.8116 4.68408 13.2175 4.9294 12.6117C4.6148 12.6117 4.31298 12.6117 4 12.6117C4 12.2358 4 11.8676 4 11.487C4.03565 11.4849 4.07775 11.4804 4.11986 11.4803C4.49852 11.4798 4.87719 11.478 5.2558 11.4815C5.3448 11.4823 5.38715 11.4624 5.42146 11.3753C5.79162 10.4364 6.16943 9.49999 6.54503 8.56286C6.92066 7.62567 7.2965 6.68856 7.67104 5.75099C7.70093 5.67616 7.72142 5.59808 7.76835 5.51449C7.86319 5.49998 7.9359 5.48681 8.00876 5.48603C8.2639 5.48332 8.51912 5.48657 8.77425 5.48345C8.82735 5.48281 8.91485 5.50549 8.88808 5.40124C8.76047 5.05005 8.63218 4.69908 8.50568 4.34755C8.4667 4.23925 8.43262 4.12942 8.39279 4.01014C8.80337 4 9.21746 4 9.64539 4ZM8.95591 5.58472C8.94771 5.5739 8.9395 5.56308 8.93129 5.55226C8.9184 5.57672 8.90552 5.60117 8.89153 5.64878C8.88185 5.70601 8.88104 5.7661 8.86095 5.81997C8.77629 6.04702 8.68394 6.27158 8.5979 6.4982C8.20767 7.52611 7.81909 8.55456 7.42893 9.5825C7.25849 10.0315 7.0846 10.4795 6.91445 10.9286C6.8461 11.109 6.78358 11.2914 6.71684 11.4773C8.22539 11.4773 9.7161 11.4773 11.2124 11.4773C10.955 10.7977 10.7003 10.1218 10.443 9.44675C10.0304 8.36475 9.61722 7.28297 9.20164 6.20199C9.1232 5.99797 9.03234 5.7981 8.95591 5.58472Z",
        fill: "#7AA72B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.447 15C12.321 14.744 12.2176 14.4859 12.0987 14.2325C11.8454 13.693 12.091 13.0742 12.7059 12.7929C12.7614 12.7676 12.8132 12.737 12.8907 12.7084C12.939 12.7082 12.9633 12.7084 12.9877 12.7086C13.0781 12.8865 13.1731 13.0629 13.258 13.2424C13.4422 13.6317 13.6267 14.0209 13.7999 14.4134C13.8846 14.6052 13.9444 14.8042 14 15C13.4772 15 12.9698 15 12.447 15Z",
        fill: "#7AA72B"
    }));



var $18593be7b4385014$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 20 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.0575 14.0509L12.9541 18.5973L15.6301 17.0465L11.8257 11.0502L10.0575 14.0509Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.0669 15.222L18.0649 13.9795L13.908 7.50496L12.3658 10.1219L16.3787 16.6119L17.8296 15.7711C17.972 15.6555 18.0581 15.4859 18.0671 15.3029L18.0669 15.222Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.647525 16.3939L2.69645 17.5746L9.51483 6.63984L8.35764 6.6093C7.37166 6.59537 6.30954 6.8517 5.82206 7.64745L1.95014 13.6488L0.647525 15.6502V16.3939Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.4501 6.63953L10.4002 6.6506L3.50016 18.037L5.91195 19.4256L6.56782 18.3133L13.4501 6.63953Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M19.3521 6.62416C19.3266 5.98633 18.9812 5.40244 18.4403 5.0625L10.8582 0.702226C10.3231 0.432793 9.65466 0.432447 9.1186 0.702053C9.05523 0.734018 1.74522 4.97352 1.74522 4.97352C1.64405 5.02206 1.54659 5.07984 1.45494 5.14546C0.972043 5.49154 0.677696 6.02937 0.647461 6.62022L0.647525 15.6502L1.95014 13.6488L1.9387 6.68126C1.94021 6.65578 1.94341 6.63069 1.94795 6.60595C1.97741 6.44202 2.06893 6.29577 2.20674 6.19694C2.24113 6.17232 9.67602 1.86871 9.69964 1.85691C9.87439 1.76914 10.0965 1.7681 10.2715 1.85418L17.7555 6.159C17.9325 6.27177 18.0435 6.46295 18.0533 6.67196V15.3031C18.0443 15.4861 17.972 15.6555 17.8296 15.7711L16.3787 16.6119L15.6301 17.0465L12.9541 18.5973L10.2405 20.1693C10.0943 20.2221 9.92344 20.2191 9.77849 20.1602L6.56782 18.3133L5.91195 19.4256L8.79726 21.0872C8.89268 21.1415 8.97768 21.1896 9.04745 21.2287C9.15546 21.2893 9.22907 21.3298 9.25507 21.3424C9.46014 21.442 9.75522 21.5 10.0211 21.5C10.2649 21.5 10.5026 21.4552 10.7275 21.3671L18.6096 16.8024C19.062 16.4519 19.3281 15.9233 19.3521 15.3506V6.62416Z",
        fill: "#151718"
    }));



var $af1b2ea8b2e4a002$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 20 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.0575 14.0509L12.9541 18.5973L15.6301 17.0465L11.8257 11.0502L10.0575 14.0509Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.0669 15.222L18.0649 13.9795L13.908 7.50496L12.3658 10.1219L16.3787 16.6119L17.8296 15.7711C17.972 15.6555 18.0581 15.4859 18.0671 15.3029L18.0669 15.222Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.647525 16.3939L2.69645 17.5746L9.51483 6.63984L8.35764 6.6093C7.37166 6.59537 6.30954 6.8517 5.82206 7.64745L1.95014 13.6488L0.647525 15.6502V16.3939Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.4501 6.63953L10.4002 6.6506L3.50016 18.037L5.91195 19.4256L6.56782 18.3133L13.4501 6.63953Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M19.3521 6.62416C19.3266 5.98633 18.9812 5.40244 18.4403 5.0625L10.8582 0.702226C10.3231 0.432793 9.65466 0.432447 9.1186 0.702053C9.05523 0.734018 1.74522 4.97352 1.74522 4.97352C1.64405 5.02206 1.54659 5.07984 1.45494 5.14546C0.972043 5.49154 0.677696 6.02937 0.647461 6.62022L0.647525 15.6502L1.95014 13.6488L1.9387 6.68126C1.94021 6.65578 1.94341 6.63069 1.94795 6.60595C1.97741 6.44202 2.06893 6.29577 2.20674 6.19694C2.24113 6.17232 9.67602 1.86871 9.69964 1.85691C9.87439 1.76914 10.0965 1.7681 10.2715 1.85418L17.7555 6.159C17.9325 6.27177 18.0435 6.46295 18.0533 6.67196V15.3031C18.0443 15.4861 17.972 15.6555 17.8296 15.7711L16.3787 16.6119L15.6301 17.0465L12.9541 18.5973L10.2405 20.1693C10.0943 20.2221 9.92344 20.2191 9.77849 20.1602L6.56782 18.3133L5.91195 19.4256L8.79726 21.0872C8.89268 21.1415 8.97768 21.1896 9.04745 21.2287C9.15546 21.2893 9.22907 21.3298 9.25507 21.3424C9.46014 21.442 9.75522 21.5 10.0211 21.5C10.2649 21.5 10.5026 21.4552 10.7275 21.3671L18.6096 16.8024C19.062 16.4519 19.3281 15.9233 19.3521 15.3506V6.62416Z",
        fill: "#ECEDEE"
    }));



var $60941dc41eb170af$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "18",
        height: "18",
        rx: "9",
        fill: "#2D374B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4888 8.46701L11.4251 6.87843L13.9485 10.8089L13.9497 11.5631L13.9415 6.37266C13.9355 6.24578 13.8682 6.12971 13.7607 6.06127L9.21745 3.44794C9.11118 3.39572 8.9764 3.39627 8.87033 3.44956C8.85601 3.45676 8.84252 3.46456 8.82966 3.47306L8.81383 3.48303L4.40391 6.03856L4.38677 6.04631C4.36478 6.05644 4.34254 6.0693 4.32166 6.08425C4.23806 6.14423 4.18252 6.23289 4.16455 6.33235C4.16186 6.34742 4.15989 6.36277 4.15894 6.37824L4.16586 10.608L6.51637 6.96479C6.8123 6.4817 7.45709 6.3261 8.05562 6.33456L8.75813 6.35312L4.61897 12.9912L5.10689 13.2721L9.29566 6.35984L11.1471 6.35312L6.96912 13.4398L8.71018 14.4412L8.9182 14.5608C9.00619 14.5966 9.10992 14.5984 9.19866 14.5664L13.8057 11.8965L12.9249 12.4069L10.4888 8.46701ZM10.846 13.6117L9.08753 10.8517L10.161 9.03018L12.4704 12.6703L10.846 13.6117Z",
        fill: "#2D374B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.08752 10.8517L10.846 13.6116L12.4705 12.6702L10.161 9.03015L9.08752 10.8517Z",
        fill: "#28A0F0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.9497 11.5631L13.9485 10.8089L11.425 6.87842L10.4888 8.467L12.9249 12.4069L13.8057 11.8965C13.8921 11.8264 13.9443 11.7234 13.9498 11.6122L13.9497 11.5631Z",
        fill: "#28A0F0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.37504 12.2744L4.61888 12.9911L8.75804 6.35311L8.05554 6.33455C7.457 6.32609 6.81225 6.48169 6.51629 6.96478L4.16577 10.608L3.375 11.823V12.2744H3.37504Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.1471 6.35309L9.29571 6.35981L5.10693 13.2721L6.57102 14.1151L6.96917 13.4398L11.1471 6.35309Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.7298 6.34358C14.7144 5.95639 14.5047 5.60191 14.1763 5.39555L9.57358 2.74864C9.24873 2.58505 8.8429 2.58485 8.51754 2.74852C8.47909 2.7679 4.04143 5.34159 4.04143 5.34159C3.98003 5.37102 3.92088 5.40611 3.86522 5.44591C3.57206 5.65603 3.39336 5.9825 3.375 6.34121V11.823L4.16577 10.608L4.15885 6.37828C4.1598 6.36281 4.16174 6.34762 4.16447 6.33258C4.18231 6.23304 4.23789 6.14427 4.32157 6.08429C4.34246 6.06934 8.85588 3.4568 8.87024 3.4496C8.97635 3.39631 9.11114 3.39576 9.21736 3.44798L13.7606 6.06131C13.8681 6.12975 13.9354 6.24582 13.9414 6.3727V11.6123C13.9359 11.7234 13.892 11.8264 13.8056 11.8965L12.9248 12.4069L12.4703 12.6703L10.8459 13.6117L9.19853 14.5664C9.10979 14.5985 9.00606 14.5967 8.91807 14.5609L6.969 13.4398L6.57084 14.1151L8.32242 15.1236C8.38034 15.1565 8.43197 15.1857 8.4743 15.2095C8.5399 15.2463 8.58456 15.2709 8.60035 15.2785C8.72485 15.3389 8.90395 15.3741 9.06536 15.3741C9.21337 15.3741 9.35765 15.347 9.49422 15.2935L14.2791 12.5224C14.5537 12.3097 14.7153 11.9888 14.7298 11.6411V6.34358Z",
        fill: "#96BEDC"
    }));



var $47d6d6287ffb6ae5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 2000 1359.88"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#000000",
        d: "M693.83,0H510.66c-12.65,0-23.94,7.91-28.28,19.79L0.92,1339.67c-3.58,9.82,3.69,20.21,14.14,20.21h183.17\n	c12.65,0,23.94-7.91,28.28-19.78L707.97,20.21C711.55,10.39,704.28,0,693.83,0z M916.62,553.04c-4.81-13.19-23.46-13.19-28.28,0\n	L793.38,813.4c-2.43,6.66-2.43,13.97,0,20.63l184.6,506.06c4.33,11.88,15.63,19.78,28.28,19.78h183.17\n	c10.45,0,17.72-10.39,14.14-20.21L916.62,553.04z M1383.57,807.88c4.81,13.19,23.46,13.19,28.27,0l287.32-787.67\n	c3.58-9.82-3.69-20.21-14.14-20.21h-183.17c-12.65,0-23.94,7.9-28.28,19.79L1288.6,526.88c-2.43,6.66-2.43,13.96,0,20.62\n	L1383.57,807.88z M1022.41,19.65C1018.12,7.85,1006.9,0,994.35,0H810.56c-12.64,0-23.93,7.9-28.27,19.78L300.84,1339.67\n	c-3.58,9.82,3.69,20.21,14.14,20.21h183.18c12.65,0,23.94-7.9,28.28-19.78L895.06,329.52c2.42-6.63,11.79-6.63,14.2,0\n	l368.63,1010.58c4.33,11.88,15.63,19.78,28.28,19.78h183.18c10.45,0,17.72-10.39,14.14-20.2L1022.41,19.65z M1984.94,0h-183.19\n	c-12.64,0-23.94,7.9-28.27,19.78l-334.93,918.2c-2.43,6.66-2.43,13.96,0,20.62l94.98,260.38c4.81,13.19,23.46,13.19,28.27,0\n	l331.55-908.93L1999.08,20.2C2002.66,10.39,1995.39,0,1984.94,0z"
    }));



var $4feb7072ab79e169$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 2000 1359.88"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#ffffff",
        d: "M693.83,0H510.66c-12.65,0-23.94,7.91-28.28,19.79L0.92,1339.67c-3.58,9.82,3.69,20.21,14.14,20.21h183.17\n	c12.65,0,23.94-7.91,28.28-19.78L707.97,20.21C711.55,10.39,704.28,0,693.83,0z M916.62,553.04c-4.81-13.19-23.46-13.19-28.28,0\n	L793.38,813.4c-2.43,6.66-2.43,13.97,0,20.63l184.6,506.06c4.33,11.88,15.63,19.78,28.28,19.78h183.17\n	c10.45,0,17.72-10.39,14.14-20.21L916.62,553.04z M1383.57,807.88c4.81,13.19,23.46,13.19,28.27,0l287.32-787.67\n	c3.58-9.82-3.69-20.21-14.14-20.21h-183.17c-12.65,0-23.94,7.9-28.28,19.79L1288.6,526.88c-2.43,6.66-2.43,13.96,0,20.62\n	L1383.57,807.88z M1022.41,19.65C1018.12,7.85,1006.9,0,994.35,0H810.56c-12.64,0-23.93,7.9-28.27,19.78L300.84,1339.67\n	c-3.58,9.82,3.69,20.21,14.14,20.21h183.18c12.65,0,23.94-7.9,28.28-19.78L895.06,329.52c2.42-6.63,11.79-6.63,14.2,0\n	l368.63,1010.58c4.33,11.88,15.63,19.78,28.28,19.78h183.18c10.45,0,17.72-10.39,14.14-20.2L1022.41,19.65z M1984.94,0h-183.19\n	c-12.64,0-23.94,7.9-28.27,19.78l-334.93,918.2c-2.43,6.66-2.43,13.96,0,20.62l94.98,260.38c4.81,13.19,23.46,13.19,28.27,0\n	l331.55-908.93L1999.08,20.2C2002.66,10.39,1995.39,0,1984.94,0z"
    }));



var $28b313035b01dcbe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.1907 5.65076H6.10825C6.03349 5.65076 5.96677 5.6975 5.94112 5.76771L3.09591 13.5676C3.07476 13.6256 3.11772 13.687 3.17947 13.687H4.26193C4.33668 13.687 4.4034 13.6403 4.42905 13.5701L7.27426 5.77019C7.29541 5.71216 7.25245 5.65076 7.1907 5.65076ZM8.50728 8.91897C8.47886 8.84103 8.36865 8.84103 8.34016 8.91897L7.77899 10.4576C7.76463 10.4969 7.76463 10.5401 7.77899 10.5795L8.86989 13.5701C8.89548 13.6403 8.96226 13.687 9.03702 13.687H10.1195C10.1812 13.687 10.2242 13.6256 10.203 13.5675L8.50728 8.91897ZM11.2667 10.425C11.2952 10.5029 11.4054 10.5029 11.4338 10.425L13.1317 5.77019C13.1529 5.71216 13.1099 5.65076 13.0482 5.65076H11.9657C11.891 5.65076 11.8243 5.69744 11.7986 5.76771L10.7055 8.76438C10.6912 8.80374 10.6912 8.84688 10.7055 8.88623L11.2667 10.425ZM9.13245 5.76688C9.1071 5.69715 9.0408 5.65076 8.96663 5.65076H7.88052C7.80582 5.65076 7.7391 5.69744 7.71345 5.76765L4.8683 13.5676C4.84715 13.6256 4.89011 13.687 4.95187 13.687H6.03438C6.10913 13.687 6.17585 13.6403 6.2015 13.5701L8.37987 7.59807C8.39418 7.55889 8.44955 7.55889 8.46379 7.59807L10.6422 13.5701C10.6678 13.6403 10.7346 13.687 10.8093 13.687H11.8919C11.9536 13.687 11.9966 13.6256 11.9754 13.5677L9.13245 5.76688ZM14.8206 5.65076H13.738C13.6633 5.65076 13.5965 5.69744 13.5709 5.76765L11.5917 11.1938C11.5773 11.2332 11.5773 11.2763 11.5917 11.3156L12.1529 12.8544C12.1814 12.9323 12.2916 12.9323 12.32 12.8544L14.2793 7.48301L14.9041 5.77013C14.9253 5.71216 14.8823 5.65076 14.8206 5.65076Z",
        fill: "#FF7B00"
    }));



var $3aec317f418033c4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5155_86557)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M23.9921 12C23.9921 18.6187 18.6231 23.9841 12.0001 23.9841C5.37706 23.9841 0.00805664 18.6187 0.00805664 12C0.00805664 5.38143 5.37706 0.0159912 12.0001 0.0159912C18.6231 0.0159912 23.9921 5.38143 23.9921 12ZM8.60188 16.7691H6.27456C5.78553 16.7691 5.54396 16.7691 5.39667 16.6749C5.23758 16.5718 5.14037 16.4011 5.12858 16.2126C5.11974 16.039 5.24054 15.827 5.4821 15.403L11.2285 5.28091C11.473 4.85108 11.5968 4.63617 11.7529 4.55668C11.9208 4.47131 12.1212 4.47131 12.2891 4.55668C12.4452 4.63617 12.569 4.85108 12.8135 5.28091L13.9948 7.34172L14.0008 7.35224C14.2649 7.81336 14.3988 8.0472 14.4573 8.29262C14.5221 8.56053 14.5221 8.84316 14.4573 9.11107C14.3984 9.35836 14.2658 9.59389 13.9977 10.062L10.9793 15.3942L10.9715 15.4079C10.7056 15.8728 10.5709 16.1084 10.3842 16.2862C10.1809 16.4806 9.93641 16.6218 9.66832 16.7014C9.4238 16.7691 9.14984 16.7691 8.60188 16.7691ZM14.4791 16.7691H17.8139C18.3059 16.7691 18.5534 16.7691 18.7008 16.6721C18.8598 16.569 18.9599 16.3952 18.9689 16.2069C18.9773 16.0389 18.8592 15.8351 18.6276 15.4358C18.6196 15.4222 18.6117 15.4084 18.6035 15.3943L16.9331 12.5386L16.9141 12.5064C16.6794 12.1098 16.5609 11.9095 16.4087 11.832C16.2409 11.7466 16.0433 11.7466 15.8755 11.832C15.7223 11.9115 15.5986 12.1205 15.3541 12.5415L13.6896 15.3972L13.6839 15.4071C13.4402 15.8274 13.3185 16.0374 13.3272 16.2098C13.339 16.3982 13.4362 16.5718 13.5953 16.6749C13.7397 16.7691 13.9871 16.7691 14.4791 16.7691Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5155_86557"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $509d3ee10af302d0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5155_86555)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M23.9921 12C23.9921 18.6187 18.6231 23.9841 12.0001 23.9841C5.37706 23.9841 0.00805664 18.6187 0.00805664 12C0.00805664 5.38143 5.37706 0.0159912 12.0001 0.0159912C18.6231 0.0159912 23.9921 5.38143 23.9921 12ZM8.60188 16.7691H6.27456C5.78553 16.7691 5.54396 16.7691 5.39667 16.6749C5.23758 16.5718 5.14037 16.4011 5.12858 16.2126C5.11974 16.039 5.24054 15.827 5.4821 15.403L11.2285 5.28091C11.473 4.85108 11.5968 4.63617 11.7529 4.55668C11.9208 4.47131 12.1212 4.47131 12.2891 4.55668C12.4452 4.63617 12.569 4.85108 12.8135 5.28091L13.9948 7.34172L14.0008 7.35224C14.2649 7.81336 14.3988 8.0472 14.4573 8.29262C14.5221 8.56053 14.5221 8.84316 14.4573 9.11107C14.3984 9.35836 14.2658 9.59389 13.9977 10.062L10.9793 15.3942L10.9715 15.4079C10.7056 15.8728 10.5709 16.1084 10.3842 16.2862C10.1809 16.4806 9.93641 16.6218 9.66832 16.7014C9.4238 16.7691 9.14984 16.7691 8.60188 16.7691ZM14.4791 16.7691H17.8139C18.3059 16.7691 18.5534 16.7691 18.7008 16.6721C18.8598 16.569 18.9599 16.3952 18.9689 16.2069C18.9773 16.0389 18.8592 15.8351 18.6276 15.4358C18.6196 15.4222 18.6117 15.4084 18.6035 15.3943L16.9331 12.5386L16.9141 12.5064C16.6794 12.1098 16.5609 11.9095 16.4087 11.832C16.2409 11.7466 16.0433 11.7466 15.8755 11.832C15.7223 11.9115 15.5986 12.1205 15.3541 12.5415L13.6896 15.3972L13.6839 15.4071C13.4402 15.8274 13.3185 16.0374 13.3272 16.2098C13.339 16.3982 13.4362 16.5718 13.5953 16.6749C13.7397 16.7691 13.9871 16.7691 14.4791 16.7691Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5155_86555"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $65f350c1ad3fb5c9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_174_1568)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.994 9.5C17.994 14.464 13.9673 18.488 8.99999 18.488C4.03274 18.488 0.00598145 14.464 0.00598145 9.5C0.00598145 4.53604 4.03274 0.511963 8.99999 0.511963C13.9673 0.511963 17.994 4.53604 17.994 9.5ZM6.45135 13.0768H4.70586C4.33908 13.0768 4.15791 13.0768 4.04744 13.0062C3.92813 12.9289 3.85521 12.8008 3.84638 12.6594C3.83974 12.5292 3.93034 12.3702 4.11151 12.0522L8.42133 4.46065C8.60472 4.13828 8.69751 3.97709 8.81462 3.91748C8.94056 3.85345 9.09081 3.85345 9.21675 3.91748C9.33385 3.97709 9.42665 4.13828 9.61003 4.46065L10.496 6.00626L10.5006 6.01415C10.6986 6.35999 10.7991 6.53537 10.8429 6.71944C10.8915 6.92037 10.8915 7.13234 10.8429 7.33327C10.7987 7.51874 10.6993 7.69539 10.4982 8.04646L8.2344 12.0456L8.22854 12.0559C8.02917 12.4046 7.92813 12.5813 7.78809 12.7146C7.63563 12.8604 7.45224 12.9663 7.25118 13.026C7.06779 13.0768 6.86232 13.0768 6.45135 13.0768ZM10.8593 13.0768H13.3604C13.7293 13.0768 13.915 13.0768 14.0255 13.004C14.1448 12.9267 14.2199 12.7964 14.2266 12.6551C14.2329 12.5291 14.1443 12.3763 13.9707 12.0768C13.9647 12.0666 13.9587 12.0562 13.9526 12.0457L12.6998 9.90392L12.6855 9.8798C12.5095 9.5823 12.4206 9.43206 12.3065 9.37399C12.1806 9.30995 12.0324 9.30995 11.9066 9.37399C11.7917 9.43361 11.6989 9.59038 11.5155 9.90612L10.2671 12.0479L10.2629 12.0553C10.0801 12.3705 9.98878 12.528 9.99537 12.6573C10.0042 12.7986 10.0771 12.9289 10.1964 13.0062C10.3047 13.0768 10.4903 13.0768 10.8593 13.0768Z",
        fill: "#E84142"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_174_1568"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }))));



var $c86b7cd015b3714d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.9993 9.2496L30.0001 0L46.0009 9.2496L40.0009 12.4992L30.0001 6.7488L19.7497 12.4992L13.9993 9.2496ZM45.7489 20.7504L39.9985 17.5008L30.0001 23.2512L19.7497 17.5008L13.9993 20.7504V27.5016L24.0001 33.252V45.0024L29.7505 48.5016L35.5009 45.0024V33.5016L45.5017 27.7512V20.7504H45.7489ZM45.7489 39.2496V32.5008L40.0009 36V42.4992L45.7489 39.2496ZM49.9993 41.5008L39.9985 47.2512V54L55.9993 44.7504V26.2512L49.9993 30V41.5008ZM44.2513 15L50.0017 18.4992V25.2504L55.7521 21.7512V15L50.0017 11.5008L44.2513 15ZM24.0001 49.7496V56.4984L29.7505 59.9976L35.5009 56.4984V49.7496L29.7505 53.2488L24.0001 49.7496ZM13.9993 39.2496L19.7497 42.4992V35.7504L13.9993 32.2512V39.2496ZM24.0001 15L29.7505 18.4992L35.7505 15L30.0001 11.5008L24.0001 15ZM9.74894 18.4992L15.7489 15L9.74894 11.5008L4.00093 15V21.7488L9.75133 25.248V18.4992H9.74894ZM9.74894 30L3.99854 26.5008V45L19.9993 54.2496V47.5008L9.99854 41.7504V30H9.74894Z",
        fill: "#11181C"
    }));



var $7a5a0aea01a7aca5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.9993 9.2496L30.0001 0L46.0009 9.2496L40.0009 12.4992L30.0001 6.7488L19.7497 12.4992L13.9993 9.2496ZM45.7489 20.7504L39.9985 17.5008L30.0001 23.2512L19.7497 17.5008L13.9993 20.7504V27.5016L24.0001 33.252V45.0024L29.7505 48.5016L35.5009 45.0024V33.5016L45.5017 27.7512V20.7504H45.7489ZM45.7489 39.2496V32.5008L40.0009 36V42.4992L45.7489 39.2496ZM49.9993 41.5008L39.9985 47.2512V54L55.9993 44.7504V26.2512L49.9993 30V41.5008ZM44.2513 15L50.0017 18.4992V25.2504L55.7521 21.7512V15L50.0017 11.5008L44.2513 15ZM24.0001 49.7496V56.4984L29.7505 59.9976L35.5009 56.4984V49.7496L29.7505 53.2488L24.0001 49.7496ZM13.9993 39.2496L19.7497 42.4992V35.7504L13.9993 32.2512V39.2496ZM24.0001 15L29.7505 18.4992L35.7505 15L30.0001 11.5008L24.0001 15ZM9.74894 18.4992L15.7489 15L9.74894 11.5008L4.00093 15V21.7488L9.75133 25.248V18.4992H9.74894ZM9.74894 30L3.99854 26.5008V45L19.9993 54.2496V47.5008L9.99854 41.7504V30H9.74894Z",
        fill: "#ECEDEE"
    }));



var $c87dda080f321097$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "#FAB600"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.53317 5.00408L9.00001 3L12.4669 5.00408L11.1669 5.70816L9.00001 4.46224L6.77909 5.70816L5.53317 5.00408ZM12.4123 7.49592L11.1663 6.79184L9.00001 8.03776L6.77909 6.79184L5.53317 7.49592V8.95868L7.70001 10.2046V12.7505L8.94593 13.5087L10.1919 12.7505V10.2587L12.3587 9.01276V7.49592H12.4123ZM12.4123 11.5041V10.0418L11.1669 10.8V12.2082L12.4123 11.5041ZM13.3332 11.9918L11.1663 13.2378V14.7L14.6332 12.6959V8.68776L13.3332 9.5V11.9918ZM12.0878 6.25L13.3337 7.00816V8.47092L14.5796 7.71276V6.25L13.3337 5.49184L12.0878 6.25ZM7.70001 13.7791V15.2413L8.94593 15.9995L10.1919 15.2413V13.7791L8.94593 14.5372L7.70001 13.7791ZM5.53317 11.5041L6.77909 12.2082V10.7459L5.53317 9.98776V11.5041ZM7.70001 6.25L8.94593 7.00816L10.2459 6.25L9.00001 5.49184L7.70001 6.25ZM4.61225 7.00816L5.91225 6.25L4.61225 5.49184L3.36685 6.25V7.71224L4.61277 8.4704V7.00816H4.61225ZM4.61225 9.5L3.36633 8.74184V12.75L6.83317 14.7541V13.2918L4.66633 12.0459V9.5H4.61225Z",
        fill: "white"
    }));



var $4fd057ba24517d08$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.7031 12.2344L7.625 0L0.5 12.2344L7.625 16.5938L14.7031 12.2344ZM7.62241 14.8337L12.674 11.7224L7.62072 2.98796L2.53487 11.7209L7.62241 14.8337ZM14.75 13.6406L7.625 18L0.5 13.6406L7.625 24L14.75 13.6406ZM9.51852 18.6L7.625 19.7585L5.73148 18.6L7.625 21.353L9.51852 18.6Z",
        fill: "#151718"
    }));



var $17293dbb35328756$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 15 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.7031 12.2344L7.625 0L0.5 12.2344L7.625 16.5938L14.7031 12.2344ZM7.62241 14.8337L12.674 11.7224L7.62072 2.98796L2.53487 11.7209L7.62241 14.8337ZM14.75 13.6406L7.625 18L0.5 13.6406L7.625 24L14.75 13.6406ZM9.51852 18.6L7.625 19.7585L5.73148 18.6L7.625 21.353L9.51852 18.6Z",
        fill: "#ECEDEE"
    }));



var $aac45b8bc7190a9e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.9375 24C11.9386 24 7.96601 24 4 24C1.79086 24 4.05403e-07 22.2091 3.49982e-07 20C2.16183e-07 14.6667 1.72474e-07 9.33333 8.03423e-08 4C4.21801e-08 1.79086 1.79086 1.09105e-06 4 9.78196e-07C9.33333 7.05733e-07 14.6667 5.93166e-07 20 2.79037e-07C22.2091 1.48921e-07 24 1.79086 24 4C24 9.33333 24 14.6667 24 20C24 22.2091 22.2091 24 20 24C18.6537 24 17.3015 24 15.9375 24ZM7.7979 11.9531C7.7979 9.97493 7.7979 7.99672 7.7979 6.01462C6.82839 6.01462 5.90347 6.01462 4.98743 6.01462C4.98743 10.3794 4.98743 14.7129 4.98743 19.0504C9.12763 19.0504 13.2415 19.0504 17.3637 19.0504C17.3637 18.2008 17.3637 17.3814 17.3637 16.5231C14.1715 16.5231 11.0081 16.5231 7.7979 16.5231C7.7979 15.0052 7.7979 13.5261 7.7979 11.9531ZM15.3044 4.48025C15.2591 4.54372 15.2121 4.60604 15.1688 4.67081C14.3322 5.92139 14.7297 7.55141 16.0518 8.29315C17.2939 8.98993 18.9121 8.44879 19.5301 7.13006C20.0459 6.02927 19.6905 4.71735 18.6873 4.01936C17.6165 3.27428 16.329 3.43311 15.3044 4.48025Z",
        fill: "#11181C"
    }));



var $7cf59313664fc5d2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.9375 24C11.9386 24 7.96601 24 4 24C1.79086 24 4.05403e-07 22.2091 3.49982e-07 20C2.16183e-07 14.6667 1.72474e-07 9.33333 8.03423e-08 4C4.21801e-08 1.79086 1.79086 1.09105e-06 4 9.78196e-07C9.33333 7.05733e-07 14.6667 5.93166e-07 20 2.79037e-07C22.2091 1.48921e-07 24 1.79086 24 4C24 9.33333 24 14.6667 24 20C24 22.2091 22.2091 24 20 24C18.6537 24 17.3015 24 15.9375 24ZM7.7979 11.9531C7.7979 9.97493 7.7979 7.99672 7.7979 6.01462C6.82839 6.01462 5.90347 6.01462 4.98743 6.01462C4.98743 10.3794 4.98743 14.7129 4.98743 19.0504C9.12763 19.0504 13.2415 19.0504 17.3637 19.0504C17.3637 18.2008 17.3637 17.3814 17.3637 16.5231C14.1715 16.5231 11.0081 16.5231 7.7979 16.5231C7.7979 15.0052 7.7979 13.5261 7.7979 11.9531ZM15.3044 4.48025C15.2591 4.54372 15.2121 4.60604 15.1688 4.67081C14.3322 5.92139 14.7297 7.55141 16.0518 8.29315C17.2939 8.98993 18.9121 8.44879 19.5301 7.13006C20.0459 6.02927 19.6905 4.71735 18.6873 4.01936C17.6165 3.27428 16.329 3.43311 15.3044 4.48025Z",
        fill: "#ECEDEE"
    }));



var $6f06c9002ddadb0a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M6.1986 9.50002C6.1986 10.4538 6.1986 11.3783 6.1986 12.327C8.33871 12.327 10.4477 12.327 12.5758 12.327C12.5758 12.8634 12.5758 13.3755 12.5758 13.9065C9.82769 13.9065 7.08508 13.9065 4.32495 13.9065C4.32495 11.1956 4.32495 8.48714 4.32495 5.75916C4.93564 5.75916 5.55226 5.75916 6.1986 5.75916C6.1986 6.99797 6.1986 8.23435 6.1986 9.50002Z",
        fill: "#FBFBFB"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.2182 4.78476C11.8861 4.14568 12.7444 4.04641 13.4583 4.51208C14.127 4.94833 14.364 5.76828 14.0201 6.45627C13.6082 7.28048 12.5293 7.61869 11.7013 7.1832C10.8199 6.71962 10.5549 5.70085 11.1126 4.91924C11.1415 4.87876 11.1728 4.8398 11.2182 4.78476Z",
        fill: "#FDFDFD"
    }));



var $fb16af9c80005fb9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24ZM7.48368 15.2962C7.812 15.3995 8.16768 15.4512 8.55072 15.4512C9.43234 15.4512 10.1346 15.2475 10.6574 14.8402C11.1803 14.4267 11.5451 13.8035 11.7518 12.9706C11.8127 12.7091 11.8704 12.4477 11.9251 12.1862C11.9859 11.9248 12.0376 11.6603 12.0802 11.3928C12.1531 10.9794 12.141 10.6176 12.0437 10.3075C11.9525 9.99744 11.7913 9.73598 11.5603 9.5232C11.3353 9.31042 11.0587 9.1523 10.7304 9.04896C10.4082 8.93952 10.0555 8.8848 9.67248 8.8848C8.78482 8.8848 8.0795 9.09758 7.55664 9.5232C7.03378 9.94882 6.672 10.572 6.47136 11.3928C6.41054 11.6603 6.34978 11.9248 6.28896 12.1862C6.23424 12.4477 6.18254 12.7091 6.13392 12.9706C6.06706 13.384 6.0792 13.7458 6.1704 14.0558C6.2677 14.3659 6.42878 14.6243 6.65376 14.831C6.87874 15.0378 7.15536 15.1928 7.48368 15.2962ZM9.53568 13.8461C9.28642 14.0406 8.9976 14.1379 8.66928 14.1379C8.33486 14.1379 8.09472 14.0406 7.9488 13.8461C7.80288 13.6515 7.7664 13.3415 7.83936 12.9158C7.88798 12.6483 7.93666 12.396 7.98528 12.1589C8.04 11.9218 8.10082 11.6755 8.16768 11.4202C8.27102 10.9945 8.4443 10.6845 8.68752 10.4899C8.93678 10.2954 9.2256 10.1981 9.55392 10.1981C9.88224 10.1981 10.1224 10.2954 10.2744 10.4899C10.4264 10.6845 10.4629 10.9945 10.3838 11.4202C10.3413 11.6755 10.2926 11.9218 10.2379 12.1589C10.1893 12.396 10.1315 12.6483 10.0646 12.9158C9.9613 13.3415 9.78494 13.6515 9.53568 13.8461ZM12.3074 15.2962C12.3439 15.3387 12.3925 15.36 12.4533 15.36H13.6936C13.7605 15.36 13.8182 15.3387 13.8669 15.2962C13.9216 15.2536 13.955 15.1989 13.9672 15.132L14.3868 13.1347H15.618C16.4023 13.1347 17.0255 12.9675 17.4876 12.6331C17.9557 12.2987 18.2658 11.7819 18.4178 11.0827C18.4908 10.7301 18.4877 10.4231 18.4087 10.1616C18.3296 9.8941 18.1898 9.67214 17.9892 9.49584C17.7885 9.31954 17.5362 9.18878 17.2322 9.10368C16.9343 9.01858 16.5998 8.976 16.229 8.976H13.8031C13.7423 8.976 13.6845 8.99726 13.6298 9.03984C13.5751 9.08242 13.5416 9.13714 13.5295 9.204L12.2709 15.132C12.2587 15.1989 12.2709 15.2536 12.3074 15.2962ZM15.6727 11.8762H14.6239L14.9796 10.2437H16.074C16.2928 10.2437 16.4539 10.2802 16.5573 10.3531C16.6668 10.4261 16.7306 10.5234 16.7488 10.645C16.7671 10.7665 16.761 10.9064 16.7306 11.0645C16.6698 11.3381 16.5391 11.5417 16.3384 11.6755C16.1438 11.8093 15.9219 11.8762 15.6727 11.8762Z",
        fill: "#151718"
    }));



var $086a58db72de6a3d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24ZM7.48368 15.2962C7.812 15.3995 8.16768 15.4512 8.55072 15.4512C9.43233 15.4512 10.1346 15.2475 10.6574 14.8402C11.1803 14.4267 11.5451 13.8035 11.7518 12.9706C11.8127 12.7091 11.8704 12.4477 11.9251 12.1862C11.9859 11.9248 12.0376 11.6603 12.0802 11.3928C12.1531 10.9794 12.141 10.6176 12.0437 10.3075C11.9525 9.99744 11.7913 9.73598 11.5603 9.5232C11.3353 9.31042 11.0587 9.1523 10.7304 9.04896C10.4082 8.93952 10.0555 8.8848 9.67248 8.8848C8.78482 8.8848 8.0795 9.09758 7.55664 9.5232C7.03378 9.94882 6.672 10.572 6.47136 11.3928C6.41054 11.6603 6.34978 11.9248 6.28896 12.1862C6.23424 12.4477 6.18254 12.7091 6.13392 12.9706C6.06706 13.384 6.0792 13.7458 6.1704 14.0558C6.2677 14.3659 6.42878 14.6243 6.65376 14.831C6.87874 15.0378 7.15536 15.1928 7.48368 15.2962ZM9.53568 13.8461C9.28642 14.0406 8.9976 14.1379 8.66928 14.1379C8.33486 14.1379 8.09472 14.0406 7.9488 13.8461C7.80288 13.6515 7.7664 13.3415 7.83936 12.9158C7.88798 12.6483 7.93666 12.396 7.98528 12.1589C8.04 11.9218 8.10082 11.6755 8.16768 11.4202C8.27102 10.9945 8.4443 10.6845 8.68752 10.4899C8.93678 10.2954 9.2256 10.1981 9.55392 10.1981C9.88224 10.1981 10.1224 10.2954 10.2744 10.4899C10.4264 10.6845 10.4629 10.9945 10.3838 11.4202C10.3413 11.6755 10.2926 11.9218 10.2379 12.1589C10.1893 12.396 10.1315 12.6483 10.0646 12.9158C9.9613 13.3415 9.78494 13.6515 9.53568 13.8461ZM12.3074 15.2962C12.3439 15.3387 12.3925 15.36 12.4533 15.36H13.6936C13.7605 15.36 13.8182 15.3387 13.8669 15.2962C13.9216 15.2536 13.955 15.1989 13.9672 15.132L14.3868 13.1347H15.618C16.4023 13.1347 17.0255 12.9675 17.4876 12.6331C17.9557 12.2987 18.2658 11.7819 18.4178 11.0827C18.4908 10.7301 18.4877 10.4231 18.4087 10.1616C18.3296 9.8941 18.1898 9.67214 17.9892 9.49584C17.7885 9.31954 17.5362 9.18878 17.2322 9.10368C16.9343 9.01858 16.5998 8.976 16.229 8.976H13.8031C13.7423 8.976 13.6845 8.99726 13.6298 9.03984C13.5751 9.08242 13.5416 9.13714 13.5295 9.204L12.2709 15.132C12.2587 15.1989 12.2709 15.2536 12.3074 15.2962ZM15.6727 11.8762H14.6239L14.9796 10.2437H16.074C16.2928 10.2437 16.4539 10.2802 16.5573 10.3531C16.6668 10.4261 16.7306 10.5234 16.7488 10.645C16.7671 10.7665 16.761 10.9064 16.7306 11.0645C16.6698 11.3381 16.5391 11.5417 16.3384 11.6755C16.1438 11.8093 15.9219 11.8762 15.6727 11.8762Z",
        fill: "#ECEDEE"
    }));



var $1d509d3670662694$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_174_1547)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5ZM5.61276 11.9721C5.859 12.0496 6.12576 12.0884 6.41304 12.0884C7.07425 12.0884 7.60093 11.9357 7.99308 11.6301C8.38523 11.3201 8.65883 10.8526 8.81388 10.2279C8.85949 10.0318 8.9028 9.83577 8.94384 9.63968C8.98945 9.44359 9.02819 9.24523 9.06012 9.0446C9.11484 8.73453 9.10573 8.4632 9.03276 8.23064C8.96436 7.99808 8.84351 7.80199 8.67024 7.6424C8.50151 7.48281 8.29404 7.36423 8.0478 7.28672C7.80613 7.20464 7.54164 7.1636 7.25436 7.1636C6.58861 7.1636 6.05963 7.32319 5.66748 7.6424C5.27533 7.96161 5.004 8.429 4.85352 9.0446C4.80791 9.24523 4.76233 9.44359 4.71672 9.63968C4.67568 9.83577 4.63691 10.0318 4.60044 10.2279C4.55029 10.538 4.5594 10.8093 4.6278 11.0419C4.70077 11.2744 4.82159 11.4682 4.99032 11.6233C5.15905 11.7783 5.36652 11.8946 5.61276 11.9721ZM7.15176 10.8846C6.96481 11.0305 6.7482 11.1034 6.50196 11.1034C6.25115 11.1034 6.07104 11.0305 5.9616 10.8846C5.85216 10.7387 5.8248 10.5061 5.87952 10.1869C5.91599 9.98625 5.95249 9.797 5.98896 9.61916C6.03 9.44132 6.07561 9.25664 6.12576 9.06512C6.20327 8.74591 6.33323 8.51335 6.51564 8.36744C6.70259 8.22153 6.9192 8.14856 7.16544 8.14856C7.41168 8.14856 7.59179 8.22153 7.7058 8.36744C7.81981 8.51335 7.84717 8.74591 7.78788 9.06512C7.75595 9.25664 7.71948 9.44132 7.67844 9.61916C7.64197 9.797 7.59863 9.98625 7.54848 10.1869C7.47097 10.5061 7.33871 10.7387 7.15176 10.8846ZM9.23054 11.9721C9.2579 12.0041 9.29437 12.02 9.33998 12.02H10.2702C10.3204 12.02 10.3637 12.0041 10.4002 11.9721C10.4412 11.9402 10.4663 11.8991 10.4754 11.849L10.7901 10.351H11.7135C12.3017 10.351 12.7691 10.2257 13.1157 9.97484C13.4668 9.72403 13.6993 9.33645 13.8133 8.81204C13.8681 8.54755 13.8658 8.31729 13.8065 8.1212C13.7472 7.92057 13.6423 7.75411 13.4919 7.62188C13.3414 7.48965 13.1521 7.39159 12.9241 7.32776C12.7007 7.26393 12.4499 7.232 12.1717 7.232H10.3523C10.3067 7.232 10.2634 7.24795 10.2223 7.27988C10.1813 7.31181 10.1562 7.35285 10.1471 7.403L9.20318 11.849C9.19404 11.8991 9.20318 11.9402 9.23054 11.9721ZM11.7545 9.40712H10.9679L11.2347 8.18276H12.0555C12.2196 8.18276 12.3404 8.21012 12.418 8.26484C12.5001 8.31956 12.5479 8.39253 12.5616 8.48372C12.5753 8.57491 12.5707 8.67981 12.5479 8.79836C12.5023 9.00356 12.4043 9.15631 12.2538 9.25664C12.1079 9.35697 11.9415 9.40712 11.7545 9.40712Z",
        fill: "#FF0000"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_174_1547"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }))));



var $17d515d2480a4c31$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        id: "Layer_2",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 408.59 401.32"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        id: "Layer_1-2"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#11181c",
        d: "M72.79,191.41c-.02-14.11,.12-27.76,.15-41.42,.05-16.83,.01-33.66,.01-51.08h-13.99v-23.94c7.82,0,15.68-.7,23.35,.19,8.49,.98,14.59,9.04,15.15,18.05,.1,1.66,.04,3.33,.04,5,0,76.32,0,152.65,0,228.97,0,26.47,18.36,46.96,44.37,49.53,24.58,2.43,47.12-14.61,52.14-39.73,4.92-24.61-14.43-58.56-49.26-53.7v26.58h13.65v23.88c-5.64,0-11.31,.51-16.85-.1-12.5-1.39-21.23-11.82-21.56-25.31-.2-8.16-.21-16.34,0-24.5,.41-15.81,9.56-24.97,25.38-25.35,8.99-.22,18-.04,27-.04,53.66,0,107.32,.08,160.98-.05,16.62-.04,31.94,3.76,45.9,13.63,14.04,11.2,23.76,24.87,27.59,42.36,9.76,44.52-22.75,86.45-68.41,86.74-65.81,.42-131.63,.21-197.44-.53-27.21-.31-48.83-11.91-61.35-37.28-5.19-10.5-6.67-21.88-6.68-33.46-.05-45.99-.04-91.98-.17-138.43m141.3,164.39c-3.67,6.79-7.33,13.59-11.22,20.79,1.54,0,3,0,4.46,0,42.99,.11,85.99,.24,128.98,.33,2.49,0,5.02,0,7.47-.38,24.78-3.76,42.07-24.83,40.48-49.62-1.66-25.73-22.02-43.92-47.98-43.95-43.16-.05-86.33-.02-129.49,0-1.2,0-2.41,.19-3.9,.32,15.76,22.38,20.5,46.02,11.2,72.51Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#11181c",
        d: "M379.54,252.32c-7.86-2.41-15.74-5.29-24.19-8.37v-5.23c0-66.45,0-132.91,0-199.36,0-11.1-3.81-14.89-15.04-14.89-79.95,0-159.89,0-239.84,0-31.26,0-58.22,17.38-69.88,45.06-11.71,27.81-5.46,58.26,16.63,80.95,1.63,1.67,3.2,3.41,4.96,4.93,4.5,3.9,6.31,8.76,4.15,14.31-2.19,5.62-6.87,7.84-13.26,7.39-7.42-6.26-15.48-11.72-21.22-19.01C-1.55,128.39-6.23,95.07,8.17,60.43,22.58,25.82,49.55,5.9,86.98,.83,91.74,.18,96.61,.04,101.43,.04,180.93-.01,260.42,0,339.92,0c24.68,0,39.59,14.83,39.59,39.36,0,70.83,0,141.66,.03,212.96Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#11181c",
        d: "M187.67,135.78c40.81,0,81.12,0,121.43,0,6.78,0,10.71,2.35,12.78,7.49,2.96,7.37-1.56,15.28-9.46,16.49-1.14,.17-2.33,.12-3.49,.12-55.3,0-110.61,0-165.91,0-1.15,0-2.29-.1-3.74-.17v-23.93h48.39Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#11181c",
        d: "M246.67,192.41c12.66,0,24.82-.12,36.98,.04,9.39,.12,14.84,6.32,13.2,14.59-1,5.06-4.83,8.71-10.24,9.54-1.8,.28-3.65,.21-5.48,.21-45.47,0-90.94,0-136.41,0h-5.38v-24.39c35.64,0,71.23,0,107.33,0Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#11181c",
        d: "M278.61,78.87c2.15,0,3.82-.02,5.48,0,7.79,.11,13.02,4.92,13.06,12,.05,7.06-5.24,12.04-12.99,12.06-16.65,.04-33.29,.01-49.94,.01h-95.01v-24.07h139.39Z"
    }))));



var $1b92fbd855547021$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        id: "Layer_2",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 408.59 401.32"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        id: "Layer_1-2"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#ecedee",
        d: "M72.79,191.41c-.02-14.11,.12-27.76,.15-41.42,.05-16.83,.01-33.66,.01-51.08h-13.99v-23.94c7.82,0,15.68-.7,23.35,.19,8.49,.98,14.59,9.04,15.15,18.05,.1,1.66,.04,3.33,.04,5,0,76.32,0,152.65,0,228.97,0,26.47,18.36,46.96,44.37,49.53,24.58,2.43,47.12-14.61,52.14-39.73,4.92-24.61-14.43-58.56-49.26-53.7v26.58h13.65v23.88c-5.64,0-11.31,.51-16.85-.1-12.5-1.39-21.23-11.82-21.56-25.31-.2-8.16-.21-16.34,0-24.5,.41-15.81,9.56-24.97,25.38-25.35,8.99-.22,18-.04,27-.04,53.66,0,107.32,.08,160.98-.05,16.62-.04,31.94,3.76,45.9,13.63,14.04,11.2,23.76,24.87,27.59,42.36,9.76,44.52-22.75,86.45-68.41,86.74-65.81,.42-131.63,.21-197.44-.53-27.21-.31-48.83-11.91-61.35-37.28-5.19-10.5-6.67-21.88-6.68-33.46-.05-45.99-.04-91.98-.17-138.43m141.3,164.39c-3.67,6.79-7.33,13.59-11.22,20.79,1.54,0,3,0,4.46,0,42.99,.11,85.99,.24,128.98,.33,2.49,0,5.02,0,7.47-.38,24.78-3.76,42.07-24.83,40.48-49.62-1.66-25.73-22.02-43.92-47.98-43.95-43.16-.05-86.33-.02-129.49,0-1.2,0-2.41,.19-3.9,.32,15.76,22.38,20.5,46.02,11.2,72.51Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#ecedee",
        d: "M379.54,252.32c-7.86-2.41-15.74-5.29-24.19-8.37v-5.23c0-66.45,0-132.91,0-199.36,0-11.1-3.81-14.89-15.04-14.89-79.95,0-159.89,0-239.84,0-31.26,0-58.22,17.38-69.88,45.06-11.71,27.81-5.46,58.26,16.63,80.95,1.63,1.67,3.2,3.41,4.96,4.93,4.5,3.9,6.31,8.76,4.15,14.31-2.19,5.62-6.87,7.84-13.26,7.39-7.42-6.26-15.48-11.72-21.22-19.01C-1.55,128.39-6.23,95.07,8.17,60.43,22.58,25.82,49.55,5.9,86.98,.83,91.74,.18,96.61,.04,101.43,.04,180.93-.01,260.42,0,339.92,0c24.68,0,39.59,14.83,39.59,39.36,0,70.83,0,141.66,.03,212.96Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#ecedee",
        d: "M187.67,135.78c40.81,0,81.12,0,121.43,0,6.78,0,10.71,2.35,12.78,7.49,2.96,7.37-1.56,15.28-9.46,16.49-1.14,.17-2.33,.12-3.49,.12-55.3,0-110.61,0-165.91,0-1.15,0-2.29-.1-3.74-.17v-23.93h48.39Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#ecedee",
        d: "M246.67,192.41c12.66,0,24.82-.12,36.98,.04,9.39,.12,14.84,6.32,13.2,14.59-1,5.06-4.83,8.71-10.24,9.54-1.8,.28-3.65,.21-5.48,.21-45.47,0-90.94,0-136.41,0h-5.38v-24.39c35.64,0,71.23,0,107.33,0Z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fill: "#ecedee",
        d: "M278.61,78.87c2.15,0,3.82-.02,5.48,0,7.79,.11,13.02,4.92,13.06,12,.05,7.06-5.24,12.04-12.99,12.06-16.65,.04-33.29,.01-49.94,.01h-95.01v-24.07h139.39Z"
    }))));



var $bf02c9c19cd88ec6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "#FFEDD8"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_179_1765)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25161 9.12536C5.25105 8.72406 5.25503 8.33584 5.25588 7.94733C5.2573 7.46867 5.25617 6.99001 5.25617 6.49457H4.85828V5.81369C5.08068 5.81369 5.30423 5.79378 5.52237 5.8191C5.76384 5.84697 5.93733 6.0762 5.95325 6.33246C5.9561 6.37967 5.95439 6.42716 5.95439 6.47466C5.95439 8.64527 5.95439 10.8162 5.95439 12.9868C5.95439 13.7396 6.47657 14.3224 7.21632 14.3955C7.91539 14.4646 8.55645 13.9799 8.69923 13.2655C8.83916 12.5656 8.28882 11.6 7.29823 11.7382V12.4942H7.68644V13.1734C7.52604 13.1734 7.36478 13.1879 7.20722 13.1705C6.8517 13.131 6.60341 12.8343 6.59403 12.4507C6.58834 12.2186 6.58806 11.9859 6.59403 11.7539C6.60569 11.3042 6.86592 11.0437 7.31586 11.0329C7.57154 11.0266 7.8278 11.0318 8.08377 11.0318C9.60991 11.0318 11.136 11.034 12.6622 11.0303C13.1349 11.0292 13.5706 11.1373 13.9676 11.418C14.3669 11.7365 14.6434 12.1253 14.7523 12.6227C15.0299 13.8889 14.1053 15.0815 12.8067 15.0897C10.935 15.1017 9.06299 15.0957 7.19129 15.0746C6.41741 15.0658 5.80252 14.7359 5.44644 14.0144C5.29883 13.7157 5.25673 13.3921 5.25645 13.0627C5.25503 11.7547 5.25531 10.4467 5.25161 9.12564M9.27032 13.8011C9.16594 13.9942 9.06185 14.1876 8.95121 14.3923C8.99501 14.3923 9.03654 14.3923 9.07806 14.3923C10.3007 14.3955 11.5237 14.3992 12.7464 14.4017C12.8172 14.4017 12.8891 14.4017 12.9588 14.3909C13.6636 14.284 14.1553 13.6847 14.1101 12.9797C14.0629 12.2479 13.4838 11.7305 12.7455 11.7297C11.518 11.7283 10.2902 11.7291 9.0627 11.7297C9.02857 11.7297 8.99416 11.7351 8.95178 11.7388C9.40001 12.3753 9.53482 13.0477 9.27032 13.8011Z",
        fill: "#1C0500"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.9759 10.8577C13.7523 10.7891 13.5282 10.7072 13.2879 10.6196V10.4709C13.2879 8.58098 13.2879 6.6908 13.2879 4.80089C13.2879 4.4852 13.1795 4.37741 12.8602 4.37741C10.5863 4.37741 8.31273 4.37741 6.03887 4.37741C5.14981 4.37741 4.38304 4.87171 4.05142 5.65896C3.71837 6.4499 3.89613 7.31593 4.52439 7.96125C4.57075 8.00875 4.6154 8.05824 4.66546 8.10147C4.79344 8.21239 4.84492 8.35061 4.78349 8.50846C4.7212 8.6683 4.5881 8.73143 4.40636 8.71864C4.19533 8.5406 3.96609 8.38531 3.80284 8.17797C3.13732 7.33299 3.00422 6.38534 3.41377 5.40015C3.8236 4.4158 4.59066 3.84926 5.6552 3.70506C5.79058 3.68658 5.92909 3.6826 6.06617 3.6826C8.32723 3.68117 10.588 3.68146 12.8491 3.68146C13.551 3.68146 13.975 4.10324 13.975 4.80089C13.975 6.81537 13.975 8.82984 13.9759 10.8577Z",
        fill: "#1C0500"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M8.51896 7.54318C9.67963 7.54318 10.8261 7.54318 11.9725 7.54318C12.1654 7.54318 12.2771 7.61002 12.336 7.75621C12.4202 7.96582 12.2917 8.19078 12.067 8.2252C12.0345 8.23003 12.0007 8.22861 11.9677 8.22861C10.3949 8.22861 8.82185 8.22861 7.24907 8.22861C7.21636 8.22861 7.18394 8.22577 7.1427 8.22377V7.54318H8.51896Z",
        fill: "#1C0500"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.197 9.15379C10.557 9.15379 10.9029 9.15038 11.2487 9.15493C11.5158 9.15834 11.6708 9.33468 11.6241 9.56988C11.5957 9.7138 11.4868 9.81761 11.3329 9.84121C11.2817 9.84918 11.2291 9.84718 11.1771 9.84718C9.88384 9.84718 8.59063 9.84718 7.29742 9.84718H7.14441V9.15351C8.15804 9.15351 9.17026 9.15351 10.197 9.15351V9.15379Z",
        fill: "#1C0500"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.1053 5.92461C11.1664 5.92461 11.2139 5.92405 11.2612 5.92461C11.4827 5.92774 11.6315 6.06454 11.6326 6.26591C11.634 6.4667 11.4836 6.60834 11.2631 6.6089C10.7896 6.61004 10.3163 6.60919 9.8428 6.60919H7.14062V5.92461H11.105H11.1053Z",
        fill: "#1C0500"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_179_1765"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "12.0164",
        height: "12.0164",
        fill: "white",
        transform: "translate(2.99182 3.49182)"
    }))));



var $5f00ef0d650f1d6c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#202425"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.4706 14.5895L18.8656 12.6291C19.0455 12.5253 19.1567 12.3322 19.1567 12.1245V8.20417C19.1567 7.99691 19.045 7.80337 18.8656 7.69949L15.4706 5.7391C15.2908 5.63522 15.0678 5.63571 14.888 5.7391L11.493 7.69949C11.3131 7.80337 11.2019 7.99691 11.2019 8.20417V15.2103L8.82113 16.5847L6.44034 15.2103V12.4611L8.82113 11.0867L10.3915 11.9932V10.1489L9.11218 9.41049C9.02398 9.35953 8.92305 9.33258 8.82064 9.33258C8.71824 9.33258 8.6173 9.35953 8.52959 9.41049L5.13455 11.3709C4.95473 11.4748 4.84351 11.6678 4.84351 11.8756V15.7959C4.84351 16.0031 4.95522 16.1967 5.13455 16.3005L8.52959 18.2609C8.70893 18.3643 8.93235 18.3643 9.11218 18.2609L12.5072 16.301C12.687 16.1971 12.7983 16.0036 12.7983 15.7963V8.79018L12.8414 8.76568L15.1791 7.4158L17.5598 8.79018V11.5394L15.1791 12.9138L13.6111 12.0083V13.8526L14.888 14.59C15.0678 14.6934 15.2908 14.6934 15.4706 14.59V14.5895Z",
        fill: "white"
    }));



var $8935b9b25f83123f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#687076"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.4706 14.5895L18.8656 12.6291C19.0455 12.5253 19.1567 12.3322 19.1567 12.1245V8.20417C19.1567 7.99691 19.045 7.80337 18.8656 7.69949L15.4706 5.7391C15.2908 5.63522 15.0678 5.63571 14.888 5.7391L11.493 7.69949C11.3131 7.80337 11.2019 7.99691 11.2019 8.20417V15.2103L8.82113 16.5847L6.44034 15.2103V12.4611L8.82113 11.0867L10.3915 11.9932V10.1489L9.11218 9.41049C9.02398 9.35953 8.92305 9.33258 8.82064 9.33258C8.71824 9.33258 8.6173 9.35953 8.52959 9.41049L5.13455 11.3709C4.95473 11.4748 4.84351 11.6678 4.84351 11.8756V15.7959C4.84351 16.0031 4.95522 16.1967 5.13455 16.3005L8.52959 18.2609C8.70893 18.3643 8.93235 18.3643 9.11218 18.2609L12.5072 16.301C12.687 16.1971 12.7983 16.0036 12.7983 15.7963V8.79018L12.8414 8.76568L15.1791 7.4158L17.5598 8.79018V11.5394L15.1791 12.9138L13.6111 12.0083V13.8526L14.888 14.59C15.0678 14.6934 15.2908 14.6934 15.4706 14.59V14.5895Z",
        fill: "white"
    }));



var $607df437226f7709$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_176_1624)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z",
        fill: "url(#paint0_linear_176_1624)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.6029 11.4422L14.1492 9.97186C14.284 9.89395 14.3674 9.74916 14.3674 9.59335V6.65313C14.3674 6.49768 14.2837 6.35253 14.1492 6.27462L11.6029 4.80432C11.468 4.72642 11.3008 4.72679 11.1659 4.80432L8.61966 6.27462C8.4848 6.35253 8.40138 6.49768 8.40138 6.65313V11.9078L6.61579 12.9385L4.83019 11.9078V9.84581L6.61579 8.81502L7.79357 9.49486V8.11166L6.83407 7.55787C6.76792 7.51965 6.69222 7.49944 6.61542 7.49944C6.53862 7.49944 6.46291 7.51965 6.39713 7.55787L3.85085 9.02816C3.71599 9.10607 3.63257 9.25086 3.63257 9.40667V12.3469C3.63257 12.5023 3.71635 12.6475 3.85085 12.7254L6.39713 14.1957C6.53163 14.2732 6.6992 14.2732 6.83407 14.1957L9.38035 12.7258C9.51522 12.6479 9.59864 12.5027 9.59864 12.3473V7.09263L9.63097 7.07426L11.3842 6.06185L13.1698 7.09263V9.15458L11.3842 10.1854L10.2083 9.50626V10.8895L11.1659 11.4425C11.3008 11.5201 11.468 11.5201 11.6029 11.4425V11.4422Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_176_1624",
        x1: "-3.28948",
        y1: "1.97941",
        x2: "15.2926",
        y2: "13.3508",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#A229C5"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#7B3FE4"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_176_1624"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }))));



var $9958e6a8fb5c6b4f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 400 400"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("circle", {
        fillRule: "evenodd",
        clipRule: "evenOdd",
        cx: "200",
        cy: "200",
        r: "200"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenOdd",
        fill: "#ffffff",
        d: "M316,199l-66.7-66.4v48.6l-66.2,48.7l66.2,0v35.5L316,199z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenOdd",
        fill: "#ffffff",
        d: "M81,199l66.7,66.4v-48.3l66.2-49.1l-66.2,0v-35.5L81,199z"
    })));



var $1592c77d361e1d1b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 400 400"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("circle", {
        fillRule: "evenodd",
        clipRule: "evenOdd",
        fill: "#ffffff",
        cx: "200",
        cy: "200",
        r: "200"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenOdd",
        d: "M316,199l-66.7-66.4v48.6l-66.2,48.7l66.2,0v35.5L316,199z"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenOdd",
        d: "M81,199l66.7,66.4v-48.3l66.2-49.1l-66.2,0v-35.5L81,199z"
    })));



var $7ceda8e364a74431$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_176_1669)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM15.75 9.49998L11.9867 5.75V8.4963L8.25 11.246L11.9867 11.2486V13.25L15.75 9.49998ZM6.01333 13.25L2.25 9.5L6.01333 5.75V7.7514L9.75 7.75394L6.01333 10.5258V13.25Z",
        fill: "black"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_176_1669"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "18",
        rx: "9",
        fill: "white"
    }))));



var $59be738baf6cb68f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_4824_71881)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z",
        fill: "url(#paint0_radial_4824_71881)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("radialGradient", {
        id: "paint0_radial_4824_71881",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(38.9752 14.6145) scale(45.1744)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.0677083",
        "stop-color": "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.25",
        "stop-color": "#787F85"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.473958",
        "stop-color": "#4C5155"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.880208",
        "stop-color": "#26292B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#313538"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_4824_71881"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white"
    }))));



var $28b38712115cb301$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_4827_71887)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z",
        fill: "url(#paint0_radial_4827_71887)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("radialGradient", {
        id: "paint0_radial_4827_71887",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(38.9752 14.6145) scale(45.1744)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.0677083",
        "stop-color": "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.25",
        "stop-color": "#F0F0F0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.473958",
        "stop-color": "#F3F3F3"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.880208",
        "stop-color": "#ADADAD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#CCCCCC"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_4827_71887"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white"
    }))));



var $75bf81594b9b1c53$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_179_1873",
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "18",
        height: "19"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z",
        fill: "#D9D9D9"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M21.0501 -3.41278H-2.77734V20.4147H21.0501V-3.41278Z",
        fill: "#A1723A"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_f_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.68737 18.1215C14.9915 18.1215 19.2913 13.8229 19.2913 8.52039C19.2913 3.21782 14.9915 -1.08075 9.68737 -1.08075C4.38331 -1.08075 0.0834961 3.21782 0.0834961 8.52039C0.0834961 13.8229 4.38331 18.1215 9.68737 18.1215Z",
        fill: "#531002"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter1_f_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.7226 15.0825C15.0246 15.0825 18.5121 11.5938 18.5121 7.29034C18.5121 2.98679 15.0246 -0.501892 10.7226 -0.501892C6.42068 -0.501892 2.93323 2.98679 2.93323 7.29034C2.93323 11.5938 6.42068 15.0825 10.7226 15.0825Z",
        fill: "#2B5DF0"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter2_f_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.5807 15.5278C15.0656 15.5278 18.7013 11.8908 18.7013 7.4044C18.7013 2.91796 15.0656 -0.718994 10.5807 -0.718994C6.0958 -0.718994 2.46008 2.91796 2.46008 7.4044C2.46008 11.8908 6.0958 15.5278 10.5807 15.5278Z",
        fill: "url(#paint0_radial_179_1873)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter3_f_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9276 9.44993C14.187 9.44993 16.0185 7.61839 16.0185 5.35904C16.0185 3.09969 14.187 1.26813 11.9276 1.26813C9.66821 1.26813 7.83667 3.09969 7.83667 5.35904C7.83667 7.61839 9.66821 9.44993 11.9276 9.44993Z",
        fill: "#FCB8D4"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter4_f_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9248 6.98982C12.8271 6.98982 13.5584 6.25846 13.5584 5.35624C13.5584 4.45404 12.8271 3.72266 11.9248 3.72266C11.0226 3.72266 10.2913 4.45404 10.2913 5.35624C10.2913 6.25846 11.0226 6.98982 11.9248 6.98982Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter5_f_179_1873)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.8395 21.667C18.9471 21.667 25.5195 15.0946 25.5195 6.98704C25.5195 -1.12047 18.9471 -7.69293 10.8395 -7.69293C2.73199 -7.69293 -3.84045 -1.12047 -3.84045 6.98704C-3.84045 15.0946 2.73199 21.667 10.8395 21.667Z",
        fill: "url(#paint1_radial_179_1873)",
        "fill-opacity": "0.9"
    })))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_f_179_1873",
        x: "-3.89229",
        y: "-5.05653",
        width: "27.1593",
        height: "27.1538",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "1.98789",
        result: "effect1_foregroundBlur_179_1873"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter1_f_179_1873",
        x: "-5.01836",
        y: "-8.45348",
        width: "31.482",
        height: "31.4876",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "3.9758",
        result: "effect1_foregroundBlur_179_1873"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter2_f_179_1873",
        x: "-0.521771",
        y: "-3.70085",
        width: "22.2049",
        height: "22.2105",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "1.49093",
        result: "effect1_foregroundBlur_179_1873"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter3_f_179_1873",
        x: "1.87298",
        y: "-4.69556",
        width: "20.1091",
        height: "20.1092",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "2.98184",
        result: "effect1_foregroundBlur_179_1873"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter4_f_179_1873",
        x: "6.31547",
        y: "-0.253129",
        width: "11.2188",
        height: "11.2187",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "1.98789",
        result: "effect1_foregroundBlur_179_1873"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter5_f_179_1873",
        x: "-6.82231",
        y: "-10.6748",
        width: "35.3237",
        height: "35.3236",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "1.49093",
        result: "effect1_foregroundBlur_179_1873"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("radialGradient", {
        id: "paint0_radial_179_1873",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(11.9504 5.11263) rotate(128.228) scale(15.3367 15.3355)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.286458",
        "stop-color": "#387AFA"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.647782",
        "stop-color": "#387AFA",
        "stop-opacity": "0"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("radialGradient", {
        id: "paint1_radial_179_1873",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(10.8395 6.98704) rotate(90) scale(14.68)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.598958",
        "stop-opacity": "0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.671875"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.734375",
        "stop-opacity": "0"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_179_1873"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "18",
        height: "18",
        fill: "white",
        transform: "translate(0 0.5)"
    }))));



var $407585777b3c7836$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.7508 11.25C12.7508 11.25 12.9154 4.25646 15.5016 1.67025C17.5824 -0.410578 20.798 -0.568718 22.6837 1.31704C24.5695 3.20279 24.4113 6.4183 22.3305 8.4992C19.7443 11.0854 12.7508 11.25 12.7508 11.25ZM11.2504 11.25C11.2504 11.25 11.0858 4.25646 8.49954 1.67026C6.41871 -0.410568 3.20316 -0.568708 1.3174 1.31704C-0.568351 3.20279 -0.410208 6.4183 1.67063 8.4992C4.25683 11.0854 11.2504 11.25 11.2504 11.25ZM8.49917 22.3302C11.0854 19.744 11.25 12.7505 11.25 12.7505C11.25 12.7505 4.25646 12.9151 1.67026 15.5013C-0.410575 17.5821 -0.568718 20.7977 1.31704 22.6834C3.20279 24.5692 6.41834 24.411 8.49917 22.3302ZM12.7515 12.7505C12.7515 12.7505 12.9161 19.744 15.5023 22.3302C17.5832 24.411 20.7987 24.5692 22.6845 22.6834C24.5702 20.7977 24.4121 17.5821 22.3312 15.5013C19.745 12.9151 12.7515 12.7505 12.7515 12.7505Z",
        fill: "#11181C"
    }));



var $c7e33304d4749623$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.7508 11.25C12.7508 11.25 12.9154 4.25646 15.5016 1.67025C17.5824 -0.410578 20.798 -0.568718 22.6837 1.31704C24.5695 3.20279 24.4113 6.4183 22.3305 8.4992C19.7443 11.0854 12.7508 11.25 12.7508 11.25ZM11.2504 11.25C11.2504 11.25 11.0858 4.25646 8.49954 1.67026C6.41871 -0.410568 3.20316 -0.568708 1.3174 1.31704C-0.568351 3.20279 -0.410208 6.4183 1.67063 8.4992C4.25683 11.0854 11.2504 11.25 11.2504 11.25ZM8.49917 22.3302C11.0854 19.744 11.25 12.7505 11.25 12.7505C11.25 12.7505 4.25646 12.9151 1.67026 15.5013C-0.410575 17.5821 -0.568718 20.7977 1.31704 22.6834C3.20279 24.5692 6.41834 24.411 8.49917 22.3302ZM12.7515 12.7505C12.7515 12.7505 12.9161 19.744 15.5023 22.3302C17.5832 24.411 20.7987 24.5692 22.6845 22.6834C24.5702 20.7977 24.4121 17.5821 22.3312 15.5013C19.745 12.9151 12.7515 12.7505 12.7515 12.7505Z",
        fill: "#ECEDEE"
    }));



var $193518419e052636$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.5",
        width: "18",
        height: "17.9992",
        rx: "8.99962",
        fill: "#F9F9F9"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.3125 9.18705C9.3125 9.18705 9.38108 6.27313 10.4586 5.19556C11.3256 4.32856 12.6654 4.26267 13.4511 5.04839C14.2369 5.83411 14.171 7.17388 13.304 8.0409C12.2264 9.11847 9.3125 9.18705 9.3125 9.18705Z",
        fill: "url(#paint0_linear_264_1723)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M8.68754 9.18704C8.68754 9.18704 8.61895 6.27312 7.54138 5.19556C6.67438 4.32856 5.33459 4.26267 4.54887 5.04839C3.76316 5.8341 3.82905 7.17387 4.69605 8.0409C5.77361 9.11846 8.68754 9.18704 8.68754 9.18704Z",
        fill: "url(#paint1_linear_264_1723)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.54113 13.8037C8.6187 12.7262 8.68728 9.81226 8.68728 9.81226C8.68728 9.81226 5.77337 9.88084 4.69581 10.9584C3.82881 11.8254 3.76292 13.1652 4.54863 13.9509C5.33435 14.7366 6.67414 14.6707 7.54113 13.8037Z",
        fill: "url(#paint2_linear_264_1723)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.31287 9.81226C9.31287 9.81226 9.38145 12.7262 10.459 13.8037C11.326 14.6707 12.6658 14.7366 13.4515 13.9509L9.31287 9.81226Z",
        fill: "#FBDB30"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.4515 13.9509C14.2372 13.1652 14.1714 11.8254 13.3043 10.9584C12.2268 9.88084 9.31287 9.81226 9.31287 9.81226L13.4515 13.9509Z",
        fill: "#FBDB30"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.31287 9.81226C9.31287 9.81226 9.38145 12.7262 10.459 13.8037C11.326 14.6707 12.6658 14.7366 13.4515 13.9509L9.31287 9.81226Z",
        fill: "#FF5E20"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_264_1723",
        x1: "9.3125",
        y1: "9.18705",
        x2: "13.4927",
        y2: "5.02",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#FCC02D"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#FCBA2C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint1_linear_264_1723",
        x1: "4.29239",
        y1: "4.92982",
        x2: "8.68753",
        y2: "9.18705",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#FD9B28"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#FD9F28"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint2_linear_264_1723",
        x1: "4.6306",
        y1: "14.0852",
        x2: "8.75729",
        y2: "9.71049",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#FE7A24"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#FE7B24"
    }))));



var $230679ca8875625f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.94903 4.125L0.000488281 7.06588H20.3608L19.2358 10.4424H11.0961L10.2799 12.8169H18.5299L17.2505 16.8034H5.71373L8.16226 9.61463L5.47108 7.65405L1.54461 19.875H16.2578L20.052 18.0016L21.3093 13.7972L18.8608 11.8584L22.6549 10.0503L24.0005 6.10737L21.3093 4.125H3.94903Z",
        fill: "#FDFE00"
    }));



var $647b9c4412cbba84$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.94854 4.125L0 7.06588H20.3603L19.2353 10.4424H11.0956L10.2794 12.8169H18.5294L17.25 16.8034H5.71324L8.16177 9.61463L5.47059 7.65405L1.54412 19.875H16.2574L20.0515 18.0016L21.3088 13.7972L18.8603 11.8584L22.6544 10.0503L24 6.10737L21.3088 4.125H3.94854Z",
        fill: "#11181C"
    }));



var $c2bf6f5a824c8495$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.94854 4.125L0 7.06588H20.3603L19.2353 10.4424H11.0956L10.2794 12.8169H18.5294L17.25 16.8034H5.71324L8.16177 9.61463L5.47059 7.65405L1.54412 19.875H16.2574L20.0515 18.0016L21.3088 13.7972L18.8603 11.8584L22.6544 10.0503L24 6.10737L21.3088 4.125H3.94854Z",
        fill: "#ECEDEE"
    }));



var $0c442dda07ba1834$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5410_9742)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.502 11.6102L14.9102 13.686V16.1586V17.8346L18.502 15.7589V11.6102ZM8.3947 6.55089L11.9865 8.62662L15.5783 6.55089L11.9865 4.47517L8.3947 6.55089ZM5.47382 13.6831V15.7589L6.44746 16.3185L9.06566 17.8317V13.6831L5.47382 11.6102V13.686V13.6831ZM3.52658 16.8809V19.1308L2.55293 18.5683L1.57935 18.0059V11.9986V5.99128L11.9865 -0.0160522L22.3937 5.99128V18.0087L17.1886 21.0124L14.9074 22.3286V20.0787L20.4464 16.8809V8.23831L12.9601 12.5611C12.9601 13.7602 12.9601 14.9566 12.9601 16.1557V23.4535L11.9865 24.0161L11.0129 23.4535L6.78149 21.0124L5.47382 20.2586V18.0087L11.0129 21.2065V12.5639L3.52658 8.24115V16.8838V16.8809ZM11.9865 10.8736L4.50023 6.55089L11.9865 2.22814L19.4728 6.55089L11.9865 10.8736Z",
        fill: "#151718"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5410_9742"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $894518fe751a27fe$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5410_9739)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.502 11.6102L14.9102 13.686V16.1586V17.8346L18.502 15.7589V11.6102ZM8.3947 6.55089L11.9865 8.62662L15.5783 6.55089L11.9865 4.47517L8.3947 6.55089ZM5.47382 13.6831V15.7589L6.44746 16.3185L9.06566 17.8317V13.6831L5.47382 11.6102V13.686V13.6831ZM3.52658 16.8809V19.1308L2.55293 18.5683L1.57935 18.0059V11.9986V5.99128L11.9865 -0.0160522L22.3937 5.99128V18.0087L17.1886 21.0124L14.9074 22.3286V20.0787L20.4464 16.8809V8.23831L12.9601 12.5611C12.9601 13.7602 12.9601 14.9566 12.9601 16.1557V23.4535L11.9865 24.0161L11.0129 23.4535L6.78149 21.0124L5.47382 20.2586V18.0087L11.0129 21.2065V12.5639L3.52658 8.24115V16.8838V16.8809ZM11.9865 10.8736L4.50023 6.55089L11.9865 2.22814L19.4728 6.55089L11.9865 10.8736Z",
        fill: "#FBFCFD"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5410_9739"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $75d05aa298971688$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5410_9710)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24.0007 12C24.0007 5.37258 18.6281 0 12.0007 0C5.37332 0 0.000732422 5.37258 0.000732422 12C0.000732422 18.6274 5.37332 24 12.0007 24C18.6281 24 24.0007 18.6274 24.0007 12Z",
        fill: "url(#paint0_linear_5410_9710)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.2856 11.7589L13.9161 13.1283V14.7594V15.8651L16.2856 14.4957V11.7589ZM9.61785 8.42133L11.9873 9.79066L14.3568 8.42133L11.9873 7.05199L9.61785 8.42133ZM7.69097 13.1264V14.4957L8.33328 14.8649L10.0605 15.8632V13.1264L7.69097 11.7589V13.1283V13.1264ZM6.4064 15.236V16.7202L5.76409 16.3491L5.12183 15.9781V12.0151V8.05215L11.9873 4.08917L18.8528 8.05215V15.9799L15.4191 17.9614L13.9142 18.8298V17.3455L17.5683 15.236V9.5345L12.6296 12.3862C12.6296 13.1773 12.6296 13.9665 12.6296 14.7576V19.5718L11.9873 19.9429L11.345 19.5718L8.55363 17.9614L7.69097 17.4642V15.9799L11.345 18.0895V12.3881L6.4064 9.53637V15.2378V15.236ZM11.9873 11.273L7.04871 8.42133L11.9873 5.56964L16.926 8.42133L11.9873 11.273Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_5410_9710",
        x1: "20.7141",
        y1: "21.0955",
        x2: "-13.8528",
        y2: "-21.7643",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#8F00FF"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.531658",
        "stop-color": "#78A5EA"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#00FFC2"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5410_9710"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.000732422)"
    }))));



var $26bf620f8ff4fc04$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.94903 4.125L0.000488281 7.06588H20.3608L19.2358 10.4424H11.0961L10.2799 12.8169H18.5299L17.2505 16.8034H5.71373L8.16226 9.61463L5.47108 7.65405L1.54461 19.875H16.2578L20.052 18.0016L21.3093 13.7972L18.8608 11.8584L22.6549 10.0503L24.0005 6.10737L21.3093 4.125H3.94903Z",
        fill: "#FDFE00"
    }));



var $cae29279e23fdfdb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.94854 4.125L0 7.06588H20.3603L19.2353 10.4424H11.0956L10.2794 12.8169H18.5294L17.25 16.8034H5.71324L8.16177 9.61463L5.47059 7.65405L1.54412 19.875H16.2574L20.0515 18.0016L21.3088 13.7972L18.8603 11.8584L22.6544 10.0503L24 6.10737L21.3088 4.125H3.94854Z",
        fill: "#ECEDEE"
    }));



var $1335e1f14e8911f1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M3.94854 4.125L0 7.06588H20.3603L19.2353 10.4424H11.0956L10.2794 12.8169H18.5294L17.25 16.8034H5.71324L8.16177 9.61463L5.47059 7.65405L1.54412 19.875H16.2574L20.0515 18.0016L21.3088 13.7972L18.8603 11.8584L22.6544 10.0503L24 6.10737L21.3088 4.125H3.94854Z",
        fill: "#11181C"
    }));



var $69ac5d378aefe15b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5415_14718)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M23.9718 11.1857C23.5221 4.57385 17.7976 -0.421607 11.1857 0.0281354C7.89191 0.252168 4.99986 1.78574 2.9817 4.08539L2.97609 4.08132C2.96249 4.10014 2.94978 4.1187 2.93628 4.1375C0.9316 6.44838 -0.195883 9.52104 0.0281222 12.8143C0.0494681 13.1282 0.0864072 13.437 0.131043 13.7431C0.131057 13.7432 0.131057 13.7432 0.13107 13.7433C0.133081 13.7571 0.135132 13.7709 0.137076 13.7847C0.16725 13.9867 0.202286 14.1869 0.242261 14.3852C0.242287 14.3853 0.242301 14.3854 0.242327 14.3855C0.24306 14.3891 0.243752 14.3927 0.244458 14.3963C0.280851 14.5759 0.321279 14.7538 0.365515 14.9303L0.365595 14.9306C0.365635 14.9308 0.365675 14.931 0.365702 14.931C1.75156 20.4578 6.92977 24.3722 12.8143 23.9718C19.4262 23.5222 24.4216 17.7975 23.9718 11.1857ZM21.3598 11.3634C21.4152 12.1774 21.364 12.9744 21.219 13.7412C21.2172 13.7368 21.2158 13.7322 21.214 13.7278V13.7278C20.3441 11.6013 18.6232 10.0661 17.1098 9.218C17.4162 5.61479 16.1938 4.09679 14.8102 3.8498C14.7726 3.84256 14.7348 3.83638 14.6963 3.83162C13.5983 3.69078 12.5942 4.46692 12.4535 5.5649C12.3126 6.66293 13.0888 7.6671 14.1868 7.80798C14.2826 7.8201 14.3773 7.82346 14.4711 7.82198C14.4772 7.94362 14.481 8.0728 14.4821 8.20792C13.2029 7.89093 12.007 7.82888 10.9168 7.9269C10.5091 7.95408 10.1011 8.00544 9.69536 8.08128C9.83144 6.86458 10.2879 5.49859 11.1737 4.49894C12.0299 3.53261 13.303 2.97874 14.6917 3.12087C14.955 3.14781 15.2358 3.21245 15.4887 3.29738C15.5003 3.30128 15.5127 3.30458 15.5242 3.30858C15.5243 3.30835 15.5246 3.30805 15.5247 3.30782C18.7414 4.61819 21.1086 7.67094 21.3598 11.3634ZM12.9959 13.1962C12.995 13.1975 12.9942 13.1988 12.9933 13.2002C12.707 13.6131 12.3664 14.0203 11.9666 14.4142C11.3674 13.7766 10.886 13.0899 10.5208 12.3796C10.5021 12.3415 10.4821 12.3054 10.4638 12.2666C10.4631 12.2653 10.4625 12.2638 10.4618 12.2624C10.2472 11.8078 10.0648 11.309 9.9236 10.7658C10.7763 10.5651 11.6126 10.4914 12.4111 10.5302C12.4534 10.533 12.4948 10.5338 12.5374 10.5374C12.539 10.5374 12.5406 10.5376 12.5422 10.5377C13.0423 10.5791 13.5646 10.6703 14.1048 10.8193C13.8522 11.6577 13.4981 12.4185 13.0653 13.0904C13.0417 13.1257 13.0203 13.161 12.9959 13.1962ZM8.89552 3.14874C8.89328 3.15163 8.8908 3.15436 8.88856 3.15726C7.48263 4.97298 7.01326 7.22954 7.03497 8.96384C3.76157 10.5002 3.05818 12.3178 3.53603 13.6394C3.54855 13.6755 3.56214 13.7114 3.57723 13.7471C4.0043 14.7685 5.17853 15.25 6.19972 14.8228C7.22106 14.3958 7.70262 13.2215 7.27566 12.2002C7.23826 12.1112 7.19381 12.0274 7.14562 11.947C7.24907 11.8801 7.36017 11.8114 7.47814 11.7422C7.84322 13.0087 8.38328 14.0801 9.01344 14.9754C9.2404 15.3142 9.48832 15.6412 9.75624 15.9541C8.6344 16.4448 7.22289 16.7326 5.91401 16.4654C4.64899 16.207 3.53282 15.3814 2.96156 14.1077C2.85327 13.8662 2.76883 13.5907 2.71591 13.3293C2.68335 13.1008 2.65607 12.8706 2.64017 12.6366C2.34778 8.33816 5.01462 4.51138 8.89552 3.14874ZM12.6366 21.3598C10.0841 21.5334 7.698 20.6628 5.89466 19.1152C8.17008 19.4249 10.359 18.703 11.8501 17.817C14.8186 19.8854 16.745 19.586 17.6509 18.5111C17.676 18.4822 17.7002 18.4525 17.7236 18.4215C18.3946 17.541 18.2246 16.2834 17.344 15.6126C16.4634 14.9415 15.2058 15.1117 14.5348 15.9921C14.4764 16.069 14.4261 16.1493 14.3805 16.2313C14.2716 16.1755 14.1573 16.114 14.0391 16.047C14.9543 15.097 15.6064 14.0918 16.067 13.0979C16.2473 12.7313 16.4068 12.3522 16.5441 11.9629C17.5305 12.6891 18.4864 13.7681 18.9095 15.0359C19.3182 16.2606 19.1614 17.6401 18.344 18.7717C18.189 18.9862 17.9926 19.1971 17.7926 19.3737C17.7897 19.3762 17.7868 19.379 17.784 19.3816C16.3538 20.5056 14.5843 21.2274 12.6366 21.3598Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5415_14718"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $43197958ab9b807d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5415_14716)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M23.9718 11.1857C23.5221 4.57385 17.7976 -0.421607 11.1857 0.0281354C7.89191 0.252168 4.99986 1.78574 2.9817 4.08539L2.97609 4.08132C2.96249 4.10014 2.94978 4.1187 2.93628 4.1375C0.9316 6.44838 -0.195883 9.52104 0.0281222 12.8143C0.0494681 13.1282 0.0864072 13.437 0.131043 13.7431C0.131057 13.7432 0.131057 13.7432 0.13107 13.7433C0.133081 13.7571 0.135132 13.7709 0.137076 13.7847C0.16725 13.9867 0.202286 14.1869 0.242261 14.3852C0.242287 14.3853 0.242301 14.3854 0.242327 14.3855C0.24306 14.3891 0.243752 14.3927 0.244458 14.3963C0.280851 14.5759 0.321279 14.7538 0.365515 14.9303L0.365595 14.9306C0.365635 14.9308 0.365675 14.931 0.365702 14.931C1.75156 20.4578 6.92977 24.3722 12.8143 23.9718C19.4262 23.5222 24.4216 17.7975 23.9718 11.1857ZM21.3598 11.3634C21.4152 12.1774 21.364 12.9744 21.219 13.7412C21.2172 13.7368 21.2158 13.7322 21.214 13.7278V13.7278C20.3441 11.6013 18.6232 10.0661 17.1098 9.218C17.4162 5.61479 16.1938 4.09679 14.8102 3.8498C14.7726 3.84256 14.7348 3.83638 14.6963 3.83162C13.5983 3.69078 12.5942 4.46692 12.4535 5.5649C12.3126 6.66293 13.0888 7.6671 14.1868 7.80798C14.2826 7.8201 14.3773 7.82346 14.4711 7.82198C14.4772 7.94362 14.481 8.0728 14.4821 8.20792C13.2029 7.89093 12.007 7.82888 10.9168 7.9269C10.5091 7.95408 10.1011 8.00544 9.69536 8.08128C9.83144 6.86458 10.2879 5.49859 11.1737 4.49894C12.0299 3.53261 13.303 2.97874 14.6917 3.12087C14.955 3.14781 15.2358 3.21245 15.4887 3.29738C15.5003 3.30128 15.5127 3.30458 15.5242 3.30858C15.5243 3.30835 15.5246 3.30805 15.5247 3.30782C18.7414 4.61819 21.1086 7.67094 21.3598 11.3634ZM12.9959 13.1962C12.995 13.1975 12.9942 13.1988 12.9933 13.2002C12.707 13.6131 12.3664 14.0203 11.9666 14.4142C11.3674 13.7766 10.886 13.0899 10.5208 12.3796C10.5021 12.3415 10.4821 12.3054 10.4638 12.2666C10.4631 12.2653 10.4625 12.2638 10.4618 12.2624C10.2472 11.8078 10.0648 11.309 9.9236 10.7658C10.7763 10.5651 11.6126 10.4914 12.4111 10.5302C12.4534 10.533 12.4948 10.5338 12.5374 10.5374C12.539 10.5374 12.5406 10.5376 12.5422 10.5377C13.0423 10.5791 13.5646 10.6703 14.1048 10.8193C13.8522 11.6577 13.4981 12.4185 13.0653 13.0904C13.0417 13.1257 13.0203 13.161 12.9959 13.1962ZM8.89552 3.14874C8.89328 3.15163 8.8908 3.15436 8.88856 3.15726C7.48263 4.97298 7.01326 7.22954 7.03497 8.96384C3.76157 10.5002 3.05818 12.3178 3.53603 13.6394C3.54855 13.6755 3.56214 13.7114 3.57723 13.7471C4.0043 14.7685 5.17853 15.25 6.19972 14.8228C7.22106 14.3958 7.70262 13.2215 7.27566 12.2002C7.23826 12.1112 7.19381 12.0274 7.14562 11.947C7.24907 11.8801 7.36017 11.8114 7.47814 11.7422C7.84322 13.0087 8.38328 14.0801 9.01344 14.9754C9.2404 15.3142 9.48832 15.6412 9.75624 15.9541C8.6344 16.4448 7.22289 16.7326 5.91401 16.4654C4.64899 16.207 3.53282 15.3814 2.96156 14.1077C2.85327 13.8662 2.76883 13.5907 2.71591 13.3293C2.68335 13.1008 2.65607 12.8706 2.64017 12.6366C2.34778 8.33816 5.01462 4.51138 8.89552 3.14874ZM12.6366 21.3598C10.0841 21.5334 7.698 20.6628 5.89466 19.1152C8.17008 19.4249 10.359 18.703 11.8501 17.817C14.8186 19.8854 16.745 19.586 17.6509 18.5111C17.676 18.4822 17.7002 18.4525 17.7236 18.4215C18.3946 17.541 18.2246 16.2834 17.344 15.6126C16.4634 14.9415 15.2058 15.1117 14.5348 15.9921C14.4764 16.069 14.4261 16.1493 14.3805 16.2313C14.2716 16.1755 14.1573 16.114 14.0391 16.047C14.9543 15.097 15.6064 14.0918 16.067 13.0979C16.2473 12.7313 16.4068 12.3522 16.5441 11.9629C17.5305 12.6891 18.4864 13.7681 18.9095 15.0359C19.3182 16.2606 19.1614 17.6401 18.344 18.7717C18.189 18.9862 17.9926 19.1971 17.7926 19.3737C17.7897 19.3762 17.7868 19.379 17.784 19.3816C16.3538 20.5056 14.5843 21.2274 12.6366 21.3598Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5415_14716"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $6db5064571756e89$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5415_14720)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5415_14720)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "url(#pattern0)"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("use", {
        xlinkHref: "#image0_5415_14720",
        transform: "scale(0.00333333)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5415_14720"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5415_14720"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("image", {
        id: "image0_5415_14720",
        width: "300",
        height: "300",
        xlinkHref: "data:image/png;base64,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"
    })));



var $0bd69c6004cd6fda$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 200 200",
        fill: "none",
        "shape-rendering": "crispEdges",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "200",
        height: "200",
        fill: "#F34242"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_1_376)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M84 84H68V68H84V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M84 100H68V84H84V100Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M84 116H68V100H84V116Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M84 132H68V116H84V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M132 84H116V68H132V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M132 100H116V84H132V100Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M132 116H116V100H132V116Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M132 132H116V116H132V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 132H84V116H100V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 132H100V116H116V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 84H84V68H100V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 84H100V68H116V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 36H84V52H100V36Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 148H100V132H116V148Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M148 100H132V116H148V100Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M68 116H52V100H68V116Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 52H100V68H116V52Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 36H100V52H116V36Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 164H84V148H100V164Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 164H100V148H116V164Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M164 84H148V100H164V84Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M164 100H148V116H164V100Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M52 116H36V100H52V116Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M52 100H36V84H52V100Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 52H84V68H100V52Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 148H84V132H100V148Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M148 84H132V100H148V84Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M68 100H52V84H68V100Z",
        fill: "white",
        "fill-opacity": "0.75"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_1_376"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "128",
        height: "128",
        fill: "white",
        transform: "translate(36 36)"
    }))));



var $032a5a280f17302d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 200 200",
        fill: "none",
        "shape-rendering": "crispEdges",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_1_639)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M84 84H68V68H84V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M84 100H68V84H84V100Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M84 116H68V100H84V116Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M84 132H68V116H84V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M132 84H116V68H132V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M132 100H116V84H132V100Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M132 116H116V100H132V116Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M132 132H116V116H132V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 132H84V116H100V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 132H100V116H116V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 84H84V68H100V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 84H100V68H116V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 36H84V52H100V36Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 148H100V132H116V148Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M148 100H132V116H148V100Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M68 116H52V100H68V116Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 52H100V68H116V52Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 36H100V52H116V36Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 164H84V148H100V164Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 164H100V148H116V164Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M164 84H148V100H164V84Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M164 100H148V116H164V100Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M52 116H36V100H52V116Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M52 100H36V84H52V100Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 52H84V68H100V52Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 148H84V132H100V148Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M148 84H132V100H148V84Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M68 100H52V84H68V100Z",
        fill: "white",
        "fill-opacity": "0.75"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_1_639"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "128",
        height: "128",
        fill: "white",
        transform: "translate(36 36)"
    }))));



var $7b47abf2a2f8001c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 200 200",
        fill: "none",
        "shape-rendering": "crispEdges",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_1_639)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M84 84H68V68H84V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M84 100H68V84H84V100Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M84 116H68V100H84V116Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M84 132H68V116H84V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M132 84H116V68H132V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M132 100H116V84H132V100Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M132 116H116V100H132V116Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        opacity: "0.75",
        d: "M132 132H116V116H132V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 132H84V116H100V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 132H100V116H116V132Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 84H84V68H100V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 84H100V68H116V84Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 36H84V52H100V36Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 148H100V132H116V148Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M148 100H132V116H148V100Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M68 116H52V100H68V116Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 52H100V68H116V52Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 36H100V52H116V36Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 164H84V148H100V164Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M116 164H100V148H116V164Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M164 84H148V100H164V84Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M164 100H148V116H164V100Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M52 116H36V100H52V116Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M52 100H36V84H52V100Z",
        fill: "white",
        "fill-opacity": "0.25"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 52H84V68H100V52Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M100 148H84V132H100V148Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M148 84H132V100H148V84Z",
        fill: "white",
        "fill-opacity": "0.75"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M68 100H52V84H68V100Z",
        fill: "white",
        "fill-opacity": "0.75"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_1_639"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "128",
        height: "128",
        fill: "white",
        transform: "translate(36 36)"
    }))));



var $e1bcb7957e81272f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.1406 16.0851V14.8219C17.9181 14.5552 18.4843 13.7271 18.4843 12.747C18.4843 11.7668 17.9181 10.9364 17.1406 10.672V9.40885C17.8728 9.15854 18.4188 8.40763 18.4793 7.5H17.5885V7.88598C17.5885 8.18307 17.4073 8.44506 17.1406 8.57606V8.39594C17.1406 8.1316 16.9091 7.91639 16.6248 7.91639H16.5795C16.2952 7.91639 16.0636 8.1316 16.0636 8.39594V8.57606C15.7969 8.44506 15.6157 8.1854 15.6157 7.88598V7.5H14.725C14.7854 8.40763 15.3314 9.15854 16.0636 9.40885V10.672C15.2886 10.9364 14.72 11.7645 14.72 12.747C14.72 13.7295 15.2861 14.5576 16.0636 14.8219V16.0851C15.3314 16.3354 14.7854 17.0863 14.725 17.9939H15.6157V17.608C15.6157 17.3109 15.7969 17.0489 16.0636 16.9179V17.098C16.0636 17.3624 16.2952 17.5776 16.5795 17.5776H16.6248C16.9091 17.5776 17.1406 17.3624 17.1406 17.098V16.9179C17.4073 17.0489 17.5885 17.3085 17.5885 17.608V17.9939H18.4793C18.4188 17.0863 17.8728 16.3354 17.1406 16.0851ZM15.6157 13.299V12.1926C15.6157 11.8955 15.7969 11.6335 16.0636 11.5025V11.6826C16.0636 11.9469 16.2952 12.1622 16.5795 12.1622H16.6248C16.9091 12.1622 17.1406 11.9469 17.1406 11.6826V11.5025C17.4073 11.6335 17.5885 11.8931 17.5885 12.1926V13.299C17.5885 13.5961 17.4073 13.8581 17.1406 13.9891V13.809C17.1406 13.5447 16.9091 13.3295 16.6248 13.3295H16.5795C16.2952 13.3295 16.0636 13.5447 16.0636 13.809V13.9891C15.7994 13.8581 15.6157 13.5985 15.6157 13.299Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M22.6058 13.4183V12.0733C23.3833 11.8066 23.9495 10.9785 23.9495 9.99834C23.9495 9.01818 23.3833 8.18774 22.6058 7.92341V7.5H21.5314V7.92341C20.7539 8.19008 20.1877 9.01818 20.1877 9.99834C20.1877 10.9785 20.7539 11.8089 21.5314 12.0733V13.4183C20.7539 13.685 20.1877 14.5131 20.1877 15.4933C20.1877 16.4734 20.7539 17.3039 21.5314 17.5682V17.9916H22.6058V17.5682C23.3833 17.3015 23.9495 16.4734 23.9495 15.4933C23.9495 14.5131 23.3833 13.685 22.6058 13.4183ZM21.081 10.5504V9.44393C21.081 9.14684 21.2622 8.88485 21.5289 8.75384V8.93397C21.5289 9.19831 21.7604 9.41352 22.0447 9.41352H22.0875C22.3718 9.41352 22.6033 9.19831 22.6033 8.93397V8.75384C22.8701 8.88485 23.0512 9.1445 23.0512 9.44393V10.5504C23.0512 10.8475 22.8701 11.1095 22.6033 11.2405V11.0604C22.6033 10.796 22.3718 10.5808 22.0875 10.5808H22.0422C21.7579 10.5808 21.5264 10.796 21.5264 11.0604V11.2405C21.2647 11.1095 21.081 10.8498 21.081 10.5504ZM23.0537 16.0477C23.0537 16.3448 22.8726 16.6068 22.6058 16.7378V16.4734C22.6058 16.2091 22.3744 15.9939 22.09 15.9939H22.0472C21.7629 15.9939 21.5314 16.2091 21.5314 16.4734V16.7378C21.2647 16.6068 21.0835 16.3471 21.0835 16.0477V14.9412C21.0835 14.6441 21.2647 14.3821 21.5314 14.2511V14.347C21.5314 14.6114 21.7629 14.8266 22.0472 14.8266H22.0926C22.3769 14.8266 22.6083 14.6114 22.6083 14.347V14.2511C22.8751 14.3821 23.0562 14.6418 23.0562 14.9412V16.0477H23.0537Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.9835 11.6757C10.9734 11.6219 10.9608 11.5704 10.9407 11.5213C10.9482 11.5096 12.619 9.34578 11.0716 8.00772C9.52656 6.66966 7.72237 8.41476 7.71231 8.42411C7.42546 8.3399 7.13609 8.28843 6.84924 8.26504C6.84924 8.26504 6.84924 8.26504 6.84672 8.26504C6.25791 8.17381 5.43258 8.26504 5.43258 8.26504C5.14825 8.28843 4.8614 8.3399 4.57706 8.42177C4.56699 8.41241 2.76284 6.66732 1.21787 8.00538C-0.327113 9.34344 1.34116 11.5096 1.34871 11.519C1.3311 11.5704 1.316 11.6219 1.30593 11.6734C1.13987 12.5997 0 12.8851 0 14.4992C0 16.1437 1.19018 17.4396 3.62089 17.4396H4.61732C4.62235 17.4443 5.00734 17.9543 5.80248 17.9847C5.80248 17.9847 5.98617 18.0034 6.40889 17.9894C7.25184 17.9894 7.66199 17.449 7.6645 17.4419H8.66093C11.0916 17.4419 12.2818 16.146 12.2818 14.5015C12.2893 12.8898 11.1495 12.602 10.9835 11.6757Z",
        fill: "#11181C"
    }));



var $928412df06a214e0$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5423_19166)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5423_19166)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.6406 16.0851V14.8219C18.4181 14.5552 18.9843 13.7271 18.9843 12.747C18.9843 11.7668 18.4181 10.9364 17.6406 10.672V9.40885C18.3728 9.15854 18.9188 8.40763 18.9793 7.5H18.0885V7.88598C18.0885 8.18307 17.9073 8.44506 17.6406 8.57606V8.39594C17.6406 8.1316 17.4091 7.91639 17.1248 7.91639H17.0795C16.7952 7.91639 16.5636 8.1316 16.5636 8.39594V8.57606C16.2969 8.44506 16.1157 8.1854 16.1157 7.88598V7.5H15.225C15.2854 8.40763 15.8314 9.15854 16.5636 9.40885V10.672C15.7886 10.9364 15.22 11.7645 15.22 12.747C15.22 13.7295 15.7861 14.5576 16.5636 14.8219V16.0851C15.8314 16.3354 15.2854 17.0863 15.225 17.9939H16.1157V17.608C16.1157 17.3109 16.2969 17.0489 16.5636 16.9179V17.098C16.5636 17.3624 16.7952 17.5776 17.0795 17.5776H17.1248C17.4091 17.5776 17.6406 17.3624 17.6406 17.098V16.9179C17.9073 17.0489 18.0885 17.3085 18.0885 17.608V17.9939H18.9793C18.9188 17.0863 18.3728 16.3354 17.6406 16.0851ZM16.1157 13.299V12.1926C16.1157 11.8955 16.2969 11.6335 16.5636 11.5025V11.6826C16.5636 11.9469 16.7952 12.1622 17.0795 12.1622H17.1248C17.4091 12.1622 17.6406 11.9469 17.6406 11.6826V11.5025C17.9073 11.6335 18.0885 11.8931 18.0885 12.1926V13.299C18.0885 13.5961 17.9073 13.8581 17.6406 13.9891V13.809C17.6406 13.5447 17.4091 13.3295 17.1248 13.3295H17.0795C16.7952 13.3295 16.5636 13.5447 16.5636 13.809V13.9891C16.2994 13.8581 16.1157 13.5985 16.1157 13.299Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M23.1058 13.4183V12.0733C23.8833 11.8066 24.4495 10.9785 24.4495 9.99834C24.4495 9.01818 23.8833 8.18774 23.1058 7.92341V7.5H22.0314V7.92341C21.2539 8.19008 20.6877 9.01818 20.6877 9.99834C20.6877 10.9785 21.2539 11.8089 22.0314 12.0733V13.4183C21.2539 13.685 20.6877 14.5131 20.6877 15.4933C20.6877 16.4734 21.2539 17.3039 22.0314 17.5682V17.9916H23.1058V17.5682C23.8833 17.3015 24.4495 16.4734 24.4495 15.4933C24.4495 14.5131 23.8833 13.685 23.1058 13.4183ZM21.581 10.5504V9.44393C21.581 9.14684 21.7622 8.88485 22.0289 8.75384V8.93397C22.0289 9.19831 22.2604 9.41352 22.5447 9.41352H22.5875C22.8718 9.41352 23.1033 9.19831 23.1033 8.93397V8.75384C23.3701 8.88485 23.5512 9.1445 23.5512 9.44393V10.5504C23.5512 10.8475 23.3701 11.1095 23.1033 11.2405V11.0604C23.1033 10.796 22.8718 10.5808 22.5875 10.5808H22.5422C22.2579 10.5808 22.0264 10.796 22.0264 11.0604V11.2405C21.7647 11.1095 21.581 10.8498 21.581 10.5504ZM23.5537 16.0477C23.5537 16.3448 23.3726 16.6068 23.1058 16.7378V16.4734C23.1058 16.2091 22.8744 15.9939 22.59 15.9939H22.5472C22.2629 15.9939 22.0314 16.2091 22.0314 16.4734V16.7378C21.7647 16.6068 21.5835 16.3471 21.5835 16.0477V14.9412C21.5835 14.6441 21.7647 14.3821 22.0314 14.2511V14.347C22.0314 14.6114 22.2629 14.8266 22.5472 14.8266H22.5926C22.8769 14.8266 23.1083 14.6114 23.1083 14.347V14.2511C23.3751 14.3821 23.5562 14.6418 23.5562 14.9412V16.0477H23.5537Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.4835 11.6757C11.4734 11.6219 11.4608 11.5704 11.4407 11.5213C11.4482 11.5096 13.119 9.34578 11.5716 8.00772C10.0266 6.66966 8.22237 8.41476 8.21231 8.42411C7.92546 8.3399 7.63609 8.28843 7.34924 8.26504C7.34924 8.26504 7.34924 8.26504 7.34672 8.26504C6.75791 8.17381 5.93258 8.26504 5.93258 8.26504C5.64825 8.28843 5.3614 8.3399 5.07706 8.42177C5.06699 8.41241 3.26284 6.66732 1.71787 8.00538C0.172887 9.34344 1.84116 11.5096 1.84871 11.519C1.8311 11.5704 1.816 11.6219 1.80593 11.6734C1.63987 12.5997 0.5 12.8851 0.5 14.4992C0.5 16.1437 1.69018 17.4396 4.12089 17.4396H5.11732C5.12235 17.4443 5.50734 17.9543 6.30248 17.9847C6.30248 17.9847 6.48617 18.0034 6.90889 17.9894C7.75184 17.9894 8.16199 17.449 8.1645 17.4419H9.16093C11.5916 17.4419 12.7818 16.146 12.7818 14.5015C12.7893 12.8898 11.6495 12.602 11.4835 11.6757Z",
        fill: "#ECEDEE"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5423_19166"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5 0.758423)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5423_19166"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "10.5169",
        fill: "white",
        transform: "translate(0.5 7.5)"
    }))));



var $9bdab9154743f9b2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        x: "0.5",
        y: "0.758423",
        width: "24",
        height: "24",
        rx: "12",
        fill: "#F47226"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M16.5324 15.3691V14.3769C17.1431 14.1674 17.5879 13.517 17.5879 12.7471C17.5879 11.9772 17.1431 11.3249 16.5324 11.1173V10.1251C17.1075 9.92847 17.5365 9.33865 17.5839 8.62573H16.8842V8.92891C16.8842 9.16226 16.742 9.36805 16.5324 9.47095V9.32947C16.5324 9.12184 16.3506 8.95279 16.1273 8.95279H16.0917C15.8684 8.95279 15.6865 9.12184 15.6865 9.32947V9.47095C15.477 9.36805 15.3347 9.1641 15.3347 8.92891V8.62573H14.6351C14.6825 9.33865 15.1114 9.92847 15.6865 10.1251V11.1173C15.0777 11.3249 14.6311 11.9754 14.6311 12.7471C14.6311 13.5188 15.0758 14.1692 15.6865 14.3769V15.3691C15.1114 15.5657 14.6825 16.1555 14.6351 16.8684H15.3347V16.5652C15.3347 16.3319 15.477 16.1261 15.6865 16.0232V16.1647C15.6865 16.3724 15.8684 16.5414 16.0917 16.5414H16.1273C16.3506 16.5414 16.5324 16.3724 16.5324 16.1647V16.0232C16.742 16.1261 16.8842 16.3301 16.8842 16.5652V16.8684H17.5839C17.5365 16.1555 17.1075 15.5657 16.5324 15.3691ZM15.3347 13.1807V12.3116C15.3347 12.0783 15.477 11.8725 15.6865 11.7696V11.9111C15.6865 12.1187 15.8684 12.2877 16.0917 12.2877H16.1273C16.3506 12.2877 16.5324 12.1187 16.5324 11.9111V11.7696C16.742 11.8725 16.8842 12.0764 16.8842 12.3116V13.1807C16.8842 13.4141 16.742 13.6199 16.5324 13.7228V13.5813C16.5324 13.3736 16.3506 13.2046 16.1273 13.2046H16.0917C15.8684 13.2046 15.6865 13.3736 15.6865 13.5813V13.7228C15.479 13.6199 15.3347 13.4159 15.3347 13.1807Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M20.8251 13.2744V12.2179C21.4358 12.0084 21.8806 11.358 21.8806 10.5881C21.8806 9.81822 21.4358 9.16594 20.8251 8.95831V8.62573H19.9812V8.95831C19.3704 9.16777 18.9258 9.81822 18.9258 10.5881C18.9258 11.358 19.3704 12.0103 19.9812 12.2179V13.2744C19.3704 13.4839 18.9258 14.1343 18.9258 14.9042C18.9258 15.6741 19.3704 16.3264 19.9812 16.534V16.8666H20.8251V16.534C21.4358 16.3246 21.8806 15.6741 21.8806 14.9042C21.8806 14.1343 21.4358 13.4839 20.8251 13.2744ZM19.6274 11.0217V10.1526C19.6274 9.91928 19.7697 9.71349 19.9792 9.61059V9.75207C19.9792 9.95971 20.1611 10.1287 20.3844 10.1287H20.418C20.6413 10.1287 20.8231 9.95971 20.8231 9.75207V9.61059C21.0327 9.71349 21.1749 9.91744 21.1749 10.1526V11.0217C21.1749 11.2551 21.0327 11.4609 20.8231 11.5638V11.4223C20.8231 11.2147 20.6413 11.0456 20.418 11.0456H20.3824C20.1591 11.0456 19.9772 11.2147 19.9772 11.4223V11.5638C19.7717 11.4609 19.6274 11.2569 19.6274 11.0217ZM21.1769 15.3397C21.1769 15.573 21.0347 15.7789 20.8251 15.8817V15.6741C20.8251 15.4665 20.6433 15.2974 20.42 15.2974H20.3864C20.163 15.2974 19.9812 15.4665 19.9812 15.6741V15.8817C19.7717 15.7789 19.6294 15.5749 19.6294 15.3397V14.4706C19.6294 14.2372 19.7717 14.0314 19.9812 13.9285V14.0039C19.9812 14.2115 20.163 14.3806 20.3864 14.3806H20.422C20.6453 14.3806 20.8271 14.2115 20.8271 14.0039V13.9285C21.0366 14.0314 21.1789 14.2354 21.1789 14.4706V15.3397H21.1769Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.696 11.9055C11.6881 11.8633 11.6783 11.8228 11.6624 11.7843C11.6684 11.7751 12.9807 10.0755 11.7652 9.02444C10.5517 7.97344 9.13455 9.34416 9.12665 9.35151C8.90133 9.28536 8.67404 9.24494 8.44873 9.22656C8.44873 9.22656 8.44873 9.22656 8.44676 9.22656C7.98426 9.1549 7.33599 9.22656 7.33599 9.22656C7.11265 9.24494 6.88734 9.28536 6.664 9.34967C6.65609 9.34232 5.23898 7.9716 4.02545 9.02261C2.81191 10.0736 4.12229 11.7751 4.12822 11.7824C4.11439 11.8228 4.10253 11.8633 4.09462 11.9037C3.96418 12.6313 3.06885 12.8555 3.06885 14.1233C3.06885 15.415 4.0037 16.4329 5.91295 16.4329H6.69562C6.69958 16.4366 7.00197 16.8372 7.62653 16.8611C7.62653 16.8611 7.77081 16.8758 8.10285 16.8647C8.76496 16.8647 9.08712 16.4403 9.0891 16.4348H9.87177C11.781 16.4348 12.7159 15.4169 12.7159 14.1251C12.7218 12.8592 11.8265 12.6332 11.696 11.9055Z",
        fill: "black"
    }));



var $bb052987c4dc25a5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9944)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M24.25 12C24.25 18.6274 18.8774 24 12.25 24C5.62258 24 0.25 18.6274 0.25 12C0.25 5.37258 5.62258 0 12.25 0C18.8774 0 24.25 5.37258 24.25 12ZM6.58249 13.5711L6.64702 14.7466C6.65124 14.8267 6.68125 14.902 6.73189 14.9637C6.79577 15.0411 6.89982 15.1532 7.04848 15.2849L7.07251 15.3061C7.76093 15.9066 9.35249 16.8875 12.249 16.8875C15.1593 16.8875 16.7395 15.91 17.4249 15.309L17.4248 15.309L17.4534 15.2837L17.4534 15.2837C17.5952 15.157 17.696 15.0486 17.7601 14.9717C17.8154 14.9053 17.8473 14.8229 17.8524 14.7363L17.9164 13.5719C18.3422 13.3383 18.7817 13.0743 18.7817 13.0743C19.4727 12.7 20.244 13.2378 20.2454 14.0266C20.2477 15.3028 19.2505 16.6143 17.9054 17.4408C16.3888 18.3728 14.1248 18.7594 12.25 18.7594C10.3752 18.7594 8.11121 18.3728 6.59456 17.4408C5.24949 16.6143 4.2523 15.3033 4.25464 14.0266C4.25605 13.2378 5.02727 12.7 5.71832 13.0743C5.71832 13.0743 6.15708 13.3377 6.58249 13.5711ZM17.1553 5.43398C15.9663 5.29741 15.1735 5.22913 12.2495 5.22913C9.74078 5.22913 8.51807 5.32001 7.34366 5.43398C6.79467 5.48719 6.35679 5.90491 6.39711 6.45731L6.83505 12.4231C6.97222 12.4628 7.12181 12.513 7.28958 12.5693C8.16804 12.8641 9.54511 13.3263 12.2494 13.3263C14.9538 13.3263 16.3309 12.8641 17.2093 12.5693C17.3769 12.5131 17.5264 12.4629 17.6634 12.4232L18.1013 6.45731C18.1421 5.90491 17.7028 5.49708 17.1548 5.43398H17.1553Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9944"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    }))));



var $1fdae21720f5fd6d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9845)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12ZM6.83249 13.5711L6.89702 14.7466C6.90124 14.8267 6.93125 14.902 6.98189 14.9637C7.04577 15.0411 7.14982 15.1532 7.29848 15.2849L7.32251 15.3061C8.01093 15.9066 9.60249 16.8875 12.499 16.8875C15.4093 16.8875 16.9895 15.91 17.6749 15.309L17.6748 15.309L17.7034 15.2837L17.7034 15.2837C17.8452 15.157 17.946 15.0486 18.0101 14.9717C18.0654 14.9053 18.0973 14.8229 18.1024 14.7363L18.1664 13.5719C18.5922 13.3383 19.0317 13.0743 19.0317 13.0743C19.7227 12.7 20.494 13.2378 20.4954 14.0266C20.4977 15.3028 19.5005 16.6143 18.1554 17.4408C16.6388 18.3728 14.3748 18.7594 12.5 18.7594C10.6252 18.7594 8.36121 18.3728 6.84456 17.4408C5.49949 16.6143 4.5023 15.3033 4.50464 14.0266C4.50605 13.2378 5.27727 12.7 5.96832 13.0743C5.96832 13.0743 6.40708 13.3377 6.83249 13.5711ZM17.4053 5.43398C16.2163 5.29741 15.4235 5.22913 12.4995 5.22913C9.99078 5.22913 8.76807 5.32001 7.59366 5.43398C7.04467 5.48719 6.60679 5.90491 6.64711 6.45731L7.08505 12.4231C7.22222 12.4628 7.37181 12.513 7.53958 12.5693C8.41804 12.8641 9.79511 13.3263 12.4994 13.3263C15.2038 13.3263 16.5809 12.8641 17.4593 12.5693C17.6269 12.5131 17.7764 12.4629 17.9134 12.4232L18.3513 6.45731C18.3921 5.90491 17.9528 5.49708 17.4048 5.43398H17.4053Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9845"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    }))));



var $b5aefc20a3d6b530$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9745)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#A36EFE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5438_9745)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M6.33591 13.5711L6.40044 14.7466C6.40466 14.8267 6.43467 14.902 6.48531 14.9637C6.83927 15.3923 8.42623 16.8875 12.0024 16.8875C15.5787 16.8875 17.1464 15.4116 17.5135 14.9717C17.5688 14.9053 17.6007 14.8229 17.6059 14.7363L17.6698 13.5719C18.0956 13.3383 18.5351 13.0743 18.5351 13.0743C19.2262 12.7 19.9974 13.2378 19.9988 14.0266C20.0011 15.3028 19.0039 16.6143 17.6589 17.4408C16.1422 18.3728 13.8783 18.7594 12.0034 18.7594C10.1286 18.7594 7.86463 18.3728 6.34798 17.4408C5.00291 16.6143 4.00572 15.3033 4.00806 14.0266C4.00947 13.2378 4.78069 12.7 5.47173 13.0743C5.47173 13.0743 5.9105 13.3377 6.33591 13.5711Z",
        fill: "#4C2896"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0029 5.22913C14.9269 5.22913 15.7197 5.29741 16.9087 5.43398H16.9082C17.4563 5.49708 17.8956 5.90491 17.8548 6.45731L17.4168 12.4232C17.2798 12.4629 17.1303 12.5131 16.9627 12.5693C16.0843 12.8641 14.7072 13.3263 12.0029 13.3263C9.29853 13.3263 7.92146 12.8641 7.043 12.5693C6.87523 12.513 6.72563 12.4628 6.58847 12.4231L6.15053 6.45731C6.11021 5.90491 6.54809 5.48719 7.09708 5.43398C8.27149 5.32001 9.4942 5.22913 12.0029 5.22913ZM6.79831 15.2818L6.79985 15.3027L6.83007 15.3097C6.81926 15.3003 6.80868 15.291 6.79831 15.2818ZM17.1782 15.309L17.2055 15.3027L17.2069 15.2837C17.1975 15.292 17.1879 15.3005 17.1782 15.309Z",
        fill: "#4C2896"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9745"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5438_9745"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "16",
        height: "13.5463",
        fill: "white",
        transform: "translate(4 5.22681)"
    }))));



var $21d20f189cb1f8b6$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9997)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.25 23.92C5.64471 23.92 0.290039 18.5653 0.290039 11.96C0.290039 5.35468 5.64471 0 12.25 0C18.8554 0 24.21 5.35468 24.21 11.96C24.21 18.5653 18.8554 23.92 12.25 23.92ZM12.2496 9.30401L8.59265 15.483H15.9065L12.2496 9.30401ZM12.2496 4.56166L12.25 4.56091H12.2491L12.2496 4.56166ZM4.25 18.0791L12.2496 4.56166L20.25 18.0791H4.25Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9997"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    }))));



var $84d581e5b4187c70$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_10001)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.5 23.92C5.89471 23.92 0.540039 18.5653 0.540039 11.96C0.540039 5.35468 5.89471 0 12.5 0C19.1054 0 24.46 5.35468 24.46 11.96C24.46 18.5653 19.1054 23.92 12.5 23.92ZM12.4996 9.30401L8.84265 15.483H16.1565L12.4996 9.30401ZM12.4996 4.56166L12.5 4.56091H12.4991L12.4996 4.56166ZM4.5 18.0791L12.4996 4.56166L20.5 18.0791H4.5Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_10001"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    }))));



var $db2d6564ff1b1c33$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9995)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5438_9995)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.0800781 11.96C0.0800781 18.5653 5.43475 23.92 12.0401 23.92C18.6454 23.92 24.0001 18.5653 24.0001 11.96C24.0001 5.35468 18.6454 0 12.0401 0C5.43475 0 0.0800781 5.35468 0.0800781 11.96Z",
        fill: "#F30019"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0392 9.30327L15.6965 15.483H8.38269L12.04 9.30327M12.04 4.56091L4.04004 18.0791H20.04L12.0392 4.56091H12.0403H12.04Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9995"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5438_9995"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $71a24e992ee3775f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5501_9760)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24.5",
        height: "24",
        fill: "url(#pattern0_5501_9760)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("pattern", {
        id: "pattern0_5501_9760",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("use", {
        xlinkHref: "#image0_5501_9760",
        transform: "scale(0.0204082 0.0208333)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5501_9760"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("image", {
        id: "image0_5501_9760",
        width: "49",
        height: "48",
        xlinkHref: "data:image/png;base64,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"
    })));



var $246b4e1c86941e69$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5501_9764)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24.5",
        height: "24",
        fill: "url(#pattern0_5501_9764)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("pattern", {
        id: "pattern0_5501_9764",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("use", {
        xlinkHref: "#image0_5501_9764",
        transform: "scale(0.0204082 0.0208333)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5501_9764"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("image", {
        id: "image0_5501_9764",
        width: "49",
        height: "48",
        xlinkHref: "data:image/png;base64,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"
    })));



var $1bfcf1ffbee935bb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5501_9758)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "url(#pattern0_5501_9758)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("pattern", {
        id: "pattern0_5501_9758",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("use", {
        xlinkHref: "#image0_5501_9758",
        transform: "scale(0.0208333)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5501_9758"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("image", {
        id: "image0_5501_9758",
        width: "48",
        height: "48",
        xlinkHref: "data:image/png;base64,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"
    })));



var $5e7cd3d60ff0222b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9950)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.2184 24.2419C15.7424 24.2419 18.9126 22.7309 21.113 20.323L20.5275 19.6786C19.8029 18.881 18.5677 18.8128 17.7588 19.5258L16.5098 20.6268C14.8107 22.1246 12.228 22.0301 10.644 20.4123L9.86301 19.6146C9.11306 18.8486 7.88421 18.822 7.10133 19.5547L4.81058 21.6984C6.85279 23.2921 9.42436 24.2419 12.2184 24.2419ZM22.2202 18.1573L22.5045 18.4703C23.6121 16.6547 24.25 14.5227 24.25 12.2419C24.25 9.47648 23.3121 6.92949 21.7361 4.90017C21.4432 4.97507 21.1632 5.11841 20.9214 5.33156L19.6724 6.43251C17.9733 7.93033 15.3906 7.83592 13.8066 6.21806L13.0256 5.42041C12.2756 4.65445 11.0468 4.62775 10.2639 5.3604L7.05042 8.36779L5.48708 6.71536L8.70058 3.70796C10.3899 2.12696 13.0417 2.18458 14.66 3.83746L15.4409 4.63511C16.1751 5.38484 17.3719 5.42859 18.1593 4.73448L19.4082 3.63353C19.6179 3.44876 19.8407 3.28832 20.0734 3.15197C17.9656 1.33852 15.2204 0.241943 12.2184 0.241943C6.18258 0.241943 1.18485 4.67474 0.319346 10.4543C1.96636 9.50871 4.10491 9.75592 5.48829 11.1688L6.39147 12.0913C7.09349 12.8084 8.22595 12.884 9.01806 12.2667L11.6954 10.1805C13.3024 8.92838 15.5774 8.98895 17.1147 10.3248L20.7603 13.4928L19.2594 15.2014L15.6137 12.0335C14.9013 11.4144 13.847 11.3863 13.1024 11.9667L10.425 14.0529C8.71568 15.3848 6.27196 15.2215 4.75707 13.6743L3.8539 12.7518C3.10394 11.9859 1.87509 11.9591 1.09222 12.6918L0.25 13.48C0.510464 16.0146 1.56188 18.3155 3.15401 20.1333L5.538 17.9022C7.22736 16.3212 9.87909 16.3788 11.4974 18.0317L12.2784 18.8293C13.0125 19.579 14.2093 19.6229 14.9967 18.9288L16.2457 17.8278C17.991 16.2892 20.6566 16.4363 22.2202 18.1573Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9950"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25 0.241943)"
    }))));



var $fa2a3300ae487506$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9957)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.4684 24.2419C15.9924 24.2419 19.1626 22.7309 21.363 20.323L20.7775 19.6786C20.0529 18.881 18.8177 18.8128 18.0088 19.5258L16.7598 20.6268C15.0607 22.1246 12.478 22.0301 10.894 20.4123L10.113 19.6146C9.36306 18.8486 8.13421 18.822 7.35133 19.5547L5.06058 21.6984C7.10279 23.2921 9.67436 24.2419 12.4684 24.2419ZM22.4702 18.1573L22.7545 18.4703C23.8621 16.6547 24.5 14.5227 24.5 12.2419C24.5 9.47648 23.5621 6.92949 21.9861 4.90017C21.6932 4.97507 21.4132 5.11841 21.1714 5.33156L19.9224 6.43251C18.2233 7.93033 15.6406 7.83592 14.0566 6.21806L13.2756 5.42041C12.5256 4.65445 11.2968 4.62775 10.5139 5.3604L7.30042 8.36779L5.73708 6.71536L8.95058 3.70796C10.6399 2.12696 13.2917 2.18458 14.91 3.83746L15.6909 4.63511C16.4251 5.38484 17.6219 5.42859 18.4093 4.73448L19.6582 3.63353C19.8679 3.44876 20.0907 3.28832 20.3234 3.15197C18.2156 1.33852 15.4704 0.241943 12.4684 0.241943C6.43258 0.241943 1.43485 4.67474 0.569346 10.4543C2.21636 9.50871 4.35491 9.75592 5.73829 11.1688L6.64147 12.0913C7.34349 12.8084 8.47595 12.884 9.26806 12.2667L11.9454 10.1805C13.5524 8.92838 15.8274 8.98895 17.3647 10.3248L21.0103 13.4928L19.5094 15.2014L15.8637 12.0335C15.1513 11.4144 14.097 11.3863 13.3524 11.9667L10.675 14.0529C8.96568 15.3848 6.52196 15.2215 5.00707 13.6743L4.1039 12.7518C3.35394 11.9859 2.12509 11.9591 1.34222 12.6918L0.5 13.48C0.760464 16.0146 1.81188 18.3155 3.40401 20.1333L5.788 17.9022C7.47736 16.3212 10.1291 16.3788 11.7474 18.0317L12.5284 18.8293C13.2625 19.579 14.4593 19.6229 15.2467 18.9288L16.4957 17.8278C18.241 16.2892 20.9066 16.4363 22.4702 18.1573Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9957"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5 0.241943)"
    }))));



var $4eb6a9d9e5e3e5a1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9946)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.9684 24.2419C15.4924 24.2419 18.6626 22.7309 20.863 20.323L20.2775 19.6786C19.5529 18.881 18.3177 18.8128 17.5088 19.5258L16.2598 20.6268C14.5607 22.1246 11.978 22.0301 10.394 20.4123L9.61301 19.6146C8.86306 18.8486 7.63421 18.822 6.85133 19.5547L4.56058 21.6984C6.60279 23.2921 9.17436 24.2419 11.9684 24.2419ZM21.9702 18.1573L22.2545 18.4703C23.3621 16.6547 24 14.5227 24 12.2419C24 9.47648 23.0621 6.92949 21.4861 4.90017C21.1932 4.97507 20.9132 5.11841 20.6714 5.33156L19.4224 6.43251C17.7233 7.93033 15.1406 7.83592 13.5566 6.21806L12.7756 5.42041C12.0256 4.65445 10.7968 4.62775 10.0139 5.3604L6.80042 8.36779L5.23708 6.71536L8.45058 3.70796C10.1399 2.12696 12.7917 2.18458 14.41 3.83746L15.1909 4.63511C15.9251 5.38484 17.1219 5.42859 17.9093 4.73448L19.1582 3.63353C19.3679 3.44876 19.5907 3.28832 19.8234 3.15197C17.7156 1.33852 14.9704 0.241943 11.9684 0.241943C5.93258 0.241943 0.934849 4.67474 0.0693464 10.4543C1.71636 9.50871 3.85491 9.75592 5.23829 11.1688L6.14147 12.0913C6.84349 12.8084 7.97595 12.884 8.76806 12.2667L11.4454 10.1805C13.0524 8.92838 15.3274 8.98895 16.8647 10.3248L20.5103 13.4928L19.0094 15.2014L15.3637 12.0335C14.6513 11.4144 13.597 11.3863 12.8524 11.9667L10.175 14.0529C8.46568 15.3848 6.02196 15.2215 4.50707 13.6743L3.6039 12.7518C2.85394 11.9859 1.62509 11.9591 0.842217 12.6918L0 13.48C0.260464 16.0146 1.31188 18.3155 2.90401 20.1333L5.288 17.9022C6.97736 16.3212 9.62909 16.3788 11.2474 18.0317L12.0284 18.8293C12.7625 19.579 13.9593 19.6229 14.7467 18.9288L15.9957 17.8278C17.741 16.2892 20.4066 16.4363 21.9702 18.1573Z",
        fill: "url(#paint0_linear_5438_9946)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_5438_9946",
        x1: "12",
        y1: "0.241944",
        x2: "16.7179",
        y2: "24.242",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#780000"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#C1121F"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9946"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.241943)"
    }))));



var $492e522d366d2641$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5445_18770)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.2499 7.71095C14.6168 7.71095 16.5357 9.63141 16.5357 12C16.5357 14.3687 14.6168 16.2892 12.2499 16.2892C9.88321 16.2892 7.96428 14.3687 7.96428 12C7.96428 9.63141 9.88321 7.71095 12.2499 7.71095ZM12.2499 -0.00939941C10.6332 -0.00939941 9.06142 0.309069 7.57643 0.93742C6.14607 1.54218 4.86357 2.4075 3.76429 3.50765C2.66499 4.6078 1.80035 5.8913 1.19607 7.32279C0.568214 8.80793 0.25 10.382 0.25 12C0.25 13.6181 0.568214 15.1911 1.19607 16.6773C1.80035 18.1087 2.66499 19.3923 3.76429 20.4924C4.86357 21.5926 6.14607 22.4579 7.57643 23.0626C9.06035 23.691 10.6332 24.0094 12.2499 24.0094C13.8667 24.0094 15.4386 23.691 16.9235 23.0626C18.3539 22.4579 19.6364 21.5926 20.7357 20.4924C21.835 19.3923 22.6997 18.1087 23.3039 16.6773C23.9318 15.1922 24.25 13.6181 24.25 12C24.25 10.382 23.9318 8.80894 23.3039 7.32279C22.6997 5.8913 21.835 4.6078 20.7357 3.50765C19.6364 2.4075 18.3539 1.54218 16.9235 0.93742C15.4397 0.309069 13.8667 -0.00939941 12.2499 -0.00939941Z",
        fill: "#C1C8CD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.2501 7.71098C14.6169 7.71098 16.5358 9.63144 16.5358 12.0001C16.5358 14.3687 14.6169 16.2892 12.2501 16.2892C9.88332 16.2892 7.96439 14.3687 7.96439 12.0001C7.96439 9.63144 9.88332 7.71098 12.2501 7.71098ZM12.2501 2.56409C7.05152 2.56409 2.82153 6.79741 2.82153 12.0001C2.82153 17.2027 7.05152 21.436 12.2501 21.436C17.4486 21.436 21.6787 17.2027 21.6787 12.0001C21.6787 6.79741 17.4486 2.56409 12.2501 2.56409Z",
        fill: "#889096"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.2499 7.71101C14.6167 7.71101 16.5357 9.63144 16.5357 12.0001C16.5357 14.3687 14.6167 16.2892 12.2499 16.2892C9.88318 16.2892 7.96425 14.3687 7.96425 12.0001C7.96425 9.63144 9.88318 7.71101 12.2499 7.71101ZM12.2499 5.13757C8.46889 5.13757 5.39282 8.21605 5.39282 12.0001C5.39282 15.7842 8.46889 18.8626 12.2499 18.8626C16.0311 18.8626 19.1071 15.7842 19.1071 12.0001C19.1071 8.21605 16.0311 5.13757 12.2499 5.13757Z",
        fill: "#687076"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.25 7.71094C14.6169 7.71094 16.5358 9.63135 16.5358 12C16.5358 14.3687 14.6169 16.2891 12.25 16.2891C9.88329 16.2891 7.96436 14.3687 7.96436 12C7.96436 9.63135 9.88329 7.71094 12.25 7.71094Z",
        fill: "#C1C8CD"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5445_18770"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    }))));



var $b8ca570db2cfb15c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5445_18774)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.4999 7.71095C14.8668 7.71095 16.7857 9.63141 16.7857 12C16.7857 14.3687 14.8668 16.2892 12.4999 16.2892C10.1332 16.2892 8.21428 14.3687 8.21428 12C8.21428 9.63141 10.1332 7.71095 12.4999 7.71095ZM12.4999 -0.00939941C10.8832 -0.00939941 9.31142 0.309069 7.82643 0.93742C6.39607 1.54218 5.11357 2.4075 4.01429 3.50765C2.91499 4.6078 2.05035 5.8913 1.44607 7.32279C0.818214 8.80793 0.5 10.382 0.5 12C0.5 13.6181 0.818214 15.1911 1.44607 16.6773C2.05035 18.1087 2.91499 19.3923 4.01429 20.4924C5.11357 21.5926 6.39607 22.4579 7.82643 23.0626C9.31035 23.691 10.8832 24.0094 12.4999 24.0094C14.1167 24.0094 15.6886 23.691 17.1735 23.0626C18.6039 22.4579 19.8864 21.5926 20.9857 20.4924C22.085 19.3923 22.9497 18.1087 23.5539 16.6773C24.1818 15.1922 24.5 13.6181 24.5 12C24.5 10.382 24.1818 8.80894 23.5539 7.32279C22.9497 5.8913 22.085 4.6078 20.9857 3.50765C19.8864 2.4075 18.6039 1.54218 17.1735 0.93742C15.6897 0.309069 14.1167 -0.00939941 12.4999 -0.00939941Z",
        fill: "#EAEAEA"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.5001 7.71098C14.8669 7.71098 16.7858 9.63144 16.7858 12.0001C16.7858 14.3687 14.8669 16.2892 12.5001 16.2892C10.1333 16.2892 8.21439 14.3687 8.21439 12.0001C8.21439 9.63144 10.1333 7.71098 12.5001 7.71098ZM12.5001 2.56409C7.30152 2.56409 3.07153 6.79741 3.07153 12.0001C3.07153 17.2027 7.30152 21.436 12.5001 21.436C17.6986 21.436 21.9287 17.2027 21.9287 12.0001C21.9287 6.79741 17.6986 2.56409 12.5001 2.56409Z",
        fill: "#CCCCCC"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.4999 7.71101C14.8667 7.71101 16.7857 9.63144 16.7857 12.0001C16.7857 14.3687 14.8667 16.2892 12.4999 16.2892C10.1332 16.2892 8.21425 14.3687 8.21425 12.0001C8.21425 9.63144 10.1332 7.71101 12.4999 7.71101ZM12.4999 5.13757C8.71889 5.13757 5.64282 8.21605 5.64282 12.0001C5.64282 15.7842 8.71889 18.8626 12.4999 18.8626C16.2811 18.8626 19.3571 15.7842 19.3571 12.0001C19.3571 8.21605 16.2811 5.13757 12.4999 5.13757Z",
        fill: "#999999"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.5 7.71094C14.8669 7.71094 16.7858 9.63135 16.7858 12C16.7858 14.3687 14.8669 16.2891 12.5 16.2891C10.1333 16.2891 8.21436 14.3687 8.21436 12C8.21436 9.63135 10.1333 7.71094 12.5 7.71094Z",
        fill: "#EAEAEA"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5445_18774"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    }))));



var $e74edf339d50787d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5445_18767)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9999 7.75819C14.3668 7.75819 16.2857 9.65744 16.2857 12.0001C16.2857 14.3427 14.3668 16.2419 11.9999 16.2419C9.63321 16.2419 7.71428 14.3427 7.71428 12.0001C7.71428 9.65744 9.63321 7.75819 11.9999 7.75819ZM11.9999 0.122803C10.3832 0.122803 8.81142 0.437765 7.32643 1.05921C5.89607 1.65731 4.61357 2.5131 3.51429 3.60115C2.41499 4.68919 1.55035 5.95856 0.946072 7.37429C0.318214 8.84308 0 10.3999 0 12.0001C0 13.6004 0.318214 15.156 0.946072 16.6258C1.55035 18.0415 2.41499 19.3109 3.51429 20.399C4.61357 21.487 5.89607 22.3428 7.32643 22.9409C8.81035 23.5624 10.3832 23.8773 11.9999 23.8773C13.6167 23.8773 15.1886 23.5624 16.6735 22.9409C18.1039 22.3428 19.3864 21.487 20.4857 20.399C21.585 19.3109 22.4497 18.0415 23.0539 16.6258C23.6818 15.1571 24 13.6004 24 12.0001C24 10.3999 23.6818 8.84409 23.0539 7.37429C22.4497 5.95856 21.585 4.68919 20.4857 3.60115C19.3864 2.5131 18.1039 1.65731 16.6735 1.05921C15.1897 0.437765 13.6167 0.122803 11.9999 0.122803Z",
        fill: "#B7F7B0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0002 7.75822C14.3669 7.75822 16.2858 9.65748 16.2858 12.0001C16.2858 14.3427 14.3669 16.2419 12.0002 16.2419C9.63332 16.2419 7.71439 14.3427 7.71439 12.0001C7.71439 9.65748 9.63332 7.75822 12.0002 7.75822ZM12.0002 2.66797C6.80154 2.66797 2.57153 6.8547 2.57153 12.0001C2.57153 17.1455 6.80154 21.3323 12.0002 21.3323C17.1987 21.3323 21.4287 17.1455 21.4287 12.0001C21.4287 6.8547 17.1987 2.66797 12.0002 2.66797Z",
        fill: "#07DC10"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9999 7.75814C14.3667 7.75814 16.2857 9.6574 16.2857 12.0001C16.2857 14.3426 14.3667 16.2418 11.9999 16.2418C9.63318 16.2418 7.71425 14.3426 7.71425 12.0001C7.71425 9.6574 9.63318 7.75814 11.9999 7.75814ZM11.9999 5.21301C8.21889 5.21301 5.14282 8.25761 5.14282 12.0001C5.14282 15.7424 8.21889 18.787 11.9999 18.787C15.7811 18.787 18.8571 15.7424 18.8571 12.0001C18.8571 8.25761 15.7811 5.21301 11.9999 5.21301Z",
        fill: "#0C9B00"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 7.75818C14.3668 7.75818 16.2858 9.65743 16.2858 12.0001C16.2858 14.3427 14.3668 16.2419 12 16.2419C9.63327 16.2419 7.71436 14.3427 7.71436 12.0001C7.71436 9.65743 9.63327 7.75818 12 7.75818Z",
        fill: "#EAEAEA"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5445_18767"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $2621370217cf8dde$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5445_18746)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.28152 14.6882C0.279215 13.2832 0.276911 11.8782 0.285398 10.4436C0.305681 10.4053 0.314504 10.3959 0.322662 10.3859C0.802041 10.1488 1.30224 9.97967 1.83723 9.92664C2.2885 9.88191 2.74003 9.83975 3.21194 9.79449C3.21194 8.42505 3.21194 7.03519 3.21194 5.64207C2.22416 5.71043 1.22186 5.70979 0.289522 6.20013C0.281748 6.09755 0.273769 6.04112 0.27374 5.9847C0.273029 4.67335 0.274562 3.36201 0.271 2.05068C0.270652 1.92256 0.29101 1.83585 0.424399 1.77786C1.33128 1.38363 2.28381 1.32438 3.28007 1.36315C3.28007 2.7659 3.28007 4.1556 3.28007 5.49385C4.22759 5.54169 5.14501 5.58802 6.0871 5.6356C6.0871 4.28877 6.0871 2.93161 6.0871 1.53531C7.08552 1.70364 8.00797 2.01904 8.94469 2.33345C8.94469 3.22814 8.94469 4.12113 8.94469 5.01412C8.94469 5.35658 8.94469 5.69903 8.94469 6.04148C8.94469 6.47081 8.94338 6.47449 9.33438 6.61359C10.0706 6.87552 10.8086 7.13275 11.5812 7.40436C11.5812 6.05836 11.5812 4.72108 11.5812 3.3443C12.224 3.52427 12.8233 3.69207 13.4487 3.86716C13.4487 3.19301 13.4487 2.5378 13.4487 1.84791C13.8129 1.93948 14.1477 2.02491 14.4832 2.10764C14.7604 2.176 15.0368 2.24884 15.3166 2.30467C15.466 2.33448 15.5169 2.40011 15.5144 2.55394C15.5056 3.09671 15.5057 3.63982 15.5171 4.1825C15.5187 4.25811 15.5913 4.38638 15.6496 4.39815C16.1466 4.49846 16.6479 4.57793 17.1482 4.66172C17.1783 4.66677 17.2111 4.65542 17.2596 4.64973C17.2596 4.01094 17.2596 3.37858 17.2596 2.69923C17.3978 2.72052 17.5124 2.74491 17.6282 2.75482C18.064 2.79208 18.4997 2.83416 18.9363 2.85471C19.139 2.86426 19.2326 2.91424 19.2253 3.14221C19.209 3.65119 19.2265 4.16117 19.2169 4.67049C19.2134 4.85412 19.2749 4.90032 19.4586 4.92057C20.488 5.03405 21.5065 5.20661 22.3891 5.80184C23.1549 6.31834 23.5133 7.06197 23.5872 7.97619C23.6464 8.7082 23.5609 9.41039 23.3405 10.1077C23.1076 10.8445 22.7201 11.4788 22.1679 12.0154C22.1084 12.0731 22.0432 12.125 21.9562 12.2009C22.0889 12.2544 22.1804 12.2988 22.2764 12.3287C23.3366 12.6594 23.9358 13.3893 24.1338 14.4676C24.3584 15.6912 24.1854 16.8687 23.6173 17.963C22.8673 19.4079 21.6774 20.304 20.0612 20.6028C19.7952 20.652 19.5273 20.6904 19.2297 20.7388C19.2297 21.3672 19.2297 22.022 19.2297 22.6767C18.5669 22.6767 17.9315 22.6767 17.2699 22.6767C17.2699 21.9904 17.2699 21.3351 17.2699 20.6828C16.6749 20.6191 16.1065 20.5583 15.517 20.4953C15.517 21.1565 15.517 21.7885 15.517 22.4905C14.8168 22.3787 14.1448 22.2714 13.4603 22.1621C13.4603 21.4724 13.4603 20.8061 13.4603 20.1382C12.7945 19.9907 12.1368 19.8722 11.4948 19.696C10.7009 19.4781 9.92169 19.207 9.13234 18.9715C8.9545 18.9184 8.88798 18.8451 8.88958 18.6511C8.8995 17.4484 8.89457 16.2456 8.89457 15.0429C8.89457 14.9517 8.89457 14.8605 8.89457 14.739C7.98702 14.5214 7.08587 14.3052 6.13944 14.0783C6.13944 15.5264 6.13944 16.9071 6.13944 18.2465C5.16107 18.2465 4.21451 18.2465 3.24192 18.2465C3.24192 16.8997 3.24192 15.5103 3.24192 14.0844C2.25955 14.1965 1.29267 14.2198 0.381146 14.6884C0.324915 14.689 0.303218 14.6886 0.28152 14.6882ZM16.0868 14.0367C15.9026 14.0168 15.7185 13.9969 15.5208 13.9755C15.5208 15.0483 15.5208 16.0814 15.5208 17.1514C15.9271 17.1998 16.331 17.2601 16.737 17.2936C17.453 17.3527 18.1698 17.4153 18.8874 17.437C19.2663 17.4486 19.6344 17.3217 19.9437 17.0918C20.4236 16.7352 20.6689 15.985 20.5093 15.4084C20.385 14.9595 20.1369 14.6372 19.6773 14.4548C19.1522 14.2464 18.6048 14.3175 18.0706 14.2427C17.4274 14.1526 16.7785 14.1036 16.0868 14.0367ZM18.0351 8.07187C17.2013 7.96203 16.3675 7.85219 15.511 7.73935C15.511 7.82867 15.511 7.91901 15.511 8.00935C15.511 8.81881 15.5165 9.62833 15.5074 10.4377C15.5049 10.6571 15.5154 10.8183 15.8027 10.7859C15.9045 10.7745 16.0127 10.8126 16.117 10.8331C16.9269 10.992 17.7421 11.1105 18.5695 11.0752C18.9797 11.0578 19.3727 10.9365 19.5989 10.5642C19.7426 10.3277 19.8433 10.054 19.9089 9.78386C19.9877 9.4598 19.7583 8.74079 19.3921 8.49801C18.9849 8.22804 18.5362 8.15614 18.0351 8.07187ZM3.28787 9.86871C3.28787 11.2349 3.28787 12.6012 3.28787 13.9864C4.22863 13.9864 5.14843 13.9864 6.07819 13.9864C6.07819 12.6577 6.07819 11.3077 6.07819 9.9395C5.16064 9.78087 4.24424 9.72105 3.28787 9.86871ZM6.95347 10.0313C7.59172 10.2023 8.22997 10.3733 8.89431 10.5513C8.89431 9.21014 8.89639 7.92517 8.88765 6.64026C8.88725 6.58134 8.80059 6.49482 8.73538 6.46962C8.50761 6.38163 8.2741 6.30567 8.03824 6.24193C7.41437 6.07334 6.78813 5.91354 6.13783 5.74371C6.13783 7.10778 6.1354 8.41806 6.14498 9.72826C6.14546 9.79402 6.23911 9.89755 6.30814 9.91705C6.50375 9.9723 6.70911 9.99304 6.95347 10.0313ZM8.94469 11.2562C8.94469 12.4064 8.94469 13.5567 8.94469 14.7125C9.82594 14.9979 10.697 15.28 11.5627 15.5603C11.5831 15.5181 11.5898 15.5106 11.5899 15.503C11.5939 14.236 11.5996 12.9689 11.5943 11.7019C11.5941 11.6434 11.507 11.5575 11.4417 11.5317C11.0857 11.3909 10.7252 11.2611 10.3636 11.1349C9.90389 10.9744 9.4417 10.821 8.94469 10.6525C8.94469 10.862 8.94469 11.0344 8.94469 11.2562Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5445_18746"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    }))));



var $59b67eb86f238e24$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5445_18750)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.53152 14.6882C0.529215 13.2832 0.526911 11.8782 0.535398 10.4436C0.555681 10.4053 0.564504 10.3959 0.572662 10.3859C1.05204 10.1488 1.55224 9.97967 2.08723 9.92664C2.5385 9.88191 2.99003 9.83975 3.46194 9.79449C3.46194 8.42505 3.46194 7.03519 3.46194 5.64207C2.47416 5.71043 1.47186 5.70979 0.539522 6.20013C0.531748 6.09755 0.523769 6.04112 0.52374 5.9847C0.523029 4.67335 0.524562 3.36201 0.521 2.05068C0.520652 1.92256 0.54101 1.83585 0.674399 1.77786C1.58128 1.38363 2.53381 1.32438 3.53007 1.36315C3.53007 2.7659 3.53007 4.1556 3.53007 5.49385C4.47759 5.54169 5.39501 5.58802 6.3371 5.6356C6.3371 4.28877 6.3371 2.93161 6.3371 1.53531C7.33552 1.70364 8.25797 2.01904 9.19469 2.33345C9.19469 3.22814 9.19469 4.12113 9.19469 5.01412C9.19469 5.35658 9.19469 5.69903 9.19469 6.04148C9.19469 6.47081 9.19338 6.47449 9.58438 6.61359C10.3206 6.87552 11.0586 7.13275 11.8312 7.40436C11.8312 6.05836 11.8312 4.72108 11.8312 3.3443C12.474 3.52427 13.0733 3.69207 13.6987 3.86716C13.6987 3.19301 13.6987 2.5378 13.6987 1.84791C14.0629 1.93948 14.3977 2.02491 14.7332 2.10764C15.0104 2.176 15.2868 2.24884 15.5666 2.30467C15.716 2.33448 15.7669 2.40011 15.7644 2.55394C15.7556 3.09671 15.7557 3.63982 15.7671 4.1825C15.7687 4.25811 15.8413 4.38638 15.8996 4.39815C16.3966 4.49846 16.8979 4.57793 17.3982 4.66172C17.4283 4.66677 17.4611 4.65542 17.5096 4.64973C17.5096 4.01094 17.5096 3.37858 17.5096 2.69923C17.6478 2.72052 17.7624 2.74491 17.8782 2.75482C18.314 2.79208 18.7497 2.83416 19.1863 2.85471C19.389 2.86426 19.4826 2.91424 19.4753 3.14221C19.459 3.65119 19.4765 4.16117 19.4669 4.67049C19.4634 4.85412 19.5249 4.90032 19.7086 4.92057C20.738 5.03405 21.7565 5.20661 22.6391 5.80184C23.4049 6.31834 23.7633 7.06197 23.8372 7.97619C23.8964 8.7082 23.8109 9.41039 23.5905 10.1077C23.3576 10.8445 22.9701 11.4788 22.4179 12.0154C22.3584 12.0731 22.2932 12.125 22.2062 12.2009C22.3389 12.2544 22.4304 12.2988 22.5264 12.3287C23.5866 12.6594 24.1858 13.3893 24.3838 14.4676C24.6084 15.6912 24.4354 16.8687 23.8673 17.963C23.1173 19.4079 21.9274 20.304 20.3112 20.6028C20.0452 20.652 19.7773 20.6904 19.4797 20.7388C19.4797 21.3672 19.4797 22.022 19.4797 22.6767C18.8169 22.6767 18.1815 22.6767 17.5199 22.6767C17.5199 21.9904 17.5199 21.3351 17.5199 20.6828C16.9249 20.6191 16.3565 20.5583 15.767 20.4953C15.767 21.1565 15.767 21.7885 15.767 22.4905C15.0668 22.3787 14.3948 22.2714 13.7103 22.1621C13.7103 21.4724 13.7103 20.8061 13.7103 20.1382C13.0445 19.9907 12.3868 19.8722 11.7448 19.696C10.9509 19.4781 10.1717 19.207 9.38234 18.9715C9.2045 18.9184 9.13798 18.8451 9.13958 18.6511C9.1495 17.4484 9.14457 16.2456 9.14457 15.0429C9.14457 14.9517 9.14457 14.8605 9.14457 14.739C8.23702 14.5214 7.33587 14.3052 6.38944 14.0783C6.38944 15.5264 6.38944 16.9071 6.38944 18.2465C5.41107 18.2465 4.46451 18.2465 3.49192 18.2465C3.49192 16.8997 3.49192 15.5103 3.49192 14.0844C2.50955 14.1965 1.54267 14.2198 0.631146 14.6884C0.574915 14.689 0.553218 14.6886 0.53152 14.6882ZM16.3368 14.0367C16.1526 14.0168 15.9685 13.9969 15.7708 13.9755C15.7708 15.0483 15.7708 16.0814 15.7708 17.1514C16.1771 17.1998 16.581 17.2601 16.987 17.2936C17.703 17.3527 18.4198 17.4153 19.1374 17.437C19.5163 17.4486 19.8844 17.3217 20.1937 17.0918C20.6736 16.7352 20.9189 15.985 20.7593 15.4084C20.635 14.9595 20.3869 14.6372 19.9273 14.4548C19.4022 14.2464 18.8548 14.3175 18.3206 14.2427C17.6774 14.1526 17.0285 14.1036 16.3368 14.0367ZM18.2851 8.07187C17.4513 7.96203 16.6175 7.85219 15.761 7.73935C15.761 7.82867 15.761 7.91901 15.761 8.00935C15.761 8.81881 15.7665 9.62833 15.7574 10.4377C15.7549 10.6571 15.7654 10.8183 16.0527 10.7859C16.1545 10.7745 16.2627 10.8126 16.367 10.8331C17.1769 10.992 17.9921 11.1105 18.8195 11.0752C19.2297 11.0578 19.6227 10.9365 19.8489 10.5642C19.9926 10.3277 20.0933 10.054 20.1589 9.78386C20.2377 9.4598 20.0083 8.74079 19.6421 8.49801C19.2349 8.22804 18.7862 8.15614 18.2851 8.07187ZM3.53787 9.86871C3.53787 11.2349 3.53787 12.6012 3.53787 13.9864C4.47863 13.9864 5.39843 13.9864 6.32819 13.9864C6.32819 12.6577 6.32819 11.3077 6.32819 9.9395C5.41064 9.78087 4.49424 9.72105 3.53787 9.86871ZM7.20347 10.0313C7.84172 10.2023 8.47997 10.3733 9.14431 10.5513C9.14431 9.21014 9.14639 7.92517 9.13765 6.64026C9.13725 6.58134 9.05059 6.49482 8.98538 6.46962C8.75761 6.38163 8.5241 6.30567 8.28824 6.24193C7.66437 6.07334 7.03813 5.91354 6.38783 5.74371C6.38783 7.10778 6.3854 8.41806 6.39498 9.72826C6.39546 9.79402 6.48911 9.89755 6.55814 9.91705C6.75375 9.9723 6.95911 9.99304 7.20347 10.0313ZM9.19469 11.2562C9.19469 12.4064 9.19469 13.5567 9.19469 14.7125C10.0759 14.9979 10.947 15.28 11.8127 15.5603C11.8331 15.5181 11.8398 15.5106 11.8399 15.503C11.8439 14.236 11.8496 12.9689 11.8443 11.7019C11.8441 11.6434 11.757 11.5575 11.6917 11.5317C11.3357 11.3909 10.9752 11.2611 10.6136 11.1349C10.1539 10.9744 9.6917 10.821 9.19469 10.6525C9.19469 10.862 9.19469 11.0344 9.19469 11.2562Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5445_18750"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    }))));



var $878dc4946753d056$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5445_18743)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.03152 14.6734C0.0292149 13.2683 0.0269111 11.8633 0.0353978 10.4287C0.0556813 10.3904 0.0645044 10.381 0.0726622 10.371C0.552041 10.1339 1.05224 9.96478 1.58723 9.91175C2.0385 9.86702 2.49003 9.82486 2.96194 9.77959C2.96194 8.41016 2.96194 7.0203 2.96194 5.62718C1.97416 5.69553 0.971861 5.6949 0.0395218 6.18524C0.031748 6.08266 0.0237692 6.02623 0.0237401 5.9698C0.0230288 4.65846 0.0245615 3.34712 0.0210004 2.03578C0.0206517 1.90766 0.0410101 1.82095 0.174399 1.76297C1.08128 1.36874 2.03381 1.30949 3.03007 1.34826C3.03007 2.75101 3.03007 4.14071 3.03007 5.47895C3.97759 5.5268 4.89501 5.57313 5.8371 5.62071C5.8371 4.27387 5.8371 2.91672 5.8371 1.52041C6.83552 1.68874 7.75797 2.00414 8.69469 2.31856C8.69469 3.21325 8.69469 4.10624 8.69469 4.99923C8.69469 5.34168 8.69469 5.68414 8.69469 6.02659C8.69469 6.45592 8.69338 6.4596 9.08438 6.5987C9.82065 6.86063 10.5586 7.11786 11.3312 7.38947C11.3312 6.04347 11.3312 4.70618 11.3312 3.32941C11.974 3.50937 12.5733 3.67717 13.1987 3.85227C13.1987 3.17812 13.1987 2.52291 13.1987 1.83301C13.5629 1.92459 13.8977 2.01001 14.2332 2.09275C14.5104 2.16111 14.7868 2.23395 15.0666 2.28977C15.216 2.31959 15.2669 2.38522 15.2644 2.53905C15.2556 3.08182 15.2557 3.62493 15.2671 4.1676C15.2687 4.24322 15.3413 4.37149 15.3996 4.38326C15.8966 4.48357 16.3979 4.56304 16.8982 4.64683C16.9283 4.65187 16.9611 4.64053 17.0096 4.63483C17.0096 3.99605 17.0096 3.36369 17.0096 2.68434C17.1478 2.70563 17.2624 2.73002 17.3782 2.73992C17.814 2.77719 18.2497 2.81926 18.6863 2.83982C18.889 2.84936 18.9826 2.89935 18.9753 3.12732C18.959 3.6363 18.9765 4.14628 18.9669 4.6556C18.9634 4.83923 19.0249 4.88543 19.2086 4.90567C20.238 5.01916 21.2565 5.19172 22.1391 5.78695C22.9049 6.30345 23.2633 7.04707 23.3372 7.9613C23.3964 8.6933 23.3109 9.3955 23.0905 10.0928C22.8576 10.8297 22.4701 11.4639 21.9179 12.0005C21.8584 12.0583 21.7932 12.1101 21.7062 12.186C21.8389 12.2395 21.9304 12.2839 22.0264 12.3139C23.0866 12.6445 23.6858 13.3744 23.8838 14.4527C24.1084 15.6763 23.9354 16.8539 23.3673 17.9481C22.6173 19.393 21.4274 20.2891 19.8112 20.5879C19.5452 20.6371 19.2773 20.6755 18.9797 20.7239C18.9797 21.3523 18.9797 22.0072 18.9797 22.6618C18.3169 22.6618 17.6815 22.6618 17.0199 22.6618C17.0199 21.9755 17.0199 21.3202 17.0199 20.6679C16.4249 20.6042 15.8565 20.5434 15.267 20.4804C15.267 21.1417 15.267 21.7736 15.267 22.4756C14.5668 22.3638 13.8948 22.2565 13.2103 22.1472C13.2103 21.4575 13.2103 20.7912 13.2103 20.1233C12.5445 19.9758 11.8868 19.8573 11.2448 19.6811C10.4509 19.4632 9.67169 19.1921 8.88234 18.9566C8.7045 18.9035 8.63798 18.8302 8.63958 18.6362C8.6495 17.4336 8.64457 16.2308 8.64457 15.028C8.64457 14.9368 8.64457 14.8456 8.64457 14.7241C7.73702 14.5065 6.83587 14.2904 5.88944 14.0634C5.88944 15.5115 5.88944 16.8922 5.88944 18.2316C4.91107 18.2316 3.96451 18.2316 2.99192 18.2316C2.99192 16.8848 2.99192 15.4954 2.99192 14.0695C2.00955 14.1816 1.04267 14.2049 0.131146 14.6735C0.0749154 14.6741 0.0532185 14.6737 0.03152 14.6734ZM15.8368 14.0218C15.6526 14.0019 15.4685 13.982 15.2708 13.9606C15.2708 15.0334 15.2708 16.0665 15.2708 17.1365C15.6771 17.1849 16.081 17.2452 16.487 17.2787C17.203 17.3378 17.9198 17.4004 18.6374 17.4222C19.0163 17.4337 19.3844 17.3068 19.6937 17.0769C20.1736 16.7203 20.4189 15.9701 20.2593 15.3935C20.135 14.9446 19.8869 14.6223 19.4273 14.4399C18.9022 14.2315 18.3548 14.3026 17.8206 14.2278C17.1774 14.1377 16.5285 14.0887 15.8368 14.0218ZM17.7851 8.05698C16.9513 7.94714 16.1175 7.83729 15.261 7.72446C15.261 7.81377 15.261 7.90412 15.261 7.99446C15.261 8.80392 15.2665 9.61344 15.2574 10.4228C15.2549 10.6423 15.2654 10.8034 15.5527 10.771C15.6545 10.7596 15.7627 10.7977 15.867 10.8182C16.6769 10.9771 17.4921 11.0956 18.3195 11.0604C18.7297 11.0429 19.1227 10.9216 19.3489 10.5493C19.4926 10.3128 19.5933 10.0391 19.6589 9.76896C19.7377 9.4449 19.5083 8.7259 19.1421 8.48311C18.7349 8.21315 18.2862 8.14125 17.7851 8.05698ZM3.03787 9.85382C3.03787 11.2201 3.03787 12.5863 3.03787 13.9715C3.97863 13.9715 4.89843 13.9715 5.82819 13.9715C5.82819 12.6428 5.82819 11.2929 5.82819 9.92461C4.91064 9.76598 3.99424 9.70616 3.03787 9.85382ZM6.70347 10.0164C7.34172 10.1874 7.97997 10.3584 8.64431 10.5364C8.64431 9.19525 8.64639 7.91027 8.63765 6.62537C8.63725 6.56645 8.55059 6.47992 8.48538 6.45473C8.25761 6.36673 8.0241 6.29078 7.78824 6.22704C7.16437 6.05845 6.53813 5.89865 5.88783 5.72882C5.88783 7.09289 5.8854 8.40317 5.89498 9.71337C5.89546 9.77913 5.98911 9.88265 6.05814 9.90215C6.25375 9.95741 6.45911 9.97814 6.70347 10.0164ZM8.69469 11.2413C8.69469 12.3915 8.69469 13.5418 8.69469 14.6976C9.57594 14.983 10.447 15.2651 11.3127 15.5454C11.3331 15.5032 11.3398 15.4957 11.3399 15.4882C11.3439 14.2211 11.3496 12.954 11.3443 11.687C11.3441 11.6285 11.257 11.5426 11.1917 11.5168C10.8357 11.376 10.4752 11.2462 10.1136 11.12C9.65389 10.9595 9.1917 10.8062 8.69469 10.6376C8.69469 10.8471 8.69469 11.0195 8.69469 11.2413Z",
        fill: "#E36E1B"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5445_18743"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $fd77ba9534398465$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9950)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.2184 24.2419C15.7424 24.2419 18.9126 22.7309 21.113 20.323L20.5275 19.6786C19.8029 18.881 18.5677 18.8128 17.7588 19.5258L16.5098 20.6268C14.8107 22.1246 12.228 22.0301 10.644 20.4123L9.86301 19.6146C9.11306 18.8486 7.88421 18.822 7.10133 19.5547L4.81058 21.6984C6.85279 23.2921 9.42436 24.2419 12.2184 24.2419ZM22.2202 18.1573L22.5045 18.4703C23.6121 16.6547 24.25 14.5227 24.25 12.2419C24.25 9.47648 23.3121 6.92949 21.7361 4.90017C21.4432 4.97507 21.1632 5.11841 20.9214 5.33156L19.6724 6.43251C17.9733 7.93033 15.3906 7.83592 13.8066 6.21806L13.0256 5.42041C12.2756 4.65445 11.0468 4.62775 10.2639 5.3604L7.05042 8.36779L5.48708 6.71536L8.70058 3.70796C10.3899 2.12696 13.0417 2.18458 14.66 3.83746L15.4409 4.63511C16.1751 5.38484 17.3719 5.42859 18.1593 4.73448L19.4082 3.63353C19.6179 3.44876 19.8407 3.28832 20.0734 3.15197C17.9656 1.33852 15.2204 0.241943 12.2184 0.241943C6.18258 0.241943 1.18485 4.67474 0.319346 10.4543C1.96636 9.50871 4.10491 9.75592 5.48829 11.1688L6.39147 12.0913C7.09349 12.8084 8.22595 12.884 9.01806 12.2667L11.6954 10.1805C13.3024 8.92838 15.5774 8.98895 17.1147 10.3248L20.7603 13.4928L19.2594 15.2014L15.6137 12.0335C14.9013 11.4144 13.847 11.3863 13.1024 11.9667L10.425 14.0529C8.71568 15.3848 6.27196 15.2215 4.75707 13.6743L3.8539 12.7518C3.10394 11.9859 1.87509 11.9591 1.09222 12.6918L0.25 13.48C0.510464 16.0146 1.56188 18.3155 3.15401 20.1333L5.538 17.9022C7.22736 16.3212 9.87909 16.3788 11.4974 18.0317L12.2784 18.8293C13.0125 19.579 14.2093 19.6229 14.9967 18.9288L16.2457 17.8278C17.991 16.2892 20.6566 16.4363 22.2202 18.1573Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9950"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25 0.241943)"
    }))));



var $1b41b0c52341f3dd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9957)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.4684 24.2419C15.9924 24.2419 19.1626 22.7309 21.363 20.323L20.7775 19.6786C20.0529 18.881 18.8177 18.8128 18.0088 19.5258L16.7598 20.6268C15.0607 22.1246 12.478 22.0301 10.894 20.4123L10.113 19.6146C9.36306 18.8486 8.13421 18.822 7.35133 19.5547L5.06058 21.6984C7.10279 23.2921 9.67436 24.2419 12.4684 24.2419ZM22.4702 18.1573L22.7545 18.4703C23.8621 16.6547 24.5 14.5227 24.5 12.2419C24.5 9.47648 23.5621 6.92949 21.9861 4.90017C21.6932 4.97507 21.4132 5.11841 21.1714 5.33156L19.9224 6.43251C18.2233 7.93033 15.6406 7.83592 14.0566 6.21806L13.2756 5.42041C12.5256 4.65445 11.2968 4.62775 10.5139 5.3604L7.30042 8.36779L5.73708 6.71536L8.95058 3.70796C10.6399 2.12696 13.2917 2.18458 14.91 3.83746L15.6909 4.63511C16.4251 5.38484 17.6219 5.42859 18.4093 4.73448L19.6582 3.63353C19.8679 3.44876 20.0907 3.28832 20.3234 3.15197C18.2156 1.33852 15.4704 0.241943 12.4684 0.241943C6.43258 0.241943 1.43485 4.67474 0.569346 10.4543C2.21636 9.50871 4.35491 9.75592 5.73829 11.1688L6.64147 12.0913C7.34349 12.8084 8.47595 12.884 9.26806 12.2667L11.9454 10.1805C13.5524 8.92838 15.8274 8.98895 17.3647 10.3248L21.0103 13.4928L19.5094 15.2014L15.8637 12.0335C15.1513 11.4144 14.097 11.3863 13.3524 11.9667L10.675 14.0529C8.96568 15.3848 6.52196 15.2215 5.00707 13.6743L4.1039 12.7518C3.35394 11.9859 2.12509 11.9591 1.34222 12.6918L0.5 13.48C0.760464 16.0146 1.81188 18.3155 3.40401 20.1333L5.788 17.9022C7.47736 16.3212 10.1291 16.3788 11.7474 18.0317L12.5284 18.8293C13.2625 19.579 14.4593 19.6229 15.2467 18.9288L16.4957 17.8278C18.241 16.2892 20.9066 16.4363 22.4702 18.1573Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9957"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5 0.241943)"
    }))));



var $09183dd2ea6fbf8c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5438_9946)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.9684 24.2419C15.4924 24.2419 18.6626 22.7309 20.863 20.323L20.2775 19.6786C19.5529 18.881 18.3177 18.8128 17.5088 19.5258L16.2598 20.6268C14.5607 22.1246 11.978 22.0301 10.394 20.4123L9.61301 19.6146C8.86306 18.8486 7.63421 18.822 6.85133 19.5547L4.56058 21.6984C6.60279 23.2921 9.17436 24.2419 11.9684 24.2419ZM21.9702 18.1573L22.2545 18.4703C23.3621 16.6547 24 14.5227 24 12.2419C24 9.47648 23.0621 6.92949 21.4861 4.90017C21.1932 4.97507 20.9132 5.11841 20.6714 5.33156L19.4224 6.43251C17.7233 7.93033 15.1406 7.83592 13.5566 6.21806L12.7756 5.42041C12.0256 4.65445 10.7968 4.62775 10.0139 5.3604L6.80042 8.36779L5.23708 6.71536L8.45058 3.70796C10.1399 2.12696 12.7917 2.18458 14.41 3.83746L15.1909 4.63511C15.9251 5.38484 17.1219 5.42859 17.9093 4.73448L19.1582 3.63353C19.3679 3.44876 19.5907 3.28832 19.8234 3.15197C17.7156 1.33852 14.9704 0.241943 11.9684 0.241943C5.93258 0.241943 0.934849 4.67474 0.0693464 10.4543C1.71636 9.50871 3.85491 9.75592 5.23829 11.1688L6.14147 12.0913C6.84349 12.8084 7.97595 12.884 8.76806 12.2667L11.4454 10.1805C13.0524 8.92838 15.3274 8.98895 16.8647 10.3248L20.5103 13.4928L19.0094 15.2014L15.3637 12.0335C14.6513 11.4144 13.597 11.3863 12.8524 11.9667L10.175 14.0529C8.46568 15.3848 6.02196 15.2215 4.50707 13.6743L3.6039 12.7518C2.85394 11.9859 1.62509 11.9591 0.842217 12.6918L0 13.48C0.260464 16.0146 1.31188 18.3155 2.90401 20.1333L5.288 17.9022C6.97736 16.3212 9.62909 16.3788 11.2474 18.0317L12.0284 18.8293C12.7625 19.579 13.9593 19.6229 14.7467 18.9288L15.9957 17.8278C17.741 16.2892 20.4066 16.4363 21.9702 18.1573Z",
        fill: "url(#paint0_linear_5438_9946)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_5438_9946",
        x1: "12",
        y1: "0.241944",
        x2: "16.7179",
        y2: "24.242",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#780000"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#C1121F"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5438_9946"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.241943)"
    }))));



var $a8ae9bcb291a0d48$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5457_9838)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5457_9838)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M1.22935 5H11.7356C11.9257 5 12.0796 5.15032 12.0796 5.33597V10.1438C12.0796 10.444 11.9005 10.7165 11.6215 10.8413L10.2982 11.4345C10.2336 11.4636 10.1919 11.5266 10.1919 11.5964C10.1919 11.6654 10.2322 11.7275 10.2959 11.757L11.6312 12.3771C11.9051 12.5042 12.0796 12.7739 12.0796 13.0705V18.2636C12.0796 18.4492 11.9257 18.5996 11.7356 18.5996H1.22935C0.68837 18.5996 0.25 18.1714 0.25 17.6431V5.95647C0.25 5.42813 0.68837 5 1.22935 5ZM6.92772 14.0663C7.19566 14.0663 7.38668 14.031 7.50028 13.9608C7.62397 13.8901 7.68582 13.7594 7.68582 13.568V13.5376C7.68582 13.3362 7.61892 13.1949 7.48471 13.1143C7.36102 13.0338 7.14945 12.9936 6.85031 12.9936H4.8916V14.0663H6.92772ZM6.83517 10.3944C7.30975 10.3944 7.54705 10.2279 7.54705 9.89555V9.81994C7.54705 9.62847 7.4852 9.4974 7.36151 9.42716C7.24791 9.34663 7.05732 9.30637 6.78889 9.30637H4.89206V10.3944H6.83566H6.83517ZM12.9701 12.9484H17.2997C17.2997 13.2911 17.3616 13.5278 17.4853 13.6588C17.6195 13.7899 17.81 13.8552 18.0578 13.8552C18.4806 13.8552 18.6923 13.6185 18.6923 13.1448C18.6923 12.913 18.6199 12.7471 18.4756 12.646C18.3414 12.5453 18.1352 12.4948 17.8568 12.4948H15.4739V10.742L19.1407 9.85037H12.9701C12.7979 9.85037 12.6581 9.71392 12.6581 9.54571V5.25455C12.6581 5.11408 12.7749 5 12.9188 5H23.0696C23.6106 5 24.0489 5.42813 24.0489 5.95647V9.386C24.0489 9.77342 23.7763 10.1103 23.3907 10.2002L19.373 11.1352L19.5585 11.1657H23.393C23.8661 11.1657 24.25 11.5406 24.25 12.0026V17.6435C24.25 18.1719 23.8116 18.6 23.2707 18.6H12.9188C12.7749 18.6 12.6581 18.4859 12.6581 18.3455V13.253C12.6581 13.0849 12.7979 12.9484 12.9701 12.9484Z",
        fill: "#11181C"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5457_9838"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5457_9838"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "13.6",
        fill: "white",
        transform: "translate(0.25 5)"
    }))));



var $b3cf31dec7dfc0b7$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5457_9847)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5457_9847)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M1.47935 5H11.9856C12.1757 5 12.3296 5.15032 12.3296 5.33597V10.1438C12.3296 10.444 12.1505 10.7165 11.8715 10.8413L10.5482 11.4345C10.4836 11.4636 10.4419 11.5266 10.4419 11.5964C10.4419 11.6654 10.4822 11.7275 10.5459 11.757L11.8812 12.3771C12.1551 12.5042 12.3296 12.7739 12.3296 13.0705V18.2636C12.3296 18.4492 12.1757 18.5996 11.9856 18.5996H1.47935C0.93837 18.5996 0.5 18.1714 0.5 17.6431V5.95647C0.5 5.42813 0.93837 5 1.47935 5ZM7.17772 14.0663C7.44566 14.0663 7.63668 14.031 7.75028 13.9608C7.87397 13.8901 7.93582 13.7594 7.93582 13.568V13.5376C7.93582 13.3362 7.86892 13.1949 7.73471 13.1143C7.61102 13.0338 7.39945 12.9936 7.10031 12.9936H5.1416V14.0663H7.17772ZM7.08517 10.3944C7.55975 10.3944 7.79705 10.2279 7.79705 9.89555V9.81994C7.79705 9.62847 7.7352 9.4974 7.61151 9.42716C7.49791 9.34663 7.30732 9.30637 7.03889 9.30637H5.14206V10.3944H7.08566H7.08517ZM13.2201 12.9484H17.5497C17.5497 13.2911 17.6116 13.5278 17.7353 13.6588C17.8695 13.7899 18.06 13.8552 18.3078 13.8552C18.7306 13.8552 18.9423 13.6185 18.9423 13.1448C18.9423 12.913 18.8699 12.7471 18.7256 12.646C18.5914 12.5453 18.3852 12.4948 18.1068 12.4948H15.7239V10.742L19.3907 9.85037H13.2201C13.0479 9.85037 12.9081 9.71392 12.9081 9.54571V5.25455C12.9081 5.11408 13.0249 5 13.1688 5H23.3196C23.8606 5 24.2989 5.42813 24.2989 5.95647V9.386C24.2989 9.77342 24.0263 10.1103 23.6407 10.2002L19.623 11.1352L19.8085 11.1657H23.643C24.1161 11.1657 24.5 11.5406 24.5 12.0026V17.6435C24.5 18.1719 24.0616 18.6 23.5207 18.6H13.1688C13.0249 18.6 12.9081 18.4859 12.9081 18.3455V13.253C12.9081 13.0849 13.0479 12.9484 13.2201 12.9484Z",
        fill: "#ECEDEE"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5457_9847"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5457_9847"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "13.6",
        fill: "white",
        transform: "translate(0.5 5)"
    }))));



var $fa5073fe8fa61d2d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5457_9830)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5457_9830)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.979348 5.19995H11.4856C11.6757 5.19995 11.8296 5.35027 11.8296 5.53592V10.3438C11.8296 10.644 11.6505 10.9164 11.3715 11.0412L10.0482 11.6345C9.98357 11.6635 9.94191 11.7266 9.94191 11.7964C9.94191 11.8653 9.98222 11.9275 10.0459 11.957L11.3812 12.5771C11.6551 12.7041 11.8296 12.9739 11.8296 13.2705V18.4635C11.8296 18.6492 11.6757 18.7995 11.4856 18.7995H0.979348C0.43837 18.7995 0 18.3714 0 17.843V6.15643C0 5.62808 0.43837 5.19995 0.979348 5.19995ZM6.67772 14.2663C6.94566 14.2663 7.13668 14.231 7.25028 14.1608C7.37397 14.09 7.43582 13.9594 7.43582 13.768V13.7376C7.43582 13.5362 7.36892 13.3948 7.23471 13.3143C7.11102 13.2338 6.89945 13.1936 6.60031 13.1936H4.6416V14.2663H6.67772ZM6.58517 10.5943C7.05975 10.5943 7.29705 10.4279 7.29705 10.0955V10.0199C7.29705 9.82842 7.2352 9.69735 7.11151 9.62711C6.99791 9.54658 6.80732 9.50632 6.53889 9.50632H4.64206V10.5943H6.58566H6.58517ZM12.7201 13.1483H17.0497C17.0497 13.491 17.1116 13.7277 17.2353 13.8588C17.3695 13.9899 17.56 14.0552 17.8078 14.0552C18.2306 14.0552 18.4423 13.8185 18.4423 13.3448C18.4423 13.113 18.3699 12.947 18.2256 12.8459C18.0914 12.7452 17.8852 12.6947 17.6068 12.6947H15.2239V10.9419L18.8907 10.0503H12.7201C12.5479 10.0503 12.4081 9.91387 12.4081 9.74566V5.4545C12.4081 5.31403 12.5249 5.19995 12.6688 5.19995H22.8196C23.3606 5.19995 23.7989 5.62808 23.7989 6.15643V9.58595C23.7989 9.97337 23.5263 10.3102 23.1407 10.4002L19.123 11.3352L19.3085 11.3656H23.143C23.6161 11.3656 24 11.7405 24 12.2026V17.8435C24 18.3718 23.5616 18.8 23.0207 18.8H12.6688C12.5249 18.8 12.4081 18.6859 12.4081 18.5454V13.453C12.4081 13.2848 12.5479 13.1483 12.7201 13.1483Z",
        fill: "#3368EF"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5457_9830"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5457_9830"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "13.6",
        fill: "white",
        transform: "translate(0 5.19995)"
    }))));



var $a6618b9fe2fcc6b8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5457_9796)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.25 0.758057C5.62704 0.758057 0.25 6.1351 0.25 12.758C0.25 19.381 5.62704 24.758 12.25 24.758C18.8729 24.758 24.25 19.381 24.25 12.758C24.2664 6.1351 18.8893 0.758057 12.25 0.758057ZM17.5287 14.2826H14.1352V15.5613C14.1352 18.1351 12.0533 20.217 9.47949 20.217C6.90573 20.217 4.82376 18.1351 4.82376 15.5613C4.82376 12.9875 6.90573 10.9056 9.47949 10.9056H10.7418V14.299H14.1352V10.8892H17.5287V14.2826ZM19.2172 9.18427H15.3975C14.6926 9.18427 14.1352 9.75804 14.1188 10.463V10.8892H10.7418V10.463C10.7418 7.88919 12.8238 5.80723 15.3975 5.80723H19.2172V9.18427Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.46301 14.2827C8.7581 14.2827 8.18433 14.8565 8.18433 15.5614C8.18433 16.2663 8.7581 16.8401 9.46301 16.8401C10.1679 16.8401 10.7417 16.2663 10.7417 15.5614V14.2827H9.46301C9.46301 14.2663 9.46301 14.2663 9.46301 14.2827Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.2787 10.8892H13.8853V14.2826H17.2787V10.8892Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4918 15.5449C10.4918 16.2498 9.91799 16.8236 9.21308 16.8236C8.50816 16.8236 7.93439 16.2498 7.93439 15.5449C7.93439 14.84 8.50816 14.2662 9.21308 14.2662H10.4918V10.8892H9.22947C6.6557 10.8892 4.57373 12.9711 4.57373 15.5449C4.57373 18.1187 6.6557 20.2006 9.22947 20.2006C11.8032 20.2006 13.8852 18.1187 13.8852 15.5449V14.2662H10.4918V15.5449Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.1474 9.1843H18.9671V5.80725H15.1474C12.5737 5.80725 10.4917 7.88922 10.4917 10.463V10.8892H13.8851V10.463C13.8851 9.75807 14.4589 9.1843 15.1474 9.1843Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5457_9796"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25 0.758057)"
    }))));



var $1e5ec29af45d770e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5457_9804)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.5 0.758057C5.87704 0.758057 0.5 6.1351 0.5 12.758C0.5 19.381 5.87704 24.758 12.5 24.758C19.1229 24.758 24.5 19.381 24.5 12.758C24.5164 6.1351 19.1393 0.758057 12.5 0.758057ZM17.7787 14.2826H14.3852V15.5613C14.3852 18.1351 12.3033 20.217 9.72949 20.217C7.15573 20.217 5.07376 18.1351 5.07376 15.5613C5.07376 12.9875 7.15573 10.9056 9.72949 10.9056H10.9918V14.299H14.3852V10.8892H17.7787V14.2826ZM19.4672 9.18427H15.6475C14.9426 9.18427 14.3852 9.75804 14.3688 10.463V10.8892H10.9918V10.463C10.9918 7.88919 13.0738 5.80723 15.6475 5.80723H19.4672V9.18427Z",
        fill: "#FBFCFD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.71301 14.2827C9.0081 14.2827 8.43433 14.8565 8.43433 15.5614C8.43433 16.2663 9.0081 16.8401 9.71301 16.8401C10.4179 16.8401 10.9917 16.2663 10.9917 15.5614V14.2827H9.71301C9.71301 14.2663 9.71301 14.2663 9.71301 14.2827Z",
        fill: "#FBFCFD"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5457_9804"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5 0.758057)"
    }))));



var $19f96307a41b3352$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5457_9788)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24.7581C18.6274 24.7581 24 19.3855 24 12.7581C24 6.13064 18.6274 0.758057 12 0.758057C5.37258 0.758057 0 6.13064 0 12.7581C0 19.3855 5.37258 24.7581 12 24.7581Z",
        fill: "#00EF8B"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.2787 10.8892H13.8853V14.2826H17.2787V10.8892Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4918 15.5449C10.4918 16.2498 9.91799 16.8236 9.21308 16.8236C8.50816 16.8236 7.93439 16.2498 7.93439 15.5449C7.93439 14.84 8.50816 14.2662 9.21308 14.2662H10.4918V10.8892H9.22947C6.6557 10.8892 4.57373 12.9711 4.57373 15.5449C4.57373 18.1187 6.6557 20.2006 9.22947 20.2006C11.8032 20.2006 13.8852 18.1187 13.8852 15.5449V14.2662H10.4918V15.5449Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M15.1474 9.1843H18.9671V5.80725H15.1474C12.5737 5.80725 10.4917 7.88922 10.4917 10.463V10.8892H13.8851V10.463C13.8851 9.75807 14.4589 9.1843 15.1474 9.1843Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4917 14.2662H13.8851V10.8892H10.4917V14.2662Z",
        fill: "#16FF99"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5457_9788"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.758057)"
    }))));



var $dfd471883153042a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5464_9795)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.5016 11.6102L14.9097 13.6859V16.1585V17.8345L18.5016 15.7588V11.6102ZM8.39421 6.55083L11.986 8.62656L15.5778 6.55083L11.986 4.4751L8.39421 6.55083ZM5.47333 13.6831V15.7588L6.44697 16.3184L9.06517 17.8316V13.6831L5.47333 11.6102V13.6859V13.6831ZM3.52609 16.8809V19.1308L2.55245 18.5683L1.57886 18.0058V11.9985V5.99122L11.986 -0.0161133L22.3932 5.99122V18.0087L17.1881 21.0123L14.9069 22.3286V20.0786L20.4459 16.8809V8.23825L12.9596 12.561C12.9596 13.7602 12.9596 14.9565 12.9596 16.1557V23.4535L11.986 24.016L11.0124 23.4535L6.781 21.0123L5.47333 20.2586V18.0087L11.0124 21.2065V12.5638L3.52609 8.24108V16.8837V16.8809ZM11.986 10.8736L4.49974 6.55083L11.986 2.22808L19.4723 6.55083L11.986 10.8736Z",
        fill: "#151718"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5464_9795"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(-0.000488281)"
    }))));



var $298e9c8bd5b177a4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5464_9794)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.502 11.6102L14.9102 13.6859V16.1585V17.8345L18.502 15.7588V11.6102ZM8.3947 6.55083L11.9865 8.62656L15.5783 6.55083L11.9865 4.4751L8.3947 6.55083ZM5.47382 13.6831V15.7588L6.44746 16.3184L9.06566 17.8316V13.6831L5.47382 11.6102V13.6859V13.6831ZM3.52658 16.8809V19.1308L2.55293 18.5683L1.57935 18.0058V11.9985V5.99122L11.9865 -0.0161133L22.3937 5.99122V18.0087L17.1886 21.0123L14.9074 22.3286V20.0786L20.4464 16.8809V8.23825L12.9601 12.561C12.9601 13.7602 12.9601 14.9565 12.9601 16.1557V23.4535L11.9865 24.016L11.0129 23.4535L6.78149 21.0123L5.47382 20.2586V18.0087L11.0129 21.2065V12.5638L3.52658 8.24108V16.8837V16.8809ZM11.9865 10.8736L4.50023 6.55083L11.9865 2.22808L19.4728 6.55083L11.9865 10.8736Z",
        fill: "#FBFCFD"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5464_9794"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $95daf0dde181c9e9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5464_9787)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
        fill: "url(#paint0_linear_5464_9787)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.2848 11.7589L13.9153 13.1282V14.7594V15.865L16.2848 14.4957V11.7589ZM9.61712 8.42126L11.9866 9.7906L14.3561 8.42126L11.9866 7.05193L9.61712 8.42126ZM7.69024 13.1263V14.4957L8.33255 14.8648L10.0597 15.8631V13.1263L7.69024 11.7589V13.1282V13.1263ZM6.40567 15.2359V16.7201L5.76336 16.3491L5.12109 15.978V12.015V8.05209L11.9866 4.08911L18.8521 8.05209V15.9799L15.4184 17.9614L13.9135 18.8297V17.3454L17.5675 15.2359V9.53444L12.6289 12.3861C12.6289 13.1772 12.6289 13.9664 12.6289 14.7575V19.5718L11.9866 19.9429L11.3443 19.5718L8.5529 17.9614L7.69024 17.4641V15.9799L11.3443 18.0894V12.388L6.40567 9.53631V15.2378V15.2359ZM11.9866 11.2729L7.04797 8.42126L11.9866 5.56958L16.9252 8.42126L11.9866 11.2729Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_5464_9787",
        x1: "20.7134",
        y1: "21.0955",
        x2: "-13.8535",
        y2: "-21.7643",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#8F00FF"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.531658",
        "stop-color": "#78A5EA"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#00FFC2"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5464_9787"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $9cfb0a47de3e13fb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5464_9765)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.25 3.83374L5.11237 11.2616H11.4117L9.98094 9.07495H14.5216L9.10162 17.3571L12.25 22.1662L24.25 3.83374L0.25 3.83374Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5464_9765"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.25)"
    }))));



var $946a6defb5aae25c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5464_9767)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0.5 3.83374L5.36237 11.2616H11.6617L10.2309 9.07495H14.7716L9.35162 17.3571L12.5 22.1662L24.5 3.83374L0.5 3.83374Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5464_9767"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0.5)"
    }))));



var $b0033bdbc2fa01c5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5464_9762)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M0 3.83374L4.86237 11.2616H11.1617L9.73094 9.07495H14.2716L8.85162 17.3571L12 22.1662L24 3.83374L0 3.83374Z",
        fill: "#FE2C2E"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5464_9762"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $fd8add7673104e82$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5466_9750)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.5781 5.422H5.42139V16.8768C5.42139 17.8164 6.1831 18.5781 7.12273 18.5781H9.033V9.03383H16.6877C17.7317 9.03383 18.5781 8.18748 18.5781 7.14345V5.422Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M16.9981 9.8127H9.84239V17.4446C9.84239 18.0706 10.3512 18.5781 10.8622 18.5781H11.9957V12.0301H15.9699C16.5378 12.0301 16.9981 11.6552 16.9981 10.9596V9.8127Z",
        fill: "#687076"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5466_9750"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(-0.000488281)"
    }))));



var $51189d4753b64ddf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5466_9747)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.5783 5.422H5.42163V16.8768C5.42163 17.8164 6.18335 18.5781 7.12297 18.5781H9.03325V9.03383H16.688C17.732 9.03383 18.5783 8.18748 18.5783 7.14345V5.422Z",
        fill: "#697177"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M16.9983 9.8127H9.84264V17.4446C9.84264 18.0706 10.3514 18.5781 10.8625 18.5781H11.996V12.0301H15.9702C16.538 12.0301 16.9983 11.6552 16.9983 10.9596V9.8127Z",
        fill: "#151718"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5466_9747"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $59db07788c98129e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5466_9753)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.5783 5.422H5.42163V16.8768C5.42163 17.8164 6.18335 18.5781 7.12297 18.5781H9.03325V9.03383H16.688C17.732 9.03383 18.5783 8.18748 18.5783 7.14345V5.422Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M16.9983 9.8127H9.84264V17.4446C9.84264 18.0706 10.3514 18.5781 10.8625 18.5781H11.996V12.0301H15.9702C16.538 12.0301 16.9983 11.6552 16.9983 10.9596V9.8127Z",
        fill: "#FF6B6B"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5466_9753"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $247d33f89ceecedf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5483_9785)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5483_9785)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "#FBFCFD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.06215 11.6658L6.91785 13.4936H7.471L7.31468 11.6658L7.20645 10.1266H7.17038L7.06215 11.6658Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0913 12.1829H12.4039C12.6444 12.1829 12.7406 11.9664 12.7406 11.5816V9.39305C12.7406 8.99623 12.6444 8.77977 12.4039 8.77977H12.0913V12.1829Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M-4.67174 0C-4.77335 0 -4.85571 0.0823656 -4.85571 0.183968V24.7277C-4.85571 24.8293 -4.77335 24.9116 -4.67175 24.9116H27.4999C27.6015 24.9116 27.6838 24.8293 27.6838 24.7277V0.183968C27.6838 0.0823653 27.6015 0 27.4999 0H-4.67174ZM6.40077 7.70954H8.06023L9.13046 16.6081H7.72353L7.5672 14.6721H6.82165L6.66532 16.6081H5.33054L6.40077 7.70954ZM12.0792 16.6081H10.6483V7.70954H12.5242C13.5463 7.70954 14.1716 8.3108 14.1716 9.39305V11.5816C14.1716 12.6518 13.5463 13.2531 12.5242 13.2531H12.0792V16.6081ZM15.82 7.70954V16.6081H18.6098V15.4296H17.2509V12.6999H18.4655V11.5215H17.2509V8.888H18.6098V7.70954H15.82Z",
        fill: "#11181C"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5483_9785"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(-0.000488281)"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5483_9785"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "white"
    }))));



var $eeba1c60d51d88f5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5483_9745)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5483_9745)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.06215 11.6658L6.91785 13.4936H7.471L7.31468 11.6658L7.20645 10.1266H7.17038L7.06215 11.6658Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0913 12.1829H12.4039C12.6444 12.1829 12.7406 11.9664 12.7406 11.5816V9.39305C12.7406 8.99623 12.6444 8.77977 12.4039 8.77977H12.0913V12.1829Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M-4.67174 0C-4.77335 0 -4.85571 0.0823656 -4.85571 0.183968V24.7277C-4.85571 24.8293 -4.77335 24.9116 -4.67175 24.9116H27.4999C27.6015 24.9116 27.6838 24.8293 27.6838 24.7277V0.183968C27.6838 0.0823653 27.6015 0 27.4999 0H-4.67174ZM6.40077 7.70954H8.06023L9.13046 16.6081H7.72353L7.5672 14.6721H6.82165L6.66532 16.6081H5.33054L6.40077 7.70954ZM12.0792 16.6081H10.6483V7.70954H12.5242C13.5463 7.70954 14.1716 8.3108 14.1716 9.39305V11.5816C14.1716 12.6518 13.5463 13.2531 12.5242 13.2531H12.0792V16.6081ZM15.82 7.70954V16.6081H18.6098V15.4296H17.2509V12.6999H18.4655V11.5215H17.2509V8.888H18.6098V7.70954H15.82Z",
        fill: "#ECEDEE"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5483_9745"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5483_9745"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "white"
    }))));



var $589101b9fee55f73$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5483_9822)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip1_5483_9822)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "#0054FA"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M7.06215 11.6658L6.91785 13.4936H7.471L7.31468 11.6658L7.20645 10.1266H7.17038L7.06215 11.6658Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0913 12.1829H12.4039C12.6444 12.1829 12.7406 11.9664 12.7406 11.5816V9.39305C12.7406 8.99623 12.6444 8.77977 12.4039 8.77977H12.0913V12.1829Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M-4.67174 0C-4.77335 0 -4.85571 0.0823656 -4.85571 0.183968V24.7277C-4.85571 24.8293 -4.77335 24.9116 -4.67175 24.9116H27.4999C27.6015 24.9116 27.6838 24.8293 27.6838 24.7277V0.183968C27.6838 0.0823653 27.6015 0 27.4999 0H-4.67174ZM6.40077 7.70954H8.06023L9.13046 16.6081H7.72353L7.5672 14.6721H6.82165L6.66532 16.6081H5.33054L6.40077 7.70954ZM12.0792 16.6081H10.6483V7.70954H12.5242C13.5463 7.70954 14.1716 8.3108 14.1716 9.39305V11.5816C14.1716 12.6518 13.5463 13.2531 12.5242 13.2531H12.0792V16.6081ZM15.82 7.70954V16.6081H18.6098V15.4296H17.2509V12.6999H18.4655V11.5215H17.2509V8.888H18.6098V7.70954H15.82Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5483_9822"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip1_5483_9822"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "12",
        fill: "white"
    }))));



var $2cf2c5e870ba0326$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5484_9754)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "black"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5484_9754"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(-0.000488281)"
    }))));



var $4295511770b2097a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5484_9745)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5484_9745"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $986150c8bc5a589f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5484_9760)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "black"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5484_9760"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $51304dc940cdde49$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5486_2301)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        transform: "matrix(-1 0 0 1 24.0005 0)",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_d_5486_2301)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.3068 14.2056L17.2284 17.0475L15.8579 18.3809L12.9358 15.5396C12.685 15.2955 12.3554 15.1628 11.9997 15.1628C11.6441 15.1628 11.3134 15.2955 11.0632 15.5396L8.14107 18.3809L6.77001 17.0475L9.6921 14.2056H14.3068Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.7842 14.4248L14.794 13.3864L14.7919 13.3843L12.4848 9.49926L13.5529 5.61902L15.4271 6.1061L14.359 9.98688C14.3133 10.1501 14.3014 10.3209 14.3241 10.4888C14.3468 10.6568 14.4036 10.8184 14.4911 10.9637C14.5789 11.1114 14.6952 11.2404 14.8331 11.3433C14.9711 11.4462 15.1281 11.521 15.2951 11.5633L19.2853 12.6022L18.7842 14.4248Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.20704 13.3864L5.21686 14.4248L4.71582 12.6022L8.706 11.5633C8.87305 11.5209 9.03006 11.4461 9.16803 11.3431C9.30599 11.2401 9.42221 11.111 9.51 10.9632C9.59747 10.8178 9.65429 10.6563 9.67699 10.4883C9.6997 10.3204 9.68781 10.1496 9.64205 9.98635L8.57449 6.1061L10.4487 5.61902L11.5168 9.49926L9.2097 13.3843L9.20704 13.3864Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_d_5486_2301",
        x: "-18.9775",
        y: "-13.3356",
        width: "61.956",
        height: "60.1485",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feOffset", {
        dy: "4.73867"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "11.8467"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5486_2301"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_5486_2301",
        result: "shape"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5486_2301"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $1eb8374dde71928c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5486_2299)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        transform: "matrix(-1 0 0 1 24 0)",
        fill: "#FDFEFF",
        "fill-opacity": "0.927"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_d_5486_2299)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.2982 14.1979L17.2094 17.0297L15.8437 18.3583L12.932 15.5271C12.6821 15.2839 12.3537 15.1517 11.9993 15.1517C11.6449 15.1517 11.3154 15.2839 11.066 15.5271L8.15431 18.3583L6.78812 17.0297L9.69984 14.1979H14.2982Z",
        fill: "#12181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.7597 14.4162L14.7837 13.3815L14.7816 13.3794L12.4826 9.5082L13.5469 5.64172L15.4145 6.12708L14.3502 9.99409C14.3046 10.1567 14.2928 10.3269 14.3154 10.4943C14.338 10.6616 14.3946 10.8226 14.4818 10.9674C14.5693 11.1146 14.6851 11.2432 14.8226 11.3457C14.9601 11.4482 15.1165 11.5227 15.2829 11.5649L19.259 12.6001L18.7597 14.4162Z",
        fill: "#12181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.2165 13.3815L5.24047 14.4162L4.74121 12.6001L8.71724 11.5649C8.88369 11.5227 9.04014 11.4481 9.17762 11.3455C9.3151 11.2429 9.4309 11.1142 9.51838 10.9669C9.60554 10.8221 9.66216 10.6611 9.68478 10.4937C9.70741 10.3264 9.69556 10.1562 9.64996 9.99356L8.58619 6.12708L10.4538 5.64172L11.5181 9.5082L9.21915 13.3794L9.2165 13.3815Z",
        fill: "#12181C"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_d_5486_2299",
        x: "-18.9521",
        y: "-13.3129",
        width: "61.9045",
        height: "60.1032",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feOffset", {
        dy: "4.73867"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "11.8467"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5486_2299"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_5486_2299",
        result: "shape"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5486_2299"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $7ee68766855764b3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5486_2303)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        transform: "matrix(-1 0 0 1 24.0005 0)",
        fill: "url(#paint0_linear_5486_2303)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_d_5486_2303)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M14.3068 14.2056L17.2284 17.0475L15.8579 18.3809L12.9358 15.5396C12.685 15.2955 12.3554 15.1628 11.9997 15.1628C11.6441 15.1628 11.3134 15.2955 11.0632 15.5396L8.14107 18.3809L6.77001 17.0475L9.6921 14.2056H14.3068Z",
        fill: "url(#paint1_linear_5486_2303)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M18.7842 14.4248L14.794 13.3864L14.7919 13.3843L12.4848 9.49926L13.5529 5.61902L15.4271 6.1061L14.359 9.98688C14.3133 10.1501 14.3014 10.3209 14.3241 10.4888C14.3468 10.6568 14.4036 10.8184 14.4911 10.9637C14.5789 11.1114 14.6952 11.2404 14.8331 11.3433C14.9711 11.4462 15.1281 11.521 15.2951 11.5633L19.2853 12.6022L18.7842 14.4248Z",
        fill: "url(#paint2_linear_5486_2303)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M9.20704 13.3864L5.21686 14.4248L4.71582 12.6022L8.706 11.5633C8.87305 11.5209 9.03006 11.4461 9.16803 11.3431C9.30599 11.2401 9.42221 11.111 9.51 10.9632C9.59747 10.8178 9.65429 10.6563 9.67699 10.4883C9.6997 10.3204 9.68781 10.1496 9.64205 9.98635L8.57449 6.1061L10.4487 5.61902L11.5168 9.49926L9.2097 13.3843L9.20704 13.3864Z",
        fill: "url(#paint3_linear_5486_2303)"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_d_5486_2303",
        x: "-18.9775",
        y: "-13.3356",
        width: "61.956",
        height: "60.1485",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feOffset", {
        dy: "4.73867"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "11.8467"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5486_2303"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_5486_2303",
        result: "shape"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_5486_2303",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#16D379"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#01CA6A"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint1_linear_5486_2303",
        x1: "12.0005",
        y1: "5.61902",
        x2: "12.0005",
        y2: "18.3809",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#D5D7D3"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint2_linear_5486_2303",
        x1: "12.0005",
        y1: "5.61902",
        x2: "12.0005",
        y2: "18.3809",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#D5D7D3"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint3_linear_5486_2303",
        x1: "12.0005",
        y1: "5.61902",
        x2: "12.0005",
        y2: "18.3809",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#D5D7D3"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5486_2303"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $0750d6c848ab0fdc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5486_2331)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        transform: "matrix(-1 0 0 1 24.0005 0)",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_d_5486_2331)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.597 7.30273H16.6972V10.4342V13.5657V16.6972H13.597H13.5657H12.8141V13.5658H11.217V16.6972H10.4342H7.30273V13.5658V10.4342V7.30273H10.4341H11.217V10.4342H12.8141V7.30273H13.5657H13.597Z",
        fill: "#EEEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.08423 4.08423H19.9158V10.3679H18.3011V5.69892H5.69892V18.3011H18.3011V13.5904H19.9158V19.9158H4.08423V4.08423Z",
        fill: "#EEEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_d_5486_2331",
        x: "-16.3906",
        y: "-11.6519",
        width: "56.7812",
        height: "56.7811",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feOffset", {
        dy: "4.73867"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "11.8467"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5486_2331"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_5486_2331",
        result: "shape"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5486_2331"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $c07ccfbfb09e736e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5486_2328)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        transform: "matrix(-1 0 0 1 24 0)",
        fill: "#FDFEFF",
        "fill-opacity": "0.927"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_d_5486_2328)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.597 7.30273H16.6972V10.4342V13.5657V16.6972H13.597H13.5657H12.8141V13.5658H11.217V16.6972H10.4342H7.30273V13.5658V10.4342V7.30273H10.4341H11.217V10.4342H12.8141V7.30273H13.5657H13.597Z",
        fill: "#12181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.08423 4.08423H19.9158V10.3679H18.3011V5.69892H5.69892V18.3011H18.3011V13.5904H19.9158V19.9158H4.08423V4.08423Z",
        fill: "#12181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_d_5486_2328",
        x: "-16.3906",
        y: "-11.6519",
        width: "56.7812",
        height: "56.7811",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feOffset", {
        dy: "4.73867"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "11.8467"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5486_2328"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_5486_2328",
        result: "shape"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5486_2328"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $d316fdb283b66cff$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5486_2334)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        transform: "matrix(-1 0 0 1 24.0005 0)",
        fill: "url(#paint0_linear_5486_2334)"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        filter: "url(#filter0_d_5486_2334)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M13.5974 7.30273H16.6977V10.4342V13.5657V16.6972H13.5974H13.5662H12.8146V13.5658H11.2175V16.6972H10.4347H7.30322V13.5658V10.4342V7.30273H10.4346H11.2175V10.4342H12.8146V7.30273H13.5662H13.5974Z",
        fill: "black"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4.08472 4.08423H19.9163V10.3679H18.3016V5.69892H5.69941V18.3011H18.3016V13.5904H19.9163V19.9158H4.08472V4.08423Z",
        fill: "black"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("filter", {
        id: "filter0_d_5486_2334",
        x: "-16.3901",
        y: "-11.6519",
        width: "56.7812",
        height: "56.7811",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feOffset", {
        dy: "4.73867"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feGaussianBlur", {
        stdDeviation: "11.8467"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_5486_2334"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_5486_2334",
        result: "shape"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("linearGradient", {
        id: "paint0_linear_5486_2334",
        x1: "22.5462",
        y1: "1.45378",
        x2: "1.28044",
        y2: "22.7196",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        "stop-color": "#FEB169"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.397256",
        "stop-color": "#F87ADD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "0.655673",
        "stop-color": "#E667F9"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("stop", {
        offset: "1",
        "stop-color": "#7F4AD1"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5486_2334"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $48d99da9a2b2f1de$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5499_9763)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_5499_9763",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_5499_9763)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C5.37277 24 0 18.6273 0 12C0 5.37277 5.37277 0 12 0C18.6273 0 24 5.37277 24 12C24 18.6273 18.6285 24 12 24Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0547 5.5636C7.87252 5.5636 6.21826 8.11944 6.21826 11.8828C6.21826 15.6461 7.87252 18.3272 12.0547 18.3272C16.237 18.3272 17.891 15.6459 17.891 11.8828C17.891 8.11963 16.237 5.5636 12.0547 5.5636ZM12.0553 16.2649C10.1478 16.2649 9.15982 15.1455 8.86162 13.2615C8.83916 13.1195 8.94779 12.9904 9.09108 12.9904H14.99C15.1328 12.9904 15.2414 13.1187 15.2198 13.2605C14.9297 15.1451 13.9634 16.2649 12.0555 16.2649H12.0553ZM9.0663 10.9475C8.92513 10.9475 8.81728 10.822 8.83626 10.6813C9.10077 8.72201 10.0901 7.62602 12.0553 7.62602C14.0206 7.62602 14.9872 8.7224 15.2439 10.6823C15.2623 10.8226 15.1547 10.9475 15.0137 10.9475H9.0663Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5499_9763"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $c34745884b7b0221$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5499_9759)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_5499_9759",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_5499_9759)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C5.37277 24 0 18.6273 0 12C0 5.37278 5.37277 0 12 0C18.6273 0 24 5.37278 24 12C24 18.6273 18.6285 24 12 24Z",
        fill: "#FDFEFF",
        "fill-opacity": "0.927"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0547 5.5636C7.87252 5.5636 6.21826 8.11944 6.21826 11.8828C6.21826 15.6461 7.87252 18.3272 12.0547 18.3272C16.237 18.3272 17.891 15.6459 17.891 11.8828C17.891 8.11963 16.237 5.5636 12.0547 5.5636ZM12.0553 16.2649C10.1478 16.2649 9.15982 15.1455 8.86162 13.2615C8.83916 13.1195 8.94779 12.9904 9.09108 12.9904H14.99C15.1328 12.9904 15.2414 13.1187 15.2198 13.2605C14.9297 15.1451 13.9634 16.2649 12.0555 16.2649H12.0553ZM9.0663 10.9475C8.92513 10.9475 8.81728 10.822 8.83626 10.6813C9.10077 8.72201 10.0901 7.62602 12.0553 7.62602C14.0206 7.62602 14.9872 8.7224 15.2439 10.6823C15.2623 10.8226 15.1547 10.9475 15.0137 10.9475H9.0663Z",
        fill: "#151718"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5499_9759"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));



var $83f08a82e2256cda$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5499_9767)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_5499_9767",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_5499_9767)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24C5.37277 24 0 18.6273 0 12C0 5.37277 5.37277 0 12 0C18.6273 0 24 5.37277 24 12C24 18.6273 18.6285 24 12 24Z",
        fill: "#FE5161"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0547 5.5636C7.87252 5.5636 6.21826 8.11944 6.21826 11.8828C6.21826 15.6461 7.87252 18.3272 12.0547 18.3272C16.237 18.3272 17.891 15.6459 17.891 11.8828C17.891 8.11963 16.237 5.5636 12.0547 5.5636ZM12.0553 16.2649C10.1478 16.2649 9.15982 15.1455 8.86162 13.2615C8.83916 13.1195 8.94779 12.9904 9.09108 12.9904H14.99C15.1328 12.9904 15.2414 13.1187 15.2198 13.2605C14.9297 15.1451 13.9634 16.2649 12.0555 16.2649H12.0553ZM9.0663 10.9475C8.92513 10.9475 8.81728 10.822 8.83626 10.6813C9.10077 8.72201 10.0901 7.62602 12.0553 7.62602C14.0206 7.62602 14.9872 8.7224 15.2439 10.6823C15.2623 10.8226 15.1547 10.9475 15.0137 10.9475H9.0663Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5499_9767"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $721a1bbac33219f9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5515_15115)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_5515_15115",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "25"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0.607666H0V24.6077H24V0.607666Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_5515_15115)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24.6077C5.37277 24.6077 0 19.2349 0 12.6077C0 5.98044 5.37277 0.607666 12 0.607666C18.6273 0.607666 24 5.98044 24 12.6077C24 19.2349 18.6285 24.6077 12 24.6077Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25391 18.7681V14.6769L13.4835 6.44727H18.7463V18.7681H13.4835V14.4312L9.14667 18.7681H5.25391Z",
        fill: "#FFFDFD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25391 10.7558V6.44727H12.0946L7.7861 10.7558H5.25391Z",
        fill: "#889096"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5515_15115"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.607666)"
    }))));



var $44aca673304b4eb9$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5515_15108)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_5515_15108",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "25"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0.607666H0V24.6077H24V0.607666Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_5515_15108)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24.6077C5.37277 24.6077 0 19.2349 0 12.6077C0 5.98045 5.37277 0.607666 12 0.607666C18.6273 0.607666 24 5.98045 24 12.6077C24 19.2349 18.6285 24.6077 12 24.6077Z",
        fill: "#FDFEFF",
        "fill-opacity": "0.927"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25391 18.7681V14.6769L13.4835 6.44727H18.7463V18.7681H13.4835V14.4312L9.14667 18.7681H5.25391Z",
        fill: "#151718"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25391 10.7558V6.44727H12.0946L7.7861 10.7558H5.25391Z",
        fill: "#697177"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5515_15108"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "translate(0 0.607666)"
    }))));



var $280e816b1cb3a498$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5515_15122)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("mask", {
        id: "mask0_5515_15122",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "25"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0.607666H0V24.6077H24V0.607666Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        mask: "url(#mask0_5515_15122)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12 24.6077C5.37277 24.6077 0 19.2349 0 12.6077C0 5.98044 5.37277 0.607666 12 0.607666C18.6273 0.607666 24 5.98044 24 12.6077C24 19.2349 18.6285 24.6077 12 24.6077Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25391 18.7681V14.6769L13.4835 6.44727H18.7463V18.7681H13.4835V14.4312L9.14667 18.7681H5.25391Z",
        fill: "#FFFDFD"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M5.25391 10.7558V6.44727H12.0946L7.7861 10.7558H5.25391Z",
        fill: "#ED3E7D"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5515_15122"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        y: "0.607666",
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $1db9805d7b94dd3e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5516_24344)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0936 0C8.73327 0 0.457275 8.27578 0.457275 11.6363C0.457275 14.9968 8.73327 23.2727 12.0936 23.2727C15.4539 23.2727 23.73 14.9967 23.73 11.6363C23.73 8.27593 15.454 0 12.0936 0ZM10.2803 18.2903C8.86323 17.9042 5.0535 11.24 5.43969 9.82298C5.82589 8.40589 12.49 4.59621 13.9069 4.9824C15.324 5.36853 19.1338 12.0327 18.7476 13.4497C18.3614 14.8668 11.6973 18.6765 10.2803 18.2903Z",
        fill: "#11181C"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5516_24344"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "23.2727",
        fill: "white"
    }))));



var $38f6e362c769a22e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5516_24346)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0936 0C8.73327 0 0.457275 8.27578 0.457275 11.6363C0.457275 14.9968 8.73327 23.2727 12.0936 23.2727C15.4539 23.2727 23.73 14.9967 23.73 11.6363C23.73 8.27593 15.454 0 12.0936 0ZM10.2803 18.2903C8.86323 17.9042 5.0535 11.24 5.43969 9.82298C5.82589 8.40589 12.49 4.59621 13.9069 4.9824C15.324 5.36853 19.1338 12.0327 18.7476 13.4497C18.3614 14.8668 11.6973 18.6765 10.2803 18.2903Z",
        fill: "#ECEDEE"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5516_24346"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "23.2727",
        fill: "white"
    }))));



var $9b5d9f89bd79935a$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5516_24342)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M12.0936 0C8.73327 0 0.457275 8.27578 0.457275 11.6363C0.457275 14.9968 8.73327 23.2727 12.0936 23.2727C15.4539 23.2727 23.73 14.9967 23.73 11.6363C23.73 8.27593 15.454 0 12.0936 0ZM10.2803 18.2903C8.86323 17.9042 5.0535 11.24 5.43969 9.82298C5.82589 8.40589 12.49 4.59621 13.9069 4.9824C15.324 5.36853 19.1338 12.0327 18.7476 13.4497C18.3614 14.8668 11.6973 18.6765 10.2803 18.2903Z",
        fill: "#806FF1"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5516_24342"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "23.2727",
        fill: "white"
    }))));



var $ee7670a6a57120a5$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5528_29303)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9999 23.9203C18.5833 23.9203 23.9202 18.5834 23.9202 12C23.9202 5.41662 18.5833 0.0797119 11.9999 0.0797119C5.4165 0.0797119 0.0795898 5.41662 0.0795898 12C0.0795898 18.5834 5.4165 23.9203 11.9999 23.9203Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.8312 12.5906L22.064 8.35779L11.9999 12.3797L1.93115 8.35779L6.16396 12.5906C6.4874 12.914 6.92334 13.0969 7.38271 13.0969H9.1874L6.6374 15.6468L11.9905 13.4812L17.3437 15.6468L14.7937 13.0969H16.5983C17.0577 13.0969 17.4937 12.914 17.8171 12.5906H17.8312Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5528_29303"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $d1a7c67aef3a232b$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5528_29309)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9999 23.9203C18.5833 23.9203 23.9202 18.5834 23.9202 12C23.9202 5.41662 18.5833 0.0797119 11.9999 0.0797119C5.4165 0.0797119 0.0795898 5.41662 0.0795898 12C0.0795898 18.5834 5.4165 23.9203 11.9999 23.9203Z",
        fill: "#ECEDEE"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.8312 12.5906L22.064 8.35779L11.9999 12.3797L1.93115 8.35779L6.16396 12.5906C6.4874 12.914 6.92334 13.0969 7.38271 13.0969H9.1874L6.6374 15.6468L11.9905 13.4812L17.3437 15.6468L14.7937 13.0969H16.5983C17.0577 13.0969 17.4937 12.914 17.8171 12.5906H17.8312Z",
        fill: "#151718"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5528_29309"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $60d4ee109b9c451e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("g", {
        "clip-path": "url(#clip0_5528_29297)"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M24 0H0V24H24V0Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M11.9999 23.9203C18.5833 23.9203 23.9202 18.5834 23.9202 12C23.9202 5.41662 18.5833 0.0797119 11.9999 0.0797119C5.4165 0.0797119 0.0795898 5.41662 0.0795898 12C0.0795898 18.5834 5.4165 23.9203 11.9999 23.9203Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M17.8312 12.5906L22.064 8.35779L11.9999 12.3797L1.93115 8.35779L6.16396 12.5906C6.4874 12.914 6.92334 13.0969 7.38271 13.0969H9.1874L6.6374 15.6468L11.9905 13.4812L17.3437 15.6468L14.7937 13.0969H16.5983C17.0577 13.0969 17.4937 12.914 17.8171 12.5906H17.8312Z",
        fill: "white"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement("defs", null, /*#__PURE__*/ (0, $TBcmg$react).createElement("clipPath", {
        id: "clip0_5528_29297"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("rect", {
        width: "24",
        height: "24",
        rx: "4",
        fill: "white"
    }))));



var $1d1b3a8aaad67b6e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4899 17.354C11.3989 17.6109 12.3583 17.6296 13.2766 17.4081L9.11403 21.583C6.66634 20.8391 4.59716 19.1782 3.33483 16.9443C2.0725 14.7105 1.71368 12.0746 2.33264 9.5823C2.95088 7.08982 4.50032 4.93189 6.65977 3.55586C8.81921 2.17984 11.423 1.69127 13.9314 2.19143C13.9314 2.19143 10.5576 5.53743 8.72024 7.37626C8.14106 7.92976 7.63542 8.55602 7.21584 9.23953C6.57666 10.288 6.31422 11.5248 6.47221 12.744C6.6302 13.9631 7.19908 15.0912 8.08419 15.9404C8.75267 16.6103 9.58094 17.097 10.4899 17.354Z",
        fill: "#11181C"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.7139 6.59581C11.632 6.37395 12.5914 6.3924 13.5004 6.64937C14.4094 6.90634 15.2376 7.39325 15.9057 8.06353C17.7264 9.89292 18.0821 12.6078 16.7674 14.7544C16.3471 15.4384 15.8415 16.0657 15.263 16.621C13.4251 18.4571 10.0513 21.8053 10.0513 21.8053C12.5619 22.3104 15.1698 21.8245 17.333 20.4485C19.4962 19.0726 21.0485 16.9123 21.6672 14.4167C22.2867 11.9212 21.9259 9.28192 20.6596 7.04655C19.3933 4.81118 17.3187 3.15135 14.8664 2.4115L10.7139 6.59581Z",
        fill: "#11181C"
    }));



var $db5429c7b8e72de2$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4902 17.354C11.3992 17.6109 12.3586 17.6296 13.2768 17.4081L9.11428 21.583C6.66658 20.8391 4.5974 19.1782 3.33507 16.9443C2.07274 14.7105 1.71392 12.0746 2.33289 9.5823C2.95112 7.08982 4.50057 4.93189 6.66001 3.55586C8.81946 2.17984 11.4233 1.69127 13.9317 2.19143C13.9317 2.19143 10.5578 5.53743 8.72048 7.37626C8.1413 7.92976 7.63566 8.55602 7.21609 9.23953C6.5769 10.288 6.31447 11.5248 6.47246 12.744C6.63045 13.9631 7.19933 15.0912 8.08443 15.9404C8.75292 16.6103 9.58119 17.097 10.4902 17.354Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.7141 6.59581C11.6322 6.37395 12.5917 6.3924 13.5006 6.64937C14.4096 6.90634 15.2378 7.39325 15.9059 8.06353C17.7267 9.89292 18.0823 12.6078 16.7676 14.7544C16.3473 15.4384 15.8417 16.0657 15.2632 16.621C13.4253 18.4571 10.0515 21.8053 10.0515 21.8053C12.5622 22.3104 15.17 21.8245 17.3333 20.4485C19.4965 19.0726 21.0487 16.9123 21.6674 14.4167C22.287 11.9212 21.9262 9.28192 20.6599 7.04655C19.3936 4.81118 17.319 3.15135 14.8667 2.4115L10.7141 6.59581Z",
        fill: "white"
    }));



var $8a677cc2e6a6121e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.4902 17.354C11.3992 17.6109 12.3586 17.6296 13.2768 17.4081L9.11428 21.583C6.66658 20.8391 4.5974 19.1782 3.33507 16.9443C2.07274 14.7105 1.71392 12.0746 2.33289 9.5823C2.95112 7.08982 4.50057 4.93189 6.66001 3.55586C8.81946 2.17984 11.4233 1.69127 13.9317 2.19143C13.9317 2.19143 10.5578 5.53743 8.72048 7.37626C8.1413 7.92976 7.63566 8.55602 7.21609 9.23953C6.5769 10.288 6.31447 11.5248 6.47246 12.744C6.63045 13.9631 7.19933 15.0912 8.08443 15.9404C8.75292 16.6103 9.58119 17.097 10.4902 17.354Z",
        fill: "black"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M10.7141 6.59581C11.6322 6.37395 12.5917 6.3924 13.5006 6.64937C14.4096 6.90634 15.2378 7.39325 15.9059 8.06353C17.7267 9.89292 18.0823 12.6078 16.7676 14.7544C16.3473 15.4384 15.8417 16.0657 15.2632 16.621C13.4253 18.4571 10.0515 21.8053 10.0515 21.8053C12.5622 22.3104 15.17 21.8245 17.3333 20.4485C19.4965 19.0726 21.0487 16.9123 21.6674 14.4167C22.287 11.9212 21.9262 9.28192 20.6599 7.04655C19.3936 4.81118 17.319 3.15135 14.8667 2.4115L10.7141 6.59581Z",
        fill: "black"
    }));


const $028f64b16da3067e$var$chainIcons = {
    [(0, $TBcmg$reservoirChains).ancient8.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $cba61d2f7feded0d$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $486c3fd4717bcbc9$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4c7f319d74acbe9e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).ancient8Testnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $cba61d2f7feded0d$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $486c3fd4717bcbc9$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4c7f319d74acbe9e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).arbitrum.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $18593be7b4385014$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $af1b2ea8b2e4a002$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $60941dc41eb170af$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).arbitrumNova.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $47d6d6287ffb6ae5$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4feb7072ab79e169$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $28b313035b01dcbe$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).avalanche.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $3aec317f418033c4$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $509d3ee10af302d0$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $65f350c1ad3fb5c9$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).base.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $14da40da7324b67b$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $66db8f2c4f96b2a7$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $376fd4008438767b$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).baseSepolia.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $14da40da7324b67b$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $66db8f2c4f96b2a7$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $376fd4008438767b$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).bsc.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c86b7cd015b3714d$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7a5a0aea01a7aca5$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c87dda080f321097$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).opBnb.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c86b7cd015b3714d$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7a5a0aea01a7aca5$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c87dda080f321097$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).sepolia.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4fd057ba24517d08$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $17293dbb35328756$export$2e2bcd8739ae039), null),
        color: null
    },
    [(0, $TBcmg$reservoirChains).linea.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $aac45b8bc7190a9e$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7cf59313664fc5d2$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6f06c9002ddadb0a$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).mainnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e9f22f83d7ce6c58$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7084704732449a1c$export$2e2bcd8739ae039), null),
        color: null
    },
    [(0, $TBcmg$reservoirChains).optimism.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fb16af9c80005fb9$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $086a58db72de6a3d$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1d509d3670662694$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).polygonZkEvm.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5f00ef0d650f1d6c$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $8935b9b25f83123f$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $607df437226f7709$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).polygon.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7d47708f704afd5e$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fa23e6b7777a860c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fddcc1a25ecfbbc3$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).polygonAmoy.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7d47708f704afd5e$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fa23e6b7777a860c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fddcc1a25ecfbbc3$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).scrollTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $17d515d2480a4c31$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1b92fbd855547021$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bf02c9c19cd88ec6$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).scroll.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $17d515d2480a4c31$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1b92fbd855547021$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bf02c9c19cd88ec6$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).zkSync.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9958e6a8fb5c6b4f$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1592c77d361e1d1b$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7ceda8e364a74431$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).zora.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $59be738baf6cb68f$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $28b38712115cb301$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $75bf81594b9b1c53$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).frameTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $407585777b3c7836$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c7e33304d4749623$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $193518419e052636$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).blastSepolia.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c2bf6f5a824c8495$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $647b9c4412cbba84$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $230679ca8875625f$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).apexPop.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0c442dda07ba1834$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $894518fe751a27fe$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $75d05aa298971688$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).apexPopTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0c442dda07ba1834$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $894518fe751a27fe$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $75d05aa298971688$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).blast.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1335e1f14e8911f1$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $cae29279e23fdfdb$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $26bf620f8ff4fc04$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).astarZkEVM.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $69ac5d378aefe15b$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $43197958ab9b807d$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6db5064571756e89$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).garnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7b47abf2a2f8001c$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $032a5a280f17302d$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0bd69c6004cd6fda$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).redstone.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7b47abf2a2f8001c$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $032a5a280f17302d$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0bd69c6004cd6fda$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).berachainTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e1bcb7957e81272f$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $928412df06a214e0$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9bdab9154743f9b2$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).degen.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bb052987c4dc25a5$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fdae21720f5fd6d$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b5aefc20a3d6b530$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).xai.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $21d20f189cb1f8b6$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $84d581e5b4187c70$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $db2d6564ff1b1c33$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).nebula.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $71a24e992ee3775f$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $246b4e1c86941e69$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1bfcf1ffbee935bb$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).seiTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5e7cd3d60ff0222b$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fa2a3300ae487506$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4eb6a9d9e5e3e5a1$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).cyber.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $492e522d366d2641$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b8ca570db2cfb15c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e74edf339d50787d$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).bitlayer.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2621370217cf8dde$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $59b67eb86f238e24$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $878dc4946753d056$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).sei.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fd77ba9534398465$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1b41b0c52341f3dd$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $09183dd2ea6fbf8c$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).b3Testnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a8ae9bcb291a0d48$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3cf31dec7dfc0b7$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fa5073fe8fa61d2d$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).flowPreviewnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a6618b9fe2fcc6b8$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1e5ec29af45d770e$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $19f96307a41b3352$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).cloud.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $dfd471883153042a$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $298e9c8bd5b177a4$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $95daf0dde181c9e9$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).game7Testnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9cfb0a47de3e13fb$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $946a6defb5aae25c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b0033bdbc2fa01c5$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).boss.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0c442dda07ba1834$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $894518fe751a27fe$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $75d05aa298971688$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).forma.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fd8add7673104e82$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $51189d4753b64ddf$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $59db07788c98129e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).forma.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fd8add7673104e82$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $51189d4753b64ddf$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $59db07788c98129e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).formaSketchpad.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fd8add7673104e82$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $51189d4753b64ddf$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $59db07788c98129e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).b3.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a8ae9bcb291a0d48$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3cf31dec7dfc0b7$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fa5073fe8fa61d2d$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).apechain.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $247d33f89ceecedf$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $eeba1c60d51d88f5$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $589101b9fee55f73$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).curtis.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $247d33f89ceecedf$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $eeba1c60d51d88f5$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $589101b9fee55f73$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).shape.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2cf2c5e870ba0326$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4295511770b2097a$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $986150c8bc5a589f$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).shapeSepolia.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2cf2c5e870ba0326$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4295511770b2097a$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $986150c8bc5a589f$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).abstractTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $51304dc940cdde49$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1eb8374dde71928c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7ee68766855764b3$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).minato.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1d1b3a8aaad67b6e$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $db5429c7b8e72de2$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $8a677cc2e6a6121e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).hychain.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0750d6c848ab0fdc$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c07ccfbfb09e736e$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d316fdb283b66cff$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).hychainTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0750d6c848ab0fdc$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c07ccfbfb09e736e$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d316fdb283b66cff$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).flow.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a6618b9fe2fcc6b8$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1e5ec29af45d770e$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $19f96307a41b3352$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).zero.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $48d99da9a2b2f1de$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c34745884b7b0221$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $83f08a82e2256cda$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).zeroTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $48d99da9a2b2f1de$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c34745884b7b0221$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $83f08a82e2256cda$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).abstract.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $51304dc940cdde49$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1eb8374dde71928c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7ee68766855764b3$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).animeTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $721a1bbac33219f9$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $44aca673304b4eb9$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $280e816b1cb3a498$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).monadDevnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1db9805d7b94dd3e$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38f6e362c769a22e$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9b5d9f89bd79935a$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).game7.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9cfb0a47de3e13fb$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $946a6defb5aae25c$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b0033bdbc2fa01c5$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).creatorTestnet.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ee7670a6a57120a5$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d1a7c67aef3a232b$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $60d4ee109b9c451e$export$2e2bcd8739ae039), null)
    },
    [(0, $TBcmg$reservoirChains).soneium.id]: {
        light: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1d1b3a8aaad67b6e$export$2e2bcd8739ae039), null),
        dark: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $db5429c7b8e72de2$export$2e2bcd8739ae039), null),
        color: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $8a677cc2e6a6121e$export$2e2bcd8739ae039), null)
    }
};
var $028f64b16da3067e$export$2e2bcd8739ae039 = $028f64b16da3067e$var$chainIcons;


const $a17c19ca9f9aa5ab$var$ChainIcon = ({ chainId: chainId, css: css = {}, height: height = 14, color: color })=>{
    const themeContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$2c657da244d00bd6));
    if (!chainId) return null;
    const chainIconConfig = (0, $028f64b16da3067e$export$2e2bcd8739ae039)[chainId];
    let iconTheme = themeContext && themeContext ? themeContext["assets"]["chainIcon"]["value"] : "dark";
    let icon = chainIconConfig[iconTheme];
    if (color) icon = chainIconConfig.color;
    return icon ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            display: "flex",
            height: height,
            ...css
        }
    }, icon) : null;
};
var $a17c19ca9f9aa5ab$export$2e2bcd8739ae039 = $a17c19ca9f9aa5ab$var$ChainIcon;




var $1f92eca932117255$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement("svg", {
        width: "auto",
        height: "100%",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
        fill: "#627EEA"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M41.2451 10V32.175L59.9876 40.55L41.2451 10Z",
        fill: "white",
        "fill-opacity": "0.602"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M41.245 10L22.5 40.55L41.245 32.175V10Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M41.2451 54.92V69.9875L60.0001 44.04L41.2451 54.92Z",
        fill: "white",
        "fill-opacity": "0.602"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M41.245 69.9875V54.9175L22.5 44.04L41.245 69.9875Z",
        fill: "white"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M41.2451 51.4326L59.9876 40.5501L41.2451 32.1801V51.4326Z",
        fill: "white",
        "fill-opacity": "0.2"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("path", {
        d: "M22.5 40.5501L41.245 51.4326V32.1801L22.5 40.5501Z",
        fill: "white",
        "fill-opacity": "0.602"
    }));



const $63fa277c4c09f916$var$PaymentTokenRow = ({ setCurrency: setCurrency, paymentToken: paymentToken, goBack: goBack, currency: currency })=>{
    const isSelectedCurrency = currency?.address.toLowerCase() === paymentToken?.address && currency?.chainId === paymentToken?.chainId;
    const formattedBalance = (0, $TBcmg$formatUnits)(BigInt(paymentToken?.balance || 0), paymentToken?.decimals || 18);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        color: "ghost",
        size: "none",
        css: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            p: "$4",
            background: "$neutralBg",
            borderRadius: 8,
            border: isSelectedCurrency ? "1px solid $accentBorderHover" : "none",
            "&:hover": {
                background: "$neutralBgHover"
            },
            "&:disabled": {
                background: "transparent",
                cursor: "not-allowed"
            }
        },
        onClick: ()=>{
            setCurrency(paymentToken);
            goBack();
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3",
            width: "100%"
        }
    }, paymentToken?.address === (0, $TBcmg$zeroAddress) && paymentToken.symbol === "ETH" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            display: "flex",
            width: 34,
            height: 34,
            "object-fit": "contain",
            position: "relative"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1f92eca932117255$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: paymentToken.chainId,
        color: true,
        css: {
            position: "absolute",
            bottom: -5,
            right: -5,
            width: 20,
            height: 20
        }
    })) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
        chainId: paymentToken.chainId,
        address: paymentToken?.address,
        css: {
            width: 34,
            height: 34,
            "object-fit": "contain"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        css: {
            mr: "auto"
        },
        ellipsify: true
    }, paymentToken?.name), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Balance: ", (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(Number(formattedBalance), 6))));
};
const $63fa277c4c09f916$export$ca31b002d5acc121 = ({ paymentTokens: paymentTokens, setCurrency: setCurrency, goBack: goBack, currency: currency, itemAmount: itemAmount, chainId: chainId })=>{
    const availablePaymentTokens = paymentTokens.filter((paymentToken)=>{
        const isSelectedCurrency = currency?.address.toLowerCase() === paymentToken?.address && currency?.chainId === paymentToken?.chainId;
        const hasMaxPricePerItem = paymentToken?.maxPricePerItem != undefined;
        const hasCurrencyTotalRaw = paymentToken?.currencyTotalRaw != undefined;
        const maxPurchasablePrice = paymentToken?.capacityPerRequest;
        return Boolean(isSelectedCurrency || !hasMaxPricePerItem && hasCurrencyTotalRaw || maxPurchasablePrice && paymentToken?.currencyTotalRaw !== undefined && maxPurchasablePrice >= paymentToken?.currencyTotalRaw);
    });
    const nativeCurrencies = availablePaymentTokens.filter((token)=>token.chainId === chainId);
    const crossChainCurrencies = availablePaymentTokens.filter((token)=>token.chainId !== chainId);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            width: "100%",
            gap: "$3",
            px: "$3"
        }
    }, nativeCurrencies.map((paymentToken, idx)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($63fa277c4c09f916$var$PaymentTokenRow, {
            key: idx,
            currency: currency,
            goBack: goBack,
            setCurrency: setCurrency,
            paymentToken: paymentToken
        })), crossChainCurrencies.length > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "start",
        css: {
            gap: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "CrossChain ETH")) : null, crossChainCurrencies.map((paymentToken, idx)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($63fa277c4c09f916$var$PaymentTokenRow, {
            key: idx,
            currency: currency,
            goBack: goBack,
            setCurrency: setCurrency,
            paymentToken: paymentToken
        })));
};







const $fafed10a0d83e98f$var$FormatCurrency = ({ amount: amount, maximumFractionDigits: maximumFractionDigits = 2, currency: currency = "USD", ...props })=>{
    const [formattedValue, setFormattedValue] = (0, $TBcmg$useState)("");
    (0, $TBcmg$useEffect)(()=>{
        let parsedAmount;
        if (typeof amount === "bigint") parsedAmount = (0, $TBcmg$formatUnits)(amount, 6);
        else parsedAmount = amount;
        if (parsedAmount) {
            const lowestValue = Number(`0.${new Array(maximumFractionDigits).join("0")}1`);
            const tooLow = +parsedAmount < lowestValue;
            const formatted = new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: currency
            }).format(tooLow ? lowestValue : +parsedAmount);
            setFormattedValue(tooLow ? `< ${formatted}` : formatted);
        } else setFormattedValue("");
    }, [
        amount,
        maximumFractionDigits
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        ...props,
        style: props.style || "subtitle3",
        color: props.color || "base"
    }, formattedValue);
};
var $fafed10a0d83e98f$export$2e2bcd8739ae039 = $fafed10a0d83e98f$var$FormatCurrency;






const $fb1d785e6d7e5526$export$b1bd3336d32d1d33 = ({ css: css, chainId: chainId, paymentCurrency: paymentCurrency, loading: loading, feeOnTop: feeOnTop, feeUsd: feeUsd, crosschainFees: crosschainFees })=>{
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const usdTotal = (0, $TBcmg$formatUnits)(((paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop) * (paymentCurrency?.usdPriceRaw || 0n), (paymentCurrency?.decimals || 18) + 6);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            width: "100%",
            ...css
        }
    }, feeOnTop > 0 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "start",
        css: {
            px: "$4",
            py: "$3",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3"
    }, "Referral Fee"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: paymentCurrency?.chainId ?? chainId,
        amount: feeOnTop,
        address: paymentCurrency?.address,
        decimals: paymentCurrency?.decimals,
        symbol: paymentCurrency?.name
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: feeUsd,
        color: "subtle",
        style: "tiny"
    }))), crosschainFees && crosschainFees?.relayer?.amount?.raw ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "start",
        css: {
            px: "$4",
            py: "$3",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3"
    }, "Relay Cost"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $656b4c95fe3d553c$export$2e2bcd8739ae039), {
        content: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            css: {
                maxWidth: 200,
                textAlign: "center",
                display: "block"
            }
        }, "A fee paid to the Relayer who executes your transaction on the destination chain.")
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralText"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faInfoCircle)
    })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: paymentCurrency?.chainId ?? chainId,
        amount: crosschainFees?.relayer?.amount?.raw
    }), crosschainFees?.relayer?.amount?.usd ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: crosschainFees?.relayer?.amount?.usd,
        color: "subtle",
        style: "tiny"
    }) : null)) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "start",
        css: {
            px: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, "You Pay"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1"
        }
    }, loading ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, providerOptions.preferDisplayFiatTotal ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdTotal,
        style: "h6",
        color: "base"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: paymentCurrency?.chainId ?? chainId,
        textStyle: "body2",
        textColor: "subtle",
        amount: (paymentCurrency?.currencyTotalRaw ?? 0n) + feeOnTop,
        address: paymentCurrency?.address,
        decimals: paymentCurrency?.decimals,
        symbol: paymentCurrency?.symbol,
        logoWidth: 12
    })) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: paymentCurrency?.chainId ?? chainId,
        textStyle: "h6",
        textColor: "base",
        amount: (paymentCurrency?.currencyTotalRaw ?? 0n) + feeOnTop,
        address: paymentCurrency?.address,
        decimals: paymentCurrency?.decimals,
        symbol: paymentCurrency?.symbol,
        logoWidth: 18
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdTotal,
        style: "body2",
        color: "subtle"
    }))))));
};



const $edbd6b160d26668e$var$Divider = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("hr", {
    width: "100%",
    height: "1px",
    borderWidth: 0,
    backgroundColor: "$neutralLine",
    variants: {
        direction: {
            vertical: {
                height: "100%",
                maxHeight: 16,
                minHeight: 12,
                width: 1,
                margin: "0 5px"
            }
        }
    }
});
var $edbd6b160d26668e$export$2e2bcd8739ae039 = $edbd6b160d26668e$var$Divider;






const $94585ecf38154231$var$StyledImg = (0, $TBcmg$styled)("img");
const $94585ecf38154231$var$Img = (props)=>{
    const [imageBroken, setImageBroken] = (0, $TBcmg$useState)(false);
    (0, $TBcmg$useEffect)(()=>{
        if (imageBroken) setImageBroken(false);
    }, [
        props.src
    ]);
    return imageBroken || !props.src ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            ...props.css,
            background: "$neutralBgActive"
        },
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faImage),
        size: "2x"
    })) : /*#__PURE__*/ (0, $TBcmg$react).createElement($94585ecf38154231$var$StyledImg, {
        ...props,
        onError: (e)=>{
            setImageBroken(true);
        }
    });
};
var $94585ecf38154231$export$2e2bcd8739ae039 = $94585ecf38154231$var$Img;


const $71d6dcfaea16228b$export$47d8a00fffa4e400 = ({ token: token, collection: collection, chain: chain, css: css })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            gap: "$4",
            ...css
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
        src: token?.token?.image || token?.token?.collection?.image,
        css: {
            borderRadius: 8,
            objectFit: "cover",
            height: 56,
            width: 56
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, token?.token?.name || `#${token?.token?.tokenId}`), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, collection?.name), chain ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain.id,
        height: 12
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, chain.name)) : null))));
};


const $8befffb57023ead8$var$ModalCopy = {
    titleInsufficientFunds: "Add Funds",
    titleDefault: "Buy",
    ctaClose: "Close",
    ctaCheckout: "Checkout",
    ctaConnect: "Connect",
    ctaInsufficientFunds: "Add Funds",
    ctaGoToToken: "",
    ctaAwaitingValidation: "Waiting for transaction to be validated",
    ctaAwaitingApproval: "Waiting for approval...",
    ctaCopyAddress: "Copy Wallet Address"
};
function $8befffb57023ead8$export$7055e49b90860ae6({ openState: openState, trigger: trigger, token: token, orderId: orderId, chainId: chainId, feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, normalizeRoyalties: normalizeRoyalties, defaultQuantity: defaultQuantity, copyOverrides: copyOverrides, walletClient: walletClient, executeBuyOptions: executeBuyOptions, promptPaymentMethod: promptPaymentMethod, onConnectWallet: onConnectWallet, onPurchaseComplete: onPurchaseComplete, onPurchaseError: onPurchaseError, onClose: onClose, onGoToToken: onGoToToken, onPointerDownOutside: onPointerDownOutside, creditCardCheckoutButton: creditCardCheckoutButton }) {
    const copy = {
        ...$8befffb57023ead8$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1cf2d84a10342ca7$export$8913f774683cde87), {
        chainId: modalChain?.id,
        open: open,
        defaultQuantity: defaultQuantity,
        token: token,
        orderId: orderId,
        feesOnTopBps: feesOnTopBps,
        feesOnTopUsd: feesOnTopUsd,
        normalizeRoyalties: normalizeRoyalties,
        walletClient: walletClient,
        executeBuyOptions: executeBuyOptions,
        onConnectWallet: onConnectWallet
    }, ({ loading: loading, isFetchingPath: isFetchingPath, tokenData: tokenData, collection: collection, quantityAvailable: quantityAvailable, quantity: quantity, averageUnitPrice: averageUnitPrice, totalIncludingFees: totalIncludingFees, buyResponseFees: buyResponseFees, feeOnTop: feeOnTop, paymentCurrency: paymentCurrency, paymentTokens: paymentTokens, buyStep: buyStep, transactionError: transactionError, hasEnoughCurrency: hasEnoughCurrency, hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport, addFundsLink: addFundsLink, steps: steps, stepData: stepData, feeUsd: feeUsd, totalUsd: totalUsd, usdPrice: usdPrice, balance: balance, address: address, blockExplorerBaseName: blockExplorerBaseName, isConnected: isConnected, isOwner: isOwner, setPaymentCurrency: setPaymentCurrency, setQuantity: setQuantity, setBuyStep: setBuyStep, buyToken: buyToken })=>{
        (0, $TBcmg$useEffect)(()=>{
            if (buyStep === (0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Complete && onPurchaseComplete) {
                const data = {
                    token: token,
                    maker: address
                };
                if (steps) data.steps = steps;
                onPurchaseComplete(data);
            }
        }, [
            buyStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onPurchaseError) {
                const data = {
                    token: token,
                    maker: address
                };
                onPurchaseError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const executableSteps = steps?.filter((step)=>step.items && step.items.length > 0) || [];
        const lastStepItems = executableSteps[executableSteps.length - 1]?.items || [];
        const totalPurchases = stepData?.currentStep?.items?.reduce((total, item)=>{
            item.transfersData?.forEach((transferData)=>{
                total += Number(transferData.amount || 1);
            });
            return total;
        }, 0) || 0;
        const failedPurchases = quantity - totalPurchases;
        const successfulPurchases = quantity - failedPurchases;
        const finalTxHashes = lastStepItems[lastStepItems.length - 1]?.txHashes;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.titleDefault,
            open: open,
            onPointerDownOutside: (e)=>{
                const dismissableLayers = Array.from(document.querySelectorAll("div[data-radix-dismissable]"));
                const clickedDismissableLayer = dismissableLayers.some((el)=>e.target ? el.contains(e.target) : false);
                if (!clickedDismissableLayer && dismissableLayers.length > 0) e.preventDefault();
                if (onPointerDownOutside) onPointerDownOutside(e);
            },
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        token: token,
                        maker: address
                    };
                    onClose(data, stepData, buyStep);
                }
                setOpen(open);
            },
            loading: loading
        }, buyStep === (0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Unavailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                py: "$6",
                px: "$4",
                gap: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, isOwner ? "You already own this token." : "Item is no longer available.")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                m: "$4"
            }
        }, copy.ctaClose)), buyStep === (0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).SelectPayment && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                pb: 20
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>setBuyStep((0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Checkout),
            color: "ghost",
            size: "xs",
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronLeft),
            width: 10
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Select Payment Method")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $63fa277c4c09f916$export$ca31b002d5acc121), {
            paymentTokens: paymentTokens,
            currency: paymentCurrency,
            setCurrency: setPaymentCurrency,
            goBack: ()=>setBuyStep((0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Checkout),
            itemAmount: quantity,
            chainId: modalChain?.id || 1
        })), buyStep === (0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Checkout && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $71d6dcfaea16228b$export$47d8a00fffa4e400), {
            token: tokenData,
            chain: modalChain,
            collection: collection,
            css: {
                p: "$4"
            }
        }), quantityAvailable > 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4"
            },
            justify: "between"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "subtle"
        }, (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(quantityAvailable), " items available")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
            min: 1,
            max: quantityAvailable,
            quantity: quantity,
            setQuantity: (quantity)=>{
                setQuantity(quantity);
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                pb: "$2",
                borderTop: "1px solid $neutralBorder"
            }
        }, paymentTokens.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                py: "$3",
                px: "$4",
                borderRadius: "$3",
                borderBottom: "1px solid $neutralBorder",
                "&:hover": {
                    backgroundColor: "$neutralBgHover"
                }
            },
            onClick: ()=>setBuyStep((0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).SelectPayment)
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Select Payment Method"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2",
                cursor: "pointer"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            address: paymentCurrency?.address,
            chainId: paymentCurrency?.chainId,
            css: {
                width: 16,
                height: 16,
                mr: "$1"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, paymentCurrency?.name)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronDown),
            width: 10
        }))))) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fb1d785e6d7e5526$export$b1bd3336d32d1d33), {
            feeOnTop: feeOnTop,
            feeUsd: feeUsd,
            crosschainFees: buyResponseFees,
            chainId: modalChain?.id,
            paymentCurrency: paymentCurrency,
            loading: isFetchingPath,
            css: {
                pt: "$4"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                width: "100%"
            }
        }, hasEnoughCurrency || !isConnected || hasAuxiliaryFundsSupport ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: !hasEnoughCurrency && !hasAuxiliaryFundsSupport && isConnected,
            onClick: buyToken,
            css: {
                width: "100%"
            },
            color: "primary"
        }, !isConnected ? copy.ctaConnect : copy.ctaCheckout), creditCardCheckoutButton && creditCardCheckoutButton) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                mb: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                mr: "$3"
            },
            color: "error",
            style: "body3"
        }, "Insufficient Balance", paymentTokens.length > 1 ? ", select another token or add funds" : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: paymentCurrency?.chainId,
            amount: paymentCurrency?.balance,
            address: paymentCurrency?.address,
            decimals: paymentCurrency?.decimals,
            symbol: paymentCurrency?.name,
            textStyle: "body3"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: !promptPaymentMethod && providerOptions.disableJumperLink,
            onClick: ()=>{
                if (promptPaymentMethod) setBuyStep((0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).SelectPayment);
                else window.open(addFundsLink, "_blank");
            },
            css: {
                width: "100%"
            }
        }, !promptPaymentMethod && providerOptions.disableJumperLink ? copy.ctaCheckout : copy.ctaInsufficientFunds)))), buyStep === (0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Approving && token && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $71d6dcfaea16228b$export$47d8a00fffa4e400), {
            token: tokenData,
            chain: modalChain,
            collection: collection,
            css: {
                p: "$4",
                borderBottom: "1px solid $neutralBorder"
            }
        }), stepData && stepData.totalSteps > 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2e70e0c380877307$export$2e2bcd8739ae039), {
            css: {
                px: "$4",
                mt: "$3"
            },
            value: stepData?.stepProgress || 0,
            max: stepData?.totalSteps || 0
        }), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
            css: {
                height: 206
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e92d8c2581b5f9df$export$2e2bcd8739ae039), {
            title: stepData?.currentStep.action || "",
            txHashes: stepData?.currentStepItem.txHashes
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), stepData?.currentStepItem?.txHashes ? copy.ctaAwaitingValidation : copy.ctaAwaitingApproval)), buyStep === (0, $1cf2d84a10342ca7$export$b41ddf00b39567e8).Complete && token && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                py: "$5",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center"
            }
        }, totalPurchases === 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                textAlign: "center",
                mt: 24,
                mb: 24
            }
        }, "Congratulations!")) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: failedPurchases ? "$errorAccent" : "$successAccent"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: failedPurchases ? (0, $TBcmg$faCircleExclamation) : (0, $TBcmg$faCheckCircle),
            fontSize: 32
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                textAlign: "center",
                mt: 24,
                mb: 24
            }
        }, failedPurchases ? `${successfulPurchases} ${successfulPurchases > 1 ? "items" : "item"} purchased, ${failedPurchases} ${failedPurchases > 1 ? "items" : "item"} failed` : "Congrats! Purchase was successful.")), totalPurchases === 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
            src: tokenData?.token?.imageSmall,
            style: {
                width: 100,
                height: 100
            }
        }), totalPurchases > 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2"
            }
        }, stepData?.currentStep?.items?.map((item, itemIndex)=>{
            if (Array.isArray(item?.txHashes) && item?.txHashes.length > 0) return item.txHashes.map((hash, txHashIndex)=>{
                const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
                const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
                return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                    key: `${itemIndex}-${txHashIndex}`,
                    href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                    color: "primary",
                    weight: "medium",
                    target: "_blank",
                    css: {
                        fontSize: 12
                    }
                }, "View transaction: ", truncatedTxHash);
            });
            else return null;
        })), totalPurchases === 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mb: 24,
                mt: 24,
                maxWidth: "100%"
            },
            align: "center",
            justify: "center"
        }, !!tokenData?.token?.collection?.image && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                mr: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
            src: tokenData?.token?.collection?.image,
            style: {
                width: 24,
                height: 24,
                borderRadius: "50%"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            css: {
                maxWidth: "100%"
            },
            ellipsify: true
        }, tokenData?.token?.name ? tokenData?.token?.name : `#${tokenData?.token?.tokenId}`)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mb: "$2"
            },
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$successAccent",
                mr: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCheckCircle)
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body1"
        }, "Your transaction went through successfully")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$2"
            }
        }, finalTxHashes?.map((hash, index)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                key: index,
                href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                color: "primary",
                weight: "medium",
                target: "_blank",
                css: {
                    fontSize: 12
                }
            }, "View transaction: ", truncatedTxHash);
        })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                flexDirection: "column",
                gap: "$3",
                "@bp1": {
                    flexDirection: "row"
                }
            }
        }, !!onGoToToken ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                flex: 1
            },
            color: "ghost"
        }, copy.ctaClose), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            style: {
                flex: 1
            },
            color: "primary",
            onClick: ()=>{
                onGoToToken();
            }
        }, copy.ctaGoToToken.length > 0 ? copy.ctaGoToToken : `Go to ${successfulPurchases > 1 ? "Tokens" : "Token"}`)) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            style: {
                flex: 1
            },
            color: "primary"
        }, copy.ctaClose))));
    });
}
$8befffb57023ead8$export$7055e49b90860ae6.Custom = (0, $1cf2d84a10342ca7$export$8913f774683cde87);










const $5c0c2c3952297d70$var$StyledInput = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("input", {
    all: "unset",
    width: "100%",
    px: 16,
    py: 12,
    borderRadius: 8,
    fontFamily: "$body",
    fontSize: 16,
    color: "$neutralTextContrast",
    backgroundColor: "$inputBackground",
    $$focusColor: "$colors$accentBorderHover",
    "&:placeholder": {
        color: "$neutralText"
    },
    "&:focus": {
        boxShadow: "0 0 0 2px $$focusColor"
    },
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
    },
    "&[type=number]": {
        "-moz-appearance": "textfield"
    }
});
const $5c0c2c3952297d70$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ children: children, icon: icon, containerCss: containerCss, iconCss: iconCss, ...props }, forwardedRef)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            ...containerCss,
            position: "relative"
        }
    }, icon && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: 16,
            color: "$neutralTextContrast",
            pointerEvents: "none",
            ...iconCss
        }
    }, icon), /*#__PURE__*/ (0, $TBcmg$react).createElement($5c0c2c3952297d70$var$StyledInput, {
        css: {
            pl: icon ? 48 : 16,
            ...props.css
        },
        ref: forwardedRef,
        ...props
    })));
var $5c0c2c3952297d70$export$2e2bcd8739ae039 = $5c0c2c3952297d70$export$f5b8910cec6cf069;



//@ts-ignore
const $b31bbf36f2fe9ca4$var$Flatpickr = (0, $TBcmg$reactflatpickr).default ? (0, $TBcmg$reactflatpickr).default : (0, $TBcmg$reactflatpickr);
var $b31bbf36f2fe9ca4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ options: options, onChange: onChange, value: value, defaultValue: defaultValue, ...inputProps }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($b31bbf36f2fe9ca4$var$Flatpickr, {
        ref: forwardedRef,
        value: value,
        options: {
            dateFormat: "m/d/Y h:i K",
            ...options
        },
        onChange: onChange,
        defaultValue: defaultValue,
        render: ({ defaultValue: defaultValue }, ref)=>{
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5c0c2c3952297d70$export$2e2bcd8739ae039), {
                ...inputProps,
                ref: ref,
                defaultValue: defaultValue
            });
        }
    });
});







const $53b68d251033efcb$var$StyledTrigger = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Trigger2, {
    boxSizing: "border-box",
    borderWidth: 0,
    width: "100%",
    px: "$4",
    py: "$3",
    borderRadius: "$borderRadius",
    fontfamily: "$body",
    fontSize: 16,
    display: "flex",
    justifyContent: "space-between",
    color: "$neutralTextContrast",
    backgroundColor: "$inputBackground",
    $$focusColor: "$colors$accentBorderHover",
    "&:placeholder": {
        color: "$neutralText"
    },
    "&:focus": {
        boxShadow: "0 0 0 2px $$focusColor"
    }
});
const $53b68d251033efcb$var$StyledContent = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Content3, {
    backgroundColor: "$inputBackground",
    color: "$textColor",
    borderRadius: "$borderRadius",
    overflow: "hidden",
    $$focusColor: "$colors$accentBorderHover",
    boxShadow: "0 0 0 2px $$focusColor"
});
const $53b68d251033efcb$var$textCss = {
    color: "$textColor",
    fontFamily: "$body",
    letterSpacing: 0
};
const $53b68d251033efcb$var$StyledItemText = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$ItemText, $53b68d251033efcb$var$textCss);
const $53b68d251033efcb$var$StyledValue = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Value, $53b68d251033efcb$var$textCss);
const $53b68d251033efcb$var$SelectDownIcon = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ ...props }, forwardedRef)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Icon, {
        asChild: true,
        ref: forwardedRef,
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralSolidHover"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faChevronDown),
        width: "14",
        color: ""
    }))));
const $53b68d251033efcb$export$863d5f18a1f54f2d = ({ children: children, trigger: trigger, css: css, ...props })=>/*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root3, {
        ...props
    }, trigger ? trigger : /*#__PURE__*/ (0, $TBcmg$react).createElement($53b68d251033efcb$var$StyledTrigger, {
        css: {
            ...$53b68d251033efcb$var$textCss,
            ...css
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($53b68d251033efcb$var$StyledValue, {
        placeholder: props.placeholder
    }, props.value), /*#__PURE__*/ (0, $TBcmg$react).createElement($53b68d251033efcb$var$SelectDownIcon, null)), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Portal, {
        style: {
            zIndex: 1000000
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($53b68d251033efcb$var$StyledContent, null, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$ScrollUpButton, null), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Viewport, null, children), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$ScrollDownButton, null))));
const $53b68d251033efcb$var$StyledItem = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Item, {
    cursor: "pointer",
    py: "$3",
    px: "$4",
    color: "$textColor",
    fontFamily: "$body",
    letterSpacing: 0,
    "&:hover": {
        background: "$neutralBgActive"
    }
});
$53b68d251033efcb$export$863d5f18a1f54f2d.Item = $53b68d251033efcb$var$StyledItem;
$53b68d251033efcb$export$863d5f18a1f54f2d.ItemText = $53b68d251033efcb$var$StyledItemText;
$53b68d251033efcb$export$863d5f18a1f54f2d.Trigger = $53b68d251033efcb$var$StyledTrigger;
$53b68d251033efcb$export$863d5f18a1f54f2d.Value = $53b68d251033efcb$var$StyledValue;
$53b68d251033efcb$export$863d5f18a1f54f2d.DownIcon = $53b68d251033efcb$var$SelectDownIcon;
var $53b68d251033efcb$export$2e2bcd8739ae039 = $53b68d251033efcb$export$863d5f18a1f54f2d;







var $49ea92be0f1fc634$export$2e2bcd8739ae039 = ()=>{
    const client = (0, $TBcmg$getClient)();
    let reservoirTitleEl = document.querySelector("meta[property='reservoir:title']");
    let title = null;
    if (reservoirTitleEl) title = reservoirTitleEl.getAttribute("content");
    if (!title && client && client.source) title = client.source;
    else if (!title) title = location ? location.hostname.replace("www.", "") : "";
    const reservoirIconEl = document.querySelector("meta[property='reservoir:icon']");
    let icon = null;
    if (reservoirIconEl) icon = reservoirIconEl.getAttribute("content");
    if (!icon) {
        const favicon = document.querySelector("link[rel*='icon']");
        if (favicon) icon = favicon.getAttribute("href");
    }
    return {
        title: title,
        icon: icon
    };
};





function $6bcc64b528de3c29$export$2e2bcd8739ae039(collectionId, tokenId, listingEnabledOnly, fees, chainId, enabled = true) {
    const [marketplaces, setMarketplaces] = (0, $TBcmg$useState)([]);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const chain = chainId !== undefined ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const { data: data, isValidating: isValidating } = (0, $TBcmg$swr)(()=>{
        if (!enabled || !collectionId) return null;
        const url = new URL(`${chain?.baseApiUrl}/collections/${collectionId}/marketplace-configurations/v2`);
        if (tokenId) {
            let query = {
                tokenId: tokenId
            };
            (0, $TBcmg$setParams)(url, query);
        }
        return [
            url.href,
            client?.apiKey,
            client?.version
        ];
    });
    (0, $TBcmg$useEffect)(()=>{
        if (data && data.marketplaces) {
            let updatedMarketplaces = data.marketplaces;
            if (listingEnabledOnly) updatedMarketplaces = updatedMarketplaces.filter((marketplace)=>Object.values(marketplace.exchanges || {}).some((exchange)=>exchange.enabled) && marketplace.orderbook !== "x2y2");
            updatedMarketplaces.forEach((marketplace)=>{
                if (marketplace.orderbook === "reservoir") {
                    const data = (0, $49ea92be0f1fc634$export$2e2bcd8739ae039)();
                    marketplace.name = data.title;
                    marketplace.domain = client?.source;
                    let marketplaceFees = fees;
                    if (!fees && chain?.marketplaceFees) marketplaceFees = chain?.marketplaceFees;
                    else if (!fees && client?.marketplaceFees) marketplaceFees = client.marketplaceFees;
                    const feeBps = marketplaceFees?.reduce((total, fee)=>{
                        const bps = Number(fee.split(":")[1]);
                        total += bps;
                        return total;
                    }, 0);
                    marketplace.fee = {
                        bps: feeBps || 0,
                        percent: (feeBps || 0) / 100
                    };
                    if (data.icon) marketplace.imageUrl = data.icon;
                }
                if (marketplace.fee) marketplace.fee.percent = (marketplace.fee.bps || 0) / 100;
                marketplace.price = 0;
                marketplace.truePrice = 0;
            });
            setMarketplaces(updatedMarketplaces);
        }
    }, [
        data,
        listingEnabledOnly,
        chain,
        chainId,
        fees
    ]);
    return [
        !isValidating ? marketplaces : [],
        setMarketplaces
    ];
}





const $4dd727d17c3f54df$var$expirationOptions = [
    {
        text: "1 Hour",
        value: "hour",
        relativeTime: 1,
        relativeTimeUnit: "h"
    },
    {
        text: "12 Hours",
        value: "12 hours",
        relativeTime: 12,
        relativeTimeUnit: "h"
    },
    {
        text: "1 Day",
        value: "1 day",
        relativeTime: 1,
        relativeTimeUnit: "d"
    },
    {
        text: "3 Day",
        value: "3 days",
        relativeTime: 3,
        relativeTimeUnit: "d"
    },
    {
        text: "1 Week",
        value: "week",
        relativeTime: 1,
        relativeTimeUnit: "w"
    },
    {
        text: "1 Month",
        value: "month",
        relativeTime: 1,
        relativeTimeUnit: "M"
    },
    {
        text: "3 Months",
        value: "3 months",
        relativeTime: 3,
        relativeTimeUnit: "M"
    },
    {
        text: "6 Months",
        value: "6 months",
        relativeTime: 6,
        relativeTimeUnit: "M"
    }
];
var $4dd727d17c3f54df$export$2e2bcd8739ae039 = $4dd727d17c3f54df$var$expirationOptions;




var $0dfcd962a810a554$export$7f4afd65e1e67072;
(function(ListStep) {
    ListStep[ListStep["Unavailable"] = 0] = "Unavailable";
    ListStep[ListStep["SetPrice"] = 1] = "SetPrice";
    ListStep[ListStep["Listing"] = 2] = "Listing";
    ListStep[ListStep["Complete"] = 3] = "Complete";
})($0dfcd962a810a554$export$7f4afd65e1e67072 || ($0dfcd962a810a554$export$7f4afd65e1e67072 = {}));
const $0dfcd962a810a554$var$expirationOptions = [
    ...(0, $4dd727d17c3f54df$export$2e2bcd8739ae039),
    {
        text: "Custom",
        value: "custom",
        relativeTime: null,
        relativeTimeUnit: null
    }
];
const $0dfcd962a810a554$export$5cb91f178b51ac3 = ({ open: open, tokenId: tokenId, collectionId: collectionId, orderKind: orderKind, currencies: preferredCurrencies, chainId: chainId, normalizeRoyalties: normalizeRoyalties, conduitKey: conduitKey, oracleEnabled: oracleEnabled = false, feesBps: feesBps, children: children, walletClient: walletClient })=>{
    const account = (0, $TBcmg$useAccount)();
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWallet;
    const [listStep, setListStep] = (0, $TBcmg$useState)($0dfcd962a810a554$export$7f4afd65e1e67072.SetPrice);
    const [listingData, setListingData] = (0, $TBcmg$useState)([]);
    const [allMarketplaces] = (0, $6bcc64b528de3c29$export$2e2bcd8739ae039)(collectionId, tokenId, true, feesBps, rendererChain?.id, open);
    const marketplace = (0, $TBcmg$useMemo)(()=>allMarketplaces.find((marketplace)=>marketplace.orderbook === "reservoir"), [
        allMarketplaces
    ]);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [price, setPrice] = (0, $TBcmg$useState)("");
    const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(rendererChain?.id);
    const defaultCurrency = {
        contract: chainCurrency.address,
        symbol: chainCurrency.symbol
    };
    const [currencies, setCurrencies] = (0, $TBcmg$useState)(preferredCurrencies);
    const [currency, setCurrency] = (0, $TBcmg$useState)(preferredCurrencies && preferredCurrencies[0] ? preferredCurrencies[0] : defaultCurrency);
    const [quantity, setQuantity] = (0, $TBcmg$useState)(1);
    const contract = collectionId ? collectionId?.split(":")[0] : undefined;
    const { data: collections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && {
        id: collectionId,
        normalizeRoyalties: normalizeRoyalties
    }, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    const [expirationOption, setExpirationOption] = (0, $TBcmg$useState)($0dfcd962a810a554$var$expirationOptions[5]);
    const royaltyBps = collection?.royalties?.bps ? collection?.royalties?.bps : marketplace?.royalties?.maxBps ? marketplace?.royalties?.maxBps : 0;
    const { data: tokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && {
        tokens: [
            `${contract}:${tokenId}`
        ],
        includeAttributes: true,
        includeLastSale: true,
        normalizeRoyalties: normalizeRoyalties
    }, {
        revalidateFirstPage: true
    }, rendererChain?.id);
    const token = tokens && tokens.length > 0 ? tokens[0] : undefined;
    const is1155 = token?.token?.kind === "erc1155";
    const { data: userTokens } = (0, $adb61885b37a317b$export$2e2bcd8739ae039)(open && is1155 ? account.address : undefined, {
        tokens: [
            `${contract}:${tokenId}`
        ]
    }, {}, rendererChain?.id);
    const quantityAvailable = is1155 && userTokens[0] ? Number(userTokens[0].ownership?.tokenCount || 1) : 1;
    const coinConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open ? "USD" : undefined, currency.symbol, currency.coinGeckoId);
    const usdPrice = coinConversion.length > 0 ? coinConversion[0].price : 0;
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setListStep($0dfcd962a810a554$export$7f4afd65e1e67072.SetPrice);
            setTransactionError(null);
            setPrice("");
            setStepData(null);
            setExpirationOption($0dfcd962a810a554$var$expirationOptions[5]);
            setQuantity(1);
            setCurrency(defaultCurrency);
        }
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "listModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    const exchange = (0, $TBcmg$useMemo)(()=>{
        const exchanges = marketplace?.exchanges || {};
        const exchange = orderKind ? exchanges[orderKind] : Object.values(exchanges).find((exchange)=>exchange?.enabled);
        return exchange?.enabled ? exchange : undefined;
    }, [
        marketplace,
        orderKind
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (exchange?.paymentTokens && exchange?.paymentTokens.length > 0) {
            const restrictedCurrencies = exchange.paymentTokens.filter((token)=>token.address && token.symbol).map((token)=>({
                    contract: token.address,
                    decimals: token.decimals,
                    name: token.name,
                    symbol: token.symbol
                }));
            setCurrencies(restrictedCurrencies);
            if (!restrictedCurrencies.find((c)=>currency.contract.toLowerCase() == c.contract.toLowerCase())) setCurrency(restrictedCurrencies[0]);
        } else {
            setCurrency(preferredCurrencies && preferredCurrencies[0] ? preferredCurrencies[0] : defaultCurrency);
            setCurrencies(preferredCurrencies);
        }
    }, [
        exchange,
        open
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (marketplace && !exchange) setListStep($0dfcd962a810a554$export$7f4afd65e1e67072.Unavailable);
    }, [
        marketplace,
        exchange,
        open
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (currencies && currencies.length > 5) console.warn("The ListModal UI was designed to have a maximum of 5 currencies, going above 5 may degrade the user experience.");
    }, [
        currencies
    ]);
    const listToken = (0, $TBcmg$useCallback)(async (options)=>{
        const { royaltyBps: royaltyBps } = options ?? {};
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        if (!marketplace) throw new Error("No marketplace found");
        if (!exchange) throw new Error("No exchange found");
        setTransactionError(null);
        let expirationTime = null;
        if (expirationOption.relativeTime) {
            if (expirationOption.relativeTimeUnit) expirationTime = (0, $TBcmg$dayjs)().add(expirationOption.relativeTime, expirationOption.relativeTimeUnit).unix().toString();
            else expirationTime = `${expirationOption.relativeTime}`;
        }
        const listing = {
            token: `${contract}:${tokenId}`,
            weiPrice: ((0, $TBcmg$parseUnits)(`${+price}`, currency.decimals || 18) * BigInt(quantity)).toString(),
            // @ts-ignore
            orderbook: marketplace.orderbook,
            // @ts-ignore
            orderKind: exchange.orderKind
        };
        const fees = feesBps || client.marketplaceFees;
        if (fees) listing.marketplaceFees = fees;
        if (quantity > 1) listing.quantity = quantity;
        if (expirationTime) listing.expirationTime = expirationTime;
        if (currency && currency.contract != (0, $TBcmg$zeroAddress)) listing.currency = currency.contract;
        if (oracleEnabled || conduitKey) listing.options = {
            [`${listing.orderKind}`]: {
                useOffChainCancellation: oracleEnabled,
                conduitKey: conduitKey
            }
        };
        if (royaltyBps !== undefined) listing.royaltyBps = royaltyBps;
        setListingData([
            {
                listing: listing,
                marketplace: marketplace
            }
        ]);
        setListStep($0dfcd962a810a554$export$7f4afd65e1e67072.Listing);
        client.actions.listToken({
            chainId: rendererChain?.id,
            listings: [
                listing
            ],
            wallet: wallet,
            onProgress: (steps)=>{
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let incompleteStepItemIndex = null;
                let incompleteStepIndex = null;
                executableSteps.find((step, i)=>{
                    if (!step.items) return false;
                    incompleteStepItemIndex = step.items.findIndex((item)=>item.status == "incomplete");
                    if (incompleteStepItemIndex !== -1) {
                        incompleteStepIndex = i;
                        return true;
                    }
                });
                if (incompleteStepIndex === null || incompleteStepItemIndex === null) {
                    const currentStep = executableSteps[executableSteps.length - 1];
                    const currentStepItem = currentStep.items ? currentStep.items[currentStep.items.length] : null;
                    setListStep($0dfcd962a810a554$export$7f4afd65e1e67072.Complete);
                    const listings = currentStepItem && currentStepItem.orderIndexes !== undefined ? listingData.filter((_, i)=>currentStepItem.orderIndexes?.includes(i)) : [
                        listingData[listingData.length - 1]
                    ];
                    setStepData({
                        totalSteps: stepCount,
                        stepProgress: stepCount,
                        currentStep: currentStep,
                        listingData: listings
                    });
                } else {
                    const currentStep = executableSteps[incompleteStepIndex];
                    const listingIndexes = new Set();
                    currentStep.items?.forEach(({ orderIndexes: orderIndexes, status: status })=>{
                        if (status === "incomplete") orderIndexes?.forEach((orderIndex)=>{
                            listingIndexes.add(orderIndex);
                        });
                    });
                    const listings = Array.from(listingIndexes).map((index)=>listingData[index]);
                    setStepData({
                        totalSteps: stepCount,
                        stepProgress: incompleteStepIndex,
                        currentStep: executableSteps[incompleteStepIndex],
                        listingData: listings
                    });
                }
            }
        }).catch((error)=>{
            setListStep($0dfcd962a810a554$export$7f4afd65e1e67072.SetPrice);
            setTransactionError(error);
        });
    }, [
        client,
        wallet,
        config,
        collectionId,
        chainId,
        tokenId,
        expirationOption,
        currency,
        quantity,
        feesBps,
        price,
        marketplace,
        exchange,
        conduitKey
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: !token || !collection || !marketplace,
        token: token,
        quantityAvailable: quantityAvailable,
        collection: collection,
        listStep: listStep,
        usdPrice: usdPrice,
        marketplace: marketplace,
        exchange: exchange,
        expirationOption: expirationOption,
        expirationOptions: $0dfcd962a810a554$var$expirationOptions,
        listingData: listingData,
        transactionError: transactionError,
        stepData: stepData,
        price: price,
        currencies: currencies || [
            defaultCurrency
        ],
        currency: currency,
        quantity: quantity,
        royaltyBps: royaltyBps,
        setListStep: setListStep,
        setPrice: setPrice,
        setCurrency: setCurrency,
        setExpirationOption: setExpirationOption,
        setQuantity: setQuantity,
        listToken: listToken
    }));
};
$0dfcd962a810a554$export$5cb91f178b51ac3.displayName = "ListModalRenderer";










const $d6ae44a4b381214a$var$SigninStep = ({ css: css })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralText",
            ...css
        },
        direction: "column",
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        color: "base",
        css: {
            mb: "$2",
            textAlign: "center"
        }
    }, "Sign in to Blur"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle",
        css: {
            mb: 20,
            textAlign: "center"
        }
    }, "This is a one-time approval process that takes place once a month"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faPenNib),
        width: 32,
        height: 32,
        style: {
            height: 32
        }
    }));
};
var $d6ae44a4b381214a$export$2e2bcd8739ae039 = $d6ae44a4b381214a$var$SigninStep;








(0, $TBcmg$dayjs).extend((0, $TBcmg$dayjspluginrelativeTimejs));
function $2f4c390a81073897$export$2e2bcd8739ae039(timestamp) {
    const [timeSince, setTimeSince] = (0, $TBcmg$useState)("");
    (0, $TBcmg$useEffect)(()=>{
        if (timestamp) setTimeSince((0, $TBcmg$dayjs).unix(timestamp).fromNow());
        else setTimeSince("");
    }, [
        timestamp
    ]);
    return timeSince;
}


const $c32e446acab1dc33$var$ListCheckout = ({ collection: collection, token: token, price: price, currency: currency, quantity: quantity, chain: chain, expirationOption: expirationOption, containerCss: containerCss })=>{
    const expirationDisplay = expirationOption?.value === "custom" && expirationOption.relativeTime ? (0, $2f4c390a81073897$export$2e2bcd8739ae039)(expirationOption.relativeTime) : `in ${expirationOption?.text.toLowerCase()}`;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        justify: "between",
        css: {
            p: "$4",
            ...containerCss
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
        src: token?.token?.imageSmall || collection?.image,
        alt: token?.token?.name || collection?.name,
        css: {
            width: 56,
            height: 56,
            borderRadius: 4,
            aspectRatio: "1/1"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$1",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        ellipsify: true
    }, token?.token?.name ? token?.token?.name : `#${token?.token?.tokenId}`), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, collection?.name), chain && !expirationOption ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain.id,
        height: 12
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, chain.name)) : null), quantity && quantity > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            width: "max-content",
            backgroundColor: "$neutralBg",
            borderRadius: 4,
            py: "$1",
            px: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle",
        ellipsify: true
    }, quantity, " items")) : null)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1",
            flexShrink: 0
        }
    }, price && currency ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: Number(price),
        address: currency?.contract,
        symbol: currency?.symbol,
        textStyle: "h6"
    }) : null, expirationOption ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body2",
        color: "subtle"
    }, "Expires ", expirationDisplay) : null));
};
var $c32e446acab1dc33$export$2e2bcd8739ae039 = $c32e446acab1dc33$var$ListCheckout;






const $09a27344989ccc4f$export$e7345cb65e28db6f = ({ triggerCss: triggerCss, valueCss: valueCss, chainId: chainId, currencies: currencies, currency: currency, setCurrency: setCurrency })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039), {
        trigger: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Trigger, {
            css: {
                width: "auto",
                p: 0,
                backgroundColor: "transparent",
                ...triggerCss
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Value, {
            asChild: true
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                ...valueCss
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: chainId,
            address: currency.contract,
            css: {
                height: 18
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle1",
            color: "subtle",
            css: {
                ml: "$1"
            }
        }, currency.symbol)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).DownIcon, {
            style: {
                marginLeft: 6
            }
        })))),
        value: currency.contract,
        onValueChange: (value)=>{
            const option = currencies.find((option)=>option.contract == value);
            if (option) setCurrency(option);
        }
    }, currencies.map((option)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Item, {
            key: option.contract,
            value: option.contract
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).ItemText, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: chainId,
            address: option.contract,
            css: {
                height: 18
            }
        }), option.symbol)))));
};






const $1e2f6c55518d39c3$var$slideDown = (0, $TBcmg$keyframes)({
    from: {
        height: 0
    },
    to: {
        height: "var(--radix-collapsible-content-height)"
    }
});
const $1e2f6c55518d39c3$var$slideUp = (0, $TBcmg$keyframes)({
    from: {
        height: "var(--radix-collapsible-content-height)"
    },
    to: {
        height: 0
    }
});
const $1e2f6c55518d39c3$export$aadde00976f34151 = (0, $TBcmg$styled)($TBcmg$CollapsibleContent, {
    background: "transparent",
    overflow: "hidden",
    border: "none",
    borderRadius: 0,
    '&[data-state="open"]': {
        animation: `${$1e2f6c55518d39c3$var$slideDown} 300ms cubic-bezier(0.87, 0, 0.13, 1)`
    },
    '&[data-state="closed"]': {
        animation: `${$1e2f6c55518d39c3$var$slideUp} 300ms cubic-bezier(0.87, 0, 0.13, 1)`
    }
});
const $1e2f6c55518d39c3$export$2ad57374564f8390 = (0, $TBcmg$styled)($TBcmg$Root4, {
    borderRadius: 8,
    overflow: "hidden"
});
const $1e2f6c55518d39c3$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ children: children, trigger: trigger, contentProps: contentProps, open: open, onOpenChange: onOpenChange, ...props }, forwardedRef)=>{
    const [collapsibleOpen, setCollapsibleOpen] = (0, $TBcmg$useState)(false);
    (0, $TBcmg$useEffect)(()=>{
        if (open !== undefined && open !== collapsibleOpen) {
            setCollapsibleOpen(open);
            if (onOpenChange) onOpenChange(open);
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($1e2f6c55518d39c3$export$2ad57374564f8390, {
        ...props,
        onOpenChange: (open)=>{
            setCollapsibleOpen(open);
            if (onOpenChange) onOpenChange(open);
        },
        open: collapsibleOpen
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Trigger3, {
        asChild: true
    }, trigger), /*#__PURE__*/ (0, $TBcmg$react).createElement($1e2f6c55518d39c3$export$aadde00976f34151, {
        ref: forwardedRef,
        ...contentProps
    }, children));
});












const $b3c42dc96a91e1fd$var$Arrow = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Arrow1, {
    width: 15,
    height: 7,
    fill: "$popoverBackground"
});
const $b3c42dc96a91e1fd$var$Content = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Content1, {
    filter: "drop-shadow(0px 2px 16px rgba(0, 0, 0, 0.75))",
    zIndex: 1000
});
const $b3c42dc96a91e1fd$var$RKPopover = ({ children: children, content: content, side: side = "bottom", width: width = "100%", ...props })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root1, {
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Trigger1, {
        style: {
            backgroundColor: "transparent",
            borderWidth: 0,
            cursor: "pointer",
            padding: 0
        }
    }, children), /*#__PURE__*/ (0, $TBcmg$react).createElement($b3c42dc96a91e1fd$var$Content, {
        side: side
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($b3c42dc96a91e1fd$var$Arrow, null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            p: "$3",
            maxWidth: 320,
            overflowY: "auto",
            maxHeight: 322,
            width: width,
            borderRadius: 8,
            backgroundColor: "$popoverBackground"
        }
    }, content)));
};
$b3c42dc96a91e1fd$var$RKPopover.Root = $TBcmg$Root1;
$b3c42dc96a91e1fd$var$RKPopover.Portal = $TBcmg$Portal1;
$b3c42dc96a91e1fd$var$RKPopover.Trigger = $TBcmg$Trigger1;
$b3c42dc96a91e1fd$var$RKPopover.Arrow = $b3c42dc96a91e1fd$var$Arrow;
$b3c42dc96a91e1fd$var$RKPopover.Content = $b3c42dc96a91e1fd$var$Content;
var $b3c42dc96a91e1fd$export$2e2bcd8739ae039 = $b3c42dc96a91e1fd$var$RKPopover;


const $a813136de1d75d50$var$InfoTooltip = ({ side: side, content: content, width: width, kind: kind = "info" })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039), {
        side: side,
        width: width,
        content: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            as: "p"
        }, content)
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: kind === "error" ? "$errorAccent" : "$neutralText"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faInfoCircle)
    })));
};
var $a813136de1d75d50$export$2e2bcd8739ae039 = $a813136de1d75d50$var$InfoTooltip;


const $8d84c0d06ac004cf$var$PriceBreakdown = ({ price: price, usdPrice: usdPrice, currency: currency, quantity: quantity, royaltyBps: royaltyBps, marketplace: marketplace, exchange: exchange })=>{
    const marketplaceFee = (marketplace?.fee?.percent ?? 0) / 100 + (exchange?.fee?.bps ?? 0) * 0.0001;
    const royaltyFee = (royaltyBps || 0) * 0.0001;
    const profit = (1 - marketplaceFee - royaltyFee) * Number(price) * quantity;
    if (Number(price) > 0 && (marketplace?.fee?.percent || royaltyBps)) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1e2f6c55518d39c3$export$6eb0f7ddcda6131f), {
        style: {
            width: "100%",
            borderRadius: 0,
            overflow: "visible"
        },
        trigger: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "ghost",
            size: "none",
            css: {
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                "& > div > span > svg": {
                    transition: ".3s"
                },
                '&[data-state="open"] > div > span > svg': {
                    transform: "rotate(180deg)"
                },
                $$focusColor: "$colors$accentBorderHover",
                "&:focus-visible": {
                    boxShadow: "0 0 0 2px $$focusColor"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Total Earnings"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronDown),
            width: 16,
            height: 16
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "end"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            amount: profit,
            address: currency.contract,
            symbol: currency.symbol,
            textStyle: "h6"
        }), usdPrice ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
            amount: profit * (usdPrice || 0),
            style: "subtitle3",
            color: "subtle"
        }) : null))
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$2",
            mt: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Total Listing Value"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: Number(price) * quantity,
        address: currency.contract,
        symbol: currency.symbol,
        textStyle: "subtitle2",
        textColor: "subtle"
    })), royaltyBps ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Creator Royalties"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a813136de1d75d50$export$2e2bcd8739ae039), {
        side: "right",
        width: 200,
        content: "A fee on every order that goes to the collection creator."
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "-"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: quantity * Number(price) * royaltyFee,
        address: currency.contract,
        symbol: currency.symbol,
        textStyle: "subtitle2",
        textColor: "subtle"
    }))) : null, marketplaceFee ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, marketplace?.name || "Marketplace", " Fee"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "-"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: quantity * Number(price) * marketplaceFee,
        address: currency.contract,
        symbol: currency.symbol,
        textStyle: "subtitle2",
        textColor: "subtle"
    }))) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Total Earnings"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: profit,
        address: currency.contract,
        symbol: currency.symbol,
        textStyle: "subtitle2",
        textColor: "subtle"
    }))));
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "start",
        css: {
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, "Total Earnings"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: profit,
        address: currency.contract,
        symbol: currency.symbol,
        textStyle: "h6"
    }), usdPrice ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: profit * (usdPrice || 0),
        style: "subtitle3",
        color: "subtle"
    }) : null));
};
var $8d84c0d06ac004cf$export$2e2bcd8739ae039 = $8d84c0d06ac004cf$var$PriceBreakdown;






const $e4991506bf3a72aa$export$6e76d93a37c01248 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$DropdownMenuContent, {
    p: "$3",
    borderRadius: 8,
    zIndex: 5,
    background: "$neutralBg",
    $$borderColor: "$colors$gray7",
    boxShadow: "0 0 0 1px $$borderColor"
});
const $e4991506bf3a72aa$export$ed97964d1871885d = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$DropdownMenuItem, {
    fontSize: 16,
    fontFamily: "$body",
    color: "$gray12",
    px: "$4",
    py: "$4",
    borderRadius: 8,
    outline: "none",
    cursor: "pointer",
    backgroundColor: "$neutralBgActive",
    $$focusColor: "$colors$focusColor",
    "&:hover": {
        backgroundColor: "$neutralBgHover"
    },
    "&[data-highlighted]": {
        boxShadow: "0 0 0 2px $$focusColor"
    }
});
const $e4991506bf3a72aa$export$931cbfb6bfb85fc = /*#__PURE__*/ (0, $TBcmg$forwardRef)(({ children: children, trigger: trigger, contentProps: contentProps, ...props }, forwardedRef)=>{
    const [open, setOpen] = (0, $TBcmg$useState)(false);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root5, {
        ...props,
        open: open,
        onOpenChange: setOpen
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Trigger4, {
        asChild: true
    }, trigger), open && /*#__PURE__*/ (0, $TBcmg$react).createElement($e4991506bf3a72aa$export$6e76d93a37c01248, {
        ref: forwardedRef,
        ...contentProps
    }, children));
});





const $af9eb7fb15eeb1e9$var$FloorDropdown = ({ token: token, currency: currency, defaultCurrency: defaultCurrency, setPrice: setPrice, setCurrency: setCurrency })=>{
    const highestTraitFloor = (0, $TBcmg$useMemo)(()=>{
        if (token?.token?.attributes && token?.token?.attributes?.length < 2000) return Math.max(...token.token.attributes.map((attr)=>Number(attr.floorAskPrice)), 0);
    }, [
        token?.token?.attributes
    ]);
    const recentSalePrice = token?.token?.lastSale?.price;
    const decimalSalePrice = recentSalePrice?.amount?.decimal;
    const nativeSalePrice = recentSalePrice?.amount?.native;
    const usdSalePrice = recentSalePrice?.amount?.usd;
    const recentSale = (0, $TBcmg$useMemo)(()=>{
        // If currency matches recent sale currency, use decimal floor price
        if (currency.contract === recentSalePrice?.currency?.contract && decimalSalePrice) return {
            address: currency.contract,
            amount: decimalSalePrice
        };
        else if (currency.symbol === "USDC" && usdSalePrice) return {
            address: currency.contract,
            amount: usdSalePrice
        };
        else if (nativeSalePrice && defaultCurrency) return {
            address: defaultCurrency.contract,
            amount: nativeSalePrice
        };
    }, [
        token,
        currency
    ]);
    if ((highestTraitFloor || recentSale) && defaultCurrency) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e4991506bf3a72aa$export$931cbfb6bfb85fc), {
        contentProps: {
            align: "end",
            sideOffset: 10,
            style: {
                width: 265
            }
        },
        trigger: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "secondary",
            size: "none",
            css: {
                height: 44,
                px: "$4",
                borderRadius: 8
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                color: "$textColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faEllipsis)
        })))
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            width: "100%",
            gap: "$3"
        }
    }, highestTraitFloor ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e4991506bf3a72aa$export$ed97964d1871885d), {
        onClick: ()=>{
            setPrice(highestTraitFloor.toString());
            setCurrency(defaultCurrency);
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle1"
    }, "Highest Trait"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: highestTraitFloor,
        textStyle: "h6"
    }))) : null, recentSale ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e4991506bf3a72aa$export$ed97964d1871885d), {
        onClick: ()=>{
            setPrice(recentSale?.amount?.toString());
            if (currency.contract != recentSale.address) setCurrency(defaultCurrency);
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle1"
    }, "Recent Sale"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        address: recentSale?.address,
        amount: recentSale?.amount,
        textStyle: "h6"
    }))) : null));
    return null;
};
var $af9eb7fb15eeb1e9$export$2e2bcd8739ae039 = $af9eb7fb15eeb1e9$var$FloorDropdown;



const $5bc22b51ac8fa039$var$ModalCopy = {
    title: "List Item for sale",
    ctaClose: "Close",
    ctaSetPrice: "Set your price",
    ctaList: "List for Sale",
    ctaAwaitingApproval: "Waiting for Approval",
    ctaGoToToken: "Go to Token"
};
const $5bc22b51ac8fa039$var$Image = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {});
const $5bc22b51ac8fa039$var$MINIMUM_AMOUNT = 0.000001;
const $5bc22b51ac8fa039$var$MAXIMUM_AMOUNT = Infinity;
function $5bc22b51ac8fa039$export$d23efc006864db2f({ openState: openState, trigger: trigger, tokenId: tokenId, collectionId: collectionId, chainId: chainId, orderKind: orderKind, currencies: currencies, normalizeRoyalties: normalizeRoyalties, oracleEnabled: oracleEnabled = false, conduitKey: conduitKey, copyOverrides: copyOverrides, feesBps: feesBps, walletClient: walletClient, onGoToToken: onGoToToken, onListingComplete: onListingComplete, onListingError: onListingError, onClose: onClose, onPointerDownOutside: onPointerDownOutside }) {
    const copy = {
        ...$5bc22b51ac8fa039$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const datetimeElement = (0, $TBcmg$useRef)(null);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0dfcd962a810a554$export$5cb91f178b51ac3), {
        open: open,
        orderKind: orderKind,
        chainId: modalChain?.id,
        tokenId: tokenId,
        collectionId: collectionId,
        currencies: currencies,
        normalizeRoyalties: normalizeRoyalties,
        oracleEnabled: oracleEnabled,
        conduitKey: conduitKey,
        feesBps: feesBps,
        walletClient: walletClient
    }, ({ loading: loading, token: token, quantityAvailable: quantityAvailable, collection: collection, usdPrice: usdPrice, listStep: listStep, marketplace: marketplace, exchange: exchange, expirationOption: expirationOption, expirationOptions: expirationOptions, royaltyBps: royaltyBps, listingData: listingData, transactionError: transactionError, stepData: stepData, price: price, currencies: currencies, currency: currency, quantity: quantity, setPrice: setPrice, listToken: listToken, setCurrency: setCurrency, setExpirationOption: setExpirationOption, setQuantity: setQuantity })=>{
        const source = client?.source ? client?.source : marketplace?.domain;
        const minimumDate = (0, $TBcmg$useMemo)(()=>{
            return (0, $TBcmg$dayjs)().add(1, "h").format("MM/DD/YYYY h:mm A");
        }, [
            open
        ]);
        const expirationDate = (0, $TBcmg$useMemo)(()=>{
            if (expirationOption && expirationOption.relativeTime) {
                const newExpirationTime = expirationOption.relativeTimeUnit ? (0, $TBcmg$dayjs)().add(expirationOption.relativeTime, expirationOption.relativeTimeUnit) : (0, $TBcmg$dayjs).unix(expirationOption.relativeTime);
                return newExpirationTime.format("MM/DD/YYYY h:mm A");
            }
            return "";
        }, [
            expirationOption
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (listStep === (0, $0dfcd962a810a554$export$7f4afd65e1e67072).Complete && onListingComplete) {
                const data = {
                    tokenId: tokenId,
                    collectionId: collectionId,
                    listings: listingData
                };
                onListingComplete(data);
            }
        }, [
            listStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onListingError) {
                const data = {
                    tokenId: tokenId,
                    collectionId: collectionId,
                    listings: listingData
                };
                onListingError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const floorAskPrice = token?.token?.kind === "erc1155" ? token?.market?.floorAsk?.price : collection?.floorAsk?.price;
        const decimalFloorPrice = floorAskPrice?.amount?.decimal;
        const nativeFloorPrice = floorAskPrice?.amount?.native;
        const usdFloorPrice = floorAskPrice?.amount?.usd;
        const defaultCurrency = currencies?.find((currency)=>currency?.contract === (0, $TBcmg$zeroAddress));
        const floorButtonEnabled = currency.contract === floorAskPrice?.currency?.contract && decimalFloorPrice || currency.symbol === "USDC" && usdFloorPrice || nativeFloorPrice && currency.contract === (0, $TBcmg$zeroAddress) || nativeFloorPrice && defaultCurrency;
        const minimumAmount = exchange?.minPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.minPriceRaw), currency?.decimals || 18)) : $5bc22b51ac8fa039$var$MINIMUM_AMOUNT;
        const maximumAmount = exchange?.maxPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.maxPriceRaw), currency?.decimals || 18)) : $5bc22b51ac8fa039$var$MAXIMUM_AMOUNT;
        const withinPricingBounds = price && Number(price) !== 0 && Number(price) <= maximumAmount && Number(price) >= minimumAmount;
        const canPurchase = price !== "" && withinPricingBounds;
        const handleSetFloor = ()=>{
            // If currency matches floor ask currency, use decimal floor price
            if (currency.contract === floorAskPrice?.currency?.contract && decimalFloorPrice) setPrice(decimalFloorPrice.toString());
            else if (currency.symbol === "USDC" && usdFloorPrice) setPrice(usdFloorPrice?.toString());
            else if (nativeFloorPrice) {
                // If currency is native currency, use native floor price
                if (currency.contract === (0, $TBcmg$zeroAddress)) setPrice(nativeFloorPrice.toString());
                else if (defaultCurrency) {
                    setCurrency(defaultCurrency);
                    setPrice(nativeFloorPrice.toString());
                }
            }
        };
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.title,
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        tokenId: tokenId,
                        collectionId: collectionId,
                        listings: listingData
                    };
                    onClose(data, stepData, listStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (e.target instanceof Element && datetimeElement.current?.flatpickr?.calendarContainer && datetimeElement.current.flatpickr.calendarContainer.contains(e.target)) e.preventDefault();
                if (onPointerDownOutside) onPointerDownOutside(e);
            },
            onFocusCapture: (e)=>{
                e.stopPropagation();
            }
        }, !loading && listStep == (0, $0dfcd962a810a554$export$7f4afd65e1e67072).Unavailable && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4",
                gap: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid",
                mt: 48
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faTag),
            style: {
                width: "32px",
                height: "32px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                mb: "$3",
                textAlign: "center"
            }
        }, "Listing is not available for this collection."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>{
                setOpen(false);
            }
        }, copy.ctaClose)), !loading && listStep == (0, $0dfcd962a810a554$export$7f4afd65e1e67072).SetPrice && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c32e446acab1dc33$export$2e2bcd8739ae039), {
            collection: collection,
            token: token,
            chain: modalChain
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4",
                gap: 24
            }
        }, quantityAvailable > 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "between",
            css: {
                width: "100%",
                gap: "$3",
                "@bp1": {
                    gap: "$6"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "start",
            direction: "column",
            css: {
                gap: "$1",
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "subtle"
        }, quantityAvailable, " items available")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
            quantity: quantity,
            setQuantity: setQuantity,
            min: 1,
            max: quantityAvailable,
            css: {
                width: "100%",
                justifyContent: "space-between"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Enter a price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "between",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5c0c2c3952297d70$export$2e2bcd8739ae039), {
            type: "number",
            value: price,
            onChange: (e)=>{
                setPrice(e.target.value);
            },
            placeholder: "Amount",
            css: {
                width: "100%"
            },
            containerCss: {
                width: "100%",
                height: 44
            }
        }), currencies.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $09a27344989ccc4f$export$e7345cb65e28db6f), {
            chainId: chainId,
            currency: currency,
            currencies: currencies,
            setCurrency: setCurrency,
            triggerCss: {
                backgroundColor: "$neutralBgHover",
                borderRadius: 8,
                p: "$3",
                width: 120,
                flexShrink: 0,
                height: 44
            },
            valueCss: {
                justifyContent: "space-between",
                width: "100%"
            }
        }) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                flexShrink: 0,
                px: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                width: "auto",
                height: 20
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: chainId,
            css: {
                height: 18
            },
            address: currency.contract
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body1",
            color: "subtle",
            css: {
                ml: "$1"
            },
            as: "p"
        }, currency.symbol)), floorButtonEnabled ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "secondary",
            size: "none",
            css: {
                height: 44,
                px: "$4",
                borderRadius: 8,
                fontWeight: 500
            },
            onClick: ()=>handleSetFloor()
        }, "Floor") : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $af9eb7fb15eeb1e9$export$2e2bcd8739ae039), {
            token: token,
            currency: currency,
            defaultCurrency: defaultCurrency,
            setPrice: setPrice,
            setCurrency: setCurrency
        })), Number(price) !== 0 && !withinPricingBounds && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "error"
        }, maximumAmount !== Infinity ? `Amount must be between ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount)} - ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(maximumAmount)}` : `Amount must be higher than ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount)}`)), floorAskPrice?.amount?.native !== undefined && Number(price) !== 0 && Number(price) >= minimumAmount && currency.contract === (0, $TBcmg$zeroAddress) && Number(price) < floorAskPrice.amount.native && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "error"
        }, "Price is", " ", Math.round((floorAskPrice.amount.native - +price) / ((floorAskPrice.amount.native + +price) / 2) * 100000) / 1000, "% below the floor"))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                width: "100%",
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Expiration Date"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039), {
            value: expirationOption?.text || "",
            onValueChange: (value)=>{
                const option = expirationOptions.find((option)=>option.value == value);
                if (option) setExpirationOption(option);
            },
            css: {
                borderRadius: 8,
                maxWidth: 160,
                height: 44
            }
        }, expirationOptions.filter(({ value: value })=>value !== "custom").map((option)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Item, {
                key: option.text,
                value: option.value
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).ItemText, null, option.text)))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b31bbf36f2fe9ca4$export$2e2bcd8739ae039), {
            ref: datetimeElement,
            icon: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
                icon: (0, $TBcmg$faCalendar),
                width: 14,
                height: 16
            }),
            value: expirationDate,
            options: {
                chainId: modalChain?.id,
                minDate: minimumDate,
                enableTime: true,
                minuteIncrement: 1
            },
            defaultValue: expirationDate,
            onChange: (e)=>{
                if (Array.isArray(e)) {
                    const customOption = expirationOptions.find((option)=>option.value === "custom");
                    if (customOption) setExpirationOption({
                        ...customOption,
                        relativeTime: e[0] / 1000
                    });
                }
            },
            containerCss: {
                height: 44,
                width: 46,
                "@bp1": {
                    flex: 1,
                    width: "100%"
                }
            },
            css: {
                padding: 0,
                "@bp1": {
                    padding: "12px 16px 12px 48px"
                }
            }
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $8d84c0d06ac004cf$export$2e2bcd8739ae039), {
            price: price,
            usdPrice: usdPrice,
            currency: currency,
            quantity: quantity,
            royaltyBps: royaltyBps,
            marketplace: marketplace,
            exchange: exchange
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: canPurchase ? false : true,
            onClick: ()=>listToken(),
            css: {
                width: "100%"
            }
        }, copy.ctaList))), !loading && listStep == (0, $0dfcd962a810a554$export$7f4afd65e1e67072).Listing && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c32e446acab1dc33$export$2e2bcd8739ae039), {
            collection: collection,
            token: token,
            price: price,
            currency: currency,
            quantity: quantity,
            expirationOption: expirationOption,
            containerCss: {
                borderBottom: "1px solid",
                borderBottomColor: "$neutralLine",
                borderColor: "$neutralLine"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: 24,
                gap: "$4"
            }
        }, stepData && stepData.currentStep.id === "auth" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d6ae44a4b381214a$export$2e2bcd8739ae039), {
            css: {
                mt: 48,
                mb: "$4",
                gap: 20
            }
        }) : null, stepData && stepData.currentStep.id !== "auth" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center"
            },
            style: "h6"
        }, stepData.currentStep.kind === "transaction" ? "Approve Collections" : "Confirm listing in your wallet"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center",
                maxWidth: 395,
                mx: "auto"
            },
            style: "body1",
            color: "subtle"
        }, stepData?.currentStep.description), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: stepData.currentStep.kind === "transaction" ? (0, $TBcmg$faImages) : (0, $TBcmg$faTag),
            size: "2x"
        }))) : null, !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                height: "100%",
                py: "$5"
            },
            justify: "center",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                p: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                mt: "auto"
            },
            disabled: true
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.ctaAwaitingApproval))), !loading && listStep == (0, $0dfcd962a810a554$export$7f4afd65e1e67072).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                px: "$5",
                pt: "$5",
                gap: 24
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                gap: "$2",
                overflow: "hidden"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
            src: token?.token?.image || collection?.image,
            alt: token?.token?.name || token?.token?.tokenId,
            css: {
                width: 120,
                height: 120,
                aspectRatio: "1/1",
                borderRadius: 4
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            ellipsify: true
        }, token?.token?.tokenId ? `#${token?.token?.tokenId}` : token?.token?.name), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2",
            color: "accent",
            ellipsify: true
        }, collection?.name)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            as: "h5"
        }, "Your item has been listed!"), source ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            as: "p"
        }, "View Listing on"), /*#__PURE__*/ (0, $TBcmg$react).createElement("a", {
            target: "_blank",
            href: `${modalChain?.baseApiUrl}/redirect/sources/${source}/tokens/${token?.token?.contract}:${token?.token?.tokenId}/link/v2`
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement($5bc22b51ac8fa039$var$Image, {
            css: {
                width: 24,
                borderRadius: 4
            },
            src: marketplace?.imageUrl
        }))) : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                width: "100%",
                flexDirection: "column",
                gap: "$3",
                "@bp1": {
                    flexDirection: "row"
                }
            }
        }, !!onGoToToken ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                flex: 1
            },
            color: "secondary"
        }, copy.ctaClose), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            style: {
                flex: 1
            },
            color: "primary",
            onClick: ()=>{
                onGoToToken();
            }
        }, copy.ctaGoToToken)) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            style: {
                flex: 1
            },
            color: "primary"
        }, copy.ctaClose))));
    });
}
$5bc22b51ac8fa039$export$d23efc006864db2f.Custom = (0, $0dfcd962a810a554$export$5cb91f178b51ac3);








const $bf67ac886f7190ba$var$FormatWrappedCurrency = ({ logoWidth: logoWidth, address: address, ...props })=>{
    const { chain: activeChain } = (0, $TBcmg$useAccount)();
    const chains = (0, $TBcmg$useChains)();
    let chain = chains.find((chain)=>activeChain?.id === chain.id);
    if (!chain && chains.length > 0) chain = chains[0];
    else chain = activeChain;
    const contractAddress = chain?.id !== undefined && chain.id in (0, $539986c326843873$export$2e2bcd8739ae039) ? (0, $539986c326843873$export$2e2bcd8739ae039)[chain.id] : (0, $539986c326843873$export$2e2bcd8739ae039)[1];
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        ...props,
        address: address || contractAddress
    });
};
var $bf67ac886f7190ba$export$2e2bcd8739ae039 = $bf67ac886f7190ba$var$FormatWrappedCurrency;












const $ccbd22d7b24d8923$var$wrappedContractNames = {
    1: "WETH",
    10: "WETH",
    56: "WBNB",
    204: "WBNB",
    137: "WMATIC",
    1101: "WETH ",
    324: "WETH",
    42161: "WETH",
    42170: "WETH",
    43114: "WAVAX",
    59144: "WETH",
    999: "WETH",
    80002: "WMATIC",
    8453: "WETH",
    84532: "WETH",
    534353: "WETH",
    534352: "WETH",
    7777777: "WETH",
    11155111: "WETH",
    888888888: "WETH",
    28122024: "WETH",
    68840142: "WETH",
    168587773: "WETH",
    70700: "WETH",
    70800: "WETH",
    81457: "WETH",
    3776: "WETH",
    17069: "WETH",
    690: "WETH",
    80084: "WBERA",
    666666666: "WDEGEN",
    660279: "WXAI",
    1482601649: "ETH",
    713715: "WSEI",
    7560: "WETH",
    200901: "WBTC",
    1329: "WSEI",
    1993: "WETH",
    646: "WFLOW",
    70805: "WETH",
    13746: "WTG7T",
    70701: "WETH",
    984122: "WTIA",
    984123: "WTIA",
    8333: "WETH",
    33139: "WAPE",
    33111: "WAPE",
    360: "WETH",
    11011: "WETH",
    11124: "WETH",
    1946: "WETH",
    2911: "WTOPIA",
    29112: "WTOPIA",
    747: "WFLOW",
    543210: "WETH",
    43210: "WETH",
    2741: "WETH",
    6900: "WANIME",
    41454: "WMON",
    2187: "WG7",
    4654: "WETH",
    1868: "WETH"
};
var $ccbd22d7b24d8923$export$2e2bcd8739ae039 = $ccbd22d7b24d8923$var$wrappedContractNames;







const $2b3bdb31da73e768$var$expirationOptions = [
    ...(0, $4dd727d17c3f54df$export$2e2bcd8739ae039),
    {
        text: "Custom",
        value: "custom",
        relativeTime: null,
        relativeTimeUnit: null
    }
];
var $2b3bdb31da73e768$export$7a92ddb9e11f37f7;
(function(BidStep) {
    BidStep[BidStep["SetPrice"] = 0] = "SetPrice";
    BidStep[BidStep["Offering"] = 1] = "Offering";
    BidStep[BidStep["Complete"] = 2] = "Complete";
    BidStep[BidStep["Unavailable"] = 3] = "Unavailable";
})($2b3bdb31da73e768$export$7a92ddb9e11f37f7 || ($2b3bdb31da73e768$export$7a92ddb9e11f37f7 = {}));
const $2b3bdb31da73e768$export$1d1be26767be2a74 = 0.000001;
const $2b3bdb31da73e768$export$89d91658eb2b6698 = ({ open: open, tokenId: tokenId, chainId: chainId, collectionId: collectionId, orderKind: orderKind, attribute: attribute, conduitKey: conduitKey, normalizeRoyalties: normalizeRoyalties, currencies: preferredCurrencies, oracleEnabled: oracleEnabled = false, feesBps: feesBps, children: children, walletClient: walletClient, usePermit: usePermit })=>{
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const config = (0, $TBcmg$useConfig)();
    const wallet = walletClient || wagmiWallet;
    const [bidStep, setBidStep] = (0, $TBcmg$useState)($2b3bdb31da73e768$export$7a92ddb9e11f37f7.SetPrice);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [bidAmountPerUnit, setBidAmountPerUnit] = (0, $TBcmg$useState)("");
    const [quantity, setQuantity] = (0, $TBcmg$useState)(1);
    const [expirationOption, setExpirationOption] = (0, $TBcmg$useState)($2b3bdb31da73e768$var$expirationOptions[3]);
    const [hasEnoughNativeCurrency, setHasEnoughNativeCurrency] = (0, $TBcmg$useState)(false);
    const [hasEnoughWrappedCurrency, setHasEnoughWrappedCurrency] = (0, $TBcmg$useState)(false);
    const [amountToWrap, setAmountToWrap] = (0, $TBcmg$useState)("");
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [bidData, setBidData] = (0, $TBcmg$useState)(null);
    const contract = collectionId ? collectionId?.split(":")[0] : undefined;
    const [trait, setTrait] = (0, $TBcmg$useState)(attribute);
    const [attributes, setAttributes] = (0, $TBcmg$useState)();
    const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(rendererChain?.id);
    const nativeWrappedContractAddress = chainCurrency.chainId in (0, $539986c326843873$export$2e2bcd8739ae039) ? (0, $539986c326843873$export$2e2bcd8739ae039)[chainCurrency.chainId] : (0, $539986c326843873$export$2e2bcd8739ae039)[1];
    const nativeWrappedContractName = chainCurrency.chainId in (0, $ccbd22d7b24d8923$export$2e2bcd8739ae039) ? (0, $ccbd22d7b24d8923$export$2e2bcd8739ae039)[chainCurrency.chainId] : (0, $ccbd22d7b24d8923$export$2e2bcd8739ae039)[1];
    const defaultCurrency = {
        contract: nativeWrappedContractAddress,
        symbol: nativeWrappedContractName
    };
    const [currency, setCurrency] = (0, $TBcmg$useState)(preferredCurrencies && preferredCurrencies[0] ? preferredCurrencies[0] : defaultCurrency);
    const [currencies, setCurrencies] = (0, $TBcmg$useState)(preferredCurrencies);
    const wrappedContractAddress = currency ? currency.contract : nativeWrappedContractAddress;
    const wrappedContractName = currency ? currency.symbol : nativeWrappedContractName;
    const { data: tokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && tokenId !== undefined && {
        tokens: [
            `${contract}:${tokenId}`
        ],
        includeTopBid: true,
        normalizeRoyalties: normalizeRoyalties
    }, {
        revalidateFirstPage: true
    }, rendererChain?.id);
    const { data: traits } = (0, $7c7b75a236ce465b$export$2e2bcd8739ae039)(open && !tokenId ? collectionId : undefined, rendererChain?.id);
    const { data: collections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && {
        id: collectionId,
        normalizeRoyalties: normalizeRoyalties
    }, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    const token = tokens && tokens.length > 0 ? tokens[0] : undefined;
    const usdConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open ? "USD" : undefined, wrappedContractName);
    const usdPrice = usdConversion.length > 0 ? usdConversion[0].price : null;
    const totalBidAmount = (0, $TBcmg$parseUnits)(bidAmountPerUnit, currency?.decimals ?? 18) * BigInt(quantity ?? 1);
    const totalBidAmountUsd = Number((0, $TBcmg$formatUnits)(totalBidAmount, currency?.decimals ?? 18)) * (usdPrice || 0);
    const [allMarketplaces] = (0, $6bcc64b528de3c29$export$2e2bcd8739ae039)(collectionId, tokenId, undefined, undefined, rendererChain?.id, open);
    const reservoirMarketplace = (0, $TBcmg$useMemo)(()=>allMarketplaces.find((marketplace)=>marketplace.orderbook === "reservoir"), [
        allMarketplaces
    ]);
    const exchange = (0, $TBcmg$useMemo)(()=>{
        const exchanges = reservoirMarketplace?.exchanges || {};
        const exchange = orderKind ? exchanges[orderKind] : Object.values(exchanges).find((exchange)=>exchange?.enabled);
        return exchange?.enabled ? exchange : undefined;
    }, [
        reservoirMarketplace,
        orderKind
    ]);
    const traitBidSupported = Boolean(exchange?.traitBidSupported);
    const collectionBidSupported = Boolean(exchange?.collectionBidSupported);
    const partialBidSupported = Boolean(exchange?.partialOrderSupported);
    const biddingSupported = exchange?.supportedBidCurrencies ? exchange?.supportedBidCurrencies?.length > 0 : false;
    // Set bid step to unavailable if collection bid is not supported or if bidding is not supported
    (0, $TBcmg$useEffect)(()=>{
        if (open && reservoirMarketplace && (!tokenId && !collectionBidSupported || !biddingSupported)) setBidStep($2b3bdb31da73e768$export$7a92ddb9e11f37f7.Unavailable);
        else setBidStep($2b3bdb31da73e768$export$7a92ddb9e11f37f7.SetPrice);
    }, [
        open,
        tokenId,
        reservoirMarketplace,
        collectionBidSupported,
        biddingSupported
    ]);
    const { address: address, connector: connector } = (0, $TBcmg$useAccount)();
    const { data: capabilities } = (0, $TBcmg$useCapabilities)({
        query: {
            enabled: connector && (connector.id === "coinbaseWalletSDK" || connector.id === "coinbase")
        }
    });
    const hasAuxiliaryFundsSupport = Boolean(rendererChain?.id ? capabilities?.[rendererChain?.id]?.auxiliaryFunds?.supported : false);
    const { data: balance } = (0, $TBcmg$useBalance)({
        address: address,
        chainId: rendererChain?.id,
        query: {
            enabled: open
        }
    });
    const { data: wrappedBalance } = (0, $TBcmg$useReadContracts)({
        allowFailure: false,
        contracts: [
            {
                address: wrappedContractAddress,
                abi: (0, $TBcmg$erc20Abi),
                functionName: "balanceOf",
                chainId: rendererChain?.id,
                args: [
                    address
                ]
            },
            {
                address: wrappedContractAddress,
                abi: (0, $TBcmg$erc20Abi),
                chainId: rendererChain?.id,
                functionName: "decimals"
            },
            {
                address: wrappedContractAddress,
                abi: (0, $TBcmg$erc20Abi),
                chainId: rendererChain?.id,
                functionName: "symbol"
            }
        ],
        query: {
            enabled: Boolean(open && address !== undefined)
        }
    });
    const { relayLink: relayLink } = (0, $ff7ce0ca6096b543$export$2e2bcd8739ae039)(rendererChain?.id);
    const canAutomaticallyConvert = !currency || currency.contract.toLowerCase() === nativeWrappedContractAddress.toLowerCase();
    let convertLink = "";
    if (providerOptions?.convertLink) {
        convertLink = providerOptions.convertLink.tokenUrl ?? providerOptions.convertLink.chainUrl ?? providerOptions.convertLink.customUrl?.({
            toChain: rendererChain?.id,
            toToken: wrappedContractAddress,
            amountToWrap: amountToWrap
        }) ?? "";
        if (rendererChain?.id) convertLink = convertLink.replace("{toChain}", `${rendererChain.id}`);
        convertLink = convertLink.replace("{toToken}", wrappedContractAddress);
    } else if (relayLink) convertLink = `${relayLink}?toCurrency=${wrappedContractAddress}&fromChainId=${rendererChain?.id}&fromCurrency=${chainCurrency.address}`;
    else if (canAutomaticallyConvert) convertLink = rendererChain?.id === (0, $TBcmg$mainnet).id || rendererChain?.id === (0, $TBcmg$goerli).id ? `https://app.uniswap.org/#/swap?theme=dark&exactAmount=${amountToWrap}&chain=mainnet&inputCurrency=eth&outputCurrency=${wrappedContractAddress}` : `https://app.uniswap.org/#/swap?theme=dark&exactAmount=${amountToWrap}`;
    else convertLink = `https://jumper.exchange/?toChain=${rendererChain?.id}&toToken=${wrappedContractAddress}`;
    const feeBps = (0, $TBcmg$useMemo)(()=>{
        let totalFeeBps = 0;
        const bpsFees = feesBps || client?.marketplaceFees;
        totalFeeBps += bpsFees?.reduce((total, fee)=>{
            const bps = Number(fee.split(":")[1]);
            total += bps;
            return total;
        }, 0) ?? 0;
        totalFeeBps += exchange?.fee?.bps ?? 0;
        return totalFeeBps;
    }, [
        feesBps,
        client?.marketplaceFees,
        currency,
        exchange
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (totalBidAmount !== 0n) {
            const bid = totalBidAmount;
            if (!wrappedBalance?.[0] || wrappedBalance?.[0] < bid) {
                setHasEnoughWrappedCurrency(false);
                const wrappedAmount = wrappedBalance?.[0] ? BigInt(wrappedBalance?.[0]) : BigInt(0);
                const amountToWrap = bid - wrappedAmount;
                setAmountToWrap((0, $6f54b4a5aad888ed$export$87710fd8420713d9)(amountToWrap, 5));
                if (!balance?.value || balance.value < amountToWrap) setHasEnoughNativeCurrency(false);
                else setHasEnoughNativeCurrency(true);
            } else {
                setHasEnoughWrappedCurrency(true);
                setHasEnoughNativeCurrency(true);
                setAmountToWrap("");
            }
        } else {
            setHasEnoughNativeCurrency(true);
            setHasEnoughWrappedCurrency(true);
            setAmountToWrap("");
        }
    }, [
        totalBidAmount,
        balance,
        wrappedBalance
    ]);
    (0, $TBcmg$useEffect)(()=>{
        const validAttributes = traits ? traits.filter((attribute)=>attribute.values && attribute.values.length > 0) : undefined;
        setAttributes(validAttributes);
    }, [
        traits
    ]);
    (0, $TBcmg$useEffect)(()=>{
        const validAttributes = traits ? traits.filter((attribute)=>attribute.values && attribute.values.length > 0) : undefined;
        setAttributes(validAttributes);
    }, [
        traits
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setBidStep($2b3bdb31da73e768$export$7a92ddb9e11f37f7.SetPrice);
            setExpirationOption($2b3bdb31da73e768$var$expirationOptions[3]);
            setHasEnoughNativeCurrency(false);
            setHasEnoughWrappedCurrency(false);
            setAmountToWrap("");
            setBidAmountPerUnit("");
            setQuantity(1);
            setStepData(null);
            setBidData(null);
            setTransactionError(null);
            setTrait(undefined);
        } else setTrait(attribute);
        setCurrency(currencies && currencies[0] ? currencies[0] : defaultCurrency);
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "bidModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    (0, $TBcmg$useEffect)(()=>{
        const setDefaultCurrency = async ()=>{
            const supportedCurrencies = exchange?.supportedBidCurrencies?.map((currency)=>{
                return {
                    address: currency?.address?.toLowerCase(),
                    contract: currency?.address?.toLowerCase(),
                    decimals: currency?.decimals ?? 18,
                    name: currency?.name ?? "",
                    symbol: currency?.symbol ?? ""
                };
            }) || [];
            const supportedCurrencyAddresses = supportedCurrencies.map((currency)=>currency.address);
            if (exchange?.paymentTokens) {
                let restrictedCurrencies = exchange.paymentTokens.filter((token)=>token.address && token.symbol && supportedCurrencyAddresses.includes(token.address.toLowerCase())).map((token)=>({
                        contract: token.address,
                        decimals: token.decimals,
                        name: token.name,
                        symbol: token.symbol
                    }));
                if (!restrictedCurrencies.length) restrictedCurrencies = supportedCurrencies ?? [];
                setCurrencies(restrictedCurrencies);
                if (!restrictedCurrencies.find((c)=>currency.contract.toLowerCase() == c.contract.toLowerCase())) setCurrency(restrictedCurrencies[0]);
            } else {
                const currencies = preferredCurrencies?.filter((currency)=>currency.contract.toLowerCase());
                setCurrency(currencies && currencies[0] ? currencies[0] : defaultCurrency);
                setCurrencies(preferredCurrencies);
            }
        };
        setDefaultCurrency();
    }, [
        exchange,
        open
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (currencies && currencies.length > 5) console.warn("The BidModal UI was designed to have a maximum of 5 currencies, going above 5 may degrade the user experience.");
    }, [
        currencies
    ]);
    const placeBid = (0, $TBcmg$useCallback)(async (options)=>{
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!tokenId && !collectionId) {
            const error = new Error("Missing tokenId and collectionId");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        if (!tokenId && !collectionBidSupported) {
            const error = new Error("Collection bids are not supported for this collection");
            setTransactionError(error);
            throw error;
        }
        if (!exchange) {
            const error = new Error("Missing Exchange");
            setTransactionError(error);
            throw error;
        }
        setBidStep($2b3bdb31da73e768$export$7a92ddb9e11f37f7.Offering);
        setTransactionError(null);
        setBidData(null);
        const bid = {
            weiPrice: totalBidAmount.toString(),
            orderbook: "reservoir",
            orderKind: orderKind || exchange?.orderKind || "seaport",
            attributeKey: traitBidSupported ? trait?.key : undefined,
            attributeValue: traitBidSupported ? trait?.value : undefined
        };
        if (feesBps && feesBps?.length > 0) bid.marketplaceFees = feesBps;
        else if (!feesBps) {
            delete bid.fees;
            delete bid.marketplaceFees;
        }
        if (currency) bid.currency = currency.contract;
        if (tokenId && collectionId) {
            const contract = collectionId ? collectionId?.split(":")[0] : undefined;
            bid.token = `${contract}:${tokenId}`;
        } else if (collectionId) bid.collection = collectionId;
        if (expirationOption.relativeTime) {
            if (expirationOption.relativeTimeUnit) bid.expirationTime = (0, $TBcmg$dayjs)().add(expirationOption.relativeTime, expirationOption.relativeTimeUnit).unix().toString();
            else bid.expirationTime = `${expirationOption.relativeTime}`;
        }
        if (oracleEnabled || conduitKey) bid.options = {
            [exchange.orderKind]: {
                useOffChainCancellation: oracleEnabled,
                conduitKey: conduitKey
            }
        };
        if (usePermit) bid.usePermit = true;
        if (quantity > 1) bid.quantity = quantity;
        if (options?.royaltyBps !== undefined) bid.royaltyBps = options.royaltyBps;
        setBidData(bid);
        client.actions.placeBid({
            chainId: rendererChain?.id,
            wallet: wallet,
            bids: [
                bid
            ],
            onProgress: (steps)=>{
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let incompleteStepItemIndex = null;
                let incompleteStepIndex = null;
                executableSteps.find((step, i)=>{
                    if (!step.items) return false;
                    incompleteStepItemIndex = step.items.findIndex((item)=>item.status == "incomplete");
                    if (incompleteStepItemIndex !== -1) {
                        incompleteStepIndex = i;
                        return true;
                    }
                });
                if (incompleteStepIndex !== null) setStepData({
                    totalSteps: stepCount,
                    stepProgress: incompleteStepIndex,
                    currentStep: executableSteps[incompleteStepIndex]
                });
                else setBidStep($2b3bdb31da73e768$export$7a92ddb9e11f37f7.Complete);
            }
        }).catch((e)=>{
            setTransactionError(e);
        });
    }, [
        config,
        tokenId,
        rendererChain,
        collectionId,
        currency,
        client,
        wallet,
        totalBidAmount,
        expirationOption,
        trait,
        quantity,
        feesBps,
        exchange,
        usePermit,
        conduitKey
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        token: token,
        collection: collection,
        attributes: attributes,
        usdPrice: usdPrice,
        balance: balance,
        wrappedBalance: wrappedBalance,
        wrappedContractName: wrappedContractName,
        wrappedContractAddress: wrappedContractAddress,
        convertLink: convertLink,
        canAutomaticallyConvert: canAutomaticallyConvert,
        bidAmountPerUnit: bidAmountPerUnit,
        totalBidAmount: totalBidAmount,
        quantity: quantity,
        setQuantity: setQuantity,
        bidData: bidData,
        totalBidAmountUsd: totalBidAmountUsd,
        bidStep: bidStep,
        loading: !collection || !reservoirMarketplace,
        hasEnoughNativeCurrency: hasEnoughNativeCurrency,
        hasEnoughWrappedCurrency: hasEnoughWrappedCurrency,
        hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport,
        traitBidSupported: traitBidSupported,
        collectionBidSupported: collectionBidSupported,
        partialBidSupported: partialBidSupported,
        biddingSupported: biddingSupported,
        amountToWrap: amountToWrap,
        transactionError: transactionError,
        expirationOption: expirationOption,
        expirationOptions: $2b3bdb31da73e768$var$expirationOptions,
        stepData: stepData,
        currencies: currencies || [
            defaultCurrency
        ],
        currency: currency,
        exchange: exchange,
        feeBps: feeBps,
        setCurrency: setCurrency,
        setBidStep: setBidStep,
        setBidAmountPerUnit: setBidAmountPerUnit,
        setExpirationOption: setExpirationOption,
        setTrait: setTrait,
        trait: trait,
        placeBid: placeBid
    }));
};





const $ea5a2f2758be6422$var$TokenInfo = ({ token: token, collection: collection, chain: chain, price: price, currency: currency, quantity: quantity, trait: trait, expirationOption: expirationOption, containerCss: containerCss })=>{
    const expirationDisplay = expirationOption?.value === "custom" && expirationOption.relativeTime ? (0, $2f4c390a81073897$export$2e2bcd8739ae039)(expirationOption.relativeTime) : `in ${expirationOption?.text.toLowerCase()}`;
    const floorAsk = token?.market?.floorAsk ?? collection?.floorAsk;
    const topBid = token?.market?.topBid ?? collection?.topBid;
    const tokenName = token?.token?.name ? token?.token?.name : `#${token?.token?.tokenId}`;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "start",
        justify: "between",
        direction: price ? "row" : "column",
        css: {
            p: "$4",
            gap: "$4",
            ...containerCss
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
        src: token?.token?.imageSmall || collection?.image,
        alt: token?.token?.name || collection?.name,
        css: {
            width: 56,
            height: 56,
            borderRadius: 4,
            aspectRatio: "1/1"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$1",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        ellipsify: true
    }, token ? tokenName : collection?.name), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, token ? collection?.name : null), chain && !expirationOption ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, token ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical"
    }) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain.id,
        height: 12
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, chain.name)) : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1"
        }
    }, trait ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            width: "max-content",
            backgroundColor: "$neutralBg",
            borderRadius: 4,
            py: "$1",
            px: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle",
        ellipsify: true
    }, trait?.key, ": ", trait?.value)) : null, quantity && quantity > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            width: "max-content",
            backgroundColor: "$neutralBg",
            borderRadius: 4,
            py: "$1",
            px: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle",
        ellipsify: true
    }, quantity, " items")) : null))), !price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$2",
            flexShrink: 0
        }
    }, floorAsk?.price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Floor Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: floorAsk?.price?.amount?.decimal,
        address: floorAsk?.price?.currency?.contract,
        symbol: floorAsk?.price?.currency?.symbol,
        decimals: floorAsk?.price?.currency?.decimals,
        textStyle: "subtitle2"
    })) : null, floorAsk?.price && topBid?.price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical",
        css: {
            display: "block"
        }
    }) : null, topBid?.price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Best Offer"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: topBid?.price?.amount?.decimal,
        address: topBid?.price?.currency?.contract,
        symbol: topBid?.price?.currency?.symbol,
        decimals: topBid?.price?.currency?.decimals,
        textStyle: "subtitle2"
    })) : null) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1",
            flexShrink: 0
        }
    }, price && currency ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: price,
        address: currency?.contract,
        symbol: currency?.symbol,
        textStyle: "h6"
    }) : null, expirationOption ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body2",
        color: "subtle"
    }, "Expires ", expirationDisplay) : null));
};
var $ea5a2f2758be6422$export$2e2bcd8739ae039 = $ea5a2f2758be6422$var$TokenInfo;











const $0f4eeb921315fd4d$var$Img = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {
    width: 56,
    height: 56,
    borderRadius: 4,
    objectFit: "cover",
    "& + img": {
        ml: -20
    }
});
const $0f4eeb921315fd4d$var$ProgressDot = (0, $4a58f4053e821189$export$3817b7a54a07cec7)((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
    borderRadius: "50%",
    width: 5,
    height: 5
});
const $0f4eeb921315fd4d$var$loadingStart = (0, $4a58f4053e821189$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    },
    "20%": {
        transform: "scale(1)",
        backgroundColor: "$accentText"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    }
});
const $0f4eeb921315fd4d$var$loadingMiddle = (0, $4a58f4053e821189$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    },
    "20%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    },
    "40%": {
        transform: "scale(1)",
        backgroundColor: "$accentText"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    }
});
const $0f4eeb921315fd4d$var$loadingEnd = (0, $4a58f4053e821189$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    },
    "40%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    },
    "60%": {
        transform: "scale(1)",
        backgroundColor: "$accentText"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$neutralSolid"
    }
});
const $0f4eeb921315fd4d$var$TransactionProgress = ({ fromImg: fromImg, toImgs: toImgs, ...props })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        ...props,
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($0f4eeb921315fd4d$var$Img, {
        src: fromImg
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1",
            mx: 23
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($0f4eeb921315fd4d$var$ProgressDot, {
        css: {
            animation: `${$0f4eeb921315fd4d$var$loadingStart} 1s ease-in-out infinite`
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement($0f4eeb921315fd4d$var$ProgressDot, {
        css: {
            animation: `${$0f4eeb921315fd4d$var$loadingMiddle} 1s ease-in-out infinite`
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement($0f4eeb921315fd4d$var$ProgressDot, {
        css: {
            animation: `${$0f4eeb921315fd4d$var$loadingEnd} 1s ease-in-out infinite`
        }
    })), toImgs.map((src, i)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($0f4eeb921315fd4d$var$Img, {
            key: i,
            src: src
        })));
};
var $0f4eeb921315fd4d$export$2e2bcd8739ae039 = $0f4eeb921315fd4d$var$TransactionProgress;









const $9340aeb7dd0cf09a$var$SCROLLBAR_SIZE = 10;
const $9340aeb7dd0cf09a$var$ScrollArea = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Root6, {
    height: 322,
    borderRadius: "$space$2",
    overflow: "hidden",
    boxShadow: `0 2px 10px $inputBackground`
});
const $9340aeb7dd0cf09a$var$ScrollAreaViewport = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Viewport1, {
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    borderRadius: "inherit"
});
const $9340aeb7dd0cf09a$var$ScrollAreaScrollbar = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Scrollbar, {
    display: "flex",
    // ensures no selection
    userSelect: "none",
    // disable browser handling of all panning and zooming gestures on touch devices
    touchAction: "none",
    padding: 2,
    background: "$inputBackground",
    transition: "background 160ms ease-out",
    "&:hover": {
        background: "$inputBackground"
    },
    '&[data-orientation="vertical"]': {
        width: $9340aeb7dd0cf09a$var$SCROLLBAR_SIZE
    },
    '&[data-orientation="horizontal"]': {
        flexDirection: "column",
        height: $9340aeb7dd0cf09a$var$SCROLLBAR_SIZE
    }
});
const $9340aeb7dd0cf09a$var$ScrollAreaThumb = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Thumb, {
    flex: 1,
    background: "$wellBackground",
    borderRadius: $9340aeb7dd0cf09a$var$SCROLLBAR_SIZE,
    // increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
    position: "relative",
    "&::before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        minWidth: 44,
        minHeight: 44
    }
});
const $9340aeb7dd0cf09a$var$ScrollAreaCorner = (0, $4a58f4053e821189$export$3817b7a54a07cec7)($TBcmg$Corner, {
    background: "$wellBackground"
});
const $9340aeb7dd0cf09a$var$RKScrollArea = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollArea, {
        ...props
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollAreaViewport, null, children), /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollAreaScrollbar, {
        orientation: "vertical"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollAreaThumb, null)), /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollAreaScrollbar, {
        orientation: "horizontal"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollAreaThumb, null)), /*#__PURE__*/ (0, $TBcmg$react).createElement($9340aeb7dd0cf09a$var$ScrollAreaCorner, null));
};
$9340aeb7dd0cf09a$var$RKScrollArea.Root = $9340aeb7dd0cf09a$var$ScrollArea;
$9340aeb7dd0cf09a$var$RKScrollArea.Viewport = $9340aeb7dd0cf09a$var$ScrollAreaViewport;
$9340aeb7dd0cf09a$var$RKScrollArea.Scrollbar = $9340aeb7dd0cf09a$var$ScrollAreaScrollbar;
$9340aeb7dd0cf09a$var$RKScrollArea.Thumb = $9340aeb7dd0cf09a$var$ScrollAreaThumb;
$9340aeb7dd0cf09a$var$RKScrollArea.Corner = $9340aeb7dd0cf09a$var$ScrollAreaCorner;
var $9340aeb7dd0cf09a$export$2e2bcd8739ae039 = $9340aeb7dd0cf09a$var$RKScrollArea;



const $f8d8cda59d836a2f$var$AttributeSelector = ({ attributes: attributes, chainId: chainId, setTrait: setTrait, setOpen: setOpen, tokenCount: tokenCount })=>{
    const [results, setResults] = (0, $TBcmg$useState)([]);
    const [query, setQuery] = (0, $TBcmg$useState)("");
    (0, $TBcmg$useEffect)(()=>{
        if (query === "") setResults(attributes);
        else {
            let results = [];
            attributes?.forEach((attribute)=>{
                const values = attribute.values?.filter(({ value: value })=>value.toLowerCase().includes(query.toLowerCase()));
                if (values && values.length > 0) results?.push({
                    ...attribute,
                    values: values
                });
            });
            setResults(results ? [
                ...results
            ] : []);
        }
    }, [
        query
    ]);
    if (!attributes) return null;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            width: "100%",
            maxWidth: 484,
            maxHeight: 250,
            "@bp1": {
                maxHeight: 500
            },
            zIndex: 1000,
            padding: "$4",
            overflowY: "auto",
            borderRadius: "$space$2",
            backgroundColor: "$contentBackground",
            border: "1px solid $borderColor"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5c0c2c3952297d70$export$2e2bcd8739ae039), {
        css: {
            marginBottom: "$4",
            padding: "$space$4 $space$4 $space$4 48px"
        },
        placeholder: "Filter attribute",
        value: query,
        onChange: (e)=>setQuery(e.target.value),
        iconCss: {
            top: "26px",
            color: "$neutralText"
        },
        icon: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faMagnifyingGlass),
            width: 16,
            height: 16
        })
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            borderBottom: "1px solid $borderColor",
            pb: "$2",
            mb: "$4",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "subtle",
        style: "subtitle3"
    }, "Trait"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "subtle",
        style: "subtitle3"
    }, "Floor")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9340aeb7dd0cf09a$export$2e2bcd8739ae039), {
        css: {
            width: "100%",
            minWidth: "80vw",
            "@bp1": {
                minWidth: 468
            }
        }
    }, results?.map(({ key: key, values: values })=>{
        if (values?.length === 0) return null;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            key: key,
            css: {
                gap: "$2",
                marginBottom: "$3",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2",
            color: "accent",
            as: "div"
        }, key), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                width: "100%"
            }
        }, values?.map(({ value: value, count: count, floorAskPrice: floorAskPrice })=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                key: value,
                justify: "between",
                align: "center",
                css: {
                    cursor: "pointer",
                    borderRadius: "$space$2",
                    width: "100%",
                    py: "$3",
                    backgroundColor: "$contentBackground",
                    transition: "background-color 0.25s ease-in-out",
                    "&:hover": {
                        backgroundColor: "$neutralBgHover"
                    }
                },
                as: "button",
                onClick: ()=>{
                    setTrait({
                        key: key,
                        value: value,
                        floorAskPrice: floorAskPrice?.amount?.decimal
                    });
                    setOpen(false);
                }
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                justify: "between",
                css: {
                    gap: "$2"
                }
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                ellipsify: true,
                style: "subtitle2"
            }, value), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "body2",
                color: "subtle"
            }, count && tokenCount ? `${Math.round(count / tokenCount * 100)}%` : "-")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                chainId: chainId,
                amount: floorAskPrice?.amount?.decimal,
                logoWidth: 10,
                maximumFractionDigits: 1,
                textStyle: "subtitle2",
                css: {
                    pr: "$4"
                }
            })))));
    })));
};
var $f8d8cda59d836a2f$export$2e2bcd8739ae039 = $f8d8cda59d836a2f$var$AttributeSelector;










const $587a01049d5141ff$var$ModalCopy = {
    titleSetPrice: "Make an Offer",
    titleConfirm: "Complete Offer",
    titleComplete: "Offer Submitted",
    ctaBidDisabled: "Enter a Price",
    ctaBid: "",
    ctaConvertManually: "Get ",
    ctaConvertAutomatically: "",
    ctaAwaitingApproval: "Waiting for Approval",
    ctaEditOffer: "Edit Offer",
    ctaRetry: "Retry",
    ctaViewOffers: "View Offers",
    ctaClose: "Close"
};
function $587a01049d5141ff$var$titleForStep(step, copy) {
    switch(step){
        case (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).SetPrice:
        case (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Unavailable:
            return copy.titleSetPrice;
        case (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Offering:
            return copy.titleConfirm;
        case (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Complete:
            return copy.titleComplete;
    }
}
const $587a01049d5141ff$var$MINIMUM_DATE = (0, $TBcmg$dayjs)().add(1, "h").format("MM/DD/YYYY h:mm A");
const $587a01049d5141ff$var$MAXIMUM_AMOUNT = Infinity;
function $587a01049d5141ff$export$556cfc4a654987bd({ openState: openState, trigger: trigger, tokenId: tokenId, chainId: chainId, collectionId: collectionId, attribute: attribute, conduitKey: conduitKey, normalizeRoyalties: normalizeRoyalties, currencies: currencies, oracleEnabled: oracleEnabled = false, copyOverrides: copyOverrides, feesBps: feesBps, orderKind: orderKind, walletClient: walletClient, usePermit: usePermit, onViewOffers: onViewOffers, onClose: onClose, onBidComplete: onBidComplete, onBidError: onBidError, onPointerDownOutside: onPointerDownOutside }) {
    const copy = {
        ...$587a01049d5141ff$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const datetimeElement = (0, $TBcmg$useRef)(null);
    const [stepTitle, setStepTitle] = (0, $TBcmg$useState)("");
    const [localMarketplace, setLocalMarketplace] = (0, $TBcmg$useState)(null);
    const [attributesSelectable, setAttributesSelectable] = (0, $TBcmg$useState)(false);
    (0, $TBcmg$useEffect)(()=>{
        setLocalMarketplace((0, $49ea92be0f1fc634$export$2e2bcd8739ae039)());
    }, []);
    const [attributeSelectorOpen, setAttributeSelectorOpen] = (0, $TBcmg$useState)(false);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2b3bdb31da73e768$export$89d91658eb2b6698), {
        open: open,
        orderKind: orderKind,
        chainId: modalChain?.id,
        tokenId: tokenId,
        collectionId: collectionId,
        attribute: attribute,
        conduitKey: conduitKey,
        normalizeRoyalties: normalizeRoyalties,
        oracleEnabled: oracleEnabled,
        currencies: currencies,
        feesBps: feesBps,
        walletClient: walletClient,
        usePermit: usePermit
    }, ({ token: token, collection: collection, attributes: attributes, bidStep: bidStep, expirationOption: expirationOption, expirationOptions: expirationOptions, wrappedBalance: wrappedBalance, wrappedContractName: wrappedContractName, wrappedContractAddress: wrappedContractAddress, bidAmountPerUnit: bidAmountPerUnit, totalBidAmount: totalBidAmount, totalBidAmountUsd: totalBidAmountUsd, quantity: quantity, setQuantity: setQuantity, hasEnoughNativeCurrency: hasEnoughNativeCurrency, hasEnoughWrappedCurrency: hasEnoughWrappedCurrency, hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport, loading: loading, traitBidSupported: traitBidSupported, collectionBidSupported: collectionBidSupported, partialBidSupported: partialBidSupported, amountToWrap: amountToWrap, balance: balance, convertLink: convertLink, canAutomaticallyConvert: canAutomaticallyConvert, transactionError: transactionError, stepData: stepData, bidData: bidData, currencies: currencies, currency: currency, exchange: exchange, setCurrency: setCurrency, setBidAmountPerUnit: setBidAmountPerUnit, setExpirationOption: setExpirationOption, setBidStep: setBidStep, setTrait: setTrait, trait: trait, placeBid: placeBid })=>{
        const [expirationDate, setExpirationDate] = (0, $TBcmg$useState)("");
        const tokenCount = collection?.tokenCount ? +collection.tokenCount : undefined;
        const itemImage = token && token.token?.imageSmall ? token.token?.imageSmall : collection?.image;
        const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
        const quantityEnabled = partialBidSupported && (!tokenId || token?.token?.kind === "erc1155" && Number(token?.token?.supply) > 1);
        (0, $TBcmg$useEffect)(()=>{
            if (stepData) switch(stepData.currentStep.kind){
                case "signature":
                    setStepTitle("Confirm Offer");
                    break;
                default:
                    setStepTitle(stepData.currentStep.action);
                    break;
            }
        }, [
            stepData
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (expirationOption && expirationOption.relativeTime) {
                const newExpirationTime = expirationOption.relativeTimeUnit ? (0, $TBcmg$dayjs)().add(expirationOption.relativeTime, expirationOption.relativeTimeUnit) : (0, $TBcmg$dayjs).unix(expirationOption.relativeTime);
                setExpirationDate(newExpirationTime.format("MM/DD/YYYY h:mm A"));
            } else setExpirationDate("");
        }, [
            expirationOption
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (bidStep === (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Complete && onBidComplete) {
                const data = {
                    tokenId: tokenId,
                    collectionId: collectionId,
                    bidData: bidData
                };
                onBidComplete(data);
            }
        }, [
            bidStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onBidError) {
                const data = {
                    tokenId: tokenId,
                    collectionId: collectionId,
                    bidData: bidData
                };
                onBidError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (open && attributes && !tokenId && attribute) setTrait(attribute);
            else setTrait(undefined);
            if (open && attributes && !tokenId) {
                let attributeCount = 0;
                for(let i = 0; i < attributes.length; i++){
                    attributeCount += attributes[i].attributeCount || 0;
                    if (attributeCount >= 2000) break;
                }
                if (attributeCount >= 2000) setAttributesSelectable(false);
                else setAttributesSelectable(true);
            } else setAttributesSelectable(false);
        }, [
            open,
            attributes
        ]);
        const ctaButtonText = copy.ctaBid.length > 0 ? copy.ctaBid : token && token.token ? "Make an Offer" : trait ? "Make an Attribute Offer" : "Make a Collection Offer";
        const minimumAmount = exchange?.minPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.minPriceRaw), currency?.decimals || 18)) : (0, $2b3bdb31da73e768$export$1d1be26767be2a74);
        const minimumAmountRaw = (0, $TBcmg$parseUnits)(`${minimumAmount}`, currency?.decimals ?? 18);
        const maximumAmount = exchange?.maxPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.maxPriceRaw), currency?.decimals || 18)) : $587a01049d5141ff$var$MAXIMUM_AMOUNT;
        const maximumAmountRaw = maximumAmount !== Infinity ? (0, $TBcmg$parseUnits)(`${maximumAmount}`, currency?.decimals ?? 18) : null;
        const withinPricingBounds = totalBidAmount !== 0n && (maximumAmountRaw ? totalBidAmount <= maximumAmountRaw : true) && totalBidAmount >= minimumAmountRaw;
        const canPurchase = bidAmountPerUnit !== "" && withinPricingBounds;
        const topBidPrice = token?.market?.topBid?.price ?? collection?.topBid?.price;
        const decimalTopBidPrice = topBidPrice?.amount?.decimal;
        const nativeTopBidPrice = topBidPrice?.amount?.native;
        const usdTopBidPrice = topBidPrice?.amount?.usd;
        const defaultCurrency = currencies?.find((currency)=>currency?.contract === (0, $TBcmg$zeroAddress));
        const topOfferButtonEnabled = currency?.contract?.toLowerCase() === topBidPrice?.currency?.contract?.toLowerCase() && decimalTopBidPrice || currency?.symbol === "USDC" && usdTopBidPrice || nativeTopBidPrice && currency?.contract === (0, $TBcmg$zeroAddress) || nativeTopBidPrice && defaultCurrency;
        const handleSetBestOffer = ()=>{
            // If currency matches top bid currency, use decimal floor price
            if (currency?.contract?.toLowerCase() === topBidPrice?.currency?.contract?.toLowerCase() && decimalTopBidPrice) setBidAmountPerUnit(decimalTopBidPrice.toString());
            else if (currency?.symbol === "USDC" && usdTopBidPrice) setBidAmountPerUnit(usdTopBidPrice?.toString());
            else if (nativeTopBidPrice) {
                // If currency is native currency, use native floor price
                if (currency?.contract === (0, $TBcmg$zeroAddress)) setBidAmountPerUnit(nativeTopBidPrice.toString());
                else if (defaultCurrency) {
                    setCurrency(defaultCurrency);
                    setBidAmountPerUnit(nativeTopBidPrice.toString());
                }
            }
        };
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: $587a01049d5141ff$var$titleForStep(bidStep, copy),
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        tokenId: tokenId,
                        collectionId: collectionId,
                        bidData: bidData
                    };
                    onClose(data, stepData, bidStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (e.target instanceof Element && datetimeElement.current?.flatpickr?.calendarContainer && datetimeElement.current.flatpickr.calendarContainer.contains(e.target)) e.preventDefault();
                if (onPointerDownOutside) onPointerDownOutside(e);
            },
            onFocusCapture: (e)=>{
                e.stopPropagation();
            }
        }, bidStep === (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).SetPrice && !loading && collection && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ea5a2f2758be6422$export$2e2bcd8739ae039), {
            chain: modalChain,
            token: token ? token : undefined,
            collection: collection,
            containerCss: {
                borderBottom: "1px solid",
                borderBottomColor: "$neutralLine",
                borderColor: "$neutralLine"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4",
                gap: 24,
                overflow: "hidden"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            css: {
                gap: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Offer Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: (0, $602940fa56061b3b$export$2e2bcd8739ae039),
            css: {
                gap: "$1"
            },
            align: "center",
            style: "subtitle3"
        }, "Balance:", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bf67ac886f7190ba$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            logoWidth: 10,
            textStyle: "tiny",
            amount: wrappedBalance?.[0],
            address: wrappedContractAddress,
            decimals: wrappedBalance?.[1],
            symbol: wrappedBalance?.[2]
        }), " ")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mt: "$2",
                gap: quantityEnabled ? "$2" : 20
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: (0, $602940fa56061b3b$export$2e2bcd8739ae039),
            css: {
                gap: "$2",
                flexShrink: 0
            },
            align: "center",
            style: "body1",
            color: "subtle"
        }, currency && currencies.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $09a27344989ccc4f$export$e7345cb65e28db6f), {
            chainId: modalChain?.id,
            currency: currency,
            currencies: currencies,
            setCurrency: setCurrency,
            triggerCss: {
                backgroundColor: "$neutralBgHover",
                borderRadius: 8,
                p: "$3",
                width: 120,
                flexShrink: 0,
                height: 44
            }
        }) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            css: {
                height: 20
            },
            address: wrappedContractAddress
        }), wrappedContractName)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5c0c2c3952297d70$export$2e2bcd8739ae039), {
            type: "number",
            value: bidAmountPerUnit,
            onChange: (e)=>{
                setBidAmountPerUnit(e.target.value);
            },
            placeholder: "Enter price",
            containerCss: {
                width: "100%"
            },
            css: {
                textAlign: "center",
                "@bp1": {
                    textAlign: "left"
                }
            }
        }), topOfferButtonEnabled ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "secondary",
            size: "none",
            css: {
                height: 44,
                px: "$4",
                borderRadius: 8,
                fontWeight: 500,
                flexShrink: 0
            },
            onClick: handleSetBestOffer
        }, "Best Offer") : null), totalBidAmount !== 0n && !withinPricingBounds && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "error"
        }, maximumAmount !== Infinity ? `Amount must be between ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount, 6)} - ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(maximumAmount)}` : `Amount must be higher than ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount, 6)}`)), attributes && attributes.length > 0 && (attributesSelectable || trait) && !tokenId && traitBidSupported && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Root, {
            open: attributeSelectorOpen,
            onOpenChange: attributesSelectable ? setAttributeSelectorOpen : undefined
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Trigger, {
            asChild: true
        }, trait ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $822ff51685ab152b$export$2e2bcd8739ae039), {
            css: {
                py: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            css: {
                gap: "$2",
                alignItems: "center",
                color: "$neutralText"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                maxWidth: 385,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            color: "accent",
            style: "subtitle1"
        }, trait?.key, ":", " "), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle1"
        }, trait?.value)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                alignItems: "center",
                gap: "$2"
            }
        }, trait?.floorAskPrice && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                flex: "none"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            amount: trait?.floorAskPrice,
            maximumFractionDigits: 2,
            logoWidth: 11,
            textStyle: "body1"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            style: {
                cursor: "pointer"
            },
            onClick: (e)=>{
                e.preventDefault();
                setTrait(undefined);
            },
            icon: (0, $TBcmg$faClose),
            width: 16,
            height: 16
        })))) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "ghost",
            css: {
                color: "$accentText",
                fontWeight: 500,
                fontSize: 14,
                maxWidth: "max-content"
            },
            size: "none"
        }, "+ Add Attribute")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Content, {
            side: "bottom",
            align: "start",
            sideOffset: -20,
            style: {
                maxWidth: "100vw"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f8d8cda59d836a2f$export$2e2bcd8739ae039), {
            attributes: attributes,
            tokenCount: tokenCount,
            setTrait: setTrait,
            setOpen: setAttributeSelectorOpen
        }))))), quantityEnabled ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$5",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "start",
            css: {
                gap: "$2",
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            color: "subtle",
            style: "body3",
            css: {
                display: "none",
                "@bp1": {
                    display: "block"
                }
            }
        }, "Offers can be accepted separately")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
            quantity: quantity,
            setQuantity: setQuantity,
            min: 1,
            max: 999999,
            css: {
                justifyContent: "space-between",
                width: "100%"
            }
        })) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: (0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039),
            style: "subtitle2"
        }, "Expiration Date"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039), {
            css: {
                flex: 1,
                "@bp1": {
                    width: 160,
                    flexDirection: "row"
                }
            },
            value: expirationOption?.text || "",
            onValueChange: (value)=>{
                const option = expirationOptions.find((option)=>option.value == value);
                if (option) setExpirationOption(option);
            }
        }, expirationOptions.filter(({ value: value })=>value !== "custom").map((option)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Item, {
                key: option.text,
                value: option.value
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).ItemText, null, option.text)))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b31bbf36f2fe9ca4$export$2e2bcd8739ae039), {
            ref: datetimeElement,
            icon: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
                icon: (0, $TBcmg$faCalendar),
                width: 14,
                height: 16
            }),
            value: expirationDate,
            options: {
                chainId: modalChain?.id,
                minDate: $587a01049d5141ff$var$MINIMUM_DATE,
                enableTime: true,
                minuteIncrement: 1
            },
            defaultValue: expirationDate,
            onChange: (e)=>{
                if (Array.isArray(e)) {
                    const customOption = expirationOptions.find((option)=>option.value === "custom");
                    if (customOption) setExpirationOption({
                        ...customOption,
                        relativeTime: e[0] / 1000
                    });
                }
            },
            containerCss: {
                width: 46,
                "@bp1": {
                    flex: 1,
                    width: "100%"
                }
            },
            css: {
                padding: 0,
                "@bp1": {
                    padding: "12px 16px 12px 48px"
                }
            }
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Total Offer Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "end"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bf67ac886f7190ba$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            logoWidth: 16,
            textStyle: "h6",
            amount: totalBidAmount,
            address: currency?.contract,
            decimals: currency?.decimals,
            symbol: currency?.symbol
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            amount: totalBidAmountUsd
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                mt: "auto"
            }
        }, oracleEnabled && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                mb: 10,
                textAlign: "center",
                width: "100%",
                display: "block"
            }
        }, "You can change or cancel your offer for free on", " ", localMarketplace?.title, "."), !canPurchase && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                width: "100%"
            }
        }, copy.ctaBidDisabled), canPurchase && hasEnoughWrappedCurrency && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>placeBid(),
            css: {
                width: "100%"
            }
        }, ctaButtonText), canPurchase && !hasEnoughWrappedCurrency && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, !hasEnoughNativeCurrency && !hasAuxiliaryFundsSupport && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$2",
                mt: 10
            },
            justify: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "error"
        }, balance?.symbol || "ETH", " Balance"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            amount: balance?.value,
            symbol: balance?.symbol
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$2",
                mt: 10,
                overflow: "hidden",
                flexDirection: "column-reverse",
                "@bp1": {
                    flexDirection: "row"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: providerOptionsContext.disableJumperLink,
            css: {
                flex: "1 0 auto"
            },
            color: "secondary",
            onClick: ()=>{
                window.open(convertLink, "_blank");
            }
        }, providerOptionsContext.disableJumperLink ? ctaButtonText : currency?.symbol ? copy.ctaConvertManually + currency?.symbol : "Convert Manually"), canAutomaticallyConvert && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                flex: 1,
                maxHeight: 44
            },
            disabled: !hasEnoughNativeCurrency && !hasAuxiliaryFundsSupport,
            onClick: ()=>placeBid()
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            color: "button",
            ellipsify: true
        }, copy.ctaConvertAutomatically.length > 0 ? copy.ctaConvertAutomatically : `Convert ${amountToWrap} ${balance?.symbol || "ETH"} for me`))))))), bidStep === (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Offering && collection && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ea5a2f2758be6422$export$2e2bcd8739ae039), {
            chain: modalChain,
            token: token ? token : undefined,
            collection: collection,
            price: totalBidAmount,
            currency: currency,
            quantity: quantity,
            trait: trait,
            expirationOption: expirationOption,
            containerCss: {
                borderBottom: "1px solid",
                borderBottomColor: "$neutralLine",
                borderColor: "$neutralLine"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4",
                gap: 24
            }
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError,
            css: {
                width: "100%"
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center"
            },
            style: "subtitle1"
        }, stepTitle), stepData.currentStep.kind === "signature" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0f4eeb921315fd4d$export$2e2bcd8739ae039), {
            justify: "center",
            fromImg: itemImage || "",
            toImgs: [
                localMarketplace?.icon || ""
            ]
        }), stepData.currentStep.kind !== "signature" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                background: "$neutralLine",
                borderRadius: 8
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            css: {
                height: 56,
                width: 56
            },
            address: wrappedContractAddress
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center",
                mt: 24,
                maxWidth: 395,
                mx: "auto",
                mb: "$4"
            },
            style: "body2",
            color: "subtle"
        }, stepData?.currentStep.description)), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                height: "100%",
                py: "$5"
            },
            justify: "center",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null)), !transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                mt: "auto"
            },
            disabled: true
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.ctaAwaitingApproval), transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mt: "auto",
                gap: 10,
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "secondary",
            css: {
                flex: 1
            },
            onClick: ()=>setBidStep((0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).SetPrice)
        }, copy.ctaEditOffer), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                flex: 1
            },
            onClick: ()=>placeBid()
        }, copy.ctaRetry)))), bidStep === (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$successAccent",
                mt: 48
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCheckCircle),
            style: {
                width: "32px",
                height: "32px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                textAlign: "center",
                mt: 36,
                mb: 80
            }
        }, "Offer Submitted!"), onViewOffers ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>{
                onViewOffers();
            }
        }, copy.ctaViewOffers) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>{
                setOpen(false);
            }
        }, copy.ctaClose)), bidStep === (0, $2b3bdb31da73e768$export$7a92ddb9e11f37f7).Unavailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4",
                gap: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid",
                mt: 48
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faHand),
            style: {
                width: "32px",
                height: "32px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                maxWidth: 350,
                mb: "$3",
                textAlign: "center"
            }
        }, !collectionBidSupported ? "This collection does not support placing a collection offer." : "Oops, this collection does not support bidding."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>{
                setOpen(false);
            }
        }, copy.ctaClose)));
    });
}
$587a01049d5141ff$export$556cfc4a654987bd.Custom = (0, $2b3bdb31da73e768$export$89d91658eb2b6698);



















var $be959054ceb8cef7$export$f4dd52ca63b5fdde;
(function(AcceptBidStep) {
    AcceptBidStep[AcceptBidStep["Checkout"] = 0] = "Checkout";
    AcceptBidStep[AcceptBidStep["Auth"] = 1] = "Auth";
    AcceptBidStep[AcceptBidStep["ApproveMarketplace"] = 2] = "ApproveMarketplace";
    AcceptBidStep[AcceptBidStep["Finalizing"] = 3] = "Finalizing";
    AcceptBidStep[AcceptBidStep["Complete"] = 4] = "Complete";
    AcceptBidStep[AcceptBidStep["Unavailable"] = 5] = "Unavailable";
    AcceptBidStep[AcceptBidStep["TokenSwap"] = 6] = "TokenSwap";
})($be959054ceb8cef7$export$f4dd52ca63b5fdde || ($be959054ceb8cef7$export$f4dd52ca63b5fdde = {}));
const $be959054ceb8cef7$export$2d08bd3f57775802 = ({ open: open, tokens: tokens, chainId: chainId, normalizeRoyalties: normalizeRoyalties, children: children, walletClient: walletClient, feesOnTopBps: feesOnTopBps, feesOnTopCustom: feesOnTopCustom, currency: currency })=>{
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [prices, setPrices] = (0, $TBcmg$useState)([]);
    const [acceptBidStep, setAcceptBidStep] = (0, $TBcmg$useState)($be959054ceb8cef7$export$f4dd52ca63b5fdde.Checkout);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [txHash, setTxHash] = (0, $TBcmg$useState)(null);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWallet;
    const blockExplorerBaseUrl = wagmiChain?.blockExplorers?.default?.url || "https://etherscan.io";
    const [isFetchingBidPath, setIsFetchingBidPath] = (0, $TBcmg$useState)(false);
    const [bidsPath, setBidsPath] = (0, $TBcmg$useState)(null);
    const [feesOnTop, setFeesOnTop] = (0, $TBcmg$useState)(null);
    const _tokenIds = tokens.map((token)=>{
        const contract = (token?.collectionId || "").split(":")[0];
        return `${contract}:${token.tokenId}`;
    });
    const { data: tokensData, mutate: mutateTokens, isValidating: isFetchingTokenData } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && _tokenIds && _tokenIds.length > 0 && {
        tokens: _tokenIds,
        normalizeRoyalties: normalizeRoyalties
    }, {
        revalidateFirstPage: true
    }, rendererChain?.id);
    const enhancedTokens = (0, $TBcmg$useMemo)(()=>{
        const tokensDataMap = tokensData.reduce((map, data)=>{
            map[`${data.token?.contract}:${data.token?.tokenId}`] = data;
            return map;
        }, {});
        const tokensBidPathMap = bidsPath?.reduce((map, path)=>{
            const key = `${path.contract}:${path.tokenId}`;
            const mapPath = map[key];
            if (!mapPath) map[key] = [
                path
            ];
            else mapPath.push(path);
            return map;
        }, {}) || {};
        return tokens.reduce((enhancedTokens, token)=>{
            const contract = token.collectionId.split(":")[0];
            const dataMapKey = `${contract}:${token.tokenId}`;
            const tokenData = tokensDataMap[dataMapKey];
            const bidIds = token.bidIds?.filter((bidId)=>bidId.length > 0) || [];
            const bidsPath = tokensBidPathMap[dataMapKey] ? tokensBidPathMap[dataMapKey] : [];
            if (!bidIds.length) enhancedTokens.push({
                ...token,
                bidIds: tokenData?.market?.topBid?.id ? [
                    tokenData.market.topBid.id
                ] : [],
                tokenData: tokenData,
                bidsPath: bidsPath
            });
            else enhancedTokens.push({
                ...token,
                bidIds: token.bidIds || [],
                tokenData: tokenData,
                bidsPath: bidsPath
            });
            return enhancedTokens;
        }, []);
    }, [
        tokensData,
        tokens,
        bidsPath
    ]);
    const bidTokenMap = (0, $TBcmg$useMemo)(()=>enhancedTokens.reduce((map, token)=>{
            token.bidIds.forEach((bidId)=>{
                map[bidId] = token;
            });
            return map;
        }, {}), [
        enhancedTokens
    ]);
    const fetchBidsPath = (0, $TBcmg$useCallback)((tokens)=>{
        if (!wallet || !client) {
            setIsFetchingBidPath(false);
            return;
        }
        setIsFetchingBidPath(true);
        let options = {
            onlyPath: true,
            ...currency && {
                currency: currency
            },
            partial: true
        };
        if (normalizeRoyalties !== undefined) options.normalizeRoyalties = normalizeRoyalties;
        const items = tokens?.reduce((items, token)=>{
            if (tokens) {
                const contract = token.collectionId.split(":")[0];
                const bids = token.bidIds ? token.bidIds.filter((bid)=>bid.length > 0) : [];
                if (bids && bids.length > 0) bids.forEach((bidId)=>{
                    items.push({
                        orderId: bidId,
                        token: `${contract}:${token.tokenId}`
                    });
                });
                else items.push({
                    token: `${contract}:${token.tokenId}`
                });
            }
            return items;
        }, []);
        const acceptOfferParams = {
            chainId: rendererChain?.id,
            items: items,
            wallet: wallet,
            options: options,
            precheck: true,
            onProgress: ()=>{}
        };
        client.actions.acceptOffer(acceptOfferParams).then((data)=>{
            if (feesOnTopBps || feesOnTopCustom) {
                const bidsPath = "path" in data ? data["path"] : null;
                if (bidsPath) {
                    let feesOnTop = [];
                    if (feesOnTopBps) {
                        const total = bidsPath.reduce((total, path)=>{
                            return total += BigInt(path.totalRawPrice || 0n);
                        }, 0n);
                        feesOnTop = feesOnTopBps.map((feeOnTop)=>{
                            const [recipient, fee] = feeOnTop.split(":");
                            return `${recipient}:${(0, $TBcmg$formatUnits)(BigInt(fee) * total / 10000n, 0)}`;
                        });
                    } else if (feesOnTopCustom) feesOnTop = feesOnTopCustom(bidsPath) || [];
                    if (feesOnTop) {
                        acceptOfferParams.options.feesOnTop = feesOnTop;
                        setFeesOnTop(feesOnTop);
                    }
                    return client.actions.acceptOffer(acceptOfferParams);
                }
            } else return data;
        }).then((data)=>{
            setBidsPath("path" in data ? data["path"] : null);
        }).finally(()=>{
            setIsFetchingBidPath(false);
        });
    }, [
        currency,
        client,
        wallet,
        rendererChain,
        normalizeRoyalties,
        feesOnTopBps,
        feesOnTopCustom
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (open) fetchBidsPath(tokens);
    }, [
        client,
        tokens,
        open
    ]);
    const currencySymbols = (0, $TBcmg$useMemo)(()=>Array.from(enhancedTokens.reduce((symbols, { bidsPath: bidsPath })=>{
            bidsPath.forEach(({ sellOutCurrencySymbol: sellOutCurrencySymbol, currencySymbol: currencySymbol })=>{
                if (sellOutCurrencySymbol) symbols.add(sellOutCurrencySymbol);
                if (currencySymbol) symbols.add(currencySymbol);
            });
            return symbols;
        }, new Set())).join(","), [
        enhancedTokens
    ]);
    const conversions = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open && currencySymbols.length > 0 ? "USD" : undefined, currencySymbols);
    const usdPrices = (0, $TBcmg$useMemo)(()=>conversions.reduce((map, price)=>{
            map[price.symbol] = price;
            return map;
        }, {}), [
        conversions
    ]);
    const acceptBid = (0, $TBcmg$useCallback)(async ()=>{
        setTransactionError(null);
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!bidsPath) {
            const error = new Error("Missing bids to accept");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            setTransactionError(null);
            throw error;
        }
        let options = {
            partial: true,
            ...currency && {
                currency: currency
            }
        };
        if (normalizeRoyalties !== undefined) options.normalizeRoyalties = normalizeRoyalties;
        if (feesOnTop) options.feesOnTop = feesOnTop;
        setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.ApproveMarketplace);
        const items = bidsPath.map(({ orderId: orderId, tokenId: tokenId, contract: contract })=>({
                orderId: orderId,
                token: `${contract}:${tokenId}`
            }));
        const expectedPrice = {};
        for(let currency in prices)expectedPrice[currency] = {
            amount: prices[currency].netAmount,
            raw: (0, $TBcmg$parseUnits)(`${prices[currency].netAmount}`, prices[currency].currency.decimals || 18),
            currencyAddress: prices[currency].currency.contract,
            currencyDecimals: prices[currency].currency.decimals || 18
        };
        let hasError = false;
        client.actions.acceptOffer({
            chainId: rendererChain?.id,
            expectedPrice: expectedPrice,
            wallet: wallet,
            items: items,
            onProgress: (steps, path)=>{
                if (!steps || hasError) return;
                setBidsPath(path);
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                let currentStepIndex = 0;
                executableSteps.find((step, index)=>{
                    currentStepIndex = index;
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) {
                    setStepData({
                        totalSteps: stepCount,
                        currentStep: currentStep,
                        currentStepItem: currentStepItem,
                        steps: steps
                    });
                    if (currentStep.id === "auth") setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Auth);
                    else if (currentStep.id === "nft-approval") setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.ApproveMarketplace);
                    else if (currentStep.id === "sale") {
                        if (currentStep.items?.every((item)=>item.txHashes !== undefined)) setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Finalizing);
                        else setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.ApproveMarketplace);
                    } else if (currentStep.id === "swap") setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.TokenSwap);
                } else if (executableSteps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) {
                    setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Complete);
                    const lastStepItem = currentStep.items ? currentStep.items[currentStep.items?.length - 1] : undefined;
                    if (lastStepItem) setStepData({
                        totalSteps: stepCount,
                        steps: steps,
                        currentStep: currentStep,
                        currentStepItem: lastStepItem
                    });
                }
            },
            options: options
        }).catch((e)=>{
            hasError = true;
            setTransactionError(e);
            setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Checkout);
            setStepData(null);
            fetchBidsPath(tokens);
            mutateTokens();
        });
    }, [
        currency,
        config,
        bidsPath,
        bidTokenMap,
        rendererChain,
        client,
        wallet,
        prices,
        feesOnTop,
        mutateTokens
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (bidsPath && bidsPath.length > 0) {
            const prices = bidsPath.reduce((map, { quote: quote, sellOutCurrency: sellOutCurrency, sellOutCurrencyDecimals: sellOutCurrencyDecimals, sellOutCurrencySymbol: sellOutCurrencySymbol, sellOutQuote: sellOutQuote, sellOutRawQuote: sellOutRawQuote, currency: currency, currencyDecimals: currencyDecimals, currencySymbol: currencySymbol, builtInFees: builtInFees, feesOnTop: feesOnTop, totalPrice: totalPrice })=>{
                const netAmount = sellOutQuote || quote || 0;
                const amount = totalPrice || 0;
                let royalty = 0;
                let marketplaceFee = 0;
                let referralFee = 0;
                if (sellOutCurrency && sellOutCurrencySymbol) {
                    builtInFees?.forEach((fee)=>{
                        switch(fee.kind){
                            case "marketplace":
                                marketplaceFee += fee.amount || 0;
                                break;
                            case "royalty":
                                royalty += fee.amount || 0;
                                break;
                        }
                    });
                    feesOnTop?.forEach((fee)=>{
                        switch(fee.kind){
                            case "royalty":
                                royalty += fee.amount || 0;
                                break;
                            case "marketplace":
                            default:
                                referralFee += fee.amount || 0;
                                break;
                        }
                    });
                    if (!map[sellOutCurrencySymbol]) map[sellOutCurrencySymbol] = {
                        netAmount: netAmount - referralFee,
                        amount: amount,
                        currency: {
                            contract: sellOutCurrency,
                            symbol: sellOutCurrencySymbol,
                            decimals: currencyDecimals
                        },
                        royalty: royalty,
                        marketplaceFee: marketplaceFee,
                        feesOnTop: referralFee
                    };
                    else if (map[sellOutCurrencySymbol]) {
                        map[sellOutCurrencySymbol].netAmount += netAmount - referralFee;
                        map[sellOutCurrencySymbol].amount += amount;
                        map[sellOutCurrencySymbol].royalty += royalty;
                        map[sellOutCurrencySymbol].marketplaceFee += marketplaceFee;
                        map[sellOutCurrencySymbol].feesOnTop += referralFee;
                    }
                } else if (currency && currencySymbol) {
                    builtInFees?.forEach((fee)=>{
                        switch(fee.kind){
                            case "marketplace":
                                marketplaceFee += fee.amount || 0;
                                break;
                            case "royalty":
                                royalty += fee.amount || 0;
                                break;
                        }
                    });
                    feesOnTop?.forEach((fee)=>{
                        switch(fee.kind){
                            case "royalty":
                                royalty += fee.amount || 0;
                                break;
                            case "marketplace":
                            default:
                                referralFee += fee.amount || 0;
                                break;
                        }
                    });
                    if (!map[currencySymbol]) map[currencySymbol] = {
                        netAmount: netAmount - referralFee,
                        amount: amount,
                        currency: {
                            contract: currency,
                            symbol: currencySymbol,
                            decimals: currencyDecimals
                        },
                        royalty: royalty,
                        marketplaceFee: marketplaceFee,
                        feesOnTop: referralFee
                    };
                    else if (map[currencySymbol]) {
                        map[currencySymbol].netAmount += netAmount - referralFee;
                        map[currencySymbol].amount += amount;
                        map[currencySymbol].royalty += royalty;
                        map[currencySymbol].marketplaceFee += marketplaceFee;
                        map[currencySymbol].feesOnTop += referralFee;
                    }
                }
                return map;
            }, {});
            setPrices(Object.values(prices));
            if (acceptBidStep === $be959054ceb8cef7$export$f4dd52ca63b5fdde.Unavailable) setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Checkout);
        } else if (!isFetchingBidPath) {
            setPrices([]);
            setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Unavailable);
        }
    }, [
        client,
        bidsPath,
        isFetchingBidPath
    ]);
    const swapCurrency = (0, $TBcmg$useMemo)(()=>{
        const bidPath = bidsPath?.[0];
        if (bidPath && bidPath.sellOutCurrency) return {
            contract: bidPath.sellOutCurrency,
            decimals: bidPath.sellOutCurrencyDecimals,
            symbol: bidPath.sellOutCurrencySymbol
        };
        else return null;
    }, [
        bidsPath,
        currency
    ]);
    const { address: address } = (0, $TBcmg$useAccount)();
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setAcceptBidStep($be959054ceb8cef7$export$f4dd52ca63b5fdde.Checkout);
            setTxHash(null);
            setStepData(null);
            setTransactionError(null);
        }
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "acceptBidModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        swapCurrency: swapCurrency,
        loading: isFetchingBidPath || isFetchingTokenData,
        tokensData: enhancedTokens,
        acceptBidStep: acceptBidStep,
        transactionError: transactionError,
        txHash: txHash,
        usdPrices: usdPrices,
        prices: prices,
        address: address,
        blockExplorerBaseUrl: blockExplorerBaseUrl,
        acceptBid: acceptBid,
        setAcceptBidStep: setAcceptBidStep,
        stepData: stepData
    }));
};






const $200c3b96aa855ca1$var$Img = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {
    height: 56,
    width: 56
});
const $200c3b96aa855ca1$var$AcceptBidLineItem = ({ img: img, token: token, collection: collection, chainId: chainId, sourceImg: sourceImg, price: price, netAmount: netAmount, fees: fees, currency: currency, decimals: decimals })=>{
    const royaltiesBps = fees?.reduce((total, fee)=>{
        if (fee?.kind === "royalty") total += fee?.bps || 0;
        return total;
    }, 0);
    const isUnavailable = !price;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            p: "$4",
            borderBottom: "1px solid $borderColor",
            gap: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($200c3b96aa855ca1$var$Img, {
        src: img,
        alt: "Token Image",
        css: {
            borderRadius: 4,
            overflow: "hidden",
            visibility: !img || img.length === 0 ? "hidden" : "visible",
            flexShrink: 0,
            objectFit: "cover",
            filter: isUnavailable ? "grayscale(1)" : "unset"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "start",
        justify: "center",
        css: {
            gap: 2,
            mr: "auto"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        color: isUnavailable ? "subtle" : "base"
    }, token.name || `#${token.id}`), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: isUnavailable ? "subtle" : "base"
    }, collection?.name), royaltiesBps ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle"
    }, "Creator Royalties: ", royaltiesBps / 100, "%") : null), isUnavailable ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "error",
        style: "body3",
        css: {
            display: "flex",
            alignItems: "center",
            flexShrink: 0
        }
    }, "Offer no longer available") : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $656b4c95fe3d553c$export$2e2bcd8739ae039), {
        side: "left",
        content: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$1"
            },
            justify: "between"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3"
        }, "Total Offer Value"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: chainId,
            amount: price,
            address: currency,
            decimals: decimals,
            textStyle: "subtitle3"
        })), fees?.map((fee, i)=>{
            let feeName = "Misc Fee";
            switch(fee.kind){
                case "marketplace":
                    feeName = "Marketplace Fee";
                    break;
                case "royalty":
                    feeName = "Creator Royalties";
                    break;
            }
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                justify: "between",
                key: i
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "body3",
                color: "subtle",
                css: {
                    mr: "$1"
                }
            }, feeName), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "body3",
                color: "subtle",
                css: {
                    ml: "auto"
                }
            }, "-"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                chainId: chainId,
                amount: fee.amount,
                address: currency,
                decimals: decimals,
                textStyle: "subtitle3"
            }));
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            css: {
                gap: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3"
        }, "You Get"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: chainId,
            amount: netAmount,
            address: currency,
            decimals: decimals,
            textStyle: "subtitle3"
        })))
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        justify: "center",
        css: {
            gap: "$1",
            ml: "auto",
            height: "100%"
        }
    }, sourceImg && /*#__PURE__*/ (0, $TBcmg$react).createElement($200c3b96aa855ca1$var$Img, {
        src: sourceImg,
        css: {
            height: 16,
            width: 16
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: chainId,
        amount: price,
        address: currency,
        decimals: decimals,
        textStyle: "subtitle3"
    }))));
};
var $200c3b96aa855ca1$export$2e2bcd8739ae039 = $200c3b96aa855ca1$var$AcceptBidLineItem;










const $257531ce0e45ad5e$export$45aa975411b5e199 = ({ title: title, isInProgress: isInProgress, isComplete: isComplete, children: children, open: open, css: css, onOpenChange: onOpenChange })=>{
    (0, $TBcmg$useEffect)(()=>{
        if (isComplete) onOpenChange(false);
    }, [
        isComplete
    ]);
    let backgroundColor = "transparent";
    let borderColor = "$neutralLine";
    if (isComplete) {
        backgroundColor = "$green6";
        borderColor = "$green9";
    } else if (isInProgress) {
        backgroundColor = "$accentSolid";
        borderColor = "$accentLine";
    }
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1e2f6c55518d39c3$export$2ad57374564f8390), {
        open: open,
        onOpenChange: onOpenChange,
        css: {
            backgroundColor: "$gray3",
            ...css
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Trigger3, {
        asChild: true
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        css: {
            p: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            width: 18,
            height: 18,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderStyle: "solid",
            borderWidth: 4,
            borderRadius: 999
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        css: {
            color: isComplete ? "$neutralText" : "$textColor"
        }
    }, title)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralSolid",
            transform: open ? "rotate(180deg)" : "rotate(0)",
            transition: ".3s"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faChevronDown)
    })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1e2f6c55518d39c3$export$aadde00976f34151), null, children));
};



var $9051fde5e764f5e2$export$2e2bcd8739ae039 = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("div", {
    display: "grid",
    variants: {
        align: {
            start: {
                alignItems: "start"
            },
            center: {
                alignItems: "center"
            },
            end: {
                alignItems: "end"
            },
            stretch: {
                alignItems: "stretch"
            },
            baseline: {
                alignItems: "baseline"
            }
        },
        justify: {
            start: {
                justifyContent: "start"
            },
            center: {
                justifyContent: "center"
            },
            end: {
                justifyContent: "end"
            },
            between: {
                justifyContent: "space-between"
            }
        },
        flow: {
            row: {
                gridAutoFlow: "row"
            },
            column: {
                gridAutoFlow: "column"
            },
            dense: {
                gridAutoFlow: "dense"
            },
            rowDense: {
                gridAutoFlow: "row dense"
            },
            columnDense: {
                gridAutoFlow: "column dense"
            }
        }
    }
});





const $33f57f7d3eb24b91$var$StyledImg = (0, $TBcmg$styled)((0, $94585ecf38154231$export$2e2bcd8739ae039), {
    width: 24,
    height: 24,
    borderRadius: 4
});
const $33f57f7d3eb24b91$var$Spinner = ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
        css: {
            display: "flex",
            alignItems: "center"
        },
        icon: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                color: "$accentSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCircleNotch),
            width: 16,
            height: 16
        }))
    });
const $33f57f7d3eb24b91$export$9db3c5389236a920 = ({ step: step, tokensData: tokensData, chain: chain, open: open, isCurrentStep: isCurrentStep })=>{
    const [collapsibleOpen, setCollapsibleOpen] = (0, $TBcmg$useState)(false);
    const isComplete = step && step.items?.every((item)=>item?.status == "complete") ? true : false;
    (0, $TBcmg$useEffect)(()=>{
        if (open !== undefined && open !== collapsibleOpen) setCollapsibleOpen(open);
    }, [
        open
    ]);
    const pathMap = (0, $TBcmg$useMemo)(()=>tokensData.reduce((paths, tokenData)=>{
            tokenData.bidsPath.forEach((bidPath)=>{
                if (bidPath.orderId) paths[bidPath.orderId] = bidPath;
            });
            return paths;
        }, {}), [
        tokensData
    ]);
    const tokensMap = (0, $TBcmg$useMemo)(()=>tokensData.reduce((map, tokenData)=>{
            const contract = (tokenData?.collectionId || "").split(":")[0];
            map[`${contract}:${tokenData.tokenId}`] = tokenData;
            return map;
        }, {}), []);
    if (step.id !== "sale" && step.id !== "nft-approval") return null;
    const title = step.id === "sale" ? "Confirm Sale" : "Approve Collections";
    const disabled = !step.items || !step.items.length;
    const baseApiUrl = chain?.baseApiUrl;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $257531ce0e45ad5e$export$45aa975411b5e199), {
        title: title,
        open: disabled ? false : collapsibleOpen,
        onOpenChange: disabled ? ()=>{} : setCollapsibleOpen,
        isInProgress: isCurrentStep,
        isComplete: isComplete,
        css: {
            margin: 12
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9051fde5e764f5e2$export$2e2bcd8739ae039), {
        css: {
            px: "$4",
            pb: "$2",
            gridTemplateColumns: "auto 1fr 16px",
            gridRowGap: 24
        }
    }, step?.items?.map((item, i)=>{
        const paths = item.orderIds?.map((id)=>pathMap[id]) || [];
        const marketplaces = Array.from(paths.reduce((marketplaces, path)=>{
            if (path.source) marketplaces.add(path.source);
            return marketplaces;
        }, new Set())).join(",");
        if (step.id === "sale") {
            const images = paths.reduce((images, path)=>{
                const tokenKey = `${path?.contract}:${path?.tokenId}`;
                const tokenData = tokensMap[tokenKey]?.tokenData;
                const image = tokenData?.token?.imageSmall || baseApiUrl ? `${baseApiUrl}/redirect/tokens/${tokenKey}/image/v1?imageSize=small` : null;
                if (image && images.length < 4) images.push(image);
                return images;
            }, []);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, {
                key: i
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                css: {
                    mr: "$2"
                }
            }, images.map((image, i)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($33f57f7d3eb24b91$var$StyledImg, {
                    key: i,
                    src: image,
                    css: {
                        marginLeft: i > 0 ? -14 : 0
                    }
                }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "body2",
                color: "subtle",
                css: {
                    display: "flex",
                    alignItems: "center"
                }
            }, "Confirm sale of ", paths.length, " ", paths.length > 1 ? "items" : "item", " on", " ", marketplaces.length > 0 ? marketplaces : "exchange"), isCurrentStep ? /*#__PURE__*/ (0, $TBcmg$react).createElement($33f57f7d3eb24b91$var$Spinner, null) : null);
        } else {
            const path = paths.length > 0 ? paths[0] : null;
            const tokenKey = `${path?.contract}:${path?.tokenId}`;
            const collection = tokensMap[tokenKey]?.tokenData?.token?.collection;
            const collectionName = collection?.name || "Collection";
            const collectionImage = collection?.image || baseApiUrl ? `${baseApiUrl}/redirect/collections/${path?.contract}/image/v1` : "";
            const sourceImages = paths.map((path)=>`${baseApiUrl}/redirect/sources/${path.source}/logo/v2`);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, {
                key: i
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                css: {
                    mr: "$2"
                }
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement($33f57f7d3eb24b91$var$StyledImg, {
                src: collectionImage
            }), sourceImages.map((src, i)=>/*#__PURE__*/ (0, $TBcmg$react).createElement($33f57f7d3eb24b91$var$StyledImg, {
                    key: i,
                    src: src,
                    css: {
                        marginLeft: -14
                    }
                }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "body2",
                color: "subtle",
                css: {
                    display: "flex",
                    alignItems: "center"
                }
            }, "Approve ", collectionName, " for", " ", marketplaces.length > 0 ? marketplaces : "trading"), isCurrentStep ? /*#__PURE__*/ (0, $TBcmg$react).createElement($33f57f7d3eb24b91$var$Spinner, null) : null);
        }
    })));
};






const $ece9f53dc41fb378$var$Img = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {
    height: 56,
    width: 56,
    borderRadius: 4,
    overflow: "hidden",
    flexShrink: 0,
    objectFit: "cover"
});
const $ece9f53dc41fb378$var$AcceptBidSummaryLineItem = ({ tokensData: tokensData, prices: prices, usdPrices: usdPrices, chain: chain })=>{
    const imgs = (0, $TBcmg$useMemo)(()=>{
        if (!tokensData || tokensData.length <= 0) return [];
        const imgs = [];
        const baseApiUrl = chain?.baseApiUrl;
        for(var i = 0; i < tokensData.length; i++){
            const token = tokensData[i];
            const contract = (token?.collectionId || "").split(":")[0];
            const tokenId = `${contract}:${token?.tokenId}`;
            if (token?.tokenData?.token?.imageSmall || baseApiUrl) imgs.push(`${baseApiUrl}/redirect/tokens/${tokenId}/image/v1?imageSize=small`);
            if (imgs.length > 2) break;
        }
        return imgs;
    }, [
        tokensData,
        chain
    ]);
    const itemCount = (0, $TBcmg$useMemo)(()=>tokensData.reduce((total, tokenData)=>{
            tokenData.bidsPath.forEach((path)=>{
                total += path.quantity || 0;
            });
            return total;
        }, 0), [
        tokensData
    ]);
    const usdPrice = (0, $TBcmg$useMemo)(()=>{
        let missingConversion = false;
        const totalUsd = prices.reduce((total, { amount: amount, currency: currency })=>{
            const conversion = usdPrices[currency.symbol];
            if (conversion) total += conversion.price * amount;
            else missingConversion = true;
            return total;
        }, 0);
        return missingConversion ? 0 : totalUsd;
    }, [
        prices,
        usdPrices
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            p: "$4",
            borderBottom: "1px solid $borderColor",
            gap: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "subtle",
        style: "subtitle3"
    }, "Item"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "subtle",
        style: "subtitle3"
    }, "You Get")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            mr: "$4",
            position: "relative"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($ece9f53dc41fb378$var$Img, {
        src: imgs[0],
        alt: "Token Image",
        css: {
            visibility: !imgs[0] ? "hidden" : "visible",
            mr: itemCount > 1 && imgs[1] ? 8 : 0
        }
    }), itemCount > 1 && imgs[1] ? /*#__PURE__*/ (0, $TBcmg$react).createElement($ece9f53dc41fb378$var$Img, {
        src: imgs[1],
        alt: "Token Image",
        css: {
            position: "absolute",
            right: -5,
            zIndex: -1,
            opacity: 0.5
        }
    }) : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, itemCount, " ", itemCount > 1 ? "Items" : "Item"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "end",
        justify: "end",
        direction: "column",
        css: {
            ml: "auto",
            gap: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center"
    }, prices.map(({ netAmount: netAmount, currency: currency }, i)=>{
        return /*#__PURE__*/ (0, $TBcmg$react).createElement("span", {
            key: i
        }, i > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            color: "subtle",
            style: "subtitle3",
            css: {
                mx: "$1"
            }
        }, "+") : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: chain?.id,
            amount: netAmount,
            address: currency.contract,
            decimals: currency.decimals,
            textStyle: "h6",
            logoWidth: 19
        }));
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdPrice,
        style: "tiny",
        color: "subtle"
    }))));
};
var $ece9f53dc41fb378$export$2e2bcd8739ae039 = $ece9f53dc41fb378$var$AcceptBidSummaryLineItem;




const $d8c34b3c598b5433$var$ModalCopy = {
    title: "Accept Offer",
    ctaAccept: "Accept",
    ctaAwaitingApproval: "Waiting for Approval",
    ctaClose: "Close",
    ctaDone: "Done"
};
function $d8c34b3c598b5433$export$91ee3fa7c9f4e6c2({ openState: openState, trigger: trigger, chainId: chainId, tokens: tokens, normalizeRoyalties: normalizeRoyalties, copyOverrides: copyOverrides, walletClient: walletClient, feesOnTopBps: feesOnTopBps, feesOnTopCustom: feesOnTopCustom, onBidAccepted: onBidAccepted, onClose: onClose, onBidAcceptError: onBidAcceptError, onCurrentStepUpdate: onCurrentStepUpdate, onPointerDownOutside: onPointerDownOutside, currency: currency }) {
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const copy = {
        ...$d8c34b3c598b5433$var$ModalCopy,
        ...copyOverrides
    };
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const baseApiUrl = currentChain?.baseApiUrl;
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $be959054ceb8cef7$export$2d08bd3f57775802), {
        currency: currency,
        open: open,
        chainId: modalChain?.id,
        tokens: tokens,
        normalizeRoyalties: normalizeRoyalties,
        walletClient: walletClient,
        feesOnTopBps: feesOnTopBps,
        feesOnTopCustom: feesOnTopCustom
    }, ({ loading: loading, acceptBidStep: acceptBidStep, transactionError: transactionError, txHash: txHash, usdPrices: usdPrices, prices: prices, tokensData: tokensData, swapCurrency: swapCurrency, address: address, stepData: stepData, acceptBid: acceptBid })=>{
        (0, $TBcmg$useEffect)(()=>{
            if (acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).Complete && onBidAccepted) {
                const data = {
                    tokens: tokensData,
                    maker: address
                };
                if (txHash) data.txHash = txHash;
                onBidAccepted(data);
            }
        }, [
            acceptBidStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onBidAcceptError) {
                const data = {
                    tokens: tokensData,
                    maker: address
                };
                onBidAcceptError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (stepData && onCurrentStepUpdate) onCurrentStepUpdate(stepData);
        }, [
            stepData
        ]);
        const bidCount = (0, $TBcmg$useMemo)(()=>tokensData.reduce((total, tokenData)=>total += tokenData.bidsPath.length, 0), [
            tokensData
        ]);
        const saleStep = stepData?.steps.find((step)=>step.id === "sale");
        const swapStep = stepData?.steps.find((step)=>step.id === "swap");
        const transfersTxHashes = saleStep?.items?.reduce((txHashes, item)=>{
            item.transfersData?.forEach((transferData)=>{
                if (transferData.txHash) txHashes.add(transferData.txHash);
            });
            return txHashes;
        }, new Set()) || [];
        const totalSales = Array.from(transfersTxHashes).length;
        const failedSales = totalSales - (saleStep?.items?.length || 0);
        const successfulSales = totalSales - failedSales;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.title,
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        tokens: tokensData,
                        maker: address
                    };
                    onClose(data, stepData, acceptBidStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (onPointerDownOutside) onPointerDownOutside(e);
            }
        }, acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).Unavailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4",
                gap: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid",
                mt: 48
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faEnvelopeOpen),
            style: {
                height: 32,
                width: 32
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                mb: "$3",
                textAlign: "center"
            }
        }, tokens.length > 1 ? "Offers are " : "Offer is ", " no longer available"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>setOpen(false),
            css: {
                width: "100%"
            }
        }, copy.ctaClose)), acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).Checkout && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                px: "$4",
                pt: "$4"
            },
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle"
        }, `${bidCount} ${bidCount > 1 ? "Items" : "Item"}`), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
            direction: "vertical",
            css: {
                maxHeight: 12
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            height: 12,
            css: {
                mr: 5
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle"
        }, modalChain?.name)), tokensData.map(({ tokenData: tokenData, bidsPath: bidsPath }, i)=>{
            if (!bidsPath || !bidsPath.length) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $200c3b96aa855ca1$export$2e2bcd8739ae039), {
                chainId: modalChain?.id,
                key: i,
                token: {
                    name: tokenData?.token?.name || "",
                    id: tokenData?.token?.tokenId || ""
                },
                collection: {
                    id: tokenData?.token?.collection?.id || "",
                    name: tokenData?.token?.collection?.name || ""
                },
                img: tokenData?.token?.imageSmall || tokenData?.token?.collection?.image || ""
            });
            else return bidsPath.map((bidPath)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $200c3b96aa855ca1$export$2e2bcd8739ae039), {
                    key: i,
                    chainId: modalChain?.id,
                    token: {
                        name: tokenData?.token?.name || "",
                        id: tokenData?.token?.tokenId || ""
                    },
                    collection: {
                        id: tokenData?.token?.collection?.id || "",
                        name: tokenData?.token?.collection?.name || ""
                    },
                    img: tokenData?.token?.imageSmall || tokenData?.token?.collection?.image || "",
                    netAmount: bidPath.quote,
                    price: bidPath.totalPrice,
                    fees: bidPath.builtInFees,
                    currency: swapCurrency?.contract || bidPath.currency,
                    decimals: swapCurrency?.decimals || bidPath.currencyDecimals,
                    sourceImg: bidPath.source ? `${baseApiUrl}/redirect/sources/${bidPath.source}/logo/v2` : ""
                }));
        }), prices.map((price, i)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1e2f6c55518d39c3$export$6eb0f7ddcda6131f), {
                key: i,
                trigger: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                    justify: "between",
                    css: {
                        p: "$4"
                    }
                }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                    style: "h6"
                }, price.currency?.symbol, " You Get", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                    css: {
                        color: "$neutralSolidHover",
                        ml: "$2"
                    }
                }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
                    icon: (0, $TBcmg$faChevronDown),
                    width: 16,
                    height: 16
                }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                    direction: "column",
                    css: {
                        gap: "$1"
                    }
                }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                    chainId: modalChain?.id,
                    amount: price.netAmount,
                    decimals: price.currency?.decimals,
                    address: price.currency?.contract,
                    symbol: price.currency?.symbol,
                    textStyle: "h6"
                }), price.currency?.symbol && usdPrices[price.currency.symbol] ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
                    color: "subtle",
                    style: "tiny",
                    amount: usdPrices[price.currency.symbol].price * price.netAmount,
                    css: {
                        textAlign: "end"
                    }
                }) : null))
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                css: {
                    gap: "$2",
                    padding: "$4",
                    paddingTop: 0
                },
                direction: "column"
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                justify: "between"
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "subtitle3",
                color: "subtle"
            }, "Total ", price.currency?.symbol, " Offer Value"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                chainId: modalChain?.id,
                amount: price.amount,
                decimals: price.currency?.decimals,
                address: price.currency?.contract,
                symbol: price.currency?.symbol,
                textStyle: "subtitle3"
            })), price.royalty > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                justify: "between"
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "subtitle3",
                color: "subtle"
            }, "Creator Royalties"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                css: {
                    ml: "auto"
                },
                style: "subtitle3",
                color: "subtle"
            }, "-"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                chainId: modalChain?.id,
                amount: price.royalty,
                decimals: price.currency?.decimals,
                address: price.currency?.contract,
                symbol: price.currency?.symbol,
                textStyle: "subtitle3"
            })) : null, price.marketplaceFee > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                justify: "between"
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "subtitle3",
                color: "subtle"
            }, "Marketplace Fee"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                css: {
                    ml: "auto"
                },
                style: "subtitle3",
                color: "subtle"
            }, "-"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                chainId: modalChain?.id,
                amount: price.marketplaceFee,
                decimals: price.currency?.decimals,
                address: price.currency?.contract,
                symbol: price.currency?.symbol,
                textStyle: "subtitle3"
            })) : null, price.feesOnTop > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                justify: "between"
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "subtitle3",
                color: "subtle"
            }, "Referral Fee"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                css: {
                    ml: "auto"
                },
                style: "subtitle3",
                color: "subtle"
            }, "-"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
                chainId: modalChain?.id,
                amount: price.feesOnTop,
                decimals: price.currency?.decimals,
                address: price.currency?.contract,
                symbol: price.currency?.symbol,
                textStyle: "subtitle3"
            })) : null))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                flex: 1,
                m: "$4"
            },
            color: "primary",
            onClick: acceptBid
        }, copy.ctaAccept)), acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).Auth && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ece9f53dc41fb378$export$2e2bcd8739ae039), {
            tokensData: tokensData,
            usdPrices: usdPrices,
            prices: prices,
            chain: modalChain
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d6ae44a4b381214a$export$2e2bcd8739ae039), {
            css: {
                mt: 48,
                mb: 60,
                gap: 20
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.ctaAwaitingApproval)), acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).ApproveMarketplace && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ece9f53dc41fb378$export$2e2bcd8739ae039), {
            tokensData: tokensData,
            usdPrices: usdPrices,
            prices: prices,
            chain: modalChain
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                m: "$4",
                textAlign: "center"
            }
        }, "Confirm Selling"), stepData?.steps.map((step)=>step?.items && step.items.length > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $33f57f7d3eb24b91$export$9db3c5389236a920), {
                key: step.id,
                step: step,
                tokensData: tokensData,
                chain: modalChain,
                isCurrentStep: stepData.currentStep.id === step.id,
                open: stepData.currentStep.id === step.id
            }) : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.ctaAwaitingApproval)), acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).TokenSwap && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4",
                gap: 24
            }
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError,
            css: {
                width: "100%"
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, stepData.currentStep.action), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                background: "$neutralLine",
                borderRadius: 8
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            css: {
                height: 56,
                width: 56
            },
            address: swapCurrency?.contract
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center",
                mt: 24,
                maxWidth: 395,
                mx: "auto",
                mb: "$4"
            },
            style: "body2",
            color: "subtle"
        }, stepData?.currentStep.description)), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                height: "100%",
                py: "$5"
            },
            justify: "center",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null)), !transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                mt: "auto"
            },
            disabled: true
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.ctaAwaitingApproval))), acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).Finalizing && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                gap: "$4",
                pb: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ece9f53dc41fb378$export$2e2bcd8739ae039), {
            tokensData: tokensData,
            usdPrices: usdPrices,
            prices: prices,
            chain: modalChain
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Finalizing on blockchain"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            css: {
                textAlign: "center",
                px: "$4"
            }
        }, "You can close this modal while it finalizes on the blockchain. The transaction will continue in the background."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$2",
                mb: "$3",
                width: "100%"
            }
        }, [
            ...swapStep?.items ?? [],
            ...saleStep?.items ?? []
        ].map((item, itemIndex)=>{
            if (Array.isArray(item?.txHashes) && item?.txHashes.length > 0) return item.txHashes.map((hash, txHashIndex)=>{
                const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
                const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
                return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                    key: `${itemIndex}-${txHashIndex}`,
                    href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                    color: "primary",
                    weight: "medium",
                    target: "_blank",
                    css: {
                        fontSize: 12
                    }
                }, "View transaction: ", truncatedTxHash);
            });
            else return null;
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid",
                width: 32,
                height: 32,
                m: "0 auto"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCube),
            style: {
                width: 32,
                height: 32
            }
        }))), acceptBidStep === (0, $be959054ceb8cef7$export$f4dd52ca63b5fdde).Complete && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                py: "$5",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: failedSales ? "$errorAccent" : "$successAccent"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: failedSales ? (0, $TBcmg$faCircleExclamation) : (0, $TBcmg$faCircleCheck),
            fontSize: 32
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                my: 24
            }
        }, failedSales ? `${successfulSales} ${successfulSales > 1 ? "items" : "item"} sold, ${failedSales} ${failedSales > 1 ? "items" : "item"} failed` : `${totalSales > 1 ? "Offers" : "Offer"} accepted!`), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                mb: "$3"
            }
        }, [
            ...swapStep?.items ?? [],
            ...saleStep?.items ?? []
        ]?.map((item, itemIndex)=>{
            if (Array.isArray(item?.txHashes) && item?.txHashes.length > 0) return item.txHashes.map((hash, txHashIndex)=>{
                const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
                const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
                return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                    key: `${itemIndex}-${txHashIndex}`,
                    href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                    color: "primary",
                    weight: "medium",
                    target: "_blank",
                    css: {
                        fontSize: 12
                    }
                }, "View transaction: ", truncatedTxHash);
            });
            else return null;
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                flexDirection: "column",
                gap: "$3",
                "@bp1": {
                    flexDirection: "row"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>{
                setOpen(false);
            }
        }, copy.ctaDone))));
    });
}
$d8c34b3c598b5433$export$91ee3fa7c9f4e6c2.Custom = (0, $be959054ceb8cef7$export$2d08bd3f57775802);












var $03948d0d1ea50134$export$c5c5c857eaef0fde;
(function(CancelStep) {
    CancelStep[CancelStep["Cancel"] = 0] = "Cancel";
    CancelStep[CancelStep["Approving"] = 1] = "Approving";
    CancelStep[CancelStep["Complete"] = 2] = "Complete";
})($03948d0d1ea50134$export$c5c5c857eaef0fde || ($03948d0d1ea50134$export$c5c5c857eaef0fde = {}));
const $03948d0d1ea50134$export$d2f670ba420b64c2 = ({ open: open, chainId: chainId, bidId: bidId, normalizeRoyalties: normalizeRoyalties, children: children, walletClient: walletClient })=>{
    const [cancelStep, setCancelStep] = (0, $TBcmg$useState)($03948d0d1ea50134$export$c5c5c857eaef0fde.Cancel);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [steps, setSteps] = (0, $TBcmg$useState)(null);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const { address: address } = (0, $TBcmg$useAccount)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWallet;
    const blockExplorerBaseUrl = wagmiChain?.blockExplorers?.default.url || "https://etherscan.io";
    const blockExplorerName = wagmiChain?.blockExplorers?.default?.name || "Etherscan";
    const { data: bids, isFetchingPage: isFetchingPage } = (0, $739a88828d18ea96$export$2e2bcd8739ae039)(address, {
        ids: bidId,
        normalizeRoyalties: normalizeRoyalties,
        includeCriteriaMetadata: true,
        includeRawData: true
    }, {
        revalidateFirstPage: true
    }, open && bidId ? true : false, rendererChain?.id);
    const bid = bids && bids[0] ? bids[0] : undefined;
    const currency = bid?.price?.currency;
    const coinConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open && bid ? "USD" : undefined, currency?.symbol);
    const usdPrice = coinConversion.length > 0 ? coinConversion[0].price : 0;
    const totalUsd = usdPrice * (bid?.price?.amount?.decimal || 0);
    const cancelOrder = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!bidId) {
            const error = new Error("Missing bid id to cancel");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        setCancelStep($03948d0d1ea50134$export$c5c5c857eaef0fde.Approving);
        client.actions.cancelOrder({
            chainId: rendererChain?.id,
            ids: [
                bidId
            ],
            wallet: wallet,
            onProgress: (steps)=>{
                if (!steps) return;
                setSteps(steps);
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem
                });
                else if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setCancelStep($03948d0d1ea50134$export$c5c5c857eaef0fde.Complete);
            }
        }).catch((error)=>{
            setTransactionError(error);
            setCancelStep($03948d0d1ea50134$export$c5c5c857eaef0fde.Cancel);
            setStepData(null);
            setSteps(null);
        });
    }, [
        bidId,
        client,
        rendererChain,
        wallet,
        config
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setCancelStep($03948d0d1ea50134$export$c5c5c857eaef0fde.Cancel);
            setTransactionError(null);
            setStepData(null);
            setSteps(null);
        }
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "cancelBidModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    let tokenId;
    if (bid?.criteria?.kind === "token") tokenId = bid?.tokenSetId?.split(":")[2];
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: isFetchingPage !== undefined ? isFetchingPage : true,
        bid: bid,
        tokenId: tokenId,
        cancelStep: cancelStep,
        transactionError: transactionError,
        usdPrice: usdPrice,
        totalUsd: totalUsd,
        blockExplorerName: blockExplorerName,
        blockExplorerBaseUrl: blockExplorerBaseUrl,
        steps: steps,
        stepData: stepData,
        setCancelStep: setCancelStep,
        cancelOrder: cancelOrder
    }));
};







const $6a7867ba1ffb99fc$var$Img = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {
    height: 56,
    width: 56
});
const $6a7867ba1ffb99fc$var$TokenPrimitive = ({ img: img, name: name, chain: chain, collection: collection, currencyContract: currencyContract, currencyDecimals: currencyDecimals, currencySymbol: currencySymbol, expires: expires, warning: warning, source: source, usdPrice: usdPrice, price: price, isUnavailable: isUnavailable, priceSubtitle: priceSubtitle, royaltiesBps: royaltiesBps, quantity: quantity })=>{
    const royaltyPercent = royaltiesBps ? royaltiesBps / 100 : royaltiesBps;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle",
        css: {
            mb: 10,
            display: "block"
        }
    }, name ? "Item" : "Collection"), priceSubtitle && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle",
        css: {
            mb: 10,
            display: "block"
        }
    }, priceSubtitle)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            alignItems: "center",
            gap: 8
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($6a7867ba1ffb99fc$var$Img, {
        src: img,
        alt: name,
        css: {
            borderRadius: 4,
            overflow: "hidden",
            visibility: !img || img.length === 0 ? "hidden" : "visible",
            flexShrink: 0,
            objectFit: "cover"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9051fde5e764f5e2$export$2e2bcd8739ae039), {
        css: {
            rowGap: 2
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$2",
            mr: "$4",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        ellipsify: true,
        color: isUnavailable ? "subtle" : "base"
    }, name ? name : collection), expires && quantity && quantity > 1 && !name ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain?.id,
        height: 12,
        css: {
            mr: 5
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        color: "subtle"
    }, chain?.name)) : null, expires && quantity && quantity > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            p: "$1 ",
            background: "$neutralBgHover",
            borderRadius: 4,
            mr: "auto"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        color: "base",
        css: {
            minWidth: "max-content"
        }
    }, quantity, " items")) : null), !name && !quantity && expires ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain?.id,
        height: 12,
        css: {
            mr: 5
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle"
    }, chain?.name)) : null, name && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            maxWidth: "370px"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        ellipsify: true,
        style: "body3",
        color: "subtle"
    }, collection), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain?.id,
        css: {
            mr: 5
        },
        height: 12
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle"
    }, chain?.name)), !!expires && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        color: "subtle",
        css: {
            color: "$neutralText"
        }
    }, "Expires ", expires), !expires && quantity && quantity > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            p: "$1 ",
            background: "$neutralBgHover",
            borderRadius: 4,
            mr: "auto"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        color: "base"
    }, quantity, " ", quantity > 1 ? "items" : "item")) : null, !expires && !quantity && royaltiesBps ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle",
        css: {
            display: "flex",
            gap: "$1"
        }
    }, "Creator Royalties: ", royaltyPercent, "%", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a813136de1d75d50$export$2e2bcd8739ae039), {
        side: "right",
        width: 200,
        content: "A fee on every order that goes to the collection creator."
    })) : null)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $9051fde5e764f5e2$export$2e2bcd8739ae039), {
        css: {
            justifyItems: "end",
            alignContent: "start",
            rowGap: 4
        }
    }, source && /*#__PURE__*/ (0, $TBcmg$react).createElement($6a7867ba1ffb99fc$var$Img, {
        src: source,
        alt: "Source Icon",
        css: {
            w: 17,
            h: 17,
            borderRadius: 99999,
            overflow: "hidden"
        }
    }), price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        amount: price,
        chainId: chain?.id,
        textColor: isUnavailable ? "subtle" : "base",
        address: currencyContract,
        decimals: currencyDecimals,
        symbol: currencySymbol,
        logoWidth: 14.5
    }) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: isUnavailable ? "subtle" : "base"
    }, "--"), usdPrice ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdPrice,
        style: "tiny",
        color: "subtle"
    }) : null, warning && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "error"
    }, warning))));
};
var $6a7867ba1ffb99fc$export$2e2bcd8739ae039 = $6a7867ba1ffb99fc$var$TokenPrimitive;







const $140a00430df0958e$var$ModalCopy = {
    title: "Cancel Offer",
    ctaCancel: "Continue to Cancel",
    ctaAwaitingApproval: "Waiting for approval...",
    ctaAwaitingValidation: "Waiting for transaction to be validated",
    ctaClose: "Close"
};
function $140a00430df0958e$export$89d1e00b7fa831db({ openState: openState, bidId: bidId, chainId: chainId, trigger: trigger, normalizeRoyalties: normalizeRoyalties, copyOverrides: copyOverrides, walletClient: walletClient, onClose: onClose, onCancelComplete: onCancelComplete, onCancelError: onCancelError, onPointerDownOutside: onPointerDownOutside }) {
    const copy = {
        ...$140a00430df0958e$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $03948d0d1ea50134$export$d2f670ba420b64c2), {
        chainId: modalChain?.id,
        bidId: bidId,
        open: open,
        normalizeRoyalties: normalizeRoyalties,
        walletClient: walletClient
    }, ({ loading: loading, bid: bid, tokenId: tokenId, cancelStep: cancelStep, transactionError: transactionError, stepData: stepData, totalUsd: totalUsd, blockExplorerName: blockExplorerName, cancelOrder: cancelOrder })=>{
        const expires = (0, $2f4c390a81073897$export$2e2bcd8739ae039)(bid?.expiration);
        const collectionId = bid?.criteria?.data?.collection?.id;
        const bidImg = tokenId ? `${modalChain?.baseApiUrl}/redirect/tokens/${collectionId}:${tokenId}/image/v1?imageSize=small` : `${modalChain?.baseApiUrl}/redirect/collections/${collectionId}/image/v1`;
        const isAttributeOffer = bid?.criteria?.kind === "attribute";
        (0, $TBcmg$useEffect)(()=>{
            if (cancelStep === (0, $03948d0d1ea50134$export$c5c5c857eaef0fde).Complete && onCancelComplete) {
                const data = {
                    bid: bid,
                    stepData: stepData
                };
                onCancelComplete(data);
            }
        }, [
            cancelStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onCancelError) {
                const data = {
                    bid: bid,
                    stepData: stepData
                };
                onCancelError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const isBidAvailable = bid && (bid.status === "active" || bid.status === "inactive") && !loading;
        const isOracleOrder = bid?.isNativeOffChainCancellable;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.title,
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        bid: bid,
                        stepData: stepData
                    };
                    onClose(data, cancelStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (onPointerDownOutside) onPointerDownOutside(e);
            }
        }, !isBidAvailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                px: "$4",
                py: "$6"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Selected bid is no longer available")), isBidAvailable && cancelStep === (0, $03948d0d1ea50134$export$c5c5c857eaef0fde).Cancel && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $borderColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6a7867ba1ffb99fc$export$2e2bcd8739ae039), {
            chain: modalChain,
            img: bidImg,
            name: bid?.criteria?.data?.token?.name,
            price: bid?.price?.amount?.decimal,
            usdPrice: totalUsd,
            collection: bid?.criteria?.data?.collection?.name || "",
            currencyContract: bid?.price?.currency?.contract,
            currencyDecimals: bid?.price?.currency?.decimals,
            currencySymbol: bid?.price?.currency?.symbol,
            expires: expires,
            source: bid?.source?.icon || "",
            priceSubtitle: "Offer"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                mt: "$3",
                mr: "$3",
                ml: "$3",
                textAlign: "center"
            }
        }, !isOracleOrder ? "This action will cancel your offer. You will be prompted to confirm this cancellation from your wallet. A gas fee is required." : "This will cancel your offer for free. You will be prompted to confirm this cancellation from your wallet."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: cancelOrder,
            css: {
                m: "$4"
            }
        }, !isOracleOrder && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faGasPump),
            width: "16",
            height: "16"
        }), copy.ctaCancel)), cancelStep === (0, $03948d0d1ea50134$export$c5c5c857eaef0fde).Approving && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $borderColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6a7867ba1ffb99fc$export$2e2bcd8739ae039), {
            chain: modalChain,
            img: bidImg,
            name: bid?.criteria?.data?.token?.name,
            price: bid?.price?.amount?.decimal,
            usdPrice: totalUsd,
            collection: bid?.criteria?.data?.collection?.name || "",
            currencyContract: bid?.price?.currency?.contract,
            currencyDecimals: bid?.price?.currency?.decimals,
            currencySymbol: bid?.price?.currency?.symbol,
            expires: expires,
            source: bid?.source?.icon || "",
            priceSubtitle: "Offer"
        })), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
            css: {
                height: 206
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e92d8c2581b5f9df$export$2e2bcd8739ae039), {
            title: stepData?.currentStepItem.txHashes ? "Finalizing on blockchain" : "Confirm cancelation in your wallet",
            txHashes: stepData?.currentStepItem.txHashes
        }), isAttributeOffer && !stepData?.currentStepItem.txHashes && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                maxWidth: 400,
                textAlign: "center",
                mx: "$3"
            }
        }, "This will cancel your offer on all items that were included in this attribute offer."))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), stepData?.currentStepItem.txHashes ? copy.ctaAwaitingValidation : copy.ctaAwaitingApproval)), cancelStep === (0, $03948d0d1ea50134$export$c5c5c857eaef0fde).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                py: "$5",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                mb: "$2"
            }
        }, "Offer Canceled!"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                mb: 24
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, "Your", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "accent"
        }, bid?.source?.name), " ", "offer for", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "accent"
        }, bid?.criteria?.data?.token?.name || bid?.criteria?.data?.collection?.name, " "), "at ", bid?.price?.amount?.decimal, " ", bid?.price?.currency?.symbol, " has been canceled.")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$2"
            }
        }, stepData?.currentStepItem?.txHashes?.map((hash, index)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                key: index,
                href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                color: "primary",
                weight: "medium",
                target: "_blank",
                css: {
                    fontSize: 12
                }
            }, "View transaction: ", truncatedTxHash);
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                m: "$4"
            }
        }, copy.ctaClose)));
    });
}
$140a00430df0958e$export$89d1e00b7fa831db.Custom = (0, $03948d0d1ea50134$export$d2f670ba420b64c2);












var $6e7449d8ef933807$export$c5c5c857eaef0fde;
(function(CancelStep) {
    CancelStep[CancelStep["Cancel"] = 0] = "Cancel";
    CancelStep[CancelStep["Approving"] = 1] = "Approving";
    CancelStep[CancelStep["Complete"] = 2] = "Complete";
})($6e7449d8ef933807$export$c5c5c857eaef0fde || ($6e7449d8ef933807$export$c5c5c857eaef0fde = {}));
const $6e7449d8ef933807$export$784ecbb108ae6a2c = ({ open: open, listingId: listingId, chainId: chainId, normalizeRoyalties: normalizeRoyalties, children: children, walletClient: walletClient })=>{
    const [cancelStep, setCancelStep] = (0, $TBcmg$useState)($6e7449d8ef933807$export$c5c5c857eaef0fde.Cancel);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [steps, setSteps] = (0, $TBcmg$useState)(null);
    const { address: address } = (0, $TBcmg$useAccount)();
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWallet;
    const blockExplorerBaseUrl = wagmiChain?.blockExplorers?.default.url || "https://etherscan.io";
    const blockExplorerName = wagmiChain?.blockExplorers?.default?.name || "Etherscan";
    const { data: listings, isFetchingPage: isFetchingPage } = (0, $13e7ce1cd1160f0c$export$2e2bcd8739ae039)(address, {
        ids: listingId,
        normalizeRoyalties: normalizeRoyalties,
        includeCriteriaMetadata: true,
        includeRawData: true
    }, {
        revalidateFirstPage: true
    }, open && listingId ? true : false, rendererChain?.id);
    const listing = listings && listings[0] ? listings[0] : undefined;
    const currency = listing?.price?.currency;
    const coinConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open && listing ? "USD" : undefined, currency?.symbol);
    const usdPrice = coinConversion.length > 0 ? coinConversion[0].price : 0;
    const totalUsd = usdPrice * (listing?.price?.amount?.decimal || 0);
    const cancelOrder = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        if (!listingId) {
            const error = new Error("Missing list id to cancel");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        setCancelStep($6e7449d8ef933807$export$c5c5c857eaef0fde.Approving);
        client.actions.cancelOrder({
            chainId: rendererChain?.id,
            ids: [
                listingId
            ],
            wallet: wallet,
            onProgress: (steps)=>{
                if (!steps) return;
                setSteps(steps);
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem
                });
                else if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setCancelStep($6e7449d8ef933807$export$c5c5c857eaef0fde.Complete);
            }
        }).catch((error)=>{
            setTransactionError(error);
            setCancelStep($6e7449d8ef933807$export$c5c5c857eaef0fde.Cancel);
            setStepData(null);
            setSteps(null);
        });
    }, [
        listingId,
        client,
        rendererChain,
        wallet,
        config
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setCancelStep($6e7449d8ef933807$export$c5c5c857eaef0fde.Cancel);
            setTransactionError(null);
            setStepData(null);
            setSteps(null);
        }
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "cancelListingRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    const tokenId = listing?.tokenSetId?.split(":")[2];
    const contract = listing?.tokenSetId?.split(":")[1];
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: isFetchingPage !== undefined ? isFetchingPage : true,
        listing: listing,
        tokenId: tokenId,
        blockExplorerName: blockExplorerName,
        contract: contract,
        cancelStep: cancelStep,
        transactionError: transactionError,
        usdPrice: usdPrice,
        totalUsd: totalUsd,
        blockExplorerBaseUrl: blockExplorerBaseUrl,
        steps: steps,
        stepData: stepData,
        setCancelStep: setCancelStep,
        cancelOrder: cancelOrder
    }));
};









const $8a7188f82a67e5bb$var$ModalCopy = {
    title: "Cancel Listing",
    ctaCancel: "Continue to Cancel",
    ctaAwaitingApproval: "Waiting for approval...",
    ctaAwaitingValidation: "Waiting for transaction to be validated",
    ctaClose: "Close"
};
function $8a7188f82a67e5bb$export$5ccdc2f8532db25b({ openState: openState, listingId: listingId, chainId: chainId, trigger: trigger, normalizeRoyalties: normalizeRoyalties, copyOverrides: copyOverrides, walletClient: walletClient, onClose: onClose, onCancelComplete: onCancelComplete, onCancelError: onCancelError, onPointerDownOutside: onPointerDownOutside }) {
    const copy = {
        ...$8a7188f82a67e5bb$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6e7449d8ef933807$export$784ecbb108ae6a2c), {
        chainId: modalChain?.id,
        listingId: listingId,
        open: open,
        normalizeRoyalties: normalizeRoyalties,
        walletClient: walletClient
    }, ({ loading: loading, listing: listing, tokenId: tokenId, contract: contract, cancelStep: cancelStep, transactionError: transactionError, stepData: stepData, totalUsd: totalUsd, blockExplorerName: blockExplorerName, cancelOrder: cancelOrder })=>{
        const expires = (0, $2f4c390a81073897$export$2e2bcd8739ae039)(listing?.expiration);
        const listingImg = tokenId ? `${modalChain?.baseApiUrl}/redirect/tokens/${contract}:${tokenId}/image/v1?imageSize=small` : `${modalChain?.baseApiUrl}/redirect/collections/${contract}/image/v1`;
        (0, $TBcmg$useEffect)(()=>{
            if (cancelStep === (0, $6e7449d8ef933807$export$c5c5c857eaef0fde).Complete && onCancelComplete) {
                const data = {
                    listing: listing,
                    stepData: stepData
                };
                onCancelComplete(data);
            }
        }, [
            cancelStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onCancelError) {
                const data = {
                    listing: listing,
                    stepData: stepData
                };
                onCancelError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const isListingAvailable = listing && (listing.status === "active" || listing.status === "inactive") && !loading;
        const isOracleOrder = listing?.isNativeOffChainCancellable;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.title,
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        listing: listing,
                        stepData: stepData
                    };
                    onClose(data, cancelStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (onPointerDownOutside) onPointerDownOutside(e);
            }
        }, !isListingAvailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                px: "$4",
                py: "$6"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Selected listing is no longer available")), isListingAvailable && cancelStep === (0, $6e7449d8ef933807$export$c5c5c857eaef0fde).Cancel && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $borderColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6a7867ba1ffb99fc$export$2e2bcd8739ae039), {
            chain: modalChain,
            img: listingImg,
            name: listing.criteria?.data?.token?.name,
            price: listing?.price?.amount?.decimal,
            usdPrice: totalUsd,
            collection: listing.criteria?.data?.collection?.name || "",
            currencyContract: listing.price?.currency?.contract,
            currencyDecimals: listing?.price?.currency?.decimals,
            currencySymbol: listing?.price?.currency?.symbol,
            expires: expires,
            source: listing?.source?.icon || ""
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                mt: "$3",
                mr: "$3",
                ml: "$3",
                textAlign: "center"
            }
        }, !isOracleOrder ? "This action will cancel your listing. You will be prompted to confirm this cancellation from your wallet. A gas fee is required." : "This will cancel your listing for free. You will be prompted to confirm this cancellation from your wallet."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: cancelOrder,
            css: {
                m: "$4"
            }
        }, !isOracleOrder && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faGasPump),
            width: "16",
            height: "16"
        }), copy.ctaCancel)), cancelStep === (0, $6e7449d8ef933807$export$c5c5c857eaef0fde).Approving && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $borderColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6a7867ba1ffb99fc$export$2e2bcd8739ae039), {
            chain: modalChain,
            img: listingImg,
            name: listing?.criteria?.data?.token?.name,
            price: listing?.price?.amount?.decimal,
            usdPrice: totalUsd,
            collection: listing?.criteria?.data?.collection?.name || "",
            currencyContract: listing?.price?.currency?.contract,
            currencyDecimals: listing?.price?.currency?.decimals,
            currencySymbol: listing?.price?.currency?.symbol,
            expires: expires,
            source: listing?.source?.icon || ""
        })), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
            css: {
                height: 206
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e92d8c2581b5f9df$export$2e2bcd8739ae039), {
            title: stepData?.currentStepItem.txHashes ? "Finalizing on blockchain" : "Confirm cancelation in your wallet",
            txHashes: stepData?.currentStepItem?.txHashes
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), stepData?.currentStepItem.txHashes ? copy.ctaAwaitingValidation : copy.ctaAwaitingApproval)), cancelStep === (0, $6e7449d8ef933807$export$c5c5c857eaef0fde).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                py: "$5",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                mb: "$2"
            }
        }, "Listing Canceled!"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                mb: 24
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, "Your", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "accent"
        }, listing?.source?.name), " ", "listing for", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "accent"
        }, listing?.criteria?.data?.token?.name || listing?.criteria?.data?.collection?.name, " "), "at ", listing?.price?.amount?.decimal, " ", listing?.price?.currency?.symbol, " has been canceled.")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$2"
            }
        }, stepData?.currentStepItem?.txHashes?.map((hash, index)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                key: index,
                href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                color: "primary",
                weight: "medium",
                target: "_blank",
                css: {
                    fontSize: 12
                }
            }, "View transaction: ", truncatedTxHash);
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                m: "$4"
            }
        }, copy.ctaClose)));
    });
}
$8a7188f82a67e5bb$export$5ccdc2f8532db25b.Custom = (0, $6e7449d8ef933807$export$784ecbb108ae6a2c);
























var $c3a477f35c10f10a$export$1662ceb9c43bf6c3;
(function(EditBidStep) {
    EditBidStep[EditBidStep["Edit"] = 0] = "Edit";
    EditBidStep[EditBidStep["Approving"] = 1] = "Approving";
    EditBidStep[EditBidStep["Complete"] = 2] = "Complete";
})($c3a477f35c10f10a$export$1662ceb9c43bf6c3 || ($c3a477f35c10f10a$export$1662ceb9c43bf6c3 = {}));
const $c3a477f35c10f10a$export$f31689e1a4df1b06 = ({ open: open, bidId: bidId, chainId: chainId, tokenId: tokenId, collectionId: collectionId, attribute: attribute, normalizeRoyalties: normalizeRoyalties, walletClient: walletClient, children: children })=>{
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const { address: address, connector: connector } = (0, $TBcmg$useAccount)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const { data: wallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const { data: capabilities } = (0, $TBcmg$useCapabilities)({
        query: {
            enabled: connector && (connector.id === "coinbaseWalletSDK" || connector.id === "coinbase")
        }
    });
    const hasAuxiliaryFundsSupport = Boolean(rendererChain?.id ? capabilities?.[rendererChain?.id]?.auxiliaryFunds?.supported : false);
    const [editBidStep, setEditBidStep] = (0, $TBcmg$useState)($c3a477f35c10f10a$export$1662ceb9c43bf6c3.Edit);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [steps, setSteps] = (0, $TBcmg$useState)(null);
    const [bidAmountPerUnit, setBidAmountPerUnit] = (0, $TBcmg$useState)("");
    const [quantity, setQuantity] = (0, $TBcmg$useState)(1);
    const [expirationOption, setExpirationOption] = (0, $TBcmg$useState)((0, $4dd727d17c3f54df$export$2e2bcd8739ae039)[5]);
    const [hasEnoughNativeCurrency, setHasEnoughNativeCurrency] = (0, $TBcmg$useState)(false);
    const [hasEnoughWrappedCurrency, setHasEnoughWrappedCurrency] = (0, $TBcmg$useState)(false);
    const [amountToWrap, setAmountToWrap] = (0, $TBcmg$useState)("");
    const [trait, setTrait] = (0, $TBcmg$useState)(attribute);
    const [attributes, setAttributes] = (0, $TBcmg$useState)();
    const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(rendererChain?.id);
    const nativeWrappedContractAddress = chainCurrency.chainId in (0, $539986c326843873$export$2e2bcd8739ae039) ? (0, $539986c326843873$export$2e2bcd8739ae039)[chainCurrency.chainId] : (0, $539986c326843873$export$2e2bcd8739ae039)[1];
    const nativeWrappedContractName = chainCurrency.chainId in (0, $ccbd22d7b24d8923$export$2e2bcd8739ae039) ? (0, $ccbd22d7b24d8923$export$2e2bcd8739ae039)[chainCurrency.chainId] : (0, $ccbd22d7b24d8923$export$2e2bcd8739ae039)[1];
    const { data: bids } = (0, $739a88828d18ea96$export$2e2bcd8739ae039)(address, {
        ids: bidId,
        normalizeRoyalties: normalizeRoyalties,
        includeCriteriaMetadata: true,
        includeRawData: true
    }, {
        revalidateFirstPage: true
    }, open && bidId ? true : false, rendererChain?.id);
    const bid = bids && bids[0] ? bids[0] : undefined;
    const [allMarketplaces] = (0, $6bcc64b528de3c29$export$2e2bcd8739ae039)(collectionId, tokenId, undefined, undefined, rendererChain?.id, open);
    const reservoirMarketplace = (0, $TBcmg$useMemo)(()=>allMarketplaces.find((marketplace)=>marketplace.orderbook === "reservoir"), [
        allMarketplaces
    ]);
    const exchange = (0, $TBcmg$useMemo)(()=>{
        const exchanges = reservoirMarketplace?.exchanges || {};
        const exchange = Object.values(exchanges).find((exchange)=>exchange?.orderKind === bid?.kind);
        return exchange?.enabled ? exchange : undefined;
    }, [
        reservoirMarketplace,
        bid
    ]);
    const traitBidSupported = Boolean(exchange?.traitBidSupported);
    const collectionBidSupported = Boolean(exchange?.collectionBidSupported);
    const partialBidSupported = Boolean(exchange?.partialOrderSupported);
    const contract = bid?.tokenSetId?.split(":")[1];
    const currency = bid?.price?.currency;
    const isOracleOrder = bid?.isNativeOffChainCancellable;
    const wrappedContractAddress = currency ? currency.contract : nativeWrappedContractAddress;
    const wrappedContractName = currency ? currency.symbol : nativeWrappedContractName;
    (0, $TBcmg$useEffect)(()=>{
        if (bid?.price?.amount?.decimal) setBidAmountPerUnit(bid?.price?.amount?.decimal.toString());
        if (bid?.quantityRemaining && bid?.quantityRemaining > 1) setQuantity(bid?.quantityRemaining);
        //@ts-ignore
        if (bid?.criteria?.kind == "attribute" && bid?.criteria?.data.attribute) //@ts-ignore
        setTrait(bid?.criteria?.data?.attribute);
    }, [
        bid
    ]);
    const coinConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open && bid ? "USD" : undefined, wrappedContractName);
    const usdPrice = coinConversion.length > 0 ? coinConversion[0].price : null;
    const totalBidAmount = Number(bidAmountPerUnit) * Math.max(1, quantity);
    const totalBidAmountUsd = totalBidAmount * (usdPrice || 0);
    const { data: balance } = (0, $TBcmg$useBalance)({
        address: address,
        chainId: rendererChain?.id,
        query: {
            enabled: open
        }
    });
    const { data: wrappedBalance } = (0, $TBcmg$useReadContracts)({
        allowFailure: false,
        contracts: [
            {
                address: wrappedContractAddress,
                abi: (0, $TBcmg$erc20Abi),
                functionName: "balanceOf",
                chainId: rendererChain?.id,
                args: [
                    address
                ]
            },
            {
                address: wrappedContractAddress,
                abi: (0, $TBcmg$erc20Abi),
                functionName: "decimals",
                chainId: rendererChain?.id
            },
            {
                address: wrappedContractAddress,
                abi: (0, $TBcmg$erc20Abi),
                functionName: "symbol",
                chainId: rendererChain?.id
            }
        ],
        query: {
            enabled: Boolean(open && address !== undefined)
        }
    });
    const { relayLink: relayLink } = (0, $ff7ce0ca6096b543$export$2e2bcd8739ae039)(rendererChain?.id);
    const canAutomaticallyConvert = !currency || currency.contract === nativeWrappedContractAddress;
    let convertLink = "";
    if (providerOptions?.convertLink) {
        convertLink = providerOptions.convertLink.tokenUrl ?? providerOptions.convertLink.chainUrl ?? providerOptions.convertLink.customUrl?.({
            toChain: rendererChain?.id,
            toToken: wrappedContractAddress,
            amountToWrap: amountToWrap
        }) ?? "";
        if (rendererChain?.id) convertLink = convertLink.replace("{toChain}", `${rendererChain.id}`);
        convertLink = convertLink.replace("{toToken}", wrappedContractAddress);
    } else if (relayLink) convertLink = `${relayLink}?toCurrency=${wrappedContractAddress}&fromChainId=${rendererChain?.id}&fromCurrency=${chainCurrency.address}`;
    else if (canAutomaticallyConvert) convertLink = wagmiChain?.id === (0, $TBcmg$mainnet).id || wagmiChain?.id === (0, $TBcmg$goerli).id ? `https://app.uniswap.org/#/swap?theme=dark&exactAmount=${amountToWrap}&chain=mainnet&inputCurrency=eth&outputCurrency=${wrappedContractAddress}` : `https://app.uniswap.org/#/swap?theme=dark&exactAmount=${amountToWrap}`;
    else convertLink = `https://jumper.exchange/?toChain=${wagmiChain?.id}&toToken=${wrappedContractAddress}`;
    const isTokenBid = bid?.criteria?.kind == "token";
    const { data: traits } = (0, $7c7b75a236ce465b$export$2e2bcd8739ae039)(open && !isTokenBid ? collectionId : undefined, rendererChain?.id);
    const { data: collections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && {
        id: collectionId,
        normalizeRoyalties: normalizeRoyalties
    }, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    let royaltyBps = collection?.royalties?.bps;
    const { data: tokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && contract && tokenId ? {
        tokens: [
            `${contract}:${tokenId}`
        ],
        includeAttributes: true,
        normalizeRoyalties: normalizeRoyalties
    } : false, {
        revalidateFirstPage: true
    }, rendererChain?.id);
    const token = tokens && tokens.length > 0 ? tokens[0] : undefined;
    (0, $TBcmg$useEffect)(()=>{
        if (totalBidAmount !== 0) {
            const bid = (0, $TBcmg$parseUnits)(`${totalBidAmount}`, wrappedBalance?.[1] || 18);
            if (!wrappedBalance?.[0] || wrappedBalance?.[0] < bid) {
                setHasEnoughWrappedCurrency(false);
                const wrappedAmount = wrappedBalance?.[0] || 0n;
                const amountToWrap = bid - wrappedAmount;
                setAmountToWrap((0, $6f54b4a5aad888ed$export$87710fd8420713d9)(amountToWrap, 5));
                if (!balance?.value || balance.value < amountToWrap) setHasEnoughNativeCurrency(false);
                else setHasEnoughNativeCurrency(true);
            } else {
                setHasEnoughWrappedCurrency(true);
                setHasEnoughNativeCurrency(true);
                setAmountToWrap("");
            }
        } else {
            setHasEnoughNativeCurrency(true);
            setHasEnoughWrappedCurrency(true);
            setAmountToWrap("");
        }
    }, [
        totalBidAmount,
        balance,
        wrappedBalance
    ]);
    (0, $TBcmg$useEffect)(()=>{
        const validAttributes = traits ? traits.filter((attribute)=>attribute.values && attribute.values.length > 0) : undefined;
        setAttributes(validAttributes);
    }, [
        traits
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setEditBidStep($c3a477f35c10f10a$export$1662ceb9c43bf6c3.Edit);
            setExpirationOption((0, $4dd727d17c3f54df$export$2e2bcd8739ae039)[3]);
            setHasEnoughNativeCurrency(false);
            setHasEnoughWrappedCurrency(false);
            setAmountToWrap("");
            setBidAmountPerUnit("");
            setStepData(null);
            setTransactionError(null);
            setTrait(undefined);
        } else setTrait(attribute);
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "editBidModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    const editBid = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        if (!bidId) {
            const error = new Error("Missing bid id to edit");
            setTransactionError(error);
            throw error;
        }
        if (!isOracleOrder) {
            const error = new Error("Not an oracle powered offer");
            setTransactionError(error);
            throw error;
        }
        if (!exchange) {
            const error = new Error("Missing Exchange");
            setTransactionError(error);
            throw error;
        }
        setTransactionError(null);
        let expirationTime = null;
        if (expirationOption.relativeTime && expirationOption.relativeTimeUnit) expirationTime = (0, $TBcmg$dayjs)().add(expirationOption.relativeTime, expirationOption.relativeTimeUnit).unix().toString();
        const atomicBidAmount = (0, $TBcmg$parseUnits)(`${totalBidAmount}`, currency?.decimals || 18).toString();
        const bid = {
            weiPrice: atomicBidAmount,
            orderbook: "reservoir",
            orderKind: exchange.orderKind,
            attributeKey: trait?.key,
            attributeValue: trait?.value
        };
        if (isTokenBid && tokenId && collectionId) {
            const contract = collectionId ? collectionId?.split(":")[0] : undefined;
            bid.token = `${contract}:${tokenId}`;
        } else if (collectionId) bid.collection = collectionId;
        if (nativeWrappedContractAddress != wrappedContractAddress) bid.currency = wrappedContractAddress;
        if (expirationTime) bid.expirationTime = expirationTime;
        if (quantity > 1) bid.quantity = quantity;
        bid.options = {
            [exchange.orderKind]: {
                useOffChainCancellation: true,
                replaceOrderId: bidId
            }
        };
        setEditBidStep($c3a477f35c10f10a$export$1662ceb9c43bf6c3.Approving);
        client.actions.placeBid({
            chainId: rendererChain?.id,
            bids: [
                bid
            ],
            wallet: wallet,
            onProgress: (steps)=>{
                if (!steps) return;
                setSteps(steps);
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem
                });
                else if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setEditBidStep($c3a477f35c10f10a$export$1662ceb9c43bf6c3.Complete);
            }
        }).catch((error)=>{
            setTransactionError(error);
            setEditBidStep($c3a477f35c10f10a$export$1662ceb9c43bf6c3.Edit);
            setStepData(null);
            setSteps(null);
        });
    }, [
        config,
        client,
        wallet,
        collectionId,
        tokenId,
        rendererChain,
        expirationOption,
        trait,
        totalBidAmount,
        quantity,
        wrappedBalance,
        wrappedContractAddress,
        nativeWrappedContractAddress,
        exchange
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: !bid || !collection,
        bid: bid,
        attributes: attributes,
        trait: trait,
        tokenId: tokenId,
        contract: contract,
        isOracleOrder: isOracleOrder,
        isTokenBid: isTokenBid,
        quantity: quantity,
        bidAmountPerUnit: bidAmountPerUnit,
        totalBidAmount: totalBidAmount,
        totalBidAmountUsd: totalBidAmountUsd,
        token: token,
        currency: currency,
        collection: collection,
        editBidStep: editBidStep,
        transactionError: transactionError,
        hasEnoughNativeCurrency: hasEnoughNativeCurrency,
        hasEnoughWrappedCurrency: hasEnoughWrappedCurrency,
        hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport,
        balance: balance,
        wrappedBalance: wrappedBalance,
        wrappedContractName: wrappedContractName,
        wrappedContractAddress: wrappedContractAddress,
        amountToWrap: amountToWrap,
        convertLink: convertLink,
        canAutomaticallyConvert: canAutomaticallyConvert,
        royaltyBps: royaltyBps,
        expirationOptions: $4dd727d17c3f54df$export$2e2bcd8739ae039,
        expirationOption: expirationOption,
        usdPrice: usdPrice,
        steps: steps,
        stepData: stepData,
        exchange: exchange,
        traitBidSupported: traitBidSupported,
        partialBidSupported: partialBidSupported,
        collectionBidSupported: collectionBidSupported,
        setQuantity: setQuantity,
        setTrait: setTrait,
        setBidAmountPerUnit: setBidAmountPerUnit,
        setExpirationOption: setExpirationOption,
        setEditBidStep: setEditBidStep,
        editBid: editBid
    }));
};













const $cc999d237a46714e$var$ModalCopy = {
    title: "Edit Offer",
    ctaClose: "Close",
    ctaConfirm: "Confirm",
    ctaDisabled: "Enter a Price",
    ctaEditOffer: "Edit Offer",
    ctaRetry: "Retry",
    ctaConvertManually: "Get ",
    ctaConvertAutomatically: "",
    ctaAwaitingApproval: "Waiting for approval...",
    ctaAwaitingValidation: "Waiting for transaction to be validated"
};
const $cc999d237a46714e$var$MINIMUM_AMOUNT = 0.000001;
const $cc999d237a46714e$var$MAXIMUM_AMOUNT = Infinity;
function $cc999d237a46714e$export$799450c9ce92504c({ openState: openState, bidId: bidId, tokenId: tokenId, chainId: chainId, collectionId: collectionId, trigger: trigger, normalizeRoyalties: normalizeRoyalties, copyOverrides: copyOverrides, walletClient: walletClient, onClose: onClose, onEditBidComplete: onEditBidComplete, onEditBidError: onEditBidError, onPointerDownOutside: onPointerDownOutside }) {
    const copy = {
        ...$cc999d237a46714e$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c3a477f35c10f10a$export$f31689e1a4df1b06), {
        chainId: modalChain?.id,
        bidId: bidId,
        tokenId: tokenId,
        collectionId: collectionId,
        open: open,
        normalizeRoyalties: normalizeRoyalties,
        walletClient: walletClient
    }, ({ loading: loading, bid: bid, attributes: attributes, trait: trait, isOracleOrder: isOracleOrder, isTokenBid: isTokenBid, quantity: quantity, bidAmountPerUnit: bidAmountPerUnit, totalBidAmount: totalBidAmount, totalBidAmountUsd: totalBidAmountUsd, token: token, collection: collection, editBidStep: editBidStep, transactionError: transactionError, hasEnoughNativeCurrency: hasEnoughNativeCurrency, hasEnoughWrappedCurrency: hasEnoughWrappedCurrency, hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport, amountToWrap: amountToWrap, balance: balance, wrappedBalance: wrappedBalance, wrappedContractName: wrappedContractName, wrappedContractAddress: wrappedContractAddress, canAutomaticallyConvert: canAutomaticallyConvert, convertLink: convertLink, royaltyBps: royaltyBps, expirationOptions: expirationOptions, expirationOption: expirationOption, usdPrice: usdPrice, stepData: stepData, exchange: exchange, traitBidSupported: traitBidSupported, partialBidSupported: partialBidSupported, currency: currency, setQuantity: setQuantity, setTrait: setTrait, setBidAmountPerUnit: setBidAmountPerUnit, setExpirationOption: setExpirationOption, setEditBidStep: setEditBidStep, editBid: editBid })=>{
        const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
        const [attributeSelectorOpen, setAttributeSelectorOpen] = (0, $TBcmg$useState)(false);
        const [attributesSelectable, setAttributesSelectable] = (0, $TBcmg$useState)(false);
        const tokenCount = collection?.tokenCount ? +collection.tokenCount : undefined;
        const itemImage = isTokenBid ? bid?.criteria?.data?.token?.image || token?.token?.imageSmall : bid?.criteria?.data?.collection?.image || collection?.image;
        const quantityEnabled = partialBidSupported && (!tokenId || token?.token?.kind === "erc1155" && Number(token?.token?.supply) > 1);
        const [localMarketplace, setLocalMarketplace] = (0, $TBcmg$useState)(null);
        (0, $TBcmg$useEffect)(()=>{
            setLocalMarketplace((0, $49ea92be0f1fc634$export$2e2bcd8739ae039)());
        }, []);
        (0, $TBcmg$useEffect)(()=>{
            if (editBidStep === (0, $c3a477f35c10f10a$export$1662ceb9c43bf6c3).Complete && onEditBidComplete) {
                const data = {
                    bid: bid,
                    stepData: stepData
                };
                onEditBidComplete(data);
            }
        }, [
            editBidStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onEditBidError) {
                const data = {
                    bid: bid,
                    stepData: stepData
                };
                onEditBidError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (open && attributes) {
                let attributeCount = 0;
                for(let i = 0; i < attributes.length; i++){
                    attributeCount += attributes[i].attributeCount || 0;
                    if (attributeCount >= 2000) break;
                }
                if (attributeCount >= 2000) setAttributesSelectable(false);
                else setAttributesSelectable(true);
            } else setAttributesSelectable(false);
        }, [
            open,
            attributes
        ]);
        const isBidAvailable = bid && bid.status === "active" && !loading;
        const isBidEditable = bid && bid.status === "active" && !loading && isOracleOrder;
        const minimumAmount = exchange?.minPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.minPriceRaw), currency?.decimals || 18)) : $cc999d237a46714e$var$MINIMUM_AMOUNT;
        const maximumAmount = exchange?.maxPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.maxPriceRaw), currency?.decimals || 18)) : $cc999d237a46714e$var$MAXIMUM_AMOUNT;
        const withinPricingBounds = totalBidAmount !== 0 && totalBidAmount <= maximumAmount && totalBidAmount >= minimumAmount;
        const canPurchase = totalBidAmount !== 0 && withinPricingBounds;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.title,
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        bid: bid,
                        stepData: stepData
                    };
                    onClose(data, editBidStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (onPointerDownOutside) onPointerDownOutside(e);
            }
        }, !isBidAvailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                px: "$4",
                py: "$6"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Selected offer is no longer available")), !isBidEditable && isBidAvailable && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                px: "$4",
                py: "$6"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Selected offer is not an oracle order, so cannot be edited.")), editBidStep === (0, $c3a477f35c10f10a$export$1662ceb9c43bf6c3).Edit && isBidEditable && collection && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ea5a2f2758be6422$export$2e2bcd8739ae039), {
            chain: modalChain,
            token: token ? token : undefined,
            collection: collection,
            containerCss: {
                borderBottom: "1px solid",
                borderBottomColor: "$neutralLine",
                borderColor: "$neutralLine"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4",
                gap: 24,
                overflow: "hidden"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            css: {
                gap: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Offer Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: (0, $602940fa56061b3b$export$2e2bcd8739ae039),
            css: {
                gap: "$1"
            },
            align: "center",
            style: "subtitle3"
        }, "Balance:", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bf67ac886f7190ba$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            logoWidth: 10,
            textStyle: "tiny",
            amount: wrappedBalance?.[0],
            address: wrappedContractAddress,
            decimals: wrappedBalance?.[1],
            symbol: wrappedBalance?.[2]
        }), " ")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mt: "$2",
                gap: 20
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: (0, $602940fa56061b3b$export$2e2bcd8739ae039),
            css: {
                gap: "$2",
                flexShrink: 0
            },
            align: "center",
            style: "body1",
            color: "subtle"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            css: {
                height: 20
            },
            address: wrappedContractAddress
        }), wrappedContractName), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5c0c2c3952297d70$export$2e2bcd8739ae039), {
            type: "number",
            value: bidAmountPerUnit,
            onChange: (e)=>{
                setBidAmountPerUnit(e.target.value);
            },
            placeholder: "Enter price",
            containerCss: {
                width: "100%"
            },
            css: {
                textAlign: "center",
                "@bp1": {
                    textAlign: "left"
                }
            }
        })), totalBidAmount !== 0 && !withinPricingBounds && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "error"
        }, maximumAmount !== Infinity ? `Amount must be between ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount)} - ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(maximumAmount)}` : `Amount must be higher than ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount)}`)), attributes && attributes.length > 0 && (attributesSelectable || trait) && !tokenId && traitBidSupported && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Root, {
            open: attributeSelectorOpen,
            onOpenChange: attributesSelectable ? setAttributeSelectorOpen : undefined
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Trigger, {
            asChild: true
        }, trait ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $822ff51685ab152b$export$2e2bcd8739ae039), {
            css: {
                py: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            css: {
                gap: "$2",
                alignItems: "center",
                color: "$neutralText"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                maxWidth: 385,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            color: "accent",
            style: "subtitle1"
        }, trait?.key, ":", " "), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle1"
        }, trait?.value)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                alignItems: "center",
                gap: "$2"
            }
        }, trait?.floorAskPrice && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                flex: "none"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            amount: trait?.floorAskPrice,
            maximumFractionDigits: 2,
            logoWidth: 11,
            textStyle: "body1"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            style: {
                cursor: "pointer"
            },
            onClick: (e)=>{
                e.preventDefault();
                setTrait(undefined);
            },
            icon: (0, $TBcmg$faClose),
            width: 16,
            height: 16
        })))) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "ghost",
            css: {
                color: "$accentText",
                fontWeight: 500,
                fontSize: 14,
                maxWidth: "max-content"
            },
            size: "none"
        }, "+ Add Attribute")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Content, {
            side: "bottom",
            align: "start",
            sideOffset: -20,
            style: {
                maxWidth: "100vw"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f8d8cda59d836a2f$export$2e2bcd8739ae039), {
            attributes: attributes,
            tokenCount: tokenCount,
            setTrait: setTrait,
            setOpen: setAttributeSelectorOpen
        }))))), quantityEnabled ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$5",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "start",
            css: {
                gap: "$2",
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            color: "subtle",
            style: "body3",
            css: {
                display: "none",
                "@bp1": {
                    display: "block"
                }
            }
        }, "Offers can be accepted separately")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
            quantity: quantity,
            setQuantity: setQuantity,
            min: 1,
            max: 999999,
            css: {
                justifyContent: "space-between",
                width: "100%"
            }
        })) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: (0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039),
            style: "subtitle2"
        }, "Expiration Date"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039), {
            css: {
                flex: 1,
                width: "100%"
            },
            value: expirationOption?.text || "",
            onValueChange: (value)=>{
                const option = expirationOptions.find((option)=>option.value == value);
                if (option) setExpirationOption(option);
            }
        }, expirationOptions.filter(({ value: value })=>value !== "custom").map((option)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Item, {
                key: option.text,
                value: option.value
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).ItemText, null, option.text))))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Total Offer Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "end"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bf67ac886f7190ba$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            logoWidth: 16,
            textStyle: "h6",
            amount: totalBidAmount,
            address: currency?.contract,
            decimals: currency?.decimals,
            symbol: currency?.symbol
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            amount: totalBidAmountUsd
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                mt: "auto"
            }
        }, !canPurchase && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                width: "100%"
            }
        }, copy.ctaDisabled), canPurchase && hasEnoughWrappedCurrency && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: editBid,
            css: {
                width: "100%"
            }
        }, copy.ctaConfirm), canPurchase && !hasEnoughWrappedCurrency && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, !hasEnoughNativeCurrency && !hasAuxiliaryFundsSupport && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$2",
                mt: 10
            },
            justify: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "error"
        }, balance?.symbol || "ETH", " Balance"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            amount: balance?.value,
            symbol: balance?.symbol
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$2",
                mt: 10,
                overflow: "hidden",
                flexDirection: "column-reverse",
                "@bp1": {
                    flexDirection: "row"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: providerOptionsContext.disableJumperLink,
            css: {
                flex: "1 0 auto"
            },
            color: "secondary",
            onClick: ()=>{
                window.open(convertLink, "_blank");
            }
        }, providerOptionsContext.disableJumperLink ? copy.ctaConfirm : currency?.symbol ? copy.ctaConvertManually + currency?.symbol : "Convert Manually"), canAutomaticallyConvert && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                flex: 1,
                maxHeight: 44
            },
            disabled: !hasEnoughNativeCurrency && !hasAuxiliaryFundsSupport,
            onClick: editBid
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            color: "button",
            ellipsify: true
        }, copy.ctaConvertAutomatically.length > 0 ? copy.ctaConvertAutomatically : `Convert ${amountToWrap} ${balance?.symbol || "ETH"} for me`))))))), editBidStep === (0, $c3a477f35c10f10a$export$1662ceb9c43bf6c3).Approving && collection && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ea5a2f2758be6422$export$2e2bcd8739ae039), {
            chain: modalChain,
            token: token ? token : undefined,
            collection: collection,
            price: totalBidAmount,
            currency: currency,
            quantity: quantity,
            trait: trait,
            expirationOption: expirationOption,
            containerCss: {
                borderBottom: "1px solid",
                borderBottomColor: "$neutralLine",
                borderColor: "$neutralLine"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4",
                gap: 24
            }
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError,
            css: {
                width: "100%"
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center"
            },
            style: "subtitle1"
        }, stepData.currentStep.action), stepData.currentStep.kind === "signature" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0f4eeb921315fd4d$export$2e2bcd8739ae039), {
            justify: "center",
            fromImg: itemImage || "",
            toImgs: [
                localMarketplace?.icon || ""
            ]
        }), stepData.currentStep.kind !== "signature" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                background: "$neutralLine",
                borderRadius: 8
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            css: {
                height: 56,
                width: 56
            },
            address: wrappedContractAddress
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                textAlign: "center",
                mt: 24,
                maxWidth: 395,
                mx: "auto",
                mb: "$4"
            },
            style: "body2",
            color: "subtle"
        }, stepData?.currentStep.description)), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                height: "100%",
                py: "$5"
            },
            justify: "center",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null)), !transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                mt: "auto"
            },
            disabled: true
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.ctaAwaitingApproval), transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mt: "auto",
                gap: 10,
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "secondary",
            css: {
                flex: 1
            },
            onClick: ()=>setEditBidStep((0, $c3a477f35c10f10a$export$1662ceb9c43bf6c3).Edit)
        }, copy.ctaEditOffer), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                flex: 1
            },
            onClick: editBid
        }, copy.ctaRetry)))), editBidStep === (0, $c3a477f35c10f10a$export$1662ceb9c43bf6c3).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$successAccent",
                mt: 48
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCheckCircle),
            style: {
                width: "32px",
                height: "32px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                textAlign: "center",
                mt: 36,
                mb: 80
            }
        }, "Offer Updated!"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>{
                setOpen(false);
            }
        }, copy.ctaClose)));
    });
}
$cc999d237a46714e$export$799450c9ce92504c.Custom = (0, $c3a477f35c10f10a$export$f31689e1a4df1b06);














var $15b40f9f8236e7c4$export$3a845fe90ed2a8d8;
(function(EditListingStep) {
    EditListingStep[EditListingStep["Edit"] = 0] = "Edit";
    EditListingStep[EditListingStep["Approving"] = 1] = "Approving";
    EditListingStep[EditListingStep["Complete"] = 2] = "Complete";
})($15b40f9f8236e7c4$export$3a845fe90ed2a8d8 || ($15b40f9f8236e7c4$export$3a845fe90ed2a8d8 = {}));
const $15b40f9f8236e7c4$export$10f582750caac37a = ({ open: open, listingId: listingId, tokenId: tokenId, collectionId: collectionId, chainId: chainId, normalizeRoyalties: normalizeRoyalties, children: children, walletClient: walletClient })=>{
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const config = (0, $TBcmg$useConfig)();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const { data: wagmiWalletClient } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWalletClient;
    const account = (0, $TBcmg$useAccount)();
    const [editListingStep, setEditListingStep] = (0, $TBcmg$useState)($15b40f9f8236e7c4$export$3a845fe90ed2a8d8.Edit);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [steps, setSteps] = (0, $TBcmg$useState)(null);
    const [price, setPrice] = (0, $TBcmg$useState)(0);
    const [quantity, setQuantity] = (0, $TBcmg$useState)(1);
    const { data: listings } = (0, $13e7ce1cd1160f0c$export$2e2bcd8739ae039)(account.address, {
        ids: listingId,
        normalizeRoyalties: normalizeRoyalties,
        includeCriteriaMetadata: true,
        includeRawData: true
    }, {
        revalidateFirstPage: true
    }, open && listingId ? true : false, rendererChain?.id);
    const listing = listings && listings[0] ? listings[0] : undefined;
    const contract = listing?.tokenSetId?.split(":")[1] || collectionId?.split(":")[0];
    const currency = listing?.price?.currency;
    const [allMarketplaces] = (0, $6bcc64b528de3c29$export$2e2bcd8739ae039)(collectionId, tokenId, undefined, undefined, rendererChain?.id, open);
    const reservoirMarketplace = (0, $TBcmg$useMemo)(()=>allMarketplaces.find((marketplace)=>marketplace.orderbook === "reservoir"), [
        allMarketplaces
    ]);
    const exchange = (0, $TBcmg$useMemo)(()=>{
        const exchanges = reservoirMarketplace?.exchanges || {};
        const exchange = Object.values(exchanges).find((exchange)=>exchange?.orderKind === listing?.kind);
        return exchange?.enabled ? exchange : undefined;
    }, [
        reservoirMarketplace,
        listing
    ]);
    const isOracleOrder = listing?.isNativeOffChainCancellable;
    (0, $TBcmg$useEffect)(()=>{
        if (listing?.price?.amount?.decimal) setPrice(listing?.price?.amount?.decimal);
    }, [
        listing?.price
    ]);
    const coinConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open && listing ? "USD" : undefined, currency?.symbol);
    const usdPrice = coinConversion.length > 0 ? coinConversion[0].price : 0;
    const totalUsd = usdPrice * (listing?.price?.amount?.decimal || 0);
    const [expirationOption, setExpirationOption] = (0, $TBcmg$useState)((0, $4dd727d17c3f54df$export$2e2bcd8739ae039)[5]);
    const { data: collections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && {
        id: collectionId,
        normalizeRoyalties: normalizeRoyalties
    }, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    const royaltyBps = collection?.royalties?.bps ? collection?.royalties?.bps : reservoirMarketplace?.royalties?.maxBps ? reservoirMarketplace?.royalties?.maxBps : 0;
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setEditListingStep($15b40f9f8236e7c4$export$3a845fe90ed2a8d8.Edit);
            setTransactionError(null);
            setStepData(null);
            setExpirationOption((0, $4dd727d17c3f54df$export$2e2bcd8739ae039)[5]);
            setQuantity(1);
        }
    }, [
        open
    ]);
    const { data: tokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && contract && tokenId ? {
        tokens: [
            `${contract}:${tokenId}`
        ],
        includeAttributes: true,
        normalizeRoyalties: normalizeRoyalties
    } : false, {
        revalidateFirstPage: true
    }, rendererChain?.id);
    const token = tokens && tokens.length > 0 ? tokens[0] : undefined;
    const is1155 = token?.token?.kind === "erc1155";
    const { data: userTokens } = (0, $adb61885b37a317b$export$2e2bcd8739ae039)(open && is1155 ? account.address : undefined, {
        tokens: [
            `${contract}:${tokenId}`
        ]
    }, {}, rendererChain?.id);
    const quantityAvailable = is1155 && userTokens[0] ? Number(userTokens[0].ownership?.tokenCount || 1) : 1;
    const editListing = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            const error = new Error("Missing a wallet/signer");
            setTransactionError(error);
            throw error;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (rendererChain?.id !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: rendererChain?.id
        });
        if (rendererChain?.id !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        if (!listingId) {
            const error = new Error("Missing list id to edit");
            setTransactionError(error);
            throw error;
        }
        if (!isOracleOrder) {
            const error = new Error("Not an oracle order");
            setTransactionError(error);
            throw error;
        }
        if (!exchange) {
            const error = new Error("Missing Exchange");
            setTransactionError(error);
            throw error;
        }
        setTransactionError(null);
        let expirationTime = null;
        if (expirationOption.relativeTime && expirationOption.relativeTimeUnit) expirationTime = (0, $TBcmg$dayjs)().add(expirationOption.relativeTime, expirationOption.relativeTimeUnit).unix().toString();
        const listing = {
            token: `${contract}:${tokenId}`,
            weiPrice: ((0, $TBcmg$parseUnits)(`${price}`, currency?.decimals || 18) * BigInt(quantity)).toString(),
            orderbook: "reservoir",
            orderKind: exchange.orderKind
        };
        if (quantity > 1) listing.quantity = quantity;
        if (expirationTime) listing.expirationTime = expirationTime;
        if (currency && currency.contract != (0, $TBcmg$zeroAddress)) listing.currency = currency.contract;
        listing.options = {
            [exchange.orderKind]: {
                useOffChainCancellation: true,
                replaceOrderId: listingId
            }
        };
        setEditListingStep($15b40f9f8236e7c4$export$3a845fe90ed2a8d8.Approving);
        client.actions.listToken({
            chainId: rendererChain?.id,
            listings: [
                listing
            ],
            wallet: wallet,
            onProgress: (steps)=>{
                if (!steps) return;
                setSteps(steps);
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem
                });
                else if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setEditListingStep($15b40f9f8236e7c4$export$3a845fe90ed2a8d8.Complete);
            }
        }).catch((error)=>{
            setTransactionError(error);
            setEditListingStep($15b40f9f8236e7c4$export$3a845fe90ed2a8d8.Edit);
            setStepData(null);
            setSteps(null);
        });
    }, [
        config,
        client,
        wallet,
        rendererChain,
        collectionId,
        tokenId,
        expirationOption,
        price,
        currency,
        quantity,
        contract,
        exchange
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setEditListingStep($15b40f9f8236e7c4$export$3a845fe90ed2a8d8.Edit);
            setTransactionError(null);
            setStepData(null);
            setSteps(null);
        }
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "editListingModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: !listing || !token || !collection || !exchange,
        listing: listing,
        tokenId: tokenId,
        contract: contract,
        isOracleOrder: isOracleOrder,
        currency: currency,
        token: token,
        price: price,
        quantityAvailable: quantityAvailable,
        collection: collection,
        quantity: quantity,
        expirationOption: expirationOption,
        expirationOptions: $4dd727d17c3f54df$export$2e2bcd8739ae039,
        editListingStep: editListingStep,
        transactionError: transactionError,
        usdPrice: usdPrice,
        totalUsd: totalUsd,
        royaltyBps: royaltyBps,
        steps: steps,
        stepData: stepData,
        exchange: exchange,
        setPrice: setPrice,
        setQuantity: setQuantity,
        setExpirationOption: setExpirationOption,
        setEditListingStep: setEditListingStep,
        editListing: editListing
    }));
};









const $216fa61d27b775ef$var$PriceInput = ({ chainId: chainId, price: price, collection: collection, currency: currency, usdPrice: usdPrice, quantity: quantity = 1, placeholder: placeholder, onChange: onChange, onBlur: onBlur, ...props })=>{
    let profit = (1 - (collection?.royalties?.bps || 0) * 0.0001) * (price || 0) * quantity;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        ...props,
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            width: "auto",
            height: 20
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
        chainId: chainId,
        css: {
            height: 18
        },
        address: currency?.contract
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body1",
        color: "subtle",
        css: {
            ml: "$1",
            mr: "$4"
        },
        as: "p"
    }, currency?.symbol)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            flex: 1
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $5c0c2c3952297d70$export$2e2bcd8739ae039), {
        type: "number",
        value: price,
        onChange: onChange,
        onBlur: onBlur,
        placeholder: placeholder
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            ml: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: chainId,
        amount: profit,
        address: currency?.contract,
        decimals: currency?.decimals,
        symbol: currency?.symbol,
        textStyle: "h6",
        logoWidth: 18
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: profit * (usdPrice || 0),
        style: "subtitle3",
        color: "subtle"
    })));
};
var $216fa61d27b775ef$export$2e2bcd8739ae039 = $216fa61d27b775ef$var$PriceInput;





const $e8302fb60e57543b$var$ModalCopy = {
    title: "Edit Listing",
    ctaClose: "Close",
    ctaConfirm: "Confirm",
    ctaConvertManually: "Convert Manually",
    ctaConvertAutomatically: "",
    ctaAwaitingApproval: "Waiting for approval...",
    ctaAwaitingValidation: "Waiting for transaction to be validated"
};
const $e8302fb60e57543b$var$MINIMUM_AMOUNT = 0.000001;
const $e8302fb60e57543b$var$MAXIMUM_AMOUNT = Infinity;
function $e8302fb60e57543b$export$7856870a29100de3({ openState: openState, listingId: listingId, tokenId: tokenId, collectionId: collectionId, chainId: chainId, trigger: trigger, normalizeRoyalties: normalizeRoyalties, copyOverrides: copyOverrides, walletClient: walletClient, onClose: onClose, onEditListingComplete: onEditListingComplete, onEditListingError: onEditListingError, onPointerDownOutside: onPointerDownOutside }) {
    const copy = {
        ...$e8302fb60e57543b$var$ModalCopy,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $15b40f9f8236e7c4$export$10f582750caac37a), {
        listingId: listingId,
        chainId: modalChain?.id,
        tokenId: tokenId,
        collectionId: collectionId,
        open: open,
        normalizeRoyalties: normalizeRoyalties,
        walletClient: walletClient
    }, ({ loading: loading, listing: listing, token: token, price: price, currency: currency, isOracleOrder: isOracleOrder, quantityAvailable: quantityAvailable, collection: collection, quantity: quantity, expirationOption: expirationOption, expirationOptions: expirationOptions, editListingStep: editListingStep, transactionError: transactionError, usdPrice: usdPrice, totalUsd: totalUsd, royaltyBps: royaltyBps, stepData: stepData, exchange: exchange, setPrice: setPrice, setQuantity: setQuantity, setExpirationOption: setExpirationOption, editListing: editListing })=>{
        const expires = (0, $2f4c390a81073897$export$2e2bcd8739ae039)(listing?.expiration);
        const profit = (1 - (royaltyBps || 0) * 0.0001) * (price || 0) * quantity;
        const updatedTotalUsd = profit * usdPrice;
        (0, $TBcmg$useEffect)(()=>{
            if (editListingStep === (0, $15b40f9f8236e7c4$export$3a845fe90ed2a8d8).Complete && onEditListingComplete) {
                const data = {
                    listing: listing,
                    stepData: stepData
                };
                onEditListingComplete(data);
            }
        }, [
            editListingStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onEditListingError) {
                const data = {
                    listing: listing,
                    stepData: stepData
                };
                onEditListingError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const isListingAvailable = listing && (listing.status === "active" || listing.status === "inactive") && !loading;
        const isListingEditable = listing && listing.status === "active" && !loading && isOracleOrder;
        const minimumAmount = exchange?.minPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.minPriceRaw), currency?.decimals || 18)) : $e8302fb60e57543b$var$MINIMUM_AMOUNT;
        const maximumAmount = exchange?.maxPriceRaw ? Number((0, $TBcmg$formatUnits)(BigInt(exchange.maxPriceRaw), currency?.decimals || 18)) : $e8302fb60e57543b$var$MAXIMUM_AMOUNT;
        const withinPricingBounds = price !== 0 && Number(price) <= maximumAmount && Number(price) >= minimumAmount;
        const canPurchase = price && price !== 0 && withinPricingBounds;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.title,
            open: open,
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        listing: listing,
                        stepData: stepData
                    };
                    onClose(data, editListingStep);
                }
                setOpen(open);
            },
            loading: loading,
            onPointerDownOutside: (e)=>{
                if (onPointerDownOutside) onPointerDownOutside(e);
            }
        }, !isListingAvailable && !loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                px: "$4",
                py: "$6"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Selected listing is no longer available")), !isListingEditable && isListingAvailable && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                px: "$4",
                py: "$6"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Selected listing is not an oracle order, so cannot be edited.")), isListingEditable && editListingStep === (0, $15b40f9f8236e7c4$export$3a845fe90ed2a8d8).Edit && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, transactionError && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $borderColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6a7867ba1ffb99fc$export$2e2bcd8739ae039), {
            chain: modalChain,
            img: token?.token?.imageSmall,
            name: listing.criteria?.data?.token?.name,
            price: listing?.price?.amount?.decimal,
            priceSubtitle: "Price",
            royaltiesBps: royaltyBps,
            usdPrice: totalUsd,
            collection: listing.criteria?.data?.collection?.name || "",
            currencyContract: listing.price?.currency?.contract,
            currencyDecimals: listing?.price?.currency?.decimals,
            currencySymbol: listing?.price?.currency?.symbol,
            expires: expires,
            source: listing?.source?.icon || "",
            quantity: listing?.quantityRemaining
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                px: "$4",
                py: "$2"
            }
        }, quantityAvailable > 1 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                mb: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: "div",
            css: {
                mb: "$2"
            },
            style: "subtitle3",
            color: "subtle"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039), {
            value: `${quantity}`,
            onValueChange: (value)=>{
                setQuantity(Number(value));
            }
        }, [
            ...Array(quantityAvailable)
        ].map((_a, i)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Item, {
                key: i,
                value: `${i + 1}`
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).ItemText, null, i + 1))))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            css: {
                mb: 24,
                display: "inline-block"
            }
        }, quantityAvailable, " items available")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mb: "$2"
            },
            justify: "between"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            as: "p"
        }, "Set New Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                alignItems: "center",
                gap: 8
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            as: "p"
        }, "You Get"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a813136de1d75d50$export$2e2bcd8739ae039), {
            side: "left",
            width: 200,
            content: `How much ${currency?.symbol} you will receive after creator royalties are subtracted.`
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $216fa61d27b775ef$export$2e2bcd8739ae039), {
            chainId: modalChain?.id,
            price: price,
            collection: collection,
            currency: currency,
            usdPrice: usdPrice,
            quantity: quantity,
            placeholder: "Enter a listing price",
            onChange: (e)=>{
                if (e.target.value === "") setPrice(undefined);
                else setPrice(Number(e.target.value));
            },
            onBlur: ()=>{
                if (price === undefined) setPrice(0);
            }
        }), price && price !== 0 && !withinPricingBounds && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "error"
        }, maximumAmount !== Infinity ? `Amount must be between ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount)} - ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(maximumAmount)}` : `Amount must be higher than ${(0, $6f54b4a5aad888ed$export$f5dd818bff069720)(minimumAmount)}`)), collection && collection?.floorAsk?.price?.amount?.native !== undefined && canPurchase && currency?.contract === (0, $TBcmg$zeroAddress) && price < collection?.floorAsk?.price.amount.native && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "error"
        }, "Price is", " ", Math.round((collection.floorAsk.price.amount.native - price) / ((collection.floorAsk.price.amount.native + price) / 2) * 100000) / 1000, "% below the floor"))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                mb: "$3",
                mt: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            as: "div",
            css: {
                mb: "$2"
            },
            style: "subtitle3",
            color: "subtle"
        }, "Expiration Date"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039), {
            value: expirationOption?.text || "",
            onValueChange: (value)=>{
                const option = expirationOptions.find((option)=>option.value == value);
                if (option) setExpirationOption(option);
            }
        }, expirationOptions.filter(({ value: value })=>value !== "custom").map((option)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).Item, {
                key: option.text,
                value: option.value
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $53b68d251033efcb$export$2e2bcd8739ae039).ItemText, null, option.text))))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                gap: "$3",
                py: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            color: "secondary",
            css: {
                flex: 1
            }
        }, copy.ctaClose), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: !canPurchase,
            onClick: editListing,
            css: {
                flex: 1
            }
        }, copy.ctaConfirm)))), editListingStep === (0, $15b40f9f8236e7c4$export$3a845fe90ed2a8d8).Approving && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $borderColor"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $6a7867ba1ffb99fc$export$2e2bcd8739ae039), {
            chain: modalChain,
            img: token?.token?.imageSmall,
            name: token?.token?.name,
            price: profit,
            usdPrice: updatedTotalUsd,
            collection: collection?.name || "",
            currencyContract: listing?.price?.currency?.contract,
            currencyDecimals: listing?.price?.currency?.decimals,
            currencySymbol: listing?.price?.currency?.symbol,
            expires: `in ${expirationOption.text.toLowerCase()}`,
            source: listing?.source?.icon || "",
            quantity: quantity
        })), !stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
            css: {
                height: 206
            }
        }), stepData && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e92d8c2581b5f9df$export$2e2bcd8739ae039), {
            title: stepData?.currentStepItem.txHashes ? "Finalizing on blockchain" : "Approve Reservoir Oracle to update the listing",
            txHashes: stepData?.currentStepItem?.txHashes
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), stepData?.currentStepItem?.txHashes ? copy.ctaAwaitingValidation : copy.ctaAwaitingApproval)), editListingStep === (0, $15b40f9f8236e7c4$export$3a845fe90ed2a8d8).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4",
                py: "$5",
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$successAccent",
                mb: 24
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCheckCircle),
            size: "3x"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                mb: "$4"
            }
        }, "Listing Updated!"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle",
            css: {
                mb: 24
            }
        }, "Your listing for", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "base"
        }, token?.token?.name), " ", "has been updated.")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                m: "$4"
            }
        }, copy.ctaClose)));
    });
}
$e8302fb60e57543b$export$7856870a29100de3.Custom = (0, $15b40f9f8236e7c4$export$10f582750caac37a);


















var $35205ce66a4a25b2$export$692b64e8a8032f02;
(function(MintStep) {
    MintStep[MintStep["Idle"] = 0] = "Idle";
    MintStep[MintStep["SelectPayment"] = 1] = "SelectPayment";
    MintStep[MintStep["Approving"] = 2] = "Approving";
    MintStep[MintStep["Finalizing"] = 3] = "Finalizing";
    MintStep[MintStep["Complete"] = 4] = "Complete";
})($35205ce66a4a25b2$export$692b64e8a8032f02 || ($35205ce66a4a25b2$export$692b64e8a8032f02 = {}));
const $35205ce66a4a25b2$export$37d7d25acf36b96e = ({ open: open, contract: contract, collectionId: collectionId, token: token, onConnectWallet: onConnectWallet, chainId: chainId, defaultQuantity: defaultQuantity, feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, children: children, walletClient: walletClient })=>{
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const config = (0, $TBcmg$useConfig)();
    const { address: address, connector: connector } = (0, $TBcmg$useAccount)();
    const [mintStep, setMintStep] = (0, $TBcmg$useState)($35205ce66a4a25b2$export$692b64e8a8032f02.Idle);
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [orders, setOrders] = (0, $TBcmg$useState)([]);
    const [isFetchingPath, setIsFetchingPath] = (0, $TBcmg$useState)(false);
    const [fetchedInitialOrders, setFetchedInitialOrders] = (0, $TBcmg$useState)(false);
    const [itemAmount, setItemAmount] = (0, $TBcmg$useState)(1);
    const [maxItemAmount, setMaxItemAmount] = (0, $TBcmg$useState)(1);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [fetchMintPathError, setFetchMintPathError] = (0, $TBcmg$useState)();
    const [totalIncludingFees, setTotalIncludingFees] = (0, $TBcmg$useState)(0n);
    const [hasEnoughCurrency, setHasEnoughCurrency] = (0, $TBcmg$useState)(true);
    const [feeOnTop, setFeeOnTop] = (0, $TBcmg$useState)(0n);
    const [mintResponseFees, setMintResponseFees] = (0, $TBcmg$useState)(undefined);
    const currentChain = client?.currentChain();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWallet;
    const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(rendererChain?.id);
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const includeListingCurrency = providerOptions.alwaysIncludeListingCurrency !== false;
    const disableJumperLink = providerOptions?.disableJumperLink;
    const { data: capabilities } = (0, $TBcmg$useCapabilities)({
        query: {
            enabled: connector && (connector.id === "coinbaseWalletSDK" || connector.id === "coinbase")
        }
    });
    const hasAuxiliaryFundsSupport = Boolean(rendererChain?.id ? capabilities?.[rendererChain?.id]?.auxiliaryFunds?.supported : false);
    const collectionContract = contract ?? collectionId?.split(":")?.[0] ?? token?.split(":")?.[0];
    const tokenId = token?.split(":")?.[1];
    const { data: collections, mutate: mutateCollection, isFetchingPage: isFetchingCollections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && {
        contract: collectionId ? undefined : collectionContract,
        id: collectionId ? collectionId : undefined,
        includeMintStages: true
    }, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    const is1155 = collection?.contractKind === "erc1155";
    const isSingleToken1155 = is1155 && collection?.tokenCount === "1";
    const { data: tokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && collection && (tokenId || isSingleToken1155) ? {
        collection: isSingleToken1155 ? collection?.id : undefined,
        tokens: isSingleToken1155 ? undefined : `${collectionContract}:${tokenId}`
    } : undefined, {}, rendererChain?.id);
    const tokenData = tokens && tokens[0] ? tokens[0] : undefined;
    const [_paymentCurrency, _setPaymentCurrency] = (0, $TBcmg$useState)(undefined);
    const paymentKey = (0, $TBcmg$useMemo)(()=>{
        if (token) return token;
        else if (tokenData?.token?.tokenId && collectionContract) return `${collectionContract}:${tokenData?.token?.tokenId}`;
        else if (collectionId) return collectionId;
        else return collectionContract;
    }, [
        token,
        collectionId,
        ,
        collectionContract,
        tokenData?.token?.tokenId
    ]);
    const paymentTokens = (0, $f19c84e0e180ca0e$export$2e2bcd8739ae039)({
        open: open,
        address: address,
        quantityToken: {
            [`${paymentKey}`]: itemAmount
        },
        path: orders,
        nativeOnly: true,
        chainId: rendererChain?.id,
        crossChainDisabled: false
    });
    const paymentCurrency = paymentTokens?.find((paymentToken)=>paymentToken?.address === _paymentCurrency?.address && paymentToken?.chainId === _paymentCurrency?.chainId);
    const usdPrice = paymentCurrency?.usdPrice || 0;
    const usdPriceRaw = paymentCurrency?.usdPriceRaw || 0n;
    const feeUsd = (0, $TBcmg$formatUnits)(feeOnTop * usdPriceRaw, (paymentCurrency?.decimals || 18) + 6);
    // Fetch mint path
    const fetchMintPath = (0, $TBcmg$useCallback)((paymentCurrency)=>{
        if (!open || !client) return;
        setIsFetchingPath(true);
        let options = {
            partial: true,
            onlyPath: true,
            currencyChainId: paymentCurrency?.chainId
        };
        if (feesOnTopBps && feesOnTopBps?.length > 0) {
            const fixedFees = feesOnTopBps.map((fullFee)=>{
                const [referrer] = fullFee.split(":");
                return `${referrer}:1`;
            });
            options.feesOnTop = fixedFees;
        } else if (feesOnTopUsd && feesOnTopUsd.length > 0) {
            const feesOnTopFixed = feesOnTopUsd.map((feeOnTop)=>{
                const [recipient] = feeOnTop.split(":");
                return `${recipient}:1`;
            });
            options.feesOnTop = feesOnTopFixed;
        } else if (!feesOnTopUsd && !feesOnTopBps) delete options.feesOnTop;
        return client?.actions.mintToken({
            chainId: rendererChain?.id,
            items: [
                {
                    collection: token ?? tokenData?.token?.tokenId ? undefined : collection?.id,
                    token: token ?? tokenData?.token?.tokenId ? `${collectionContract}:${tokenId ?? tokenData?.token?.tokenId}` : undefined
                }
            ],
            expectedPrice: undefined,
            options: options,
            wallet: {
                address: async ()=>{
                    return address || (0, $TBcmg$zeroAddress);
                }
            },
            precheck: true,
            onProgress: ()=>{}
        }).then((rawData)=>{
            let data = rawData;
            if ("path" in data) {
                let pathData = data["path"];
                setOrders(pathData ?? []);
                if (data.fees) setMintResponseFees(data.fees);
                const pathOrderQuantity = pathData?.reduce((quantity, order)=>quantity + (order?.quantity || 1), 0) || 0;
                let totalMaxQuantity = pathOrderQuantity;
                if ("maxQuantities" in data && data.maxQuantities?.[0]) {
                    if (is1155) totalMaxQuantity = data.maxQuantities.reduce((total, currentQuantity)=>{
                        let maxQuantity = 0;
                        if (currentQuantity.maxQuantity === null) //Hardcoded to 30k items if unlimited
                        maxQuantity = 30000;
                        else if (!currentQuantity.maxQuantity) // if value is undefined, we don't know max quantity, but simulation succeeed with quantity of 1
                        maxQuantity = 1;
                        else maxQuantity = Number(currentQuantity.maxQuantity ?? 0);
                        return total + maxQuantity;
                    }, 0);
                    else {
                        let maxQuantity = data.maxQuantities?.[0].maxQuantity;
                        // if value is null/undefined, we don't know max quantity, but simulation succeeed with quantity of 1
                        totalMaxQuantity = maxQuantity ? Number(maxQuantity) : 1;
                    }
                }
                setMaxItemAmount(pathOrderQuantity > totalMaxQuantity ? totalMaxQuantity : pathOrderQuantity);
            }
        }).catch((err)=>{
            setOrders([]);
            setFetchMintPathError(err);
            throw err;
        }).finally(()=>{
            setFetchedInitialOrders(true);
            setIsFetchingPath(false);
        });
    }, [
        open,
        address,
        client,
        wallet,
        rendererChain,
        contract,
        tokenId,
        collection,
        token,
        tokenData?.token?.tokenId,
        paymentCurrency?.chainId,
        is1155,
        feesOnTopBps,
        feesOnTopUsd
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (open && (collection || tokenData) && !paymentCurrency) fetchMintPath(paymentCurrency);
    }, [
        fetchMintPath,
        open,
        collection,
        tokenData,
        paymentCurrency
    ]);
    const setPaymentCurrency = (0, $TBcmg$useCallback)((value)=>{
        if (typeof value === "function") _setPaymentCurrency((prevState)=>{
            const newValue = value(prevState);
            if (newValue?.address !== paymentCurrency?.address || newValue?.chainId !== paymentCurrency?.chainId) fetchMintPath(newValue)?.catch((err)=>{
                if (err?.statusCode === 400 && err?.message?.includes("Price too high")) _setPaymentCurrency(prevState);
            });
            return newValue;
        });
        else if (value?.address !== paymentCurrency?.address || value?.chainId !== paymentCurrency?.chainId) {
            _setPaymentCurrency(value);
            fetchMintPath(value)?.catch((err)=>{
                if (err?.statusCode === 400 && err?.message?.includes("Price too high")) _setPaymentCurrency(paymentCurrency);
            });
        }
    }, [
        fetchMintPath,
        _setPaymentCurrency,
        paymentCurrency
    ]);
    (0, $TBcmg$useEffect)(()=>{
        let totalFees = 0n;
        if (paymentCurrency?.currencyTotalRaw && paymentCurrency.currencyTotalRaw > 0n) {
            let currencyTotalRawMinusRelayerFees = paymentCurrency?.currencyTotalRaw;
            // if there is a relayer fee, subtract from currencyTotalRaw
            if (mintResponseFees?.relayer?.amount?.raw) {
                const relayerFees = BigInt(mintResponseFees?.relayer?.amount?.raw ?? 0);
                currencyTotalRawMinusRelayerFees -= relayerFees;
            }
            if (feesOnTopBps && feesOnTopBps.length > 0) {
                const fees = feesOnTopBps.reduce((totalFees, feeOnTop)=>{
                    const [_, fee] = feeOnTop.split(":");
                    return totalFees + BigInt(fee) * currencyTotalRawMinusRelayerFees / 10000n;
                }, 0n);
                totalFees += fees;
                setFeeOnTop(fees);
            } else if (feesOnTopUsd && feesOnTopUsd.length > 0 && usdPriceRaw) {
                const fees = feesOnTopUsd.reduce((totalFees, feeOnTop)=>{
                    const [_, fee] = feeOnTop.split(":");
                    const atomicFee = BigInt(fee);
                    const convertedAtomicFee = atomicFee * BigInt(10 ** paymentCurrency?.decimals);
                    const currencyFee = convertedAtomicFee / usdPriceRaw;
                    return totalFees + currencyFee;
                }, 0n);
                totalFees += fees;
                setFeeOnTop(fees);
            } else setFeeOnTop(0n);
            setTotalIncludingFees(paymentCurrency?.currencyTotalRaw + totalFees);
        } else setTotalIncludingFees(0n);
    }, [
        feesOnTopBps,
        feesOnTopUsd,
        usdPriceRaw,
        feeOnTop,
        itemAmount,
        paymentCurrency,
        mintResponseFees
    ]);
    const { relayLink: relayLink } = (0, $ff7ce0ca6096b543$export$2e2bcd8739ae039)(rendererChain?.id);
    let addFundsLink = "";
    if (relayLink) addFundsLink = paymentCurrency?.address ? `${relayLink}?toCurrency=${paymentCurrency?.address}` : relayLink;
    else addFundsLink = paymentCurrency?.address ? `https://jumper.exchange/?toChain=${rendererChain?.id}&toToken=${paymentCurrency?.address}` : `https://jumper.exchange/?toChain=${rendererChain?.id}`;
    if (providerOptions?.convertLink?.chainUrl) {
        addFundsLink = paymentCurrency?.address && providerOptions.convertLink.tokenUrl ? providerOptions.convertLink.tokenUrl : providerOptions.convertLink.chainUrl;
        if (rendererChain?.id) addFundsLink = addFundsLink.replace("{toChain}", `${rendererChain.id}`);
        if (paymentCurrency?.address) addFundsLink = addFundsLink.replace("{toToken}", paymentCurrency?.address);
    } else if (providerOptions?.convertLink?.customUrl) addFundsLink = providerOptions.convertLink.customUrl?.({
        toChain: rendererChain?.id,
        toToken: paymentCurrency?.address,
        toCurrency: paymentCurrency
    });
    // Determine if user has enough funds in paymentToken
    (0, $TBcmg$useEffect)(()=>{
        if (paymentCurrency?.balance != undefined && totalIncludingFees != undefined && BigInt(paymentCurrency?.balance) < totalIncludingFees) setHasEnoughCurrency(false);
        else setHasEnoughCurrency(true);
    }, [
        totalIncludingFees,
        paymentCurrency?.balance
    ]);
    // Set initial payment currency
    (0, $TBcmg$useEffect)(()=>{
        if (paymentTokens[0] && !paymentCurrency && fetchedInitialOrders) {
            if (!includeListingCurrency) _setPaymentCurrency(paymentTokens[0]);
            else _setPaymentCurrency(chainCurrency);
        }
    }, [
        paymentTokens,
        paymentCurrency,
        fetchedInitialOrders
    ]);
    // Reset state on close
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setOrders([]);
            setItemAmount(1);
            setMaxItemAmount(1);
            setMintStep($35205ce66a4a25b2$export$692b64e8a8032f02.Idle);
            setTransactionError(null);
            setFetchMintPathError(null);
            setFetchedInitialOrders(false);
            _setPaymentCurrency(undefined);
            setStepData(null);
            setMintResponseFees(undefined);
        } else setItemAmount(defaultQuantity || 1);
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "mintModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    (0, $TBcmg$useEffect)(()=>{
        if (maxItemAmount > 0 && itemAmount > maxItemAmount) setItemAmount(maxItemAmount);
    }, [
        maxItemAmount,
        itemAmount
    ]);
    const mintTokens = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            onConnectWallet();
            if (document.body.style) document.body.style.pointerEvents = "auto";
            client?.log([
                "Missing wallet, prompting connection"
            ], (0, $TBcmg$LogLevel).Verbose);
            return;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (paymentCurrency?.chainId !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: paymentCurrency?.chainId
        });
        if (paymentCurrency?.chainId !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        setTransactionError(null);
        let options = {
            partial: true,
            currencyChainId: paymentCurrency?.chainId,
            skipBalanceCheck: hasAuxiliaryFundsSupport
        };
        const relayerFee = BigInt(mintResponseFees?.relayer?.amount?.raw ?? 0);
        if (feesOnTopBps && feesOnTopBps?.length > 0) {
            const fixedFees = feesOnTopBps.map((fullFee)=>{
                const [referrer, feeBps] = fullFee.split(":");
                let totalFeeTruncated = totalIncludingFees - feeOnTop;
                if (relayerFee) totalFeeTruncated -= relayerFee;
                const fee = Math.floor(Number(totalFeeTruncated * BigInt(feeBps)) / 10000);
                const atomicUnitsFee = (0, $TBcmg$formatUnits)(BigInt(fee), 0);
                return `${referrer}:${atomicUnitsFee}`;
            });
            options.feesOnTop = fixedFees;
        } else if (feesOnTopUsd && feesOnTopUsd.length > 0 && usdPriceRaw) {
            const feesOnTopFixed = feesOnTopUsd.map((feeOnTop)=>{
                const [recipient, fee] = feeOnTop.split(":");
                const atomicFee = BigInt(fee);
                const convertedAtomicFee = atomicFee * BigInt(10 ** paymentCurrency?.decimals);
                const currencyFee = convertedAtomicFee / usdPriceRaw;
                const parsedFee = (0, $TBcmg$formatUnits)(currencyFee, 0);
                return `${recipient}:${parsedFee}`;
            });
            options.feesOnTop = feesOnTopFixed;
        } else if (!feesOnTopUsd && !feesOnTopBps) delete options.feesOnTop;
        setMintStep($35205ce66a4a25b2$export$692b64e8a8032f02.Approving);
        client.actions.mintToken({
            chainId: rendererChain?.id,
            items: [
                {
                    collection: tokenData?.token?.tokenId ? undefined : collection?.id,
                    token: tokenData?.token?.tokenId ? `${collectionContract}:${tokenData?.token?.tokenId}` : undefined,
                    quantity: itemAmount
                }
            ],
            expectedPrice: {
                [paymentCurrency?.address || (0, $TBcmg$zeroAddress)]: {
                    raw: totalIncludingFees - relayerFee,
                    currencyAddress: paymentCurrency?.address,
                    currencyDecimals: paymentCurrency?.decimals || 18
                }
            },
            wallet: wallet,
            options: options,
            onProgress: (steps, path)=>{
                if (!steps) return;
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem,
                    path: path
                });
                if (currentStepIndex + 1 === executableSteps.length && currentStep?.items?.every((item)=>item.txHashes)) setMintStep($35205ce66a4a25b2$export$692b64e8a8032f02.Finalizing);
                if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setMintStep($35205ce66a4a25b2$export$692b64e8a8032f02.Complete);
            }
        }).catch((error)=>{
            setTransactionError(error);
            setMintStep($35205ce66a4a25b2$export$692b64e8a8032f02.Idle);
            mutateCollection();
            fetchMintPath(paymentCurrency);
        });
    }, [
        client,
        wallet,
        config,
        address,
        wagmiChain,
        rendererChain,
        contract,
        token,
        feesOnTopBps,
        onConnectWallet,
        feesOnTopUsd,
        itemAmount,
        paymentCurrency?.address,
        paymentCurrency?.chainId,
        paymentCurrency?.currencyTotalRaw,
        totalIncludingFees,
        tokenData?.token?.tokenId,
        collection?.id,
        collectionContract,
        mintResponseFees,
        usdPriceRaw,
        hasAuxiliaryFundsSupport
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: isFetchingCollections || !isFetchingCollections && collection && !fetchedInitialOrders || (token !== undefined || isSingleToken1155) && !tokenData || !(paymentTokens.length > 0),
        isFetchingPath: isFetchingPath,
        collection: collection,
        token: tokenData,
        orders: orders,
        totalIncludingFees: totalIncludingFees,
        mintResponseFees: mintResponseFees,
        feeOnTop: feeOnTop,
        feeUsd: feeUsd,
        paymentTokens: paymentTokens,
        paymentCurrency: paymentCurrency,
        setPaymentCurrency: setPaymentCurrency,
        addFundsLink: addFundsLink,
        chainCurrency: chainCurrency,
        itemAmount: itemAmount,
        setItemAmount: setItemAmount,
        maxItemAmount: maxItemAmount,
        setMaxItemAmount: setMaxItemAmount,
        usdPrice: usdPrice,
        usdPriceRaw: usdPriceRaw,
        currentChain: currentChain,
        address: address,
        isConnected: wallet !== undefined,
        disableJumperLink: disableJumperLink,
        balance: paymentCurrency?.balance ? BigInt(paymentCurrency.balance) : undefined,
        hasEnoughCurrency: hasEnoughCurrency,
        hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport,
        transactionError: transactionError,
        fetchMintPathError: fetchMintPathError,
        stepData: stepData,
        mintStep: mintStep,
        setStepData: setStepData,
        setMintStep: setMintStep,
        mintTokens: mintTokens
    }));
};


















const $1fc5a6190fea5008$export$8867c41adbe809fa = ({ currentStep: currentStep, css: css })=>{
    const hasValidTxHashes = currentStep?.items?.some((item)=>Array.isArray(item?.txHashes) && item.txHashes.length > 0 || Array.isArray(item?.internalTxHashes) && item.internalTxHashes.length > 0);
    // Return null if there are no valid txHashes or internalTxHashes
    if (!hasValidTxHashes) return null;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        css: {
            width: "100%",
            gap: "$2",
            mb: "$3",
            px: "$5",
            ...css
        }
    }, currentStep?.items?.map((item, itemIndex)=>{
        // Check if txHashes and internalTxHashes arrays are valid and merge them
        const validTxHashes = Array.isArray(item?.txHashes) && item?.txHashes.length > 0 ? item.txHashes : [];
        const validInternalTxHashes = Array.isArray(item?.internalTxHashes) && item?.internalTxHashes.length > 0 ? item.internalTxHashes : [];
        const allTxHashes = [
            ...validTxHashes,
            ...validInternalTxHashes
        ];
        if (allTxHashes?.length > 0) return allTxHashes?.map((hash, txHashIndex)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                key: `${itemIndex}-${txHashIndex}`,
                href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                color: "primary",
                weight: "medium",
                target: "_blank",
                css: {
                    fontSize: 12
                }
            }, "View transaction: ", truncatedTxHash);
        });
        else return null;
    }));
};






var $3252fd4b8efa16bf$var$Size;
(function(Size) {
    Size[Size["SM"] = 0] = "SM";
    Size[Size["LG"] = 1] = "LG";
})($3252fd4b8efa16bf$var$Size || ($3252fd4b8efa16bf$var$Size = {}));
const $3252fd4b8efa16bf$export$c48a33806654dd82 = ({ itemCount: itemCount, images: images, totalPrice: totalPrice, usdPrice: usdPrice, currency: currency, chain: chain, size: size = $3252fd4b8efa16bf$var$Size.LG })=>{
    const itemSubject = itemCount > 1 ? "items" : "item";
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: size == $3252fd4b8efa16bf$var$Size.SM ? "$3" : "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), null, images.map((image)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
            src: image,
            key: image,
            css: {
                borderRadius: 4,
                objectFit: "cover",
                height: size == $3252fd4b8efa16bf$var$Size.SM ? 40 : 56,
                width: size == $3252fd4b8efa16bf$var$Size.SM ? 40 : 56,
                "& + img, & + div": {
                    marginLeft: size == $3252fd4b8efa16bf$var$Size.SM ? -32 : -48,
                    zIndex: -1
                }
            }
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: size == $3252fd4b8efa16bf$var$Size.SM ? "subtitle3" : "h6"
    }, itemCount, " ", itemSubject)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        textStyle: size == $3252fd4b8efa16bf$var$Size.SM ? "subtitle3" : "h6",
        amount: totalPrice,
        address: currency?.contract,
        decimals: currency?.decimals,
        symbol: currency?.symbol,
        logoWidth: size == $3252fd4b8efa16bf$var$Size.SM ? 12 : 18,
        chainId: chain?.id
    }), usdPrice ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdPrice * totalPrice,
        style: "subtitle3",
        color: "subtle",
        css: {
            textAlign: "end"
        }
    }) : null));
};




const $add635cbf9f5888f$export$d7253bf947e7aaac = ({ item: item, pathMap: pathMap, usdPrice: usdPrice, chain: chain, open: open })=>{
    const [collapsibleOpen, setCollapsibleOpen] = (0, $TBcmg$useState)(false);
    const isComplete = item && item?.status == "complete";
    const itemCount = item?.orderIds?.length || 1;
    function processOrders(orderIds) {
        let totalPrice = 0;
        let images = [];
        orderIds.forEach((orderId)=>{
            const path = pathMap[orderId];
            if (path) {
                let imageRedirect = `${chain?.baseApiUrl}/redirect/tokens/${path.contract}:${path.tokenId}/image/v1?imageSize=small`;
                images.push(imageRedirect);
                totalPrice += path.quote || 0;
            }
        });
        images = images.slice(0, 2);
        return {
            totalPrice: totalPrice,
            images: images
        };
    }
    const { totalPrice: totalPrice, images: images } = processOrders(item?.orderIds);
    (0, $TBcmg$useEffect)(()=>{
        if (open !== undefined && open !== collapsibleOpen) setCollapsibleOpen(open);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $257531ce0e45ad5e$export$45aa975411b5e199), {
        title: "Approve transaction",
        open: collapsibleOpen,
        onOpenChange: setCollapsibleOpen,
        isComplete: isComplete
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            px: "$4",
            pb: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $3252fd4b8efa16bf$export$c48a33806654dd82), {
        usdPrice: usdPrice,
        itemCount: itemCount,
        totalPrice: totalPrice,
        images: images,
        size: 0
    })));
};






let $0e20de6a6de69864$var$modelViewerInjected = false;
const $0e20de6a6de69864$var$importScript = (src)=>{
    if (document) {
        const script = document.createElement("script");
        script.async = true;
        script.src = src;
        script.type = "module";
        document.body.appendChild(script);
    }
};
const $0e20de6a6de69864$var$useModelViewer = (enabled)=>{
    (0, $TBcmg$useEffect)(()=>{
        if (enabled && !$0e20de6a6de69864$var$modelViewerInjected) {
            $0e20de6a6de69864$var$modelViewerInjected = true;
            $0e20de6a6de69864$var$importScript("https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js");
        }
    }, [
        enabled
    ]);
};
var $0e20de6a6de69864$export$2e2bcd8739ae039 = $0e20de6a6de69864$var$useModelViewer;









const $4104b64cb3336525$var$MediaPlayButton = ({ mediaRef: mediaRef })=>{
    const [playing, setPlaying] = (0, $TBcmg$useState)(false);
    (0, $TBcmg$useEffect)(()=>{
        if (mediaRef.current) {
            mediaRef.current.onplaying = ()=>{
                setPlaying(true);
            };
            mediaRef.current.onpause = ()=>{
                setPlaying(false);
            };
        }
        return ()=>{
            if (mediaRef.current) {
                mediaRef.current.onplaying = null;
                mediaRef.current.onpause = null;
            }
        };
    }, [
        mediaRef
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        css: {
            zIndex: 5,
            position: "absolute",
            right: 16,
            bottom: 16,
            backdropFilter: "blur(2px)",
            background: "rgba(105, 113, 119, 0.5)",
            width: 48,
            height: 48,
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            "&:hover": {
                background: "rgba(105, 113, 119, 0.7)"
            }
        },
        onClick: (e)=>{
            e.preventDefault();
            if (mediaRef.current) {
                if (mediaRef.current.paused) mediaRef.current.play();
                else mediaRef.current.pause();
            }
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: playing ? (0, $TBcmg$faPause) : (0, $TBcmg$faPlay),
        width: 24,
        height: 24
    }));
};
var $4104b64cb3336525$export$2e2bcd8739ae039 = $4104b64cb3336525$var$MediaPlayButton;










const $f03f6cdb7e860913$var$TokenFallback = ({ mode: mode, style: style, className: className, token: token, chainId: chainId, onRefreshClicked: onRefreshClicked })=>{
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const reservoirChain = chainId ? client?.chains.find((chain)=>chain.id === chainId) : client?.currentChain();
    const contract = token?.collection?.id ? token?.collection.id?.split(":")[0] : undefined;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "center",
        align: "center",
        direction: "column",
        css: {
            gap: "$2",
            aspectRatio: "1/1",
            p: "$2",
            ...style
        },
        className: className
    }, mode === "simple" || !token?.collection?.id ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faImage),
        style: {
            height: "50%"
        }
    }) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, token?.collection?.image && /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
        style: {
            width: 64,
            height: 64,
            objectFit: "cover",
            borderRadius: 8
        },
        src: token?.collection?.image
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body2",
        css: {
            textAlign: "center"
        }
    }, "No Content Available"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        color: "secondary",
        onClick: (e)=>{
            e.preventDefault();
            if (!reservoirChain) throw "ReservoirClient missing chain configuration";
            onRefreshClicked();
            const url = `${reservoirChain?.baseApiUrl}/tokens/refresh/v2`;
            const body = {
                tokens: [
                    `${contract}:${token?.tokenId}`
                ]
            };
            const headers = {
                ...(0, $36299c87cce4672d$export$a6f1ecf08e412113)(client?.apiKey, client?.version),
                "Content-Type": "application/json"
            };
            (0, $TBcmg$axios)(url, {
                headers: headers,
                method: "POST",
                data: JSON.stringify(body)
            }).then((res)=>res.data).catch((e)=>{
                throw e;
            });
        }
    }, "Refresh")));
};
var $f03f6cdb7e860913$export$2e2bcd8739ae039 = $f03f6cdb7e860913$var$TokenFallback;




const $117d66b1e9d90e22$var$gatewayConfig = {
    "ipfs://": "https://ipfs.io/ipfs/",
    "ar://": "https://arweave.net/"
};
const $117d66b1e9d90e22$var$convertToGatewayUrl = (url)=>{
    for (const [protocol, gateway] of Object.entries($117d66b1e9d90e22$var$gatewayConfig)){
        if (url.includes(protocol)) return url.replace(protocol, gateway);
    }
    return url;
};
const $117d66b1e9d90e22$var$fetchUri = async (uri)=>{
    const response = await (0, $TBcmg$axios)($117d66b1e9d90e22$var$convertToGatewayUrl(uri), {
        method: "GET"
    });
    if (!(response.status >= 200 && response.status < 300)) throw new Error("Failed to fetch URI");
    return response.data;
};
const $117d66b1e9d90e22$export$728a0cef15fdee43 = async (uri)=>{
    try {
        const json = await $117d66b1e9d90e22$var$fetchUri(uri);
        if (json.image) {
            const image = $117d66b1e9d90e22$var$convertToGatewayUrl(json.image);
            return image;
        }
        return "";
    } catch (e) {
        console.error(e);
        return "";
    }
};


const $ec5c88ec55f0ed98$export$58ebf00a187db5d3 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]"
            }
        ],
        name: "TransferBatch",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            }
        ],
        name: "TransferSingle",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "URI",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            }
        ],
        name: "balanceOfBatch",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]"
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeBatchTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256"
            }
        ],
        name: "uri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];



const $b11e5b18b62632d1$export$b7d45a46da28b4d3 = (tokenMedia)=>{
    let extension = null;
    if (tokenMedia) {
        const pieces = tokenMedia.split("/");
        const file = pieces && pieces[pieces.length - 1] ? pieces[pieces.length - 1] : null;
        const matches = file ? file.match("(\\.[^.]+)$") : null;
        extension = matches && matches[0] ? matches[0].replace(".", "") : null;
    }
    return extension ? extension : null;
};
const $b11e5b18b62632d1$var$normalizeContentType = (contentType)=>{
    if (contentType?.includes("video/")) return contentType.replace("video/", "");
    if (contentType?.includes("audio/")) return contentType.replace("audio/", "");
    if (contentType?.includes("image/svg+xml")) return "svg";
    if (contentType?.includes("image/")) return contentType.replace("image/", "");
    if (contentType?.includes("text/")) return contentType.replace("text/", "");
    return null;
};
const $b11e5b18b62632d1$var$TokenMedia = ({ token: token, staticOnly: staticOnly, imageResolution: imageResolution, style: style, className: className, modelViewerOptions: modelViewerOptions = {}, videoOptions: videoOptions = {}, audioOptions: audioOptions = {}, iframeOptions: iframeOptions = {}, disableOnChainRendering: disableOnChainRendering, chainId: chainId, fallbackMode: fallbackMode, fallback: fallback, onError: onError = ()=>{}, onRefreshToken: onRefreshToken = ()=>{} })=>{
    const [detectingMediaType, setDetectingMediaType] = (0, $TBcmg$useState)(false);
    const [mediaType, setMediaType] = (0, $TBcmg$useState)(null);
    const mediaRef = (0, $TBcmg$useRef)(null);
    const themeContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$2c657da244d00bd6));
    let borderRadius = themeContext?.radii?.borderRadius?.value || "0";
    const [error, setError] = (0, $TBcmg$useState)(null);
    const media = token?.media;
    const tokenImage = (()=>{
        switch(imageResolution){
            case "small":
                return token?.imageSmall;
            case "large":
                return token?.imageLarge;
            case "medium":
            default:
                return token?.image;
        }
    })();
    (0, $TBcmg$useEffect)(()=>{
        setDetectingMediaType(true);
        let abort = false;
        let type = $b11e5b18b62632d1$export$b7d45a46da28b4d3(token?.media);
        if (!type && token?.media) {
            async function getContentType(tokenMedia) {
                const response = await fetch(tokenMedia);
                return response.headers.get("content-type");
            }
            getContentType(token.media).then((contentType)=>{
                if (contentType && !abort) {
                    const normalizedContentType = $b11e5b18b62632d1$var$normalizeContentType(contentType);
                    type = $b11e5b18b62632d1$export$b7d45a46da28b4d3(`.${normalizedContentType}`);
                    setMediaType(type);
                }
            }).finally(()=>{
                setDetectingMediaType(false);
            });
        } else {
            setMediaType(type);
            setDetectingMediaType(false);
        }
        return ()=>{
            abort = true;
            setDetectingMediaType(false);
        };
    }, [
        token?.media
    ]);
    const defaultStyle = {
        width: "150px",
        height: "150px",
        objectFit: "cover",
        borderRadius: borderRadius,
        position: "relative"
    };
    const computedStyle = {
        ...defaultStyle,
        ...style
    };
    (0, $0e20de6a6de69864$export$2e2bcd8739ae039)(!staticOnly && mediaType && (mediaType === "gltf" || mediaType === "glb") ? true : false);
    const [measurements, containerRef] = (0, $TBcmg$useMeasure)();
    const isContainerLarge = (measurements?.width || 0) >= 360;
    const contract = token?.collection?.id?.split(":")[0];
    const [onChainImage, setOnChainImage] = (0, $TBcmg$useState)("");
    const [onChainImageBroken, setOnChainImageBroken] = (0, $TBcmg$useState)(false);
    const [isUpdatingOnChainImage, setIsUpdatingOnChainImage] = (0, $TBcmg$useState)(false);
    const is1155 = token?.kind === "erc1155";
    const { data: tokenURI, isLoading: isFetchingTokenURI, isError: fetchTokenURIError } = (0, $TBcmg$useReadContract)(// @ts-ignore
    !disableOnChainRendering && (error || !media && !tokenImage) ? {
        address: contract,
        abi: is1155 ? (0, $ec5c88ec55f0ed98$export$58ebf00a187db5d3) : (0, $TBcmg$erc721Abi),
        functionName: is1155 ? "uri" : "tokenURI",
        args: token?.tokenId ? [
            BigInt(token?.tokenId)
        ] : undefined,
        chainId: chainId
    } : undefined);
    (0, $TBcmg$useEffect)(()=>{
        if (tokenURI) {
            setIsUpdatingOnChainImage(true);
            (async ()=>{
                const updatedOnChainImage = await (0, $117d66b1e9d90e22$export$728a0cef15fdee43)(tokenURI);
                setOnChainImage(updatedOnChainImage);
            })().then(()=>{
                setIsUpdatingOnChainImage(false);
            });
        }
    }, [
        tokenURI
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (mediaRef && mediaRef.current) mediaRef.current.load();
    }, [
        media
    ]);
    if (!token && !staticOnly) {
        console.warn("A token object or a media url are required!");
        return null;
    }
    if (detectingMediaType) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
        style: {
            ...computedStyle
        }
    });
    if (error || !media && !tokenImage) {
        if (!disableOnChainRendering && !onChainImageBroken && !fetchTokenURIError) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, isFetchingTokenURI || isUpdatingOnChainImage ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
            style: {
                ...computedStyle
            }
        }) : /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
            src: onChainImage,
            style: {
                ...computedStyle
            },
            alt: "Token Image",
            onError: (e)=>{
                setOnChainImageBroken(true);
            }
        }));
        let fallbackElement;
        if (fallback) fallbackElement = fallback(mediaType);
        if (!fallbackElement) fallbackElement = /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f03f6cdb7e860913$export$2e2bcd8739ae039), {
            style: style,
            className: className,
            token: token,
            mode: fallbackMode,
            onRefreshClicked: onRefreshToken
        });
        return fallbackElement;
    }
    const onErrorCb = (e)=>{
        setError(e);
        onError(e.nativeEvent);
    };
    if (staticOnly || !media) return /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
        alt: "Token Image",
        src: tokenImage,
        style: {
            ...computedStyle,
            visibility: !tokenImage || tokenImage.length === 0 ? "hidden" : "visible"
        },
        className: className,
        onError: onErrorCb
    });
    // VIDEO
    if (mediaType === "mp4" || mediaType === "mov") return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        className: className,
        style: computedStyle,
        ref: containerRef
    }, !isContainerLarge && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4104b64cb3336525$export$2e2bcd8739ae039), {
        mediaRef: mediaRef
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("video", {
        style: computedStyle,
        className: className,
        poster: tokenImage,
        ...videoOptions,
        controls: isContainerLarge,
        loop: true,
        playsInline: true,
        onError: onErrorCb,
        ref: mediaRef
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement("source", {
        src: media,
        type: "video/mp4"
    }), "Your browser does not support the", /*#__PURE__*/ (0, $TBcmg$react).createElement("code", null, "video"), " element."));
    // AUDIO
    if (mediaType === "wav" || mediaType === "mp3" || mediaType === "m4a") return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        className: className,
        style: computedStyle,
        ref: containerRef
    }, !isContainerLarge && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $4104b64cb3336525$export$2e2bcd8739ae039), {
        mediaRef: mediaRef
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
        alt: "Audio Poster",
        src: tokenImage,
        style: {
            position: "absolute",
            height: "100%",
            width: "100%",
            visibility: !tokenImage || tokenImage.length === 0 ? "hidden" : "visible",
            objectFit: "cover"
        },
        onError: onErrorCb
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement("audio", {
        src: media,
        ...audioOptions,
        onError: onErrorCb,
        ref: mediaRef,
        controls: isContainerLarge,
        style: {
            position: "absolute",
            bottom: 16,
            left: 16,
            width: "calc(100% - 32px)"
        }
    }, "Your browser does not support the", /*#__PURE__*/ (0, $TBcmg$react).createElement("code", null, "audio"), " element."));
    // 3D
    if (mediaType === "gltf" || mediaType === "glb") return(//@ts-ignore
    /*#__PURE__*/ (0, $TBcmg$react).createElement("model-viewer", {
        src: media,
        ar: true,
        "ar-modes": "webxr scene-viewer quick-look",
        poster: tokenImage,
        "seamless-poster": true,
        "shadow-intensity": "1",
        "camera-controls": true,
        "enable-pan": true,
        ...modelViewerOptions,
        style: computedStyle,
        className: className,
        onError: onErrorCb
    }));
    //Image
    if (mediaType === "png" || mediaType === "jpeg" || mediaType === "jpg" || mediaType === "gif") return /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
        alt: "Token Image",
        src: media,
        className: className,
        style: {
            ...computedStyle,
            visibility: !media || media.length === 0 ? "hidden" : "visible"
        },
        onError: onErrorCb
    });
    // HTML
    if (mediaType === "html" || mediaType === null || mediaType === undefined || mediaType === "other" || mediaType === "svg") return /*#__PURE__*/ (0, $TBcmg$react).createElement("iframe", {
        style: computedStyle,
        className: className,
        src: media,
        sandbox: "allow-scripts",
        frameBorder: "0",
        ...iframeOptions
    });
    return /*#__PURE__*/ (0, $TBcmg$react).createElement("img", {
        alt: "Token Image",
        src: tokenImage,
        style: {
            ...computedStyle,
            visibility: !tokenImage || tokenImage.length === 0 ? "hidden" : "visible"
        },
        className: className,
        onError: onErrorCb
    });
};
var $b11e5b18b62632d1$export$2e2bcd8739ae039 = $b11e5b18b62632d1$var$TokenMedia;




const $695bb0101b6ebdf3$export$103ed344964d8252 = ({ stepData: stepData, tokenKind: tokenKind })=>{
    const totalTransfersDataLength = (0, $TBcmg$useMemo)(()=>{
        return stepData?.currentStep?.items?.reduce((total, item)=>{
            return total + (item?.transfersData?.length || 0);
        }, 0) ?? 0;
    }, [
        stepData?.currentStep?.items
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            width: "100%",
            overflow: "hidden",
            position: "relative"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            zIndex: 2,
            width: "32px",
            background: "linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, $neutralBgSubtle 50%)"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            width: "100%",
            overflowX: totalTransfersDataLength > 3 ? "scroll" : "auto",
            gap: "$2",
            px: "$5",
            pb: 10,
            position: "relative",
            justifyContent: totalTransfersDataLength > 3 ? "flex-start" : "center"
        }
    }, stepData?.currentStep?.items?.map((item, itemIndex)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, {
            key: `item-${itemIndex}`
        }, item?.transfersData?.map((mint, mintIndex)=>{
            if (mint?.token?.tokenId && mint?.token?.contract) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                direction: "column",
                align: "center",
                key: `mint-${mintIndex}`,
                css: {
                    gap: "$2"
                }
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b11e5b18b62632d1$export$2e2bcd8739ae039), {
                token: {
                    tokenId: mint?.token?.tokenId,
                    collection: {
                        id: mint?.token?.contract
                    },
                    kind: tokenKind
                },
                fallbackMode: "simple",
                style: {
                    width: 100,
                    height: 100
                },
                fallback: ()=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
                        css: {
                            borderRadius: 4,
                            objectFit: "cover",
                            height: 100,
                            width: 100,
                            background: "$neutralBgActive"
                        },
                        justify: "center",
                        align: "center"
                    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
                        icon: (0, $TBcmg$faImage),
                        size: "2x"
                    }))
            }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                style: "subtitle3"
            }, "#", mint?.token?.tokenId));
        })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            zIndex: 2,
            width: "32px",
            background: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, $neutralBgSubtle 50%)"
        }
    }));
};






const $7efb150e4bef044b$export$47d8a00fffa4e400 = ({ token: token, collection: collection, chain: chain })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            gap: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
        src: token?.token?.image || token?.token?.collection?.image,
        css: {
            borderRadius: 8,
            objectFit: "cover",
            height: 56,
            width: 56
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, token?.token?.name || `#${token?.token?.tokenId}`), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, collection?.name), chain ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical"
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain.id,
        height: 12
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, chain.name)) : null))));
};





const $ad354a6988706674$export$f8b6fec5d143bad8 = ({ collection: collection, chain: chain })=>{
    const mintData = collection?.mintStages?.find((stage)=>stage.kind === "public");
    const mintEndTime = mintData ? (0, $2f4c390a81073897$export$2e2bcd8739ae039)(mintData?.endTime) : undefined;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            gap: "$4",
            maxWidth: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
        src: collection?.image,
        css: {
            borderRadius: 8,
            objectFit: "cover",
            height: 56,
            width: 56
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$1",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        ellipsify: true
    }, collection?.name), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, mintEndTime ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle"
    }, "Ends ", mintEndTime) : null, chain ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, mintEndTime ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $edbd6b160d26668e$export$2e2bcd8739ae039), {
        direction: "vertical",
        css: {
            maxHeight: 12
        }
    }) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
        chainId: chain.id,
        height: 12
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle2",
        color: "subtle",
        ellipsify: true
    }, chain.name)) : null))));
};




var $137647f1780e4c12$var$Size;
(function(Size) {
    Size[Size["SM"] = 0] = "SM";
    Size[Size["LG"] = 1] = "LG";
})($137647f1780e4c12$var$Size || ($137647f1780e4c12$var$Size = {}));
const $137647f1780e4c12$export$15fea1e5b618f5ff = ({ collection: collection, token: token, itemCount: itemCount, totalPrice: totalPrice, chainId: chainId, usdTotalFormatted: usdTotalFormatted, currency: currency })=>{
    const itemSubject = itemCount === 1 ? "item" : "items";
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        css: {
            width: "100%",
            mb: "$2"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle"
    }, "Item"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle"
    }, "Total")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "start",
        css: {
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $94585ecf38154231$export$2e2bcd8739ae039), {
        src: token ? token?.token?.image : collection?.image,
        css: {
            borderRadius: 8,
            objectFit: "cover",
            height: 56,
            width: 56
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, token ? token?.token?.name || `#${token?.token?.tokenId}` : collection?.name), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        css: {
            p: "$1",
            borderRadius: 4,
            backgroundColor: "$neutralBgActive",
            width: "max-content"
        }
    }, itemCount, " ", itemSubject)))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "end",
        css: {
            gap: "$1",
            pt: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        chainId: chainId,
        textStyle: "h6",
        amount: totalPrice,
        address: currency?.address,
        decimals: currency?.decimals,
        symbol: currency?.symbol,
        logoWidth: 18
    }), usdTotalFormatted ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdTotalFormatted,
        style: "subtitle3",
        color: "subtle",
        css: {
            textAlign: "end"
        }
    }) : null)));
};




const $1069c5e15a889a4a$export$df7718e11944df19 = {
    ctaConnect: "Connect",
    mintTitle: "Mint",
    mintCtaClose: "Close",
    mintCtaBuy: "Mint",
    mintCtaBuyDisabled: "Mint",
    mintCtaInsufficientFunds: "Add Funds to Purchase",
    mintCtaAwaitingApproval: "Waiting for approval...",
    mintCtaAwaitingValidation: "Waiting to be validated...",
    mintCtaGoToToken: ""
};
function $1069c5e15a889a4a$export$9a9c99234bb94f07({ openState: openState, trigger: trigger, contract: contract, collectionId: collectionId, token: token, chainId: chainId, feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, copyOverrides: copyOverrides, walletClient: walletClient, onMintComplete: onMintComplete, onMintError: onMintError, onClose: onClose, onConnectWallet: onConnectWallet, onGoToToken: onGoToToken, onPointerDownOutside: onPointerDownOutside, defaultQuantity: defaultQuantity }) {
    const copy = {
        ...$1069c5e15a889a4a$export$df7718e11944df19,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $35205ce66a4a25b2$export$37d7d25acf36b96e), {
        onConnectWallet: onConnectWallet,
        chainId: modalChain?.id,
        defaultQuantity: defaultQuantity,
        open: open,
        contract: contract,
        collectionId: collectionId,
        token: token,
        feesOnTopBps: feesOnTopBps,
        feesOnTopUsd: feesOnTopUsd,
        walletClient: walletClient
    }, ({ loading: loading, isFetchingPath: isFetchingPath, collection: collection, token: token, orders: orders, totalIncludingFees: totalIncludingFees, mintResponseFees: mintResponseFees, feeOnTop: feeOnTop, feeUsd: feeUsd, paymentTokens: paymentTokens, paymentCurrency: paymentCurrency, setPaymentCurrency: setPaymentCurrency, addFundsLink: addFundsLink, chainCurrency: chainCurrency, itemAmount: itemAmount, setItemAmount: setItemAmount, maxItemAmount: maxItemAmount, setMaxItemAmount: setMaxItemAmount, usdPrice: usdPrice, usdPriceRaw: usdPriceRaw, currentChain: currentChain, address: address, isConnected: isConnected, disableJumperLink: disableJumperLink, balance: balance, hasEnoughCurrency: hasEnoughCurrency, hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport, transactionError: transactionError, fetchMintPathError: fetchMintPathError, stepData: stepData, mintStep: mintStep, setStepData: setStepData, setMintStep: setMintStep, mintTokens: mintTokens })=>{
        (0, $TBcmg$useEffect)(()=>{
            if (mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).Complete && onMintComplete) {
                const data = {
                    collectionId: collection?.id,
                    maker: address,
                    stepData: stepData
                };
                onMintComplete(data);
            }
        }, [
            mintStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onMintError) {
                const data = {
                    collectionId: collection?.id,
                    maker: address,
                    stepData: stepData
                };
                onMintError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const pathMap = stepData?.path ? stepData.path.reduce((paths, path)=>{
            if (path.orderId) paths[path.orderId] = path;
            return paths;
        }, {}) : {};
        const totalMints = stepData?.currentStep?.items?.reduce((total, item)=>{
            item.transfersData?.forEach((transferData)=>{
                total += Number(transferData.amount || 1);
            });
            return total;
        }, 0) || 0;
        const failedMints = itemAmount - totalMints;
        const successfulMints = itemAmount - failedMints;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.mintTitle,
            open: open,
            loading: loading,
            onPointerDownOutside: (e)=>{
                const dismissableLayers = Array.from(document.querySelectorAll("div[data-radix-dismissable]"));
                const clickedDismissableLayer = dismissableLayers.some((el)=>e.target ? el.contains(e.target) : false);
                if (!clickedDismissableLayer && dismissableLayers.length > 0) e.preventDefault();
                if (onPointerDownOutside) onPointerDownOutside(e);
            },
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        collectionId: collection?.id,
                        maker: address,
                        stepData: stepData
                    };
                    onClose(data, mintStep);
                }
                setOpen(open);
            }
        }, !loading && (orders?.length === 0 || maxItemAmount === 0) && mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).Idle ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                pt: 28,
                pb: 48,
                px: "$4",
                gap: 28
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faEye),
            style: {
                width: "36px",
                height: "32px"
            }
        })), !collection && !fetchMintPathError ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Collection not found.") : null, collection && fetchMintPathError?.message ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, fetchMintPathError?.message) : null, collection && !fetchMintPathError?.message ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Oops. Looks like the mint has ended or the maximum minting limit has been reached.") : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>setOpen(false)
        }, copy.mintCtaClose)) : null, !loading && orders.length > 0 && maxItemAmount !== 0 && mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).Idle && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                borderBottom: "1px solid $neutralBorder"
            }
        }, transactionError ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                p: "$4",
                gap: "$4"
            }
        }, token ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7efb150e4bef044b$export$47d8a00fffa4e400), {
            token: token,
            collection: collection,
            chain: currentChain
        }) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ad354a6988706674$export$f8b6fec5d143bad8), {
            collection: collection,
            chain: currentChain
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "between",
            css: {
                gap: 24,
                "@bp1": {
                    gap: "$6"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "start",
            css: {
                gap: "$1",
                overflow: "hidden",
                flexShrink: 0,
                maxWidth: 200
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "subtle",
            ellipsify: true,
            css: {
                width: "100%"
            }
        }, (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(maxItemAmount), " ", maxItemAmount > 1 ? "items" : "item", " available")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
            quantity: itemAmount,
            setQuantity: setItemAmount,
            min: 1,
            max: maxItemAmount,
            css: {
                width: "100%",
                justifyContent: "space-between",
                minWidth: 200
            }
        })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                pb: "$2"
            }
        }, paymentTokens.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                py: "$3",
                px: "$4",
                borderRadius: "$3",
                borderBottom: "1px solid $neutralBorder",
                "&:hover": {
                    backgroundColor: "$neutralBgHover"
                }
            },
            onClick: ()=>setMintStep((0, $35205ce66a4a25b2$export$692b64e8a8032f02).SelectPayment)
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Payment Method"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2",
                cursor: "pointer"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            address: paymentCurrency?.address,
            chainId: paymentCurrency?.chainId,
            css: {
                width: 16,
                height: 16,
                mr: "$1"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, paymentCurrency?.name)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronRight),
            width: 10
        }))))) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fb1d785e6d7e5526$export$b1bd3336d32d1d33), {
            chainId: chainId,
            crosschainFees: mintResponseFees,
            paymentCurrency: paymentCurrency,
            feeOnTop: feeOnTop,
            feeUsd: feeUsd,
            loading: isFetchingPath,
            css: {
                pt: "$4"
            }
        })), hasEnoughCurrency || !isConnected || hasAuxiliaryFundsSupport ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                m: "$4"
            },
            disabled: !hasEnoughCurrency && !hasAuxiliaryFundsSupport && isConnected,
            onClick: mintTokens
        }, !isConnected ? copy.ctaConnect : copy.mintCtaBuy) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                px: "$3",
                gap: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                mr: "$3"
            },
            color: "error",
            style: "body3"
        }, "Insufficient Balance"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: paymentCurrency?.chainId,
            amount: paymentCurrency?.balance,
            address: paymentCurrency?.address,
            decimals: paymentCurrency?.decimals,
            symbol: paymentCurrency?.name,
            textStyle: "body3"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: disableJumperLink,
            onClick: ()=>{
                window.open(addFundsLink, "_blank");
            },
            css: {
                mb: "$3",
                width: "100%"
            }
        }, disableJumperLink ? copy.mintCtaBuy : copy.mintCtaInsufficientFunds))), !loading && mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).SelectPayment && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                py: 20
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2",
                px: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>setMintStep((0, $35205ce66a4a25b2$export$692b64e8a8032f02).Idle),
            color: "ghost",
            size: "xs",
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronLeft),
            width: 10
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Select Payment Method")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $63fa277c4c09f916$export$ca31b002d5acc121), {
            paymentTokens: paymentTokens,
            currency: paymentCurrency,
            setCurrency: setPaymentCurrency,
            goBack: ()=>setMintStep((0, $35205ce66a4a25b2$export$692b64e8a8032f02).Idle),
            itemAmount: itemAmount,
            chainId: modalChain?.id || 1
        })), !loading && mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).Approving && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $neutralBorder"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $137647f1780e4c12$export$15fea1e5b618f5ff), {
            chainId: chainId,
            collection: collection,
            token: token,
            itemCount: itemAmount,
            totalPrice: (paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop,
            currency: paymentCurrency,
            usdTotalFormatted: (0, $TBcmg$formatUnits)(((paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop) * (paymentCurrency?.usdPriceRaw || 0n), (paymentCurrency?.decimals || 18) + 6)
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4",
                overflowY: "auto"
            }
        }, stepData?.currentStep == undefined ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                py: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null)) : null, stepData?.currentStep && stepData.currentStep.id !== "auth" && stepData.currentStep.id !== "sale" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralText",
                py: "$5"
            },
            direction: "column",
            justify: "center",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            color: "base",
            css: {
                mb: "$2",
                textAlign: "center"
            }
        }, stepData.currentStep.action, " ", stepData?.currentStep?.items && stepData.currentStep.items.length > 1 ? `(${stepData.currentStep.items.filter((item)=>item.status === "complete").length}/${stepData.currentStep.items.length})` : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            css: {
                mb: 20,
                textAlign: "center"
            }
        }, stepData.currentStep.description), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faPenNib),
            width: 32,
            height: 32,
            style: {
                height: 32
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fc5a6190fea5008$export$8867c41adbe809fa), {
            currentStep: stepData?.currentStep
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                mt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.mintCtaAwaitingApproval)) : null, stepData?.currentStep && stepData.currentStep.id === "auth" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d6ae44a4b381214a$export$2e2bcd8739ae039), {
            css: {
                mt: 48,
                mb: "$4",
                gap: 20
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                mt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.mintCtaAwaitingApproval)) : null, stepData?.currentStep && stepData?.currentStep?.id === "sale" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, stepData?.currentStep?.items && stepData?.currentStep?.items.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Approve Purchases"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle"
        }, "The purchase of these items needs to be split into", " ", stepData?.currentStep?.items.length, " separate transactions."), stepData?.currentStep?.items.map((item, idx)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $add635cbf9f5888f$export$d7253bf947e7aaac), {
                key: idx,
                item: item,
                pathMap: pathMap,
                usdPrice: +usdPrice,
                chain: currentChain,
                open: true
            }))) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$4",
                pt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Confirm transaction in your wallet"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralText"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faWallet),
            style: {
                width: "32px",
                height: "32px",
                margin: "12px 0px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fc5a6190fea5008$export$8867c41adbe809fa), {
            currentStep: stepData?.currentStep
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                mt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.mintCtaAwaitingApproval))) : null)), !loading && mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).Finalizing && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $neutralBorder"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $137647f1780e4c12$export$15fea1e5b618f5ff), {
            chainId: chainId,
            collection: collection,
            token: token,
            itemCount: itemAmount,
            totalPrice: (paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop,
            currency: paymentCurrency,
            usdTotalFormatted: (0, $TBcmg$formatUnits)(((paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop) * (paymentCurrency?.usdPriceRaw || 0n), (paymentCurrency?.decimals || 18) + 6)
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            justify: "center",
            css: {
                gap: "$4",
                px: "$4",
                py: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Finalizing on blockchain"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            css: {
                textAlign: "center"
            }
        }, "You can close this modal while it finalizes on the blockchain. The transaction will continue in the background."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCube),
            style: {
                width: 32,
                height: 32
            }
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fc5a6190fea5008$export$8867c41adbe809fa), {
            currentStep: stepData?.currentStep
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.mintCtaAwaitingValidation)), !loading && mintStep === (0, $35205ce66a4a25b2$export$692b64e8a8032f02).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                py: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                py: "$5",
                gap: 24,
                maxWidth: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                px: "$5"
            }
        }, "Your mint is complete!"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $695bb0101b6ebdf3$export$103ed344964d8252), {
            stepData: stepData,
            tokenKind: collection?.contractKind
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2",
                px: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: failedMints ? "$errorAccent" : "$successAccent"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: failedMints ? (0, $TBcmg$faCircleExclamation) : (0, $TBcmg$faCheckCircle),
            fontSize: 16
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body1",
            css: {
                textAlign: "center"
            }
        }, failedMints ? `${successfulMints} ${successfulMints > 1 ? "items" : "item"} minted, ${failedMints} ${failedMints > 1 ? "items" : "item"} failed` : `Successfully minted ${successfulMints} ${successfulMints > 1 ? "items" : "item"}`, collection?.name ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, " ", "from", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body1",
            color: "accent"
        }, " ", collection?.name)) : null)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                mb: "$3",
                px: "$5"
            }
        }, stepData?.currentStep?.items?.map((item, itemIndex)=>{
            if (Array.isArray(item?.txHashes) && item?.txHashes.length > 0) return item.txHashes.map((hash, txHashIndex)=>{
                const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
                const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
                return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                    key: `${itemIndex}-${txHashIndex}`,
                    href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                    color: "primary",
                    weight: "medium",
                    target: "_blank",
                    css: {
                        fontSize: 12
                    }
                }, "View transaction: ", truncatedTxHash);
            });
            else return null;
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                width: "100%",
                px: "$4"
            }
        }, !!onGoToToken ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                flex: 1
            },
            color: "ghost"
        }, copy.mintCtaClose), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            style: {
                flex: 1
            },
            color: "primary",
            onClick: ()=>{
                onGoToToken({
                    collectionId: collection?.id,
                    maker: address,
                    stepData: stepData
                });
            }
        }, copy.mintCtaGoToToken.length > 0 ? copy.mintCtaGoToToken : `View ${successfulMints > 1 ? "Tokens" : "Token"}`)) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>setOpen(false)
        }, copy.mintCtaClose))));
    });
}
$1069c5e15a889a4a$export$9a9c99234bb94f07.Custom = (0, $35205ce66a4a25b2$export$37d7d25acf36b96e);


















var $f99c3f30def4cffc$export$de6922b83abf2eed;
(function(SweepStep) {
    SweepStep[SweepStep["Idle"] = 0] = "Idle";
    SweepStep[SweepStep["SelectPayment"] = 1] = "SelectPayment";
    SweepStep[SweepStep["Approving"] = 2] = "Approving";
    SweepStep[SweepStep["Finalizing"] = 3] = "Finalizing";
    SweepStep[SweepStep["Complete"] = 4] = "Complete";
})($f99c3f30def4cffc$export$de6922b83abf2eed || ($f99c3f30def4cffc$export$de6922b83abf2eed = {}));
const $f99c3f30def4cffc$export$8727d8535fbca2ab = ({ open: open, chainId: chainId, contract: contract, collectionId: collectionId, token: token, feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, defaultQuantity: defaultQuantity, onConnectWallet: onConnectWallet, normalizeRoyalties: normalizeRoyalties, children: children, walletClient: walletClient, usePermit: usePermit })=>{
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const config = (0, $TBcmg$useConfig)();
    const { address: address, connector: connector } = (0, $TBcmg$useAccount)();
    const [selectedTokens, setSelectedTokens] = (0, $TBcmg$useState)([]);
    const [isFetchingPath, setIsFetchingPath] = (0, $TBcmg$useState)(false);
    const [fetchedInitialOrders, setFetchedInitialOrders] = (0, $TBcmg$useState)(false);
    const [orders, setOrders] = (0, $TBcmg$useState)([]);
    const [itemAmount, setItemAmount] = (0, $TBcmg$useState)(1);
    const [maxItemAmount, setMaxItemAmount] = (0, $TBcmg$useState)(1);
    const [sweepStep, setSweepStep] = (0, $TBcmg$useState)($f99c3f30def4cffc$export$de6922b83abf2eed.Idle);
    const [stepData, setStepData] = (0, $TBcmg$useState)(null);
    const [transactionError, setTransactionError] = (0, $TBcmg$useState)();
    const [totalIncludingFees, setTotalIncludingFees] = (0, $TBcmg$useState)(0n);
    const [averageUnitPrice, setAverageUnitPrice] = (0, $TBcmg$useState)(0n);
    const [hasEnoughCurrency, setHasEnoughCurrency] = (0, $TBcmg$useState)(true);
    const [feeOnTop, setFeeOnTop] = (0, $TBcmg$useState)(0n);
    const [buyResponseFees, setBuyResponseFees] = (0, $TBcmg$useState)(undefined);
    const currentChain = client?.currentChain();
    const rendererChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const chainCurrency = (0, $57dcd81a309fc6e2$export$2e2bcd8739ae039)(rendererChain?.id);
    const collectionContract = contract ?? collectionId?.split(":")?.[0] ?? token?.split(":")?.[0];
    const tokenId = token?.split(":")?.[1];
    const wagmiChain = Object.values({
        ...$TBcmg$viemchains,
        ...(0, $TBcmg$customChains)
    }).find(({ id: id })=>rendererChain?.id === id);
    const providerOptions = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const disableJumperLink = providerOptions?.disableJumperLink;
    const includeListingCurrency = providerOptions.alwaysIncludeListingCurrency !== false;
    const { data: wagmiWallet } = (0, $TBcmg$useWalletClient)({
        chainId: rendererChain?.id
    });
    const wallet = walletClient || wagmiWallet;
    const { data: capabilities } = (0, $TBcmg$useCapabilities)({
        query: {
            enabled: connector && (connector.id === "coinbaseWalletSDK" || connector.id === "coinbase")
        }
    });
    const hasAuxiliaryFundsSupport = Boolean(rendererChain?.id ? capabilities?.[rendererChain?.id]?.auxiliaryFunds?.supported : false);
    const blockExplorerBaseUrl = wagmiChain?.blockExplorers?.default?.url || "https://etherscan.io";
    const { data: collections, mutate: mutateCollection, isFetchingPage: isFetchingCollections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(open && {
        contract: collectionId ? undefined : collectionContract,
        id: collectionId ? collectionId : undefined
    }, {}, rendererChain?.id);
    const collection = collections && collections[0] ? collections[0] : undefined;
    const is1155 = collection?.contractKind === "erc1155";
    const isSingleToken1155 = is1155 && collection?.tokenCount === "1";
    const { data: tokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(open && (tokenId || isSingleToken1155) ? {
        collection: isSingleToken1155 ? collection?.id : undefined,
        tokens: isSingleToken1155 ? undefined : `${collectionContract}:${tokenId}`
    } : undefined, {}, rendererChain?.id);
    const tokenData = tokens && tokens[0] ? tokens[0] : undefined;
    const [_paymentCurrency, _setPaymentCurrency] = (0, $TBcmg$useState)(undefined);
    const paymentKey = (0, $TBcmg$useMemo)(()=>{
        if (token) return token;
        else if (tokenData?.token?.tokenId && collectionContract) return `${collectionContract}:${tokenData?.token?.tokenId}`;
        else if (collectionId) return collectionId;
        else return collectionContract;
    }, [
        token,
        collectionId,
        ,
        collectionContract,
        tokenData?.token?.tokenId
    ]);
    const paymentTokens = (0, $f19c84e0e180ca0e$export$2e2bcd8739ae039)({
        open: open,
        address: address,
        quantityToken: {
            [`${paymentKey}`]: itemAmount
        },
        path: orders,
        nativeOnly: false,
        chainId: rendererChain?.id,
        crossChainDisabled: !is1155
    });
    const paymentCurrency = paymentTokens?.find((paymentToken)=>paymentToken?.address === _paymentCurrency?.address && paymentToken?.chainId === _paymentCurrency?.chainId);
    const usdPrice = paymentCurrency?.usdPrice || 0;
    const usdPriceRaw = paymentCurrency?.usdPriceRaw || 0n;
    const feeUsd = (0, $TBcmg$formatUnits)(feeOnTop * usdPriceRaw, (paymentCurrency?.decimals || 18) + 6);
    const fetchBuyPath = (0, $TBcmg$useCallback)((paymentCurrency, paymentTokens)=>{
        if (!open || !client) return;
        setIsFetchingPath(true);
        let options = {
            partial: true,
            onlyPath: true
        };
        if (is1155) {
            if (feesOnTopBps && feesOnTopBps?.length > 0) {
                const fixedFees = feesOnTopBps.map((fullFee)=>{
                    const [referrer] = fullFee.split(":");
                    return `${referrer}:1`;
                });
                options.feesOnTop = fixedFees;
            } else if (feesOnTopUsd && feesOnTopUsd.length > 0) {
                const feesOnTopFixed = feesOnTopUsd.map((feeOnTop)=>{
                    const [recipient] = feeOnTop.split(":");
                    return `${recipient}:1`;
                });
                options.feesOnTop = feesOnTopFixed;
            } else if (!feesOnTopUsd && !feesOnTopBps) delete options.feesOnTop;
        }
        if (normalizeRoyalties !== undefined) options.normalizeRoyalties = normalizeRoyalties;
        if (paymentCurrency) {
            options.currency = paymentCurrency.address;
            if (paymentCurrency.chainId) options.currencyChainId = paymentCurrency.chainId;
        } else if (!includeListingCurrency && paymentTokens[0]) {
            options.currency = paymentTokens[0].address;
            if (paymentTokens[0].chainId) options.currencyChainId = paymentTokens[0].chainId;
            _setPaymentCurrency(paymentTokens[0]);
        }
        return client?.actions.buyToken({
            chainId: rendererChain?.id,
            items: [
                {
                    collection: token ?? tokenData?.token?.tokenId ? undefined : collection?.id,
                    token: token ?? tokenData?.token?.tokenId ? `${collectionContract}:${tokenId ?? tokenData?.token?.tokenId}` : undefined,
                    fillType: "trade"
                }
            ],
            expectedPrice: undefined,
            options: options,
            wallet: {
                address: async ()=>{
                    return address || (0, $TBcmg$zeroAddress);
                }
            },
            precheck: true,
            onProgress: ()=>{}
        }).then((rawData)=>{
            let data = rawData;
            if ("path" in data) {
                let pathData = data["path"];
                setOrders(pathData ?? []);
                if (data.fees) setBuyResponseFees(data.fees);
                const pathOrderQuantity = pathData?.reduce((quantity, order)=>quantity + (order?.quantity || 1), 0) || 0;
                let totalMaxQuantity = pathOrderQuantity;
                if ("maxQuantities" in data && data.maxQuantities?.[0]) {
                    if (is1155) totalMaxQuantity = data.maxQuantities.reduce((total, currentQuantity)=>total + Number(currentQuantity.maxQuantity ?? 1), 0);
                    else {
                        let maxQuantity = data.maxQuantities?.[0].maxQuantity;
                        // if value is null/undefined, we don't know max quantity, but simulation succeeed with quantity of 1
                        totalMaxQuantity = maxQuantity ? Number(maxQuantity) : 1;
                    }
                }
                setMaxItemAmount(pathOrderQuantity > totalMaxQuantity ? totalMaxQuantity : pathOrderQuantity);
                if (!paymentCurrency && pathData?.[0]) {
                    const listingToken = {
                        address: pathData[0].buyInCurrency || pathData[0].currency,
                        decimals: pathData[0].buyInCurrencyDecimals || pathData[0].currencyDecimals || 18,
                        symbol: pathData[0].buyInCurrencySymbol || pathData[0].currencySymbol || "",
                        name: pathData[0].buyInCurrencySymbol || pathData[0].currencySymbol || "",
                        chainId: rendererChain?.id || 1
                    };
                    _setPaymentCurrency(listingToken);
                }
            }
        }).catch((err)=>{
            setOrders([]);
            throw err;
        }).finally(()=>{
            setFetchedInitialOrders(true);
            setIsFetchingPath(false);
        });
    }, [
        address,
        client,
        wallet,
        rendererChain,
        normalizeRoyalties,
        collectionId,
        tokenData?.token?.tokenId,
        collectionContract,
        collection?.id,
        tokenId,
        rendererChain?.paymentTokens,
        is1155,
        includeListingCurrency,
        feesOnTopBps,
        feesOnTopUsd,
        _setPaymentCurrency
    ]);
    const setPaymentCurrency = (0, $TBcmg$useCallback)((value)=>{
        if (typeof value === "function") _setPaymentCurrency((prevState)=>{
            const newValue = value(prevState);
            if (newValue?.address !== paymentCurrency?.address || newValue?.chainId !== paymentCurrency?.chainId) fetchBuyPath(newValue, paymentTokens)?.catch((err)=>{
                if (err?.statusCode === 400 && err?.message?.includes("Price too high")) _setPaymentCurrency(prevState);
            });
            return newValue;
        });
        else if (value?.address !== paymentCurrency?.address || value?.chainId !== paymentCurrency?.chainId) {
            _setPaymentCurrency(value);
            fetchBuyPath(value, paymentTokens)?.catch((err)=>{
                if (err?.statusCode === 400 && err?.message?.includes("Price too high")) _setPaymentCurrency(paymentCurrency);
            });
        }
    }, [
        fetchBuyPath,
        _setPaymentCurrency,
        paymentCurrency
    ]);
    const fetchBuyPathIfIdle = (0, $TBcmg$useCallback)(()=>{
        if (collection && sweepStep === $f99c3f30def4cffc$export$de6922b83abf2eed.Idle) fetchBuyPath(paymentCurrency, paymentTokens);
    }, [
        fetchBuyPath,
        sweepStep,
        collection
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (open) {
            fetchBuyPathIfIdle();
            const intervalId = setInterval(fetchBuyPathIfIdle, 60000); // Poll buy api every 1 minute
            return ()=>clearInterval(intervalId);
        }
    }, [
        client,
        wallet,
        open,
        fetchBuyPathIfIdle,
        tokenId,
        is1155,
        collection
    ]);
    (0, $TBcmg$useEffect)(()=>{
        let totalFees = 0n;
        if (paymentCurrency?.currencyTotalRaw && paymentCurrency.currencyTotalRaw > 0n) {
            let currencyTotalRawMinusRelayerFees = paymentCurrency?.currencyTotalRaw;
            // if cross-chain, subtract relayer fees from currencyTotalRaw
            if (buyResponseFees?.relayer?.amount?.raw) {
                const relayerFees = BigInt(buyResponseFees?.relayer?.amount?.raw ?? 0);
                currencyTotalRawMinusRelayerFees -= relayerFees;
            }
            if (feesOnTopBps && feesOnTopBps.length > 0) {
                const fees = feesOnTopBps.reduce((totalFees, feeOnTop)=>{
                    const [_, fee] = feeOnTop.split(":");
                    return totalFees + BigInt(fee) * currencyTotalRawMinusRelayerFees / 10000n;
                }, 0n);
                totalFees += fees;
                setFeeOnTop(fees);
            } else if (feesOnTopUsd && feesOnTopUsd.length > 0 && usdPriceRaw) {
                const fees = feesOnTopUsd.reduce((totalFees, feeOnTop)=>{
                    const [_, fee] = feeOnTop.split(":");
                    const atomicFee = BigInt(fee);
                    const convertedAtomicFee = atomicFee * BigInt(10 ** paymentCurrency?.decimals);
                    const currencyFee = convertedAtomicFee / usdPriceRaw;
                    return totalFees + currencyFee;
                }, 0n);
                totalFees += fees;
                setFeeOnTop(fees);
            } else setFeeOnTop(0n);
            setTotalIncludingFees(paymentCurrency.currencyTotalRaw + totalFees);
            setAverageUnitPrice(paymentCurrency.currencyTotalRaw / BigInt(itemAmount));
        } else {
            setTotalIncludingFees(0n);
            setAverageUnitPrice(0n);
        }
    }, [
        paymentCurrency,
        feesOnTopBps,
        feesOnTopUsd,
        usdPriceRaw,
        itemAmount,
        buyResponseFees
    ]);
    const { relayLink: relayLink } = (0, $ff7ce0ca6096b543$export$2e2bcd8739ae039)(rendererChain?.id);
    let addFundsLink = "";
    if (relayLink) addFundsLink = paymentCurrency?.address ? `${relayLink}?toCurrency=${paymentCurrency?.address}` : relayLink;
    else addFundsLink = paymentCurrency?.address ? `https://jumper.exchange/?toChain=${rendererChain?.id}&toToken=${paymentCurrency?.address}` : `https://jumper.exchange/?toChain=${rendererChain?.id}`;
    if (providerOptions?.convertLink?.chainUrl) {
        addFundsLink = paymentCurrency?.address && providerOptions.convertLink.tokenUrl ? providerOptions.convertLink.tokenUrl : providerOptions.convertLink.chainUrl;
        if (rendererChain?.id) addFundsLink = addFundsLink.replace("{toChain}", `${rendererChain.id}`);
        if (paymentCurrency?.address) addFundsLink = addFundsLink.replace("{toToken}", paymentCurrency?.address);
    } else if (providerOptions?.convertLink?.customUrl) addFundsLink = providerOptions.convertLink.customUrl?.({
        toChain: rendererChain?.id,
        toToken: paymentCurrency?.address,
        toCurrency: paymentCurrency
    });
    // Determine if user has enough funds in paymentToken
    (0, $TBcmg$useEffect)(()=>{
        if (paymentCurrency?.balance != undefined && totalIncludingFees != undefined && BigInt(paymentCurrency?.balance) < totalIncludingFees) setHasEnoughCurrency(false);
        else setHasEnoughCurrency(true);
    }, [
        totalIncludingFees,
        paymentCurrency?.balance
    ]);
    (0, $TBcmg$useEffect)(()=>{
        let updatedTokens = [];
        let quantity = 0;
        for(var i = 0; i < orders.length; i++){
            const order = orders[i];
            if (order.quantity && order.quantity > 1) quantity += order.quantity;
            else quantity++;
            updatedTokens.push(order);
            if (quantity >= itemAmount) break;
        }
        setSelectedTokens(updatedTokens);
    }, [
        itemAmount,
        maxItemAmount,
        orders
    ]);
    // Reset state on close
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setSelectedTokens([]);
            setOrders([]);
            setItemAmount(1);
            setMaxItemAmount(1);
            setSweepStep($f99c3f30def4cffc$export$de6922b83abf2eed.Idle);
            setTransactionError(null);
            setFetchedInitialOrders(false);
            setIsFetchingPath(false);
            _setPaymentCurrency(undefined);
            setBuyResponseFees(undefined);
            setStepData(null);
        } else setItemAmount(defaultQuantity || 1);
    }, [
        open
    ]);
    open ? (0, $TBcmg$axios).defaults.headers.common["x-rkui-context"] = "sweepModalRenderer" : delete (0, $TBcmg$axios).defaults.headers.common?.["x-rkui-context"];
    (0, $TBcmg$useEffect)(()=>{
        if (maxItemAmount > 0 && itemAmount > maxItemAmount) setItemAmount(maxItemAmount);
    }, [
        maxItemAmount,
        itemAmount
    ]);
    const sweepTokens = (0, $TBcmg$useCallback)(async ()=>{
        if (!wallet) {
            onConnectWallet();
            if (document.body.style) document.body.style.pointerEvents = "auto";
            client?.log([
                "Missing wallet, prompting connection"
            ], (0, $TBcmg$LogLevel).Verbose);
            return;
        }
        let activeWalletChain = (0, $TBcmg$getAccount)(config).chain;
        if (paymentCurrency?.chainId !== activeWalletChain?.id) activeWalletChain = await (0, $TBcmg$switchChain)(config, {
            chainId: paymentCurrency?.chainId
        });
        if (paymentCurrency?.chainId !== activeWalletChain?.id) {
            const error = new Error(`Mismatching chainIds`);
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error = new Error("ReservoirClient was not initialized");
            setTransactionError(error);
            throw error;
        }
        setTransactionError(null);
        let options = {
            partial: true,
            currency: paymentCurrency?.address,
            currencyChainId: paymentCurrency?.chainId,
            skipBalanceCheck: hasAuxiliaryFundsSupport
        };
        const relayerFee = BigInt(buyResponseFees?.relayer?.amount?.raw ?? 0);
        if (feesOnTopBps && feesOnTopBps?.length > 0) {
            const fixedFees = feesOnTopBps.map((fullFee)=>{
                const [referrer, feeBps] = fullFee.split(":");
                let totalFeeTruncated = totalIncludingFees - feeOnTop;
                // if relayer fee, subtract from total
                if (relayerFee) totalFeeTruncated -= relayerFee;
                const fee = Math.floor(Number(totalFeeTruncated * BigInt(feeBps)) / 10000);
                const atomicUnitsFee = (0, $TBcmg$formatUnits)(BigInt(fee), 0);
                return `${referrer}:${atomicUnitsFee}`;
            });
            options.feesOnTop = fixedFees;
        } else if (feesOnTopUsd && feesOnTopUsd.length > 0 && usdPriceRaw) {
            const feesOnTopFixed = feesOnTopUsd.map((feeOnTop)=>{
                const [recipient, fee] = feeOnTop.split(":");
                const atomicFee = BigInt(fee);
                const convertedAtomicFee = atomicFee * BigInt(10 ** paymentCurrency?.decimals);
                const currencyFee = convertedAtomicFee / usdPriceRaw;
                const parsedFee = (0, $TBcmg$formatUnits)(currencyFee, 0);
                return `${recipient}:${parsedFee}`;
            });
            options.feesOnTop = feesOnTopFixed;
        } else if (!feesOnTopUsd && !feesOnTopBps) delete options.feesOnTop;
        if (normalizeRoyalties !== undefined) options.normalizeRoyalties = normalizeRoyalties;
        if (usePermit) options.usePermit = true;
        setSweepStep($f99c3f30def4cffc$export$de6922b83abf2eed.Approving);
        client.actions.buyToken({
            chainId: rendererChain?.id,
            items: [
                {
                    collection: tokenData?.token?.tokenId ? undefined : collection?.id,
                    token: tokenData?.token?.tokenId ? `${collectionContract}:${tokenData?.token?.tokenId}` : undefined,
                    quantity: itemAmount,
                    fillType: "trade"
                }
            ],
            expectedPrice: {
                [paymentCurrency?.address || (0, $TBcmg$zeroAddress)]: {
                    raw: totalIncludingFees - relayerFee,
                    currencyAddress: paymentCurrency?.address,
                    currencyDecimals: paymentCurrency?.decimals || 18
                }
            },
            wallet: wallet,
            options: options,
            onProgress: (steps, path)=>{
                if (!steps) return;
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let currentStepItem;
                const currentStepIndex = executableSteps.findIndex((step)=>{
                    currentStepItem = step.items?.find((item)=>item.status === "incomplete");
                    return currentStepItem;
                });
                const currentStep = currentStepIndex > -1 ? executableSteps[currentStepIndex] : executableSteps[stepCount - 1];
                if (currentStepItem) setStepData({
                    totalSteps: stepCount,
                    stepProgress: currentStepIndex,
                    currentStep: currentStep,
                    currentStepItem: currentStepItem,
                    path: path
                });
                if (currentStepIndex + 1 === executableSteps.length && currentStep?.items?.every((item)=>item.txHashes)) setSweepStep($f99c3f30def4cffc$export$de6922b83abf2eed.Finalizing);
                if (steps.every((step)=>!step.items || step.items.length == 0 || step.items?.every((item)=>item.status === "complete"))) setSweepStep($f99c3f30def4cffc$export$de6922b83abf2eed.Complete);
            }
        }).catch((error)=>{
            setTransactionError(error);
            setSweepStep($f99c3f30def4cffc$export$de6922b83abf2eed.Idle);
            mutateCollection();
            fetchBuyPath(paymentCurrency, paymentTokens);
        });
    }, [
        selectedTokens,
        client,
        wallet,
        config,
        address,
        totalIncludingFees,
        normalizeRoyalties,
        wagmiChain,
        rendererChain,
        collectionId,
        collection?.id,
        tokenId,
        feesOnTopBps,
        onConnectWallet,
        feesOnTopUsd,
        itemAmount,
        tokenData?.token?.tokenId,
        collectionContract,
        paymentCurrency?.address,
        paymentCurrency?.chainId,
        paymentCurrency?.currencyTotalRaw,
        paymentTokens,
        buyResponseFees,
        usePermit,
        hasAuxiliaryFundsSupport
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        collection: collection,
        token: tokenData,
        loading: isFetchingCollections || !isFetchingCollections && collection && !fetchedInitialOrders || (token !== undefined || isSingleToken1155) && !tokenData || !(paymentTokens.length > 0),
        isFetchingPath: isFetchingPath,
        address: address,
        selectedTokens: selectedTokens,
        setSelectedTokens: setSelectedTokens,
        itemAmount: itemAmount,
        setItemAmount: setItemAmount,
        maxItemAmount: maxItemAmount,
        setMaxItemAmount: setMaxItemAmount,
        paymentCurrency: paymentCurrency,
        setPaymentCurrency: setPaymentCurrency,
        chainCurrency: chainCurrency,
        paymentTokens: paymentTokens,
        totalIncludingFees: totalIncludingFees,
        buyResponseFees: buyResponseFees,
        averageUnitPrice: averageUnitPrice,
        feeOnTop: feeOnTop,
        feeUsd: feeUsd,
        usdPrice: usdPrice,
        disableJumperLink: disableJumperLink,
        usdPriceRaw: usdPriceRaw,
        isConnected: wallet !== undefined,
        currentChain: currentChain,
        orders: orders,
        balance: paymentCurrency?.balance ? BigInt(paymentCurrency.balance) : undefined,
        hasEnoughCurrency: hasEnoughCurrency,
        hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport,
        addFundsLink: addFundsLink,
        blockExplorerBaseUrl: blockExplorerBaseUrl,
        transactionError: transactionError,
        stepData: stepData,
        setStepData: setStepData,
        sweepStep: sweepStep,
        setSweepStep: setSweepStep,
        sweepTokens: sweepTokens
    }));
};
























const $ecf99860a3fcdd2e$export$1a76aa0856083001 = {
    ctaConnect: "Connect",
    sweepTitle: "Sweep",
    sweepCtaClose: "Close",
    sweepCtaBuy: "Sweep",
    sweepCtaBuyDisabled: "Sweep",
    sweepCtaInsufficientFunds: "Add Funds to Purchase",
    sweepCtaAwaitingApproval: "Waiting for approval...",
    sweepCtaAwaitingValidation: "Waiting to be validated...",
    sweepCtaGoToToken: ""
};
function $ecf99860a3fcdd2e$export$2536c4e1bdf96841({ openState: openState, trigger: trigger, contract: contract, collectionId: collectionId, token: token, chainId: chainId, feesOnTopBps: feesOnTopBps, feesOnTopUsd: feesOnTopUsd, copyOverrides: copyOverrides, walletClient: walletClient, normalizeRoyalties: normalizeRoyalties, usePermit: usePermit, onSweepComplete: onSweepComplete, onSweepError: onSweepError, onClose: onClose, onConnectWallet: onConnectWallet, onGoToToken: onGoToToken, onPointerDownOutside: onPointerDownOutside, defaultQuantity: defaultQuantity }) {
    const copy = {
        ...$ecf99860a3fcdd2e$export$1a76aa0856083001,
        ...copyOverrides
    };
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const modalChain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f99c3f30def4cffc$export$8727d8535fbca2ab), {
        onConnectWallet: onConnectWallet,
        chainId: modalChain?.id,
        defaultQuantity: defaultQuantity,
        open: open,
        contract: contract,
        collectionId: collectionId,
        token: token,
        feesOnTopBps: feesOnTopBps,
        feesOnTopUsd: feesOnTopUsd,
        walletClient: walletClient,
        normalizeRoyalties: normalizeRoyalties,
        usePermit: usePermit
    }, ({ loading: loading, isFetchingPath: isFetchingPath, collection: collection, token: token, orders: orders, totalIncludingFees: totalIncludingFees, buyResponseFees: buyResponseFees, averageUnitPrice: averageUnitPrice, selectedTokens: selectedTokens, feeOnTop: feeOnTop, feeUsd: feeUsd, paymentTokens: paymentTokens, paymentCurrency: paymentCurrency, setPaymentCurrency: setPaymentCurrency, addFundsLink: addFundsLink, chainCurrency: chainCurrency, itemAmount: itemAmount, setItemAmount: setItemAmount, maxItemAmount: maxItemAmount, setMaxItemAmount: setMaxItemAmount, usdPrice: usdPrice, usdPriceRaw: usdPriceRaw, currentChain: currentChain, address: address, isConnected: isConnected, disableJumperLink: disableJumperLink, balance: balance, hasEnoughCurrency: hasEnoughCurrency, hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport, transactionError: transactionError, stepData: stepData, sweepStep: sweepStep, setStepData: setStepData, setSweepStep: setSweepStep, sweepTokens: sweepTokens })=>{
        (0, $TBcmg$useEffect)(()=>{
            if (sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).Complete && onSweepComplete) {
                const data = {
                    collectionId: collection?.id,
                    maker: address,
                    stepData: stepData
                };
                onSweepComplete(data);
            }
        }, [
            sweepStep
        ]);
        (0, $TBcmg$useEffect)(()=>{
            if (transactionError && onSweepError) {
                const data = {
                    collectionId: collection?.id,
                    maker: address,
                    stepData: stepData
                };
                onSweepError(transactionError, data);
            }
        }, [
            transactionError
        ]);
        const hasTokens = orders && orders.length > 0;
        const pathMap = stepData?.path ? stepData.path.reduce((paths, path)=>{
            if (path.orderId) paths[path.orderId] = path;
            return paths;
        }, {}) : {};
        const totalSales = stepData?.currentStep?.items?.reduce((total, item)=>{
            item.transfersData?.forEach((transferData)=>{
                total += Number(transferData.amount || 1);
            });
            return total;
        }, 0) || 0;
        const failedSales = itemAmount - totalSales;
        const successfulSales = itemAmount - failedSales;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$2b77a92f1a5ad772), {
            trigger: trigger,
            title: copy.sweepTitle,
            open: open,
            loading: loading,
            onPointerDownOutside: (e)=>{
                const dismissableLayers = Array.from(document.querySelectorAll("div[data-radix-dismissable]"));
                const clickedDismissableLayer = dismissableLayers.some((el)=>e.target ? el.contains(e.target) : false);
                if (!clickedDismissableLayer && dismissableLayers.length > 0) e.preventDefault();
                if (onPointerDownOutside) onPointerDownOutside(e);
            },
            onOpenChange: (open)=>{
                if (!open && onClose) {
                    const data = {
                        collectionId: collection?.id,
                        maker: address,
                        stepData: stepData
                    };
                    onClose(data, sweepStep);
                }
                setOpen(open);
            }
        }, !loading && !hasTokens || maxItemAmount === 0 && sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).Idle ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                pt: 28,
                pb: 48,
                px: "$4",
                gap: 28
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faMagnifyingGlass),
            style: {
                width: "36px",
                height: "32px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "No available items were found for this collection.")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>setOpen(false)
        }, copy.sweepCtaClose)) : null, !loading && hasTokens && maxItemAmount !== 0 && sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).Idle && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                borderBottom: "1px solid $neutralBorder"
            }
        }, transactionError ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $f9c59e90de25e993$export$2e2bcd8739ae039), {
            error: transactionError
        }) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                p: "$4",
                gap: 10
            }
        }, token ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $7efb150e4bef044b$export$47d8a00fffa4e400), {
            token: token,
            collection: collection
        }) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ad354a6988706674$export$f8b6fec5d143bad8), {
            collection: collection
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "between",
            css: {
                gap: 24,
                "@bp1": {
                    gap: "$6"
                },
                mt: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "start",
            css: {
                gap: "$1",
                overflow: "hidden",
                flexShrink: 0,
                maxWidth: 200
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "subtle",
            ellipsify: true,
            css: {
                width: "100%"
            }
        }, (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(maxItemAmount), " ", maxItemAmount === 1 ? "item" : "items", " available")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
            quantity: itemAmount,
            setQuantity: setItemAmount,
            min: 1,
            max: maxItemAmount,
            css: {
                width: "100%",
                justifyContent: "space-between",
                minWidth: 200
            }
        })), itemAmount > 1 && averageUnitPrice ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "end",
            css: {
                gap: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle"
        }, "Avg Item Price"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: chainId,
            amount: averageUnitPrice,
            address: paymentCurrency?.address,
            decimals: paymentCurrency?.decimals,
            symbol: paymentCurrency?.name,
            maximumFractionDigits: 2
        }))) : null)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                pb: "$2"
            }
        }, paymentTokens.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                py: "$3",
                px: "$4",
                borderRadius: "$3",
                borderBottom: "1px solid $neutralBorder",
                "&:hover": {
                    backgroundColor: "$neutralBgHover"
                }
            },
            onClick: ()=>setSweepStep((0, $f99c3f30def4cffc$export$de6922b83abf2eed).SelectPayment)
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            justify: "between",
            align: "center",
            css: {
                gap: "$1"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Payment Method"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2",
                cursor: "pointer"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $facfb14f3ab47807$export$2e2bcd8739ae039), {
            address: paymentCurrency?.address,
            css: {
                width: 16,
                height: 16,
                mr: "$1"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, paymentCurrency?.name)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronRight),
            width: 10
        }))))) : null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fb1d785e6d7e5526$export$b1bd3336d32d1d33), {
            chainId: chainId,
            crosschainFees: buyResponseFees,
            paymentCurrency: paymentCurrency,
            feeOnTop: feeOnTop,
            feeUsd: feeUsd,
            loading: isFetchingPath,
            css: {
                pt: "$4"
            }
        })), hasEnoughCurrency || !isConnected || hasAuxiliaryFundsSupport ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                m: "$4"
            },
            disabled: !(selectedTokens.length > 0) || !hasEnoughCurrency && !hasAuxiliaryFundsSupport && isConnected,
            onClick: sweepTokens
        }, !isConnected ? copy.ctaConnect : selectedTokens.length > 0 ? copy.sweepCtaBuy : copy.sweepCtaBuyDisabled) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                px: "$3"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            css: {
                mr: "$3"
            },
            color: "error",
            style: "body3"
        }, "Insufficient Balance", paymentTokens.length > 1 ? ", select another token or add funds" : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            chainId: chainId,
            amount: paymentCurrency?.balance,
            address: paymentCurrency?.address,
            decimals: paymentCurrency?.decimals,
            symbol: paymentCurrency?.name,
            textStyle: "body3"
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: disableJumperLink,
            onClick: ()=>{
                window.open(addFundsLink, "_blank");
            },
            css: {
                width: "100%",
                my: "$4"
            }
        }, disableJumperLink ? copy.sweepCtaBuy : copy.sweepCtaInsufficientFunds))), !loading && sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).SelectPayment && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                py: 20
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                gap: "$2",
                px: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>setSweepStep((0, $f99c3f30def4cffc$export$de6922b83abf2eed).Idle),
            color: "ghost",
            size: "xs",
            css: {
                color: "$neutralSolidHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faChevronLeft),
            width: 10
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle2"
        }, "Select Payment Method")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $63fa277c4c09f916$export$ca31b002d5acc121), {
            paymentTokens: paymentTokens,
            currency: paymentCurrency,
            setCurrency: setPaymentCurrency,
            goBack: ()=>setSweepStep((0, $f99c3f30def4cffc$export$de6922b83abf2eed).Idle),
            itemAmount: itemAmount,
            chainId: modalChain?.id || 1
        })), sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).Approving && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $neutralBorder"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $137647f1780e4c12$export$15fea1e5b618f5ff), {
            chainId: chainId,
            collection: collection,
            token: token,
            itemCount: itemAmount,
            totalPrice: (paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop,
            currency: paymentCurrency,
            usdTotalFormatted: (0, $TBcmg$formatUnits)(((paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop) * (paymentCurrency?.usdPriceRaw || 0n), (paymentCurrency?.decimals || 18) + 6)
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                p: "$4",
                overflowY: "auto"
            }
        }, stepData?.currentStep == undefined ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                py: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null)) : null, stepData?.currentStep && stepData.currentStep.id !== "auth" && stepData.currentStep.id !== "sale" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralText",
                py: "$5"
            },
            direction: "column",
            justify: "center",
            align: "center"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            color: "base",
            css: {
                mb: "$2",
                textAlign: "center"
            }
        }, stepData.currentStep.action, " ", stepData?.currentStep?.items && stepData.currentStep.items.length > 1 ? `(${stepData.currentStep.items.filter((item)=>item.status === "complete").length}/${stepData.currentStep.items.length})` : null), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            css: {
                mb: 20,
                textAlign: "center"
            }
        }, stepData.currentStep.description), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faPenNib),
            width: 32,
            height: 32,
            style: {
                height: 32
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fc5a6190fea5008$export$8867c41adbe809fa), {
            currentStep: stepData?.currentStep
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                mt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.sweepCtaAwaitingApproval)) : null, stepData?.currentStep && stepData.currentStep.id === "auth" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d6ae44a4b381214a$export$2e2bcd8739ae039), {
            css: {
                mt: 48,
                mb: "$4",
                gap: 20
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                mt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.sweepCtaAwaitingApproval)) : null, stepData?.currentStep && stepData?.currentStep?.id === "sale" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, stepData?.currentStep?.items && stepData?.currentStep?.items.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6",
            css: {
                textAlign: "center"
            }
        }, "Approve Purchases"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle"
        }, "The purchase of these items needs to be split into", " ", stepData?.currentStep?.items.length, " separate transactions."), stepData?.currentStep?.items.map((item, idx)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $add635cbf9f5888f$export$d7253bf947e7aaac), {
                key: idx,
                item: item,
                pathMap: pathMap,
                usdPrice: +usdPrice,
                chain: currentChain,
                open: true
            }))) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                gap: "$4",
                pt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Confirm transaction in your wallet"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralText"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faWallet),
            style: {
                width: "32px",
                height: "32px",
                margin: "12px 0px"
            }
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fc5a6190fea5008$export$8867c41adbe809fa), {
            currentStep: stepData?.currentStep
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                mt: "$4",
                width: "100%"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.sweepCtaAwaitingApproval))) : null)), sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).Finalizing && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column"
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                p: "$4",
                borderBottom: "1px solid $neutralBorder"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $137647f1780e4c12$export$15fea1e5b618f5ff), {
            chainId: chainId,
            collection: collection,
            token: token,
            itemCount: itemAmount,
            totalPrice: (paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop,
            currency: paymentCurrency,
            usdTotalFormatted: (0, $TBcmg$formatUnits)(((paymentCurrency?.currencyTotalRaw || 0n) + feeOnTop) * (paymentCurrency?.usdPriceRaw || 0n), (paymentCurrency?.decimals || 18) + 6)
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            justify: "center",
            css: {
                gap: "$4",
                px: "$4",
                py: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Finalizing on blockchain"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "subtle",
            css: {
                textAlign: "center"
            }
        }, "You can close this modal while it finalizes on the blockchain. The transaction will continue in the background."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralSolid"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faCube),
            style: {
                width: 32,
                height: 32
            }
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1fc5a6190fea5008$export$8867c41adbe809fa), {
            currentStep: stepData?.currentStep
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true,
            css: {
                m: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), copy.sweepCtaAwaitingValidation)), sweepStep === (0, $f99c3f30def4cffc$export$de6922b83abf2eed).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                width: "100%",
                p: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            css: {
                px: "$4",
                py: "$5",
                gap: 24
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: failedSales ? "$errorAccent" : "$successAccent"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: failedSales ? (0, $TBcmg$faCircleExclamation) : (0, $TBcmg$faCheckCircle),
            fontSize: 32
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h5",
            css: {
                textAlign: "center"
            }
        }, failedSales ? `${successfulSales} ${successfulSales > 1 ? "items" : "item"} purchased, ${failedSales} ${failedSales > 1 ? "items" : "item"} failed` : "Congrats! Purchase was successful."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$2",
                mb: "$3"
            }
        }, stepData?.currentStep?.items?.map((item, itemIndex)=>{
            if (Array.isArray(item?.txHashes) && item?.txHashes.length > 0) return item.txHashes.map((hash, txHashIndex)=>{
                const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
                const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
                return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                    key: `${itemIndex}-${txHashIndex}`,
                    href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                    color: "primary",
                    weight: "medium",
                    target: "_blank",
                    css: {
                        fontSize: 12
                    }
                }, "View transaction: ", truncatedTxHash);
            });
            else return null;
        }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            }
        }, !!onGoToToken ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            onClick: ()=>{
                setOpen(false);
            },
            css: {
                flex: 1
            },
            color: "ghost"
        }, copy.sweepCtaClose), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            style: {
                flex: 1
            },
            color: "primary",
            onClick: ()=>{
                onGoToToken({
                    collectionId: collection?.id,
                    maker: address,
                    stepData: stepData
                });
            }
        }, copy.sweepCtaGoToToken.length > 0 ? copy.sweepCtaGoToToken : `View ${successfulSales > 1 ? "Tokens" : "Token"}`)) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            css: {
                width: "100%"
            },
            onClick: ()=>setOpen(false)
        }, copy.sweepCtaClose))));
    });
}
$ecf99860a3fcdd2e$export$2536c4e1bdf96841.Custom = (0, $f99c3f30def4cffc$export$8727d8535fbca2ab);




























const $d35781847bc1a968$var$CartItemImage = (0, $4a58f4053e821189$export$3817b7a54a07cec7)("img", {
    width: 56,
    height: 56,
    borderRadius: 4,
    objectFit: "cover"
});
const $d35781847bc1a968$var$CloseButton = (0, $4a58f4053e821189$export$3817b7a54a07cec7)((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
    position: "absolute",
    width: 24,
    height: 24,
    top: -8,
    right: -8,
    flexShrink: 0,
    defaultVariants: {
        size: "none",
        corners: "circle"
    }
});
const $d35781847bc1a968$var$CartItem = ({ item: item, usdConversion: usdConversion, tokenUrl: tokenUrl })=>{
    const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const { token: token, collection: collection, order: order } = item;
    const contract = collection.id.split(":")[0];
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const { remove: remove, data: cartCurrency, setQuantity: setQuantity } = (0, $95b0bed557a4469f$export$2e2bcd8739ae039)((cart)=>cart.currency);
    const { data: cartChain } = (0, $95b0bed557a4469f$export$2e2bcd8739ae039)((cart)=>cart.chain);
    const currencyConverted = item.price && item.price?.currency?.contract !== cartCurrency?.contract;
    let price = currencyConverted ? item.price?.amount?.native : item.price?.amount?.decimal;
    let previousPrice = item.previousPrice?.currency?.contract !== cartCurrency?.contract ? item.previousPrice?.amount?.native : item.previousPrice?.amount?.decimal;
    let priceDiff = 0;
    let priceIncrease = false;
    let priceDecrease = false;
    if (price !== undefined && previousPrice !== undefined) {
        priceDiff = Math.abs((price - previousPrice) / price * 100);
        priceIncrease = price > previousPrice;
        priceDecrease = price < previousPrice;
    }
    let usdPrice = (usdConversion || 0) * (price || 0);
    const reservoirChain = client?.chains.find((chain)=>cartChain?.id === chain.id);
    if (price && order?.quantity) {
        price = price * order.quantity;
        usdPrice = usdPrice * order.quantity;
    }
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            transition: "background-color 0.25s ease-in-out",
            "&:hover": {
                backgroundColor: "$neutralBgHover"
            }
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        onClick: ()=>{
            let chain = Object.values($TBcmg$viemchains).find((chain)=>cartChain?.id === chain.id);
            if (!chain) chain = Object.values((0, $TBcmg$customChains)).find((chain)=>chain.id === reservoirChain?.id) ?? $TBcmg$viemchains.mainnet;
            let url = tokenUrl;
            if (!url && cartChain) {
                let tokenMetaKey = null;
                if (cartChain.id === $TBcmg$viemchains.mainnet.id) tokenMetaKey = "reservoir:token-url-mainnet";
                else tokenMetaKey = `reservoir:token-url-${chain?.name.toLowerCase()}`;
                const tokenMetaTag = document.querySelector(`meta[property='${tokenMetaKey}']`);
                if (tokenMetaTag) url = tokenMetaTag.getAttribute("content") || undefined;
            }
            if (url) window.location.href = url.replace("${contract}", contract).replace("${tokenId}", token.id);
        },
        css: {
            width: "100%",
            px: 24,
            py: 8,
            cursor: "pointer"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            position: "relative",
            minWidth: 0,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($d35781847bc1a968$var$CartItemImage, {
        src: `${reservoirChain?.baseApiUrl}/redirect/tokens/${contract}:${token.id}/image/v1?imageSize=small`,
        css: !price ? {
            filter: "grayscale(1)"
        } : {},
        onError: ({ currentTarget: currentTarget })=>{
            const collectionImage = `${reservoirChain?.baseApiUrl}/redirect/collections/${collection.id}/image/v1`;
            if (currentTarget.src != collectionImage) currentTarget.src = collectionImage;
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement($d35781847bc1a968$var$CloseButton, {
        css: {
            "&:hover": {
                background: "$errorAccent"
            },
            background: !item.price ? "$errorAccent" : "$neutralSolid"
        },
        onClick: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            if (order?.id) remove([
                order?.id
            ]);
            else remove([
                `${collection.id}:${token.id}`
            ]);
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faClose),
        width: "16",
        height: "16"
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        justify: "center",
        css: {
            gap: 2,
            ml: "$2",
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            gap: "$1"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        color: price ? undefined : "subtle",
        ellipsify: true
    }, token.name ? token.name : `#${token.id}`)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle",
        ellipsify: true
    }, collection.name), !price && !order?.id && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "error"
    }, "Item no longer available"), !price && order?.id && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "error"
    }, "Listing no longer available"), !priceIncrease && !priceDecrease && currencyConverted && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1",
            color: "$accentSolidHover"
        },
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "accent"
    }, "Currency converted")), priceIncrease && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1",
            color: "$accentSolidHover"
        },
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        width: "11",
        icon: (0, $TBcmg$faArrowUp)
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body2",
        color: "accent"
    }, "Price has gone up ", (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(priceDiff), "%")), priceDecrease && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            gap: "$1",
            color: "$accentSolidHover"
        },
        align: "center"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        width: "11",
        icon: (0, $TBcmg$faArrowDown)
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "accent"
    }, "Price went down ", (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(priceDiff), "%"))), price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        justify: "center",
        css: {
            ml: "auto",
            flexShrink: 0,
            gap: "$1",
            "> div": {
                ml: "auto"
            }
        }
    }, providerOptionsContext.preferDisplayFiatTotal && usdPrice && usdPrice > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdPrice,
        style: "subtitle3",
        color: "base",
        css: {
            textAlign: "end"
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        textStyle: "tiny",
        textColor: "subtle",
        amount: price,
        address: cartCurrency?.contract,
        decimals: cartCurrency?.decimals,
        symbol: cartCurrency?.symbol,
        logoWidth: 10,
        chainId: cartChain?.id
    })) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
        textStyle: "subtitle3",
        amount: price,
        address: cartCurrency?.contract,
        decimals: cartCurrency?.decimals,
        symbol: cartCurrency?.symbol,
        logoWidth: 12,
        chainId: cartChain?.id
    }), usdPrice && usdPrice > 0 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
        amount: usdPrice,
        style: "tiny",
        color: "subtle",
        css: {
            textAlign: "end"
        }
    }) : null)) : null), order && order?.quantityRemaining > 1 && price ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        justify: "between",
        align: "center",
        css: {
            width: "100%",
            px: 24,
            pb: 8,
            gap: "$3"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "start",
        css: {
            gap: "$1",
            overflow: "hidden",
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3"
    }, "Quantity"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "body3",
        color: "subtle",
        ellipsify: true,
        css: {
            width: "100%"
        }
    }, (0, $6f54b4a5aad888ed$export$f5dd818bff069720)(order.quantityRemaining), " items available")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $c1ab7eea10f2afe3$export$2e2bcd8739ae039), {
        min: 1,
        max: order.quantityRemaining,
        quantity: order.quantity,
        setQuantity: (number)=>setQuantity(order.id, number),
        css: {
            border: "1px solid $neutralBorder",
            background: "none"
        }
    })) : null);
};
var $d35781847bc1a968$export$2e2bcd8739ae039 = $d35781847bc1a968$var$CartItem;








const $24b598a037d3635f$var$CartToast = ({ kind: kind = "success", message: message, link: link })=>{
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            width: "100%",
            background: "$wellBackground",
            p: "$2",
            borderRadius: "$borderRadius",
            mb: "$2"
        }
    }, kind === "success" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "success"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faCircleCheck),
        width: "16",
        height: "16"
    })), kind === "error" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "error"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faTriangleExclamation),
        width: "16",
        height: "16"
    })), kind === "warning" && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        color: "error"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faCircleInfo),
        width: "16",
        height: "16"
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        css: {
            ml: "$1",
            mt: 3
        },
        style: "body3"
    }, message), link);
};
var $24b598a037d3635f$export$2e2bcd8739ae039 = $24b598a037d3635f$var$CartToast;









const $d85ea08aba63d084$export$6c07efeb053daea6 = ({ open: open, children: children })=>{
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const [hasEnoughCurrency, setHasEnoughCurrency] = (0, $TBcmg$useState)(true);
    const { data: data, clear: clear, clearTransaction: clearTransaction, validate: validate, remove: remove, add: add, checkout: checkout } = (0, $95b0bed557a4469f$export$2e2bcd8739ae039)((cart)=>cart);
    const { isValidating: isValidating, totalPrice: totalPrice, items: items, currency: currency, transaction: transaction, feeOnTop: feeOnTop, chain: cartChain } = data;
    const usdConversion = (0, $b5d8dec284676ed1$export$2e2bcd8739ae039)(open ? "USD" : undefined, currency?.symbol || currency?.name);
    const usdPrice = usdConversion.length > 0 ? usdConversion[0].price : null;
    const chains = (0, $TBcmg$useChains)();
    const chain = chains.find((chain)=>chain.id === transaction?.chain.id);
    const blockExplorerBaseUrl = chain?.blockExplorers?.default?.url || "https://etherscan.io";
    const cartCurrencyConverted = items.some((item)=>item.price && item.price?.currency?.contract !== currency?.contract);
    (0, $TBcmg$useEffect)(()=>{
        if (open) validate();
        else if (transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Complete || transaction?.error) clearTransaction();
    }, [
        open
    ]);
    const unavailableItems = (0, $TBcmg$useMemo)(()=>items.filter((item)=>!item.price), [
        items
    ]);
    const priceChangeItems = (0, $TBcmg$useMemo)(()=>items.filter(({ previousPrice: previousPrice, price: price })=>previousPrice && price?.amount?.decimal !== undefined && previousPrice.amount?.decimal !== price?.amount?.decimal), [
        items
    ]);
    const { address: address, connector: connector } = (0, $TBcmg$useAccount)();
    const { data: capabilities } = (0, $TBcmg$useCapabilities)({
        query: {
            enabled: connector && (connector.id === "coinbaseWalletSDK" || connector.id === "coinbase")
        }
    });
    const cartChainId = cartChain?.id ?? client?.currentChain()?.id;
    const hasAuxiliaryFundsSupport = Boolean(cartChainId ? capabilities?.[cartChainId]?.auxiliaryFunds?.supported : false);
    const isNativeListing = currency?.contract === (0, $TBcmg$zeroAddress);
    const { data: nativeBalance } = (0, $TBcmg$useBalance)({
        chainId: cartChainId,
        address: address,
        query: {
            enabled: isNativeListing
        }
    });
    const { data: tokenBalance } = (0, $TBcmg$useReadContracts)({
        allowFailure: false,
        contracts: [
            {
                address: currency?.contract,
                abi: (0, $TBcmg$erc20Abi),
                functionName: "balanceOf",
                chainId: cartChainId,
                args: [
                    address
                ]
            }
        ],
        query: {
            enabled: address && !isNativeListing
        }
    });
    const balance = isNativeListing ? nativeBalance : {
        ...currency,
        value: tokenBalance?.[0] ?? 0n
    };
    (0, $TBcmg$useEffect)(()=>{
        if (balance) {
            const totalPriceTruncated = (0, $6f54b4a5aad888ed$export$a81f732198733497)(totalPrice, currency?.decimals || 18);
            if (!balance.value) setHasEnoughCurrency(false);
            else if (balance.value < (0, $TBcmg$parseUnits)(`${totalPriceTruncated}`, currency?.decimals || 18)) setHasEnoughCurrency(false);
            else setHasEnoughCurrency(true);
        }
    }, [
        totalPrice,
        balance,
        currency
    ]);
    (0, $TBcmg$useEffect)(()=>{
        if (hasEnoughCurrency && transaction?.errorType === (0, $ad5b3085b935ed8c$export$6adf53dcf2d42374).InsufficientBalance) setHasEnoughCurrency(false);
    }, [
        transaction
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        loading: isValidating,
        items: items,
        unavailableItems: unavailableItems,
        priceChangeItems: priceChangeItems,
        currency: currency,
        cartCurrencyConverted: cartCurrencyConverted,
        totalPrice: totalPrice,
        feeOnTop: feeOnTop,
        usdPrice: usdPrice,
        hasEnoughCurrency: hasEnoughCurrency,
        hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport,
        balance: balance?.value,
        transaction: transaction,
        blockExplorerBaseUrl: blockExplorerBaseUrl,
        cartChain: cartChain,
        checkout: checkout,
        clear: clear,
        remove: remove,
        add: add,
        validate: validate
    }));
};
var $d85ea08aba63d084$export$2e2bcd8739ae039 = $d85ea08aba63d084$export$6c07efeb053daea6;

























const $e6bafed94e2990ae$var$Title = (0, $TBcmg$styled)($TBcmg$Title, {
    margin: 0
});
function $e6bafed94e2990ae$export$603c1193809598d4({ items: items, totalPrice: totalPrice, usdPrice: usdPrice, currency: currency, cartChain: cartChain, blockExplorerBaseUrl: blockExplorerBaseUrl, transaction: transaction, open: open, setCartPopoverOpen: setCartPopoverOpen }) {
    const [dialogOpen, setDialogOpen] = (0, $TBcmg$useState)(false);
    const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const images = items.slice(0, 2).map((item)=>{
        const { token: token, collection: collection } = item;
        const contract = collection.id.split(":")[0];
        return `${cartChain?.baseApiUrl}/redirect/tokens/${contract}:${token.id}/image/v1?imageSize=small`;
    });
    const totalSales = transaction?.currentStep?.items?.reduce((total, item)=>{
        item.transfersData?.forEach((transferData)=>{
            total += Number(transferData.amount || 1);
        });
        return total;
    }, 0) || 0;
    const totalQuantity = transaction?.items?.reduce((total, item)=>{
        total += item?.order?.quantity || 1;
        return total;
    }, 0) || 0;
    const failedSales = totalQuantity - totalSales;
    const successfulSales = totalQuantity - failedSales;
    const pathMap = transaction?.path ? transaction.path.reduce((paths, path)=>{
        if (path.orderId) paths[path.orderId] = path;
        return paths;
    }, {}) : {};
    (0, $TBcmg$useEffect)(()=>{
        if (open !== undefined && open !== dialogOpen) setDialogOpen(open);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Root2, {
        onOpenChange: (open)=>{
            setDialogOpen(open);
            if (!open) setCartPopoverOpen(false);
        },
        open: dialogOpen
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$AnimatePresence), null, dialogOpen && /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$DialogPortal, {
        forceMount: true
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2fec296c1c0f429e$export$a14718312a4275d3), {
        style: {
            zIndex: 1002
        }
    }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $2fec296c1c0f429e$export$c8d6a95fc1e37f93), {
        forceMount: true,
        css: {
            zIndex: 1003
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            p: 16,
            backgroundColor: "$headerBackground",
            alignItems: "center",
            justifyContent: "space-between",
            borderTopRightRadius: "$borderRadius",
            borderTopLeftRadius: "$borderRadius"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement($e6bafed94e2990ae$var$Title, {
        css: {
            alignItems: "center",
            display: "flex"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, "Complete Checkout")), /*#__PURE__*/ (0, $TBcmg$react).createElement($TBcmg$Close, {
        asChild: true
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        color: "ghost",
        size: "none",
        css: {
            color: "$neutralText"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faClose),
        width: 16,
        height: 16
    })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            maxHeight: "85vh",
            overflowY: "auto"
        }
    }, transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Approving && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            p: "$4",
            borderBottom: "1px solid $neutralBorder"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $3252fd4b8efa16bf$export$c48a33806654dd82), {
        itemCount: items.length,
        images: images,
        totalPrice: totalPrice,
        usdPrice: usdPrice,
        currency: currency,
        chain: cartChain
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            p: "$4",
            overflowY: "auto"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        justify: "center",
        css: {
            color: "$neutralBorderHover",
            flex: 1,
            gap: "$5"
        }
    }, transaction?.currentStep == undefined ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            py: "$5"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null)) : null, transaction?.currentStep && transaction?.currentStep?.id === "auth" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d6ae44a4b381214a$export$2e2bcd8739ae039), {
        css: {
            mt: 48,
            mb: "$4",
            gap: 20
        }
    }) : null, transaction?.currentStep && transaction?.currentStep?.id !== "auth" ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, transaction?.currentStep?.items && transaction.currentStep?.items.length > 1 ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$4",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6",
        css: {
            textAlign: "center"
        }
    }, "Approve Purchases"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle"
    }, "Due to limitations with Blur, the purchase of these items needs to be split into", " ", transaction?.currentStep?.items.length, " ", "separate transactions."), transaction.currentStep?.items.map((item)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $add635cbf9f5888f$export$d7253bf947e7aaac), {
            item: item,
            pathMap: pathMap,
            usdPrice: usdPrice,
            chain: cartChain,
            open: true
        }))) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        css: {
            gap: "$4",
            py: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, "Confirm transaction in your wallet"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralText"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faWallet),
        style: {
            width: "32px",
            height: "32px",
            margin: "12px 0px"
        }
    })))) : null)), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        disabled: true,
        css: {
            m: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), "Waiting for Approval...")), transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Finalizing && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column"
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            px: "$4",
            py: "$5"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        justify: "center",
        css: {
            gap: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h6"
    }, "Finalizing on blockchain"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "subtitle3",
        color: "subtle",
        css: {
            textAlign: "center"
        }
    }, "You can close this modal while it finalizes on the blockchain. The transaction will continue in the background."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faCube),
        style: {
            height: 24,
            width: 24
        }
    }))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        disabled: true,
        css: {
            m: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null), "Waiting to be Validated...")), transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Complete && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        css: {
            width: "100%",
            p: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        css: {
            width: "100%",
            p: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        align: "center",
        css: {
            px: "$4",
            py: "$5",
            gap: 24
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: failedSales ? "$errorAccent" : "$successAccent"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: failedSales ? (0, $TBcmg$faCircleExclamation) : (0, $TBcmg$faCheckCircle),
        fontSize: 32
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "h5",
        css: {
            textAlign: "center"
        }
    }, failedSales ? `${successfulSales} ${successfulSales > 1 ? "items" : "item"} purchased, ${failedSales} ${failedSales > 1 ? "items" : "item"} failed` : "Congrats! Purchase was successful."), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        direction: "column",
        css: {
            gap: "$2",
            mb: "$3"
        }
    }, transaction?.currentStep?.items?.map((item, itemIndex)=>{
        if (Array.isArray(item?.txHashes) && item?.txHashes.length > 0) return item.txHashes.map((hash, txHashIndex)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                key: `${itemIndex}-${txHashIndex}`,
                href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                color: "primary",
                weight: "medium",
                target: "_blank",
                css: {
                    fontSize: 12
                }
            }, "View transaction: ", truncatedTxHash);
        });
        else return null;
    })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        css: {
            width: "100%",
            p: "$4"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
        css: {
            width: "100%"
        },
        onClick: ()=>setDialogOpen(false)
    }, "Close")))), !providerOptionsContext.disablePoweredByReservoir && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
        align: "center",
        css: {
            mx: "auto",
            alignItems: "center",
            justifyContent: "center",
            pb: 12,
            gap: "$1",
            visibility: "$poweredByReservoirVisibility",
            borderBottomRightRadius: "$borderRadius",
            borderBottomLeftRadius: "$borderRadius"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
        css: {
            color: "$neutralBorderHover"
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
        icon: (0, $TBcmg$faLock),
        width: 9,
        height: 10
    })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
        style: "tiny",
        color: "subtle",
        css: {
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            lineHeight: "12px",
            fontWeight: 400,
            color: "$neutralText"
        }
    }, "Powered by", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
        href: "https://reservoir.tools/",
        target: "_blank",
        weight: "heavy",
        color: "gray",
        css: {
            height: 12,
            fontSize: 12,
            "&:hover": {
                color: "$neutralSolid",
                fill: "$neutralSolid"
            }
        }
    }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$e6ff31bff12b7ff4), null))))))));
}





const $6649489e0491bc82$var$scaleUp = (0, $4a58f4053e821189$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 0,
        transform: "scale(0.9) translateY(-10px)"
    },
    "100%": {
        opacity: 1,
        transform: "scale(1) translateY(0)"
    }
});
const $6649489e0491bc82$var$scaleDown = (0, $4a58f4053e821189$export$d25ddfdf17c3ad3e)({
    "0%": {
        opacity: 1,
        transform: "scale(1) translateY(0)"
    },
    "100%": {
        opacity: 0,
        transform: "scale(0.9) translateY(-10px)"
    }
});
const $6649489e0491bc82$var$CONTENT_OFFSET = 8;
function $6649489e0491bc82$export$15123b0cb184ed6e({ trigger: trigger, side: side, openState: openState, tokenUrl: tokenUrl, onConnectWallet: onConnectWallet }) {
    const [popoverTrigger, setPopoverTrigger] = (0, $TBcmg$useState)(null);
    const [open, setOpen] = (0, $b69d00be56c1bdb6$export$2e2bcd8739ae039)(openState ? openState[0] : false, openState);
    const providerOptionsContext = (0, $TBcmg$useContext)((0, $f4609ce2cb6b416b$export$f66a1c3c9465af21));
    const [displayPendingTransaction, setDisplayPendingTransaction] = (0, $TBcmg$useState)(false);
    const [purchaseComplete, setPurchaseComplete] = (0, $TBcmg$useState)(false);
    const { isConnected: isConnected } = (0, $TBcmg$useAccount)();
    (0, $TBcmg$useEffect)(()=>{
        if (!open) {
            setDisplayPendingTransaction(false);
            setPurchaseComplete(false);
        }
    }, [
        open
    ]);
    const triggerBottom = (0, $TBcmg$useMemo)(()=>(popoverTrigger?.offsetTop || 0) + (popoverTrigger?.offsetHeight || 0) + $6649489e0491bc82$var$CONTENT_OFFSET, [
        trigger
    ]);
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d85ea08aba63d084$export$2e2bcd8739ae039), {
        open: open
    }, ({ loading: loading, items: items, unavailableItems: unavailableItems, priceChangeItems: priceChangeItems, totalPrice: totalPrice, feeOnTop: feeOnTop, usdPrice: usdPrice, hasEnoughCurrency: hasEnoughCurrency, hasAuxiliaryFundsSupport: hasAuxiliaryFundsSupport, balance: balance, currency: currency, cartCurrencyConverted: cartCurrencyConverted, transaction: transaction, blockExplorerBaseUrl: blockExplorerBaseUrl, cartChain: cartChain, remove: remove, clear: clear, checkout: checkout })=>{
        (0, $TBcmg$useEffect)(()=>{
            if (transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Complete) {
                setDisplayPendingTransaction(false);
                setPurchaseComplete(true);
            }
        }, [
            transaction?.status
        ]);
        const unavailableItemsSubject = unavailableItems.length > 1 ? "items" : "item";
        const priceChangeItemsSubject = priceChangeItems.length > 1 ? "items prices" : "item price";
        const isCartEmpty = items.length === 0;
        const hasValidItems = items.length > unavailableItems.length;
        return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Root, {
            modal: true,
            open: open,
            onOpenChange: setOpen
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Trigger, {
            asChild: true,
            ref: setPopoverTrigger
        }, trigger), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $b3c42dc96a91e1fd$export$2e2bcd8739ae039).Content, {
            side: side,
            sideOffset: $6649489e0491bc82$var$CONTENT_OFFSET,
            css: {
                display: "flex",
                flexDirection: "column",
                zIndex: 1001,
                transformOrigin: "var(--radix-popover-content-transform-origin)",
                animation: `${open ? $6649489e0491bc82$var$scaleUp : $6649489e0491bc82$var$scaleDown} 0.2s ease-in-out`,
                overflowY: "auto",
                borderRadius: "$borderRadius",
                $$shadowColor: "$colors$gray7",
                boxShadow: "box-shadow: 0px 2px 16px $$shadowColor",
                border: "1px solid $borderColor",
                p: 24,
                minHeight: 500,
                width: 395,
                maxHeight: `calc(100vh - ${triggerBottom || 0}px - (25px * 2) - 10px)`,
                backgroundColor: "$contentBackground",
                boxSizing: "border-box",
                "@media(max-width: 520px)": {
                    height: `calc(100vh - ${triggerBottom || 0}px - (25px * 2))`,
                    width: "100vw",
                    minHeight: "100%"
                }
            }
        }, loading && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), {
            css: {
                backgroundColor: "$contentBackground",
                position: "absolute",
                inset: 0,
                opacity: 0.6,
                zIndex: 10000
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                mb: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Cart"), !isCartEmpty && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "center",
            css: {
                background: "$accentSolid",
                height: 20,
                width: 20,
                borderRadius: "99999px",
                ml: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            color: "button"
        }, items.length)), !isCartEmpty && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3",
            css: {
                color: "$accentSolid",
                cursor: "pointer",
                ml: 24,
                "&:hover": {
                    color: "$accentSolidHover"
                }
            },
            onClick: clear
        }, "Clear All"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            size: "none",
            color: "ghost",
            css: {
                color: "$neutralSolid",
                ml: "auto"
            },
            onClick: ()=>{
                setOpen(false);
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faClose),
            width: "16",
            height: "16"
        }))), cartCurrencyConverted && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $24b598a037d3635f$export$2e2bcd8739ae039), {
            kind: "warning",
            message: `Mixed currency items are only available to be checked out with ${currency?.symbol}`
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                mb: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a17c19ca9f9aa5ab$export$2e2bcd8739ae039), {
            chainId: cartChain?.id,
            height: 12,
            css: {
                mr: 5
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "subtle"
        }, cartChain?.name)), unavailableItems.length > 0 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $24b598a037d3635f$export$2e2bcd8739ae039), {
            kind: "error",
            message: `${unavailableItems.length} ${unavailableItemsSubject} no longer available`,
            link: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
                color: "accent",
                style: "subtitle3",
                css: {
                    ml: "auto",
                    mt: 3,
                    cursor: "pointer"
                },
                onClick: (e)=>{
                    e.preventDefault();
                    remove(unavailableItems.map((item)=>`${item.collection.id}:${item.token.id}`));
                }
            }, "Remove ", unavailableItemsSubject)
        }), priceChangeItems.length > 0 && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $24b598a037d3635f$export$2e2bcd8739ae039), {
            kind: "warning",
            message: `${priceChangeItems.length} ${priceChangeItemsSubject} updated`
        }), transaction?.error && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $24b598a037d3635f$export$2e2bcd8739ae039), {
            kind: "error",
            message: transaction.errorType === (0, $ad5b3085b935ed8c$export$6adf53dcf2d42374).UserDenied ? "User denied transaction signature." : transaction.error.message
        }), purchaseComplete ? transaction?.txHashes?.map((hash)=>{
            const truncatedTxHash = (0, $fb2072c99d61ad71$export$cd8822fabcdefd67)(hash.txHash);
            const blockExplorerBaseUrl = (0, $e11f8e20e03baf92$export$2e2bcd8739ae039)(hash.chainId);
            return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $24b598a037d3635f$export$2e2bcd8739ae039), {
                message: `Transaction Complete`,
                link: /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
                    href: `${blockExplorerBaseUrl}/tx/${hash.txHash}`,
                    target: "_blank",
                    css: {
                        ml: "auto",
                        fontSize: 12,
                        mt: 2
                    },
                    weight: "medium",
                    color: "primary"
                }, "View transaction: ", truncatedTxHash)
            });
        }) : null, !isCartEmpty && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                gap: "$4",
                mb: "$4",
                overflowY: "auto",
                mx: -24
            }
        }, items.map((item)=>/*#__PURE__*/ (0, $TBcmg$react).createElement((0, $d35781847bc1a968$export$2e2bcd8739ae039), {
                key: `${item.collection.id}:${item.token.id}`,
                item: item,
                usdConversion: usdPrice,
                tokenUrl: tokenUrl
            }))), isCartEmpty && !(displayPendingTransaction && transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Finalizing) && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            align: "center",
            justify: "center",
            css: {
                color: "$neutralBorderHover",
                flex: 1,
                gap: "$5"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faShoppingCart),
            width: "30",
            height: "30",
            style: {
                height: 30
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body2",
            color: "subtle"
        }, "No items in your cart")), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            css: {
                mt: "auto",
                pb: 10
            }
        }, !isCartEmpty && feeOnTop ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mb: "$4"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "subtitle3"
        }, "Referrer Fee"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                ml: "auto",
                gap: "$1",
                "> div": {
                    ml: "auto"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            textStyle: "subtitle3",
            amount: feeOnTop,
            address: currency?.contract,
            decimals: currency?.decimals,
            symbol: currency?.symbol,
            logoWidth: 12,
            chainId: cartChain?.id
        }), usdPrice && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
            amount: usdPrice * feeOnTop,
            style: "subtitle3",
            color: "subtle",
            css: {
                textAlign: "end"
            }
        }))) : null, !isCartEmpty && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            css: {
                mb: 28
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "h6"
        }, "Total"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            direction: "column",
            justify: "center",
            css: {
                ml: "auto",
                gap: "$1",
                "> div": {
                    ml: "auto"
                }
            }
        }, providerOptionsContext.preferDisplayFiatTotal && usdPrice ? /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
            amount: usdPrice * totalPrice,
            style: "h6",
            color: "base",
            css: {
                textAlign: "end"
            }
        }), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            textStyle: "subtitle3",
            textColor: "subtle",
            amount: totalPrice,
            address: currency?.contract,
            decimals: currency?.decimals,
            symbol: currency?.symbol,
            logoWidth: 12,
            chainId: cartChain?.id
        })) : /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            textStyle: "h6",
            amount: totalPrice,
            address: currency?.contract,
            decimals: currency?.decimals,
            symbol: currency?.symbol,
            logoWidth: 18,
            chainId: cartChain?.id
        }), usdPrice && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $fafed10a0d83e98f$export$2e2bcd8739ae039), {
            amount: usdPrice * totalPrice,
            style: "subtitle3",
            color: "subtle",
            css: {
                textAlign: "end"
            }
        })))), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6bafed94e2990ae$export$603c1193809598d4), {
            open: (transaction?.status == (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Approving || transaction?.status == (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Finalizing || transaction?.status == (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Complete) && !transaction?.error,
            items: items,
            currency: currency,
            totalPrice: totalPrice,
            usdPrice: usdPrice || 0,
            transaction: transaction,
            cartChain: cartChain,
            blockExplorerBaseUrl: blockExplorerBaseUrl,
            setCartPopoverOpen: setOpen
        }), !hasEnoughCurrency && !hasAuxiliaryFundsSupport && isConnected && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            justify: "center",
            css: {
                mb: "$2",
                gap: "$2"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "body3",
            color: "error"
        }, "Insufficient balance"), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bedde9b021cf9a1c$export$2e2bcd8739ae039), {
            textStyle: "body3",
            chainId: cartChain?.id,
            amount: balance,
            address: currency?.contract,
            decimals: currency?.decimals,
            symbol: currency?.symbol,
            logoWidth: 10
        })), isCartEmpty && !displayPendingTransaction && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: true
        }, "Select Items to Buy"), !isCartEmpty && hasValidItems && (transaction?.status === (0, $ad5b3085b935ed8c$export$de7bcda3c490bf18).Idle || !displayPendingTransaction) && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            disabled: !hasEnoughCurrency && !hasAuxiliaryFundsSupport && isConnected,
            onClick: async ()=>{
                if (!isConnected) onConnectWallet?.();
                else checkout({
                    skipBalanceCheck: hasAuxiliaryFundsSupport
                }).then(()=>{
                    setDisplayPendingTransaction(true);
                }).catch((e)=>{
                    console.error(e);
                    setDisplayPendingTransaction(false);
                });
            }
        }, hasEnoughCurrency || !isConnected || hasAuxiliaryFundsSupport ? "Purchase" : "Add Funds to Purchase"), !isCartEmpty && !hasValidItems && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
            color: "secondary",
            onClick: ()=>{
                clear();
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faRefresh),
            width: "16",
            height: "16"
        }), "Refresh Cart"), !providerOptionsContext.disablePoweredByReservoir && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $602940fa56061b3b$export$2e2bcd8739ae039), {
            align: "center",
            css: {
                mx: "auto",
                alignItems: "center",
                justifyContent: "center",
                mt: 26,
                gap: "$1",
                visibility: "$poweredByReservoirVisibility"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                color: "$neutralBorderHover"
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$FontAwesomeIcon), {
            icon: (0, $TBcmg$faLock),
            width: 9,
            height: 10
        })), /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $38b6348718e47dcf$export$2e2bcd8739ae039), {
            style: "tiny",
            color: "subtle",
            css: {
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                lineHeight: "14px",
                fontWeight: 400,
                color: "$neutralText"
            }
        }, "Powered by", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $a663831c1deeb453$export$2e2bcd8739ae039), {
            href: "https://reservoir.tools/",
            target: "_blank",
            weight: "heavy",
            color: "gray",
            css: {
                height: 12,
                fontSize: 12,
                "&:hover": {
                    color: "$neutralSolid",
                    fill: "$neutralSolid"
                }
            }
        }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $32d03e1adcee2721$export$e6ff31bff12b7ff4), null)))))), open && /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $0af15c1ef5e8ac4a$export$2e2bcd8739ae039), {
            css: {
                backgroundColor: "$overlayBackground",
                position: "fixed",
                inset: 0,
                zIndex: 1000
            }
        }));
    });
}
$6649489e0491bc82$export$15123b0cb184ed6e.Custom = (0, $d85ea08aba63d084$export$2e2bcd8739ae039);
var $6649489e0491bc82$export$2e2bcd8739ae039 = $6649489e0491bc82$export$15123b0cb184ed6e;





function $24f1d70cae242ff6$export$69b0e3fe386591dc({ token: token, contract: contract, collectionId: collectionId, swrOptions: swrOptions, chainId: chainId, children: children }) {
    const client = (0, $3663d60eaf20fbf3$export$2e2bcd8739ae039)();
    const currentChain = client?.currentChain();
    const chain = chainId ? client?.chains.find(({ id: id })=>id === chainId) || currentChain : currentChain;
    const { data: tokens, isFetchingPage: isFetchingTokens } = (0, $074b4666df4341a7$export$2e2bcd8739ae039)(token && !collectionId && !contract ? {
        tokens: [
            token
        ]
    } : false, undefined, chain?.id);
    const _collectionId = !collectionId && tokens && tokens[0] ? tokens[0].token?.collection?.id : collectionId;
    const collectionQuery = (0, $TBcmg$useMemo)(()=>{
        let query = {
            includeMintStages: true
        };
        if (_collectionId) query.id = _collectionId;
        else if (contract) query.contract = contract;
        else query = false;
        return query;
    }, [
        _collectionId,
        contract
    ]);
    const { data: collections, isFetchingPage: isFetchingCollections } = (0, $afd6276a623787c2$export$2e2bcd8739ae039)(collectionQuery, swrOptions, chain?.id);
    const tokenData = tokens && tokens[0] ? tokens[0] : undefined;
    const collection = collections && collections[0] ? collections[0] : undefined;
    const mintStages = collection?.mintStages;
    const publicMintData = collection?.mintStages?.find((stage)=>stage.kind === "public");
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $TBcmg$react).Fragment, null, children({
        publicMintData: publicMintData,
        mintStages: mintStages,
        collection: collection,
        tokenData: tokenData,
        loading: (contract !== undefined || collection !== undefined) && isFetchingCollections && !collection || token !== undefined && isFetchingTokens && !tokenData
    }));
}
var $24f1d70cae242ff6$export$2e2bcd8739ae039 = $24f1d70cae242ff6$export$69b0e3fe386591dc;







function $4aea6767631d7df1$export$5cfdd9bc54669b75({ token: token, contract: contract, collectionId: collectionId, onConnectWallet: onConnectWallet, optionalMintModalProps: optionalMintModalProps, optionalSweepModalProps: optionalSweepModalProps, customTriggerRenderer: customTriggerRenderer, triggerCss: triggerCss, swrOptions: swrOptions, chainId: chainId }) {
    return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $24f1d70cae242ff6$export$2e2bcd8739ae039), {
        token: token,
        contract: contract,
        collectionId: collectionId,
        swrOptions: swrOptions,
        chainId: chainId
    }, ({ loading: loading, tokenData: tokenData, publicMintData: publicMintData, mintStages: mintStages, collection: collection })=>{
        const mintPriceDecimal = publicMintData?.price?.amount?.decimal;
        const mintCurrency = publicMintData?.price?.currency?.symbol?.toUpperCase();
        const mintPrice = typeof mintPriceDecimal === "number" && mintPriceDecimal !== null && mintPriceDecimal !== undefined ? mintPriceDecimal === 0 ? "Free" : `${mintPriceDecimal} ${mintCurrency}` : undefined;
        const sweepPriceData = tokenData ? tokenData?.market?.floorAsk?.price : collection?.floorAsk?.price;
        const sweepSymbol = sweepPriceData?.currency?.symbol;
        const sweepPriceRaw = sweepPriceData?.amount?.raw;
        const trigger = (0, $TBcmg$useMemo)(()=>{
            if (customTriggerRenderer) return customTriggerRenderer(loading, publicMintData, mintStages, collection, tokenData);
            else if (loading) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
                css: {
                    ...triggerCss
                }
            }, /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $bbced143042e1aed$export$2e2bcd8739ae039), null));
            else if (publicMintData && mintPrice) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
                css: {
                    ...triggerCss
                }
            }, "Mint ", mintPrice);
            else if (sweepPriceRaw) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $e6a4e3d86984e475$export$2e2bcd8739ae039), {
                css: {
                    ...triggerCss
                }
            }, "Collect", " ", /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $916b743aad99c93e$export$2e2bcd8739ae039), {
                amount: sweepPriceRaw,
                decimals: sweepPriceData?.currency?.decimals,
                maximumFractionDigits: 4,
                textStyle: "h6",
                css: {
                    color: "$buttonTextColor"
                }
            }), sweepSymbol);
            else return null;
        }, [
            customTriggerRenderer,
            loading,
            tokenData,
            publicMintData,
            mintStages,
            collection
        ]);
        if (publicMintData && mintPrice) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $1069c5e15a889a4a$export$9a9c99234bb94f07), {
            trigger: trigger,
            chainId: chainId,
            collectionId: collectionId,
            contract: contract,
            token: token,
            onConnectWallet: onConnectWallet,
            ...optionalMintModalProps
        });
        else if (sweepPriceRaw) return /*#__PURE__*/ (0, $TBcmg$react).createElement((0, $ecf99860a3fcdd2e$export$2536c4e1bdf96841), {
            trigger: trigger,
            chainId: chainId,
            collectionId: collectionId,
            contract: contract,
            token: token,
            onConnectWallet: onConnectWallet,
            ...optionalSweepModalProps
        });
        else return trigger;
    });
}
$4aea6767631d7df1$export$5cfdd9bc54669b75.Custom = (0, $24f1d70cae242ff6$export$2e2bcd8739ae039);




export {$f4609ce2cb6b416b$export$14ec072536e53e19 as ReservoirKitProvider, $2deec6552e3d4fa0$export$9d733ffc7f61c45c as ReservoirClientProvider, $afd6276a623787c2$export$2e2bcd8739ae039 as useCollections, $3ec5bd98aa11a4af$export$2e2bcd8739ae039 as useCollectionActivity, $df89d2f0bf3a2e94$export$2e2bcd8739ae039 as useUsersActivity, $3663d60eaf20fbf3$export$2e2bcd8739ae039 as useReservoirClient, $074b4666df4341a7$export$2e2bcd8739ae039 as useTokens, $a6a22af2ea7cc64d$export$2e2bcd8739ae039 as useTokenActivity, $b5d8dec284676ed1$export$2e2bcd8739ae039 as useCoinConversion, $b9d7d4ec194b807a$export$2e2bcd8739ae039 as useListings, $6b5464cef6d36d49$export$2e2bcd8739ae039 as useOwnerListings, $7c7b75a236ce465b$export$2e2bcd8739ae039 as useAttributes, $e5a3042549429464$export$2e2bcd8739ae039 as useBids, $adb61885b37a317b$export$2e2bcd8739ae039 as useUserTokens, $9e5d58301bd315fe$export$2e2bcd8739ae039 as useUserTopBids, $f03c3cbef8c597c8$export$2e2bcd8739ae039 as useUserCollections, $95b0bed557a4469f$export$2e2bcd8739ae039 as useCart, $7eca4ecf85dae226$export$2e2bcd8739ae039 as useDynamicTokens, $bfd69022dcb7499e$export$2e2bcd8739ae039 as useTrendingCollections, $4719414bc2959e37$export$2e2bcd8739ae039 as useTrendingMints, $392877f7a5a0835e$export$2e2bcd8739ae039 as useCurrencyConversion, $201908b8377e3dd2$export$2e2bcd8739ae039 as useSolverCapacity, $64e3a4f1258fcb50$export$2e2bcd8739ae039 as useMarketplaceConfigs, $13e7ce1cd1160f0c$export$2e2bcd8739ae039 as useUserListings, $739a88828d18ea96$export$2e2bcd8739ae039 as useUserBids, $e235ec7f4c2cf2ae$export$2e2bcd8739ae039 as lightTheme, $1fa63d73b4d6b2f8$export$2e2bcd8739ae039 as darkTheme, $8befffb57023ead8$export$7055e49b90860ae6 as BuyModal, $1cf2d84a10342ca7$export$b41ddf00b39567e8 as BuyStep, $5bc22b51ac8fa039$export$d23efc006864db2f as ListModal, $0dfcd962a810a554$export$7f4afd65e1e67072 as ListStep, $587a01049d5141ff$export$556cfc4a654987bd as BidModal, $2b3bdb31da73e768$export$7a92ddb9e11f37f7 as BidStep, $d8c34b3c598b5433$export$91ee3fa7c9f4e6c2 as AcceptBidModal, $be959054ceb8cef7$export$f4dd52ca63b5fdde as AcceptBidStep, $140a00430df0958e$export$89d1e00b7fa831db as CancelBidModal, $03948d0d1ea50134$export$c5c5c857eaef0fde as CancelBidStep, $8a7188f82a67e5bb$export$5ccdc2f8532db25b as CancelListingModal, $6e7449d8ef933807$export$c5c5c857eaef0fde as CancelListingStep, $cc999d237a46714e$export$799450c9ce92504c as EditBidModal, $c3a477f35c10f10a$export$1662ceb9c43bf6c3 as EditBidStep, $e8302fb60e57543b$export$7856870a29100de3 as EditListingModal, $15b40f9f8236e7c4$export$3a845fe90ed2a8d8 as EditListingStep, $1069c5e15a889a4a$export$9a9c99234bb94f07 as MintModal, $35205ce66a4a25b2$export$692b64e8a8032f02 as MintStep, $ecf99860a3fcdd2e$export$2536c4e1bdf96841 as SweepModal, $f99c3f30def4cffc$export$de6922b83abf2eed as SweepStep, $b11e5b18b62632d1$export$2e2bcd8739ae039 as TokenMedia, $b11e5b18b62632d1$export$b7d45a46da28b4d3 as extractMediaType, $6649489e0491bc82$export$2e2bcd8739ae039 as CartPopover, $ad5b3085b935ed8c$export$9081b9c87ee4e12e as CartProvider, $4aea6767631d7df1$export$5cfdd9bc54669b75 as CollectButton};
//# sourceMappingURL=index.mjs.map
